/* ───────────────────────────────────────────────────────────────────────────
   assets/cod-co.js — Pago contra entrega de COLOMBIA.

   🔴 ARCHIVO NUEVO. Copia la MECÁNICA de src/cod/theme-carrito/cod-carrito.js
   (apertura/cierre del modal, cascada de cobertura, guard de re-entrada del
   submit, etiquetado del botón con el total, pantalla de éxito) y cambia lo que
   obliga Colombia. No importa ni comparte estado con ningún archivo mexicano.

   🔒 REGLA DURA CONSERVADA (cod-carrito.js:5-9): este archivo NUNCA manda
   precios. Al servidor sólo viajan: los datos del cliente, el productGid, QUÉ
   tier eligió y QUÉ variante quiere en cada unidad. El dinero lo resuelve
   POST /ordenar-co leyendo el metafield `landing.data` y las variantes reales
   (router-co.js:1044 "PRECIOS — SIEMPRE DEL METAFIELD, JAMÁS DEL BODY"). Si
   alguien edita este JS en el navegador, lo peor que consigue es pedir otro tier
   —y si ese tier no está en el metafield, se lleva `oferta_no_disponible`.

   ═══════════════════════════════════════════════════════════════════════════
   🔒 EL TOTAL LO CALCULA EL SERVIDOR. AQUÍ NO SE SUMA UN PESO.
   ═══════════════════════════════════════════════════════════════════════════
   Cambio del 2026-09-01, al cerrar los defectos ALTO A-1 y A-2 de la revisión
   adversaria. Hasta entonces este archivo calculaba el resumen por su cuenta
   (espejaba la regla de envío leyendo settings.cod_co_envio_*) y el desglose real
   sólo se conocía DESPUÉS de crear la orden — o sea cuando el cliente ya se había
   comprometido. Con eso vivían tres divergencias:
     · DOS autoridades del envío: el tema leía los settings, el servidor leía
       ENVIO_CO_COSTO / ENVIO_CO_UMBRAL (envio-co.js). Si alguien movía una, el
       cliente veía un número y pagaba otro.
     · el metafield de la página puede venir RANCIO de la caché de Shopify.
     · cualquier adicional que el servidor aceptara y esta pantalla no supiera
       pintar se COBRABA invisible (ALTO A-1: un tick `marcadoDefault` de $15.000
       sobre un tier de $43.000 → el botón decía $43.000 y se cobraban $75.700, y
       de paso el tick movía el umbral de envío gratis, así que la pantalla podía
       decir "te faltan $9.000" sobre un pedido que YA lo tenía).

   Ahora hay UN solo número y viene de POST /cotizar-co, que por dentro usa la
   MISMA `cotizarPedidoCo` que arma las líneas de la orden (orden-co.js). Este
   archivo sólo PINTA lo que le contestan.

   ⚠️ MODO DEGRADADO — DECISIÓN DELIBERADA, NO UN OLVIDO.
   Si /cotizar-co no responde, el submit queda BLOQUEADO. Sí: por un hipo de red
   la landing deja de vender durante ese rato. Se elige a conciencia — es mejor no
   vender que cobrarle a alguien un número que nunca vio; esa es la regla que este
   proyecto ya pagó cara. Para que un hipo no cueste la venta, el bloqueo NO es
   pasivo: se reintenta solo (2 veces, con espera creciente), el cliente ve un
   mensaje que explica qué pasa, y tiene un botón "Reintentar" a mano. Sólo el
   resumen se bloquea: la landing y el resto de la página siguen vivos.

   Lo que se sigue pintando desde la página (y no es dinero cobrable): los precios
   de los BOTONES de la escalera de ofertas, que son los mismos que Shopify ya
   renderizó arriba. El total, el envío, los descuentos y la lista de lo que se
   cobra salen SIEMPRE del servidor.

   ═══════════════════════════════════════════════════════════════════════════
   🔒 …Y SIGUE SIÉNDOLO UN MINUTO DESPUÉS. EL EJE TIEMPO.
   ═══════════════════════════════════════════════════════════════════════════
   Cambio del 2026-09-01 (2ª revisión adversaria, ALTO-1). La cotización ataba el
   total al PAYLOAD del cliente, no al ESTADO DEL SERVIDOR que lo produjo: entre que
   el cliente veía el número y pulsaba enviar podían pasar minutos, y /ordenar-co
   vuelve a leer el metafield y ENVIO_CO_* por su cuenta. Un rollout de precios en
   medio y se cobraba el número nuevo con la huella intacta. Ahora:
     · TTL de 5 min: una cotización vieja NO se puede enviar (se revalida primero);
     · refresco SILENCIOSO de fondo y al volver la pestaña a primer plano, para que el
       TTL casi nunca le toque el turno a nadie;
     · si el total cambia, hace falta un GESTO EXPLÍCITO del cliente ("Acepto pagar
       $X"). Nunca se cobra sin él;
     · ECO al servidor de lo aprobado → /ordenar-co responde 409 (sin crear nada) si
       al recalcular no le sale lo mismo, y devuelve la cotización FRESCA para
       repintarla.
   ⚠️ NINGUNO de esos caminos toca el formulario: lo que el cliente escribió no se
   pierde jamás, ni cuando caduca, ni cuando el precio cambia, ni en el 409.

   ⚠️ ADICIONALES (2026-09-02). Los TICK ya se ofrecen: el formulario pinta una tarjeta
   con casilla por cada entrada de `landing.upsellTick`, debajo de la suscripción, y lo
   que el cliente marque viaja como VOTO EXPLÍCITO POR ÍNDICE
   (`upsells: {ticks:{0:true,1:false}, flashAceptados:[]}`) en la cotización Y en el
   pedido, por el MISMO `payloadPedido()`. Mandar el objeto `ticks` es lo que hace del
   cliente la AUTORIDAD sobre todos los índices y lo que impide que el servidor acepte
   "por defecto" algo que esta pantalla no mostró (router-co.js,
   resolverTicksAceptadosCo). El precio del adicional lo sigue poniendo el servidor
   desde el metafield: aquí sólo se dice SÍ o NO. Y cada casilla RECOTIZA, así que el
   total del botón y la lista `items` del resumen incluyen siempre lo marcado — marcar
   un extra y que el total no se mueva sería el bug de confianza que esto cierra.
   ⚡ CADENA FLASH (2026-09-10). Ya tiene UI: tras validar el formulario y ANTES del POST
   se ofrecen, UNA A LA VEZ, las `ofertasFlash` que el servidor coció en la cotización
   (foto grande, tachado VIVO, badge, chips de variante, 60 s por delta de reloj). Lo que
   el cliente acepta viaja como `flashAceptados: [{id, qty, variantId}]` por el MISMO
   payload, así que entra en la HUELLA: aceptar una oferta invalida la cotización
   aprobada, se recotiza y sólo se envía si el total nuevo cuadra con la fórmula de
   §G2.2 — si no, gesto explícito. Sin ofertas o con todo rechazado el array vuelve a
   viajar vacío (también es un voto) y el submit es byte a byte el de antes.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  /* ⚡ ENLACE TEMPRANO (velocidad, 21-oct-2026). Este archivo ya no va `defer`: va `async`
     (cod-co.liquid) y se ejecuta EN CUANTO LLEGA, no al final de la lectura del HTML detrás
     de todos los diferidos de la página — medido en un móvil lento, eso dejaba el botón
     7,2–7,6 s sin abrir el formulario. El <script> va después de [data-cco-root], así que lo
     normal es que la raíz ya exista; si algún día se incluyera antes (o desde el <head>),
     se espera a DOMContentLoaded en vez de no arrancar. `ccoListo` lo hace idempotente: un
     segundo arranque (dos inclusiones, o el respaldo) no hace nada. */
  if (!document.querySelector('[data-cco-root]') && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarCco);
    return;
  }
  arrancarCco();

  function arrancarCco() {
  var root = document.querySelector('[data-cco-root]');
  if (!root || root.dataset.ccoListo === '1') return;
  root.dataset.ccoListo = '1';

  var ENDPOINT = String(root.dataset.ccoEndpoint || '').replace(/\/+$/, '');
  var PRODUCT_GID = String(root.dataset.ccoProductGid || '').trim();
  // Id NUMÉRICO del producto del pack. `/cart.js` identifica cada línea por
  // `product_id` numérico y el resto del carril habla en gid: ésta es la única
  // traducción entre los dos, y vive aquí para que no haya una segunda.
  var PRODUCT_ID_NUM = (PRODUCT_GID.match(/(\d+)\s*$/) || [])[1] || '';
  // ── ¿ESTE FORMULARIO SE ABRIÓ DESDE EL CARRITO? ───────────────────────────
  // Lo declara el snippet que lo renderiza (cod-co.liquid ← carrito-co.liquid), no se
  // adivina por la URL. En el carrito manda EL CARRITO: la escalera de ofertas se
  // esconde (cod-co.css) y las unidades del pack salen de las líneas del carrito, no
  // de una elección dentro del modal.
  var EN_CARRITO = root.dataset.ccoEnCarrito === '1';

  var $ = function (sel) { return root.querySelector(sel); };
  var modal = $('[data-cco-modal]');
  var form = $('[data-cco-form]');
  var elTiers = $('[data-cco-tiers]');
  var elUnidades = $('[data-cco-unidades]');
  var elResumen = $('[data-cco-resumen]');
  // Tarjetas de adicionales tipo TICK. Opcional a propósito: un tema montado con el
  // snippet viejo no trae el ancla, y entonces NO se pinta ninguna tarjeta — y como el
  // voto se deriva de lo pintado, tampoco se puede votar que SÍ a nada. El fallo cae
  // del lado de no cobrar, que es la única dirección aceptable aquí.
  var elTicks = $('[data-cco-ticks]');
  var elError = $('[data-cco-error]');
  // Aviso de CAMBIO DE PRECIO (eje tiempo). Vive pegado al botón de enviar y fuera del
  // resumen, que se repinta entero en cada cotización. Es opcional a propósito: si un
  // tema viejo no trae el elemento, el aviso no se pinta pero el candado sigue
  // BLOQUEANDO el envío (nunca al revés).
  var elCambio = $('[data-cco-cambio]');
  var elOk = $('[data-cco-ok]');
  var btnSubmit = $('[data-cco-submit]');

  // Cap anti-abuso del tier ABIERTO. Espeja OPEN_TIER_CAP_CO (router-co.js:102).
  // El servidor clampa igual, así que esto sólo evita que el cliente vea un total
  // por 15 unidades y reciba una orden de 10.
  var CAP_UNIDADES = 10;

  function jsonDe(sel, porDefecto) {
    try {
      var el = $(sel);
      if (!el) return porDefecto;
      var v = JSON.parse(el.textContent);
      return (v == null) ? porDefecto : v;
    } catch (e) { return porDefecto; }
  }

  var LANDING = jsonDe('[data-cco-landing]', null) || {};
  var VARIANTES = jsonDe('[data-cco-variantes]', []) || [];
  var PRECIO = jsonDe('[data-cco-precio]', {}) || {};
  // ⑥ MEJORA 6 (barra de envío + tira 2x1): estado declarado ARRIBA porque lo leen
  // `payloadPedido`, `pintarTiers` y `refrescarControles`, que corren desde el arranque.
  // Apagado por defecto: sólo `m6Abrir()` lo enciende (ver el bloque ⑥ más abajo).
  var M6 = { barra: false, tira: false };
  var EXTRAS_TIRA = [];   // [{ productGid, titulo, precio, img, nombres:[a,b], lineas:[{variantId,cantidad}] }]

  // ── Dinero: COP ENTEROS ──────────────────────────────────────────────────
  // 🔴 PROHIBIDO aquí: 'es-MX', 'MXN', toFixed(2), dividir por 100.
  // Espejo EXACTO de formatearCop (envio-co.js:124): agrupado MANUAL con punto de
  // miles y CERO decimales. Nada de toLocaleString ni Intl: el separador depende
  // del ICU del navegador y un fallback a en-US pintaría '43,000', que un
  // colombiano lee como decimales — sería un PRECIO EQUIVOCADO en pantalla
  // (envio-co.js:108-114 documenta la misma decisión del lado del servidor).
  function cop(v) {
    var n = Number(v);
    if (!isFinite(n) || n < 0) return 0;
    return Math.round(n);
  }
  function money(v) {
    var n = Number(v);
    var entero = isFinite(n) ? Math.round(n) : 0;
    var negativo = entero < 0;
    var abs = Math.abs(entero);
    var agrupado = String(abs).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (negativo ? '-' : '') + '$' + agrupado;
  }
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // 🔒 EL ENVÍO DEL **ESTIMADO** — ESPEJO DECLARADO, NO UNA SEGUNDA AUTORIDAD
  // ═══════════════════════════════════════════════════════════════════════════
  // Aquí vivieron `envioCosto()`, `envioUmbral()` y `calcularEnvio()`, alimentados por
  // `settings.cod_co_envio_*` del tema: eran la SEGUNDA autoridad del dinero — si
  // alguien movía el setting y no el env (o al revés), el cliente leía un número y
  // pagaba otro. Se borraron el 2026-09-01 y NO vuelven. El resumen REAL
  // (`pintarResumen`) sigue sacando el costo, el umbral, el "te faltan $X" y el total
  // de POST /cotizar-co, que los produce con la MISMA llamada a `calcularEnvioCo` que
  // decide lo que se cobra. Esa regla no se toca ni se matiza.
  //
  // LO QUE SÍ CAMBIA (dictado del dueño 02-sep, pedido tres veces): el DESGLOSE
  // ESTIMADO —el que se ve mientras el servidor todavía no ha contestado— enseña
  // TAMBIÉN la línea de Envío. Un cliente colombiano que ve "Subtotal" y nada más no
  // sabe si va a pagar flete, y en Colombia el flete es plata real.
  //
  // Ese estimado ya mintió una vez y así es como no vuelve a hacerlo:
  //   · La vez que mintió usaba `t.precio` sin mirar las unidades (selector en 4 →
  //     $60.700 en pantalla contra $172.000 del servidor). Ahora se calcula sobre el
  //     SUBTOTAL EFECTIVO que ya usa el estimado, el que espeja `resolverTierAbiertoCo`
  //     (unitario = precio / n, cap 10) vía `unidadesEfectivas()`.
  //   · Y las dos cifras de la regla NO son literales sueltos repartidos por el
  //     archivo (así fue como se reabrió el defecto): viven AQUÍ, JUNTAS Y CON NOMBRE.
  //
  // 🔴 SON ESPEJO DE ENVIO_CO_COSTO / ENVIO_CO_UMBRAL (src/cod-co/envio-co.js:27 y :30).
  //    SI ALLÁ CAMBIAN —el env del servidor o el default del módulo— HAY QUE CAMBIARLAS
  //    AQUÍ. Ése es el precio de enseñar el envío antes de tener cotización, y por eso
  //    se paga en UN solo sitio y a la vista.
  var ENVIO_ESPEJO_COSTO = 17700;    // espejo de ENVIO_CO_COSTO  (envio-co.js:27)
  var ENVIO_ESPEJO_UMBRAL = 129000;  // espejo de ENVIO_CO_UMBRAL (envio-co.js:30)

  // Espejo EXACTO de `calcularEnvioCo` (envio-co.js:164). El umbral es INCLUSIVO
  // (`>=`, jamás `>`): exactamente $129.000 ya sale GRATIS, igual que en el servidor.
  //
  // ⚠️ LA BASE, DECLARADA (actualizada 02-sep). Es el subtotal efectivo del estimado
  // MÁS los adicionales marcados — o sea EXACTAMENTE lo que el servidor llama
  // `subtotalProductos` (orden-co.js:579-581: la suma de las líneas ya construidas,
  // pack + ticks, a precio COBRADO, después de descuento), que es el mismo número con
  // el que él llama a `calcularEnvioCo`. Antes los adicionales quedaban FUERA (porque
  // el estimado tampoco los listaba) y eso hacía la base estructuralmente MENOR: el
  // estimado sólo podía cobrar envío donde el servidor lo regalaba. Ahora el desglose
  // SÍ los lista —dictado del dueño 02-sep— así que dejarlos fuera de la base sería la
  // divergencia contraria: el cliente vería el extra sumado al subtotal y el envío
  // calculado como si no existiera. Con la misma base y la misma regla inclusiva, el
  // veredicto del estimado y el del servidor sólo pueden separarse si el metafield de
  // la página llegó RANCIO de la caché de Shopify — exposición que ya existía para el
  // precio del pack (es de donde sale `t.precio`), que no crece con este cambio, y que
  // el diseño entero contiene igual: el TOTAL sigue sin cifra y el submit sigue
  // BLOQUEADO hasta que conteste quien va a cobrar.
  // Entrada basura → `cop()` la deja en 0 → envío COBRADO, misma dirección que
  // `enteroCop` del servidor (envio-co.js:90-94).
  //
  // 🔒 Y POR ESO EL ESTIMADO SIGUE SIN PINTAR UN TOTAL CON CIFRA: la fila "Total"
  // conserva "los confirma el sistema". El único envío que MANDA es el del servidor,
  // y el submit sigue BLOQUEADO hasta que él conteste (los cinco candados intactos).
  function envioEstimado(subtotalEfectivo) {
    var s = cop(subtotalEfectivo);
    var gratis = s >= ENVIO_ESPEJO_UMBRAL;
    return { gratis: gratis, costo: gratis ? 0 : ENVIO_ESPEJO_COSTO };
  }

  // Devuelve SIEMPRE { status, body, headers }. `headers` viaja porque el 429 trae la
  // espera en `Retry-After` y hay que respetarla (MEDIO-3). ⚠️ Esa cabecera sólo se
  // puede LEER si el servidor la expone por CORS (router-co.js, corsCo hace
  // `Access-Control-Expose-Headers: Retry-After`); si un proxy la borrara, el mismo
  // dato viene en el cuerpo como `reintentarEnSeg`. Se leen los dos.
  //
  // ⏱️ `plazoMs` (21-oct-2026, incidente del iPhone del dueño): las lecturas (/cotizar-co,
  // /tira2x1-co) pasan PLAZO_LECTURA_MS. Desde el 22-oct /ordenar-co pasa PLAZO_ENVIO_MS
  // (25 s) — ver su cabecera: el envío colgado se corta, pero JAMÁS se reintenta solo.
  function api(ruta, body, plazoMs) {
    return conPlazo(function (senal) {
      var init = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
        body: JSON.stringify(body),
      };
      if (senal) init.signal = senal;
      return fetch(ENDPOINT + ruta, init).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          return { status: r.status, body: j, headers: r.headers };
        });
      });
    }, plazoMs);
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     ⏱️ NINGUNA LECTURA PUEDE DEJAR EL FORMULARIO ESPERANDO PARA SIEMPRE (21-oct-2026)
     ═══════════════════════════════════════════════════════════════════════════
     Incidente: el dueño, en Chrome de su iPhone, abrió el formulario dos veces (18:04 y
     18:16) y se quedó en «Calculando tu total…» / «Calculando tus productos…» SIN FIN.
     En nginx no llegó NADA de su teléfono, ni el OPTIONS: el `fetch` se quedó colgado
     antes de llegar al servidor (conexión que el teléfono creía viva). Y `fetch` no trae
     tiempo límite: el reintento automático y el botón «Reintentar» sólo existían para la
     petición que FALLA, no para la que se CUELGA. Medido en nginx: cada día desde el
     07-oct hay de 2 a 13 «OPTIONS de /cotizar-co sin su POST» (casi todos iPhone) — la
     misma firma: no es de hoy.

     Ahora toda lectura va con TIEMPO LÍMITE: al vencer se ABORTA (eso suelta la conexión
     colgada y el reintento sale por otra) y se entra al camino de fallo que ya existía:
     2 reintentos automáticos y luego «Reintentar».
     El ENVÍO del pedido (/ordenar-co) tiene su propio plazo, más largo y SIN reintento
     automático: ver PLAZO_ENVIO_MS justo debajo.
     `window.__CCO_PLAZO_MS` existe SÓLO para las pruebas (acorta la espera); sin él, 12 s. */
  var PLAZO_LECTURA_MS = (function () {
    var n = Number(window.__CCO_PLAZO_MS);
    return (isFinite(n) && n >= 100 && n <= 60000) ? n : 12000;
  })();

  /* ⏱️ EL ENVÍO DEL PEDIDO TAMPOCO SE QUEDA «ENVIANDO…» PARA SIEMPRE (22-oct-2026, CORDI,
     aprobado por el dueño). Si la conexión se cuelga al tocar «Finaliza tu compra», antes el
     botón quedaba en «ENVIANDO…» sin fin y la venta se perdía en silencio. Ahora, a los 25 s
     sin respuesta se ABORTA la espera, el botón vuelve a su texto y se dice «No recibimos
     respuesta. Toca para intentar de nuevo».
     🔒 POR QUÉ ESO NO DUPLICA PEDIDOS (comprobado en el servidor, router-co.js paso (10)):
        /ordenar-co reconoce un pedido repetido POR SU CONTENIDO — clave de idempotencia =
        WhatsApp + producto + escalón (+ unidades del tier abierto) + huella de los artículos
        del carrito — y la RESERVA antes de crear la orden en Shopify (src/cod/idempotencia.js,
        archivo en disco, ventana de 10 min). Un segundo envío del MISMO pedido recibe:
          · la MISMA orden (`duplicado:true`) si la primera ya se creó, o
          · 429 `pedido_en_vuelo` («Estamos registrando tu pedido, un momento») si la primera
            todavía se está creando.
        El reintento sale por este mismo `submit` con `payloadPedido()`: mismo contenido,
        misma clave. El cuerpo no lleva una clave propia: la deriva el servidor.
     🔒 NUNCA SE REINTENTA SOLO: el cliente tiene que tocar el botón otra vez.
     ⚠️ Límite declarado: la ventana del servidor es de 10 min. Un cliente que vuelva a tocar
        MÁS de 10 min después de un envío que sí llegó crearía un 2.º pedido — exactamente lo
        mismo que pasaba hasta hoy si recargaba la página y volvía a enviar.
     `window.__CCO_PLAZO_ENVIO_MS` existe SÓLO para las pruebas (acorta la espera). */
  var PLAZO_ENVIO_MS = (function () {
    var n = Number(window.__CCO_PLAZO_ENVIO_MS);
    return (isFinite(n) && n >= 100 && n <= 120000) ? n : 25000;
  })();
  var TXT_ENVIO_COLGADO = 'No recibimos respuesta. Toca para intentar de nuevo.';
  // /cart.js es del mismo dominio y casi siempre contesta en <1 s; la cobertura tiene
  // respaldo estático: no se les hace esperar tanto.
  var PLAZO_CARRITO_MS = Math.min(8000, PLAZO_LECTURA_MS);
  var PLAZO_COBERTURA_MS = Math.min(8000, PLAZO_LECTURA_MS);
  // «Pegado»: si el resumen sigue en «Calculando tu total…» este tiempo después de pedir
  // la cotización, se avisa al servidor y se fuerza la salida (reintento / «Reintentar»).
  var VIGIA_CALCULANDO_MS = PLAZO_LECTURA_MS + 3000;

  // `hacer(senal)` arranca la petición (con la señal de aborto si el navegador la tiene).
  // Sin `ms` es EXACTAMENTE `hacer(undefined)`: ni señal ni temporizador.
  function conPlazo(hacer, ms) {
    if (!(ms > 0)) return hacer(undefined);
    var ctrl = null;
    try { ctrl = (typeof AbortController === 'function') ? new AbortController() : null; } catch (e) { ctrl = null; }
    var timer = null;
    var viaje;
    // Lo que lanza ANTES de salir (armar el cuerpo) se marca `local`: no es la red.
    try { viaje = Promise.resolve(hacer(ctrl ? ctrl.signal : undefined)); }
    catch (e) { try { e.local = true; } catch (e2) { /* */ } return Promise.reject(e); }
    var limite = new Promise(function (_ok, rechazar) {
      timer = setTimeout(function () {
        timer = null;
        try { if (ctrl) ctrl.abort(); } catch (e) { /* sin aborto: la carrera ya decide */ }
        var err = new Error('plazo_vencido');
        err.plazo = true;
        rechazar(err);
      }, ms);
    });
    return Promise.race([viaje, limite]).then(
      function (v) { if (timer) { clearTimeout(timer); timer = null; } return v; },
      function (e) { if (timer) { clearTimeout(timer); timer = null; } throw e; }
    );
  }

  /* ── QUE NOS ENTEREMOS (21-oct-2026) ─────────────────────────────────────
     Aviso pequeño al servidor (`POST /salud-form`, sendBeacon en texto plano: sin
     preflight) al abrir el formulario, si se queda «Calculando» de más, si se agotan
     los reintentos o si algo lanza una excepción.
     🔒 SIN DATOS PERSONALES: motivo, handle del producto, familia del navegador y
     pantalla (ficha/carrito). La tienda la deriva el servidor del Origin. Una vez por
     motivo y por carga de página. Fire-and-forget: jamás cambia lo que ve el cliente. */
  var SALUD_SES = (function () {
    var abc = 'abcdefghijklmnopqrstuvwxyz0123456789', out = '';
    for (var i = 0; i < 12; i++) out += abc.charAt(Math.floor(Math.random() * abc.length));
    return out;
  })();
  var saludEnviado = {};
  function familiaNavegador() {
    var ua = String((navigator && navigator.userAgent) || '');
    var ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && Number(navigator.maxTouchPoints) > 1);
    if (ios) {
      if (/FBAN|FBAV|Instagram/.test(ua)) return 'iphone-app';
      if (/CriOS/.test(ua)) return 'iphone-chrome';
      if (/FxiOS/.test(ua)) return 'iphone-firefox';
      if (/EdgiOS/.test(ua)) return 'iphone-edge';
      return 'iphone-safari';
    }
    if (/Android/.test(ua)) {
      if (/FBAN|FBAV|Instagram/.test(ua) || /; wv\)/.test(ua)) return 'android-app';
      if (/SamsungBrowser/.test(ua)) return 'android-samsung';
      if (/Chrome/.test(ua)) return 'android-chrome';
      return 'android-otro';
    }
    if (/Edg\//.test(ua)) return 'pc-edge';
    if (/Firefox\//.test(ua)) return 'pc-firefox';
    if (/Chrome\//.test(ua)) return 'pc-chrome';
    if (/Safari\//.test(ua)) return 'pc-safari';
    return 'otro';
  }
  function handlePagina() {
    try {
      var ruta = String(location.pathname || '');
      var m = ruta.match(/\/products\/([^\/?#]+)/);
      if (m) return decodeURIComponent(m[1]).slice(0, 100);
      if (/\/cart\/?$/.test(ruta)) return 'carrito';
    } catch (e) { /* */ }
    return '';
  }
  function reportarSalud(motivo) {
    if (!ENDPOINT || saludEnviado[motivo]) return;
    saludEnviado[motivo] = true;
    try {
      var cuerpo = JSON.stringify({
        v: 1, pais: 'co', motivo: String(motivo), handle: handlePagina(),
        nav: familiaNavegador(), pantalla: EN_CARRITO ? 'carrito' : 'ficha', ses: SALUD_SES,
      });
      var url = ENDPOINT + '/salud-form';
      if (navigator.sendBeacon && navigator.sendBeacon(url, cuerpo)) return;
      fetch(url, { method: 'POST', body: cuerpo, keepalive: true }).catch(function () { /* */ });
    } catch (e) { /* una métrica jamás rompe el formulario */ }
  }

  /* ── VER LO QUE VE EL CLIENTE AL ENVIAR (22-oct-2026) ───────────────────────
     El código HTTP de un envío que no salió bien, reducido a una lista CERRADA (la misma
     que acepta el servidor en salud-form.js): así un estado raro no abre un motivo nuevo
     y el conteo se puede leer. `red` = el navegador ni siquiera recibió respuesta. */
  var ESTADOS_ENVIO = { 400: 1, 403: 1, 404: 1, 409: 1, 429: 1, 500: 1, 502: 1, 503: 1, 504: 1 };
  function codigoEnvio(status) {
    var s = Math.trunc(Number(status));
    if (!isFinite(s) || s <= 0) return 'red';
    if (ESTADOS_ENVIO[s]) return String(s);
    if (s >= 500 && s <= 599) return '5xx';
    if (s >= 400 && s <= 499) return '4xx';
    return 'otro';
  }

  /* ── ERRORES DE JAVASCRIPT DE NUESTROS SCRIPTS (22-oct-2026) ───────────────
     Un error que se escapa de nuestros archivos en la ficha puede dejar el botón muerto sin
     que nadie lo sepa. Se avisa con `js_error:<archivo>` —SÓLO el nombre del archivo: ni el
     mensaje ni la pila viajan (podrían arrastrar algo que escribió el cliente)—, sólo si el
     error viene de UNO de estos cinco archivos, una vez por archivo y por página y como
     mucho 5 avisos por sesión del navegador. Un solo oyente por página (`__sbErroresJs`):
     si México (landing-buda.js) ya lo puso, no se pone otro y no se cuenta dos veces. */
  var JS_NUESTRO = /\/(cod-co|meta-co|puente-landing-co|landing-buda|cod-mejoras)\.js\b/;
  var JS_TOPE_SESION = 5;
  var jsAvisosMem = 0;
  function archivoNuestro(txt) {
    var m = String(txt || '').match(JS_NUESTRO);
    return m ? m[1] + '.js' : '';
  }
  function avisarErrorJs(archivo) {
    if (!archivo) return;
    var motivo = 'js_error:' + archivo;
    if (saludEnviado[motivo]) return;
    var n = jsAvisosMem;
    try { n = Number(window.sessionStorage.getItem('sb-js-err')) || 0; } catch (e) { /* privado: memoria */ }
    if (n >= JS_TOPE_SESION) return;
    try { window.sessionStorage.setItem('sb-js-err', String(n + 1)); } catch (e) { /* */ }
    jsAvisosMem = n + 1;
    reportarSalud(motivo);
  }
  try {
    if (!window.__sbErroresJs) {
      window.__sbErroresJs = 'co';
      window.addEventListener('error', function (ev) {
        try { avisarErrorJs(archivoNuestro(ev && ev.filename) || archivoNuestro(ev && ev.error && ev.error.stack)); } catch (e) { /* */ }
      });
      window.addEventListener('unhandledrejection', function (ev) {
        try { var r = ev && ev.reason; avisarErrorJs(archivoNuestro(r && r.stack)); } catch (e) { /* */ }
      });
    }
  } catch (e) { /* sin oyente: el formulario sigue igual */ }

  // ── Tiers ────────────────────────────────────────────────────────────────
  // Normaliza lo que trae el metafield a la forma mínima que necesita la pantalla.
  // `n` y `precio` son los dos campos que el servidor exige para reconocer el tier
  // (router-co.js:1031: `t.n ?? t.unidades` y `Number(t.precio) > 0`).
  function leerTiers() {
    var brutos = (LANDING && LANDING.packs && Array.isArray(LANDING.packs.tiers))
      ? LANDING.packs.tiers : [];
    var out = [];
    brutos.forEach(function (t) {
      if (!t || typeof t !== 'object') return;
      var n = Math.trunc(Number(t.n != null ? t.n : t.unidades));
      var precio = Number(t.precio);
      if (!isFinite(n) || n < 1 || !isFinite(precio) || precio <= 0) return;
      out.push({
        n: n,
        precio: cop(precio),
        comparacion: Number(t.comparacion) > 0 ? cop(t.comparacion) : 0,
        abierto: t.abierto === true,
        // `items` sólo se usa para saber que este tier trae PIEZAS FIJAS: en ese
        // caso el servidor ignora `variantesPorUnidad` (router-co.js:1110) y no
        // hay nada que preguntarle al cliente.
        tieneItems: Array.isArray(t.items) && t.items.length > 0,
        titulo: t.titulo ? String(t.titulo) : null,
        // Para pintar la tarjeta como la mexicana: sello, destacado y % real.
        // El % NO se recalcula aquí: se toma el que el portón ya auditó contra el
        // precio vivo (landing-schema lo deriva con FLOOR, jamás promete de más).
        badge: t.badge ? String(t.badge) : '',
        // (arreglos 27-oct) la frase corta del 2x1 («Una para ti y otra para regalar»), la misma
        // que la ficha pinta bajo «HOY 2X1» (dato `packs.tiers[n=2].subtitulo`).
        subtitulo: t.subtitulo ? String(t.subtitulo) : '',
        popular: t.popular === true,
        ahorroPct: Number(t.ahorroPct) > 0 ? Math.trunc(Number(t.ahorroPct)) : 0,
      });
    });
    out.sort(function (a, b) { return a.n - b.n; });
    return out;
  }

  var TIERS = leerTiers();

  /* ═══════════════════════════════════════════════════════════════════════════
     🔒 ¿ESTE PRODUCTO TIENE ESCALERA EN EL METAFIELD? — ESPEJO DEL SERVIDOR
     ═══════════════════════════════════════════════════════════════════════════
     Espejo EXACTO de `!tiers.length` (router-co.js:1201), la condición con la que el
     servidor decide SINTETIZAR un tier al vuelo: sin escalera cotiza el `n` que se le
     pida al PRECIO VIVO de la variante (`precio: precioVivo * nPedido`,
     router-co.js:1214-1219). O sea que en esos productos NO hay «paquetes»: el pedido
     se cobra por unidad y cualquier cantidad es válida.

     🔴 SE CUENTA EL ARRAY **CRUDO**, NO `TIERS` (que `leerTiers` ya filtró). Con un
     metafield que trae tiers pero todos inválidos (precio 0, `n` basura) el cliente se
     queda sin escalera y el servidor **NO sintetiza nada** (`tiers.length` es > 0 para
     él): pedirle 6 unidades devolvería `oferta_no_disponible`. Contar el crudo falla del
     lado cerrado — que es el único aceptable aquí. */
  var TIERS_CRUDOS_N = (LANDING && LANDING.packs && Array.isArray(LANDING.packs.tiers))
    ? LANDING.packs.tiers.length : 0;
  var SIN_ESCALERA = TIERS_CRUDOS_N === 0;

  // Fallback cuando el producto no trae metafield: un tier de 1 unidad al precio
  // de lista de Shopify. Es SÓLO display — si ese tier tampoco existe en el
  // metafield del servidor, /ordenar-co responde `oferta_no_disponible` y el
  // cliente lee el motivo. Fail-closed: un producto sin alta COD no se pide.
  //
  /* 🔑 `porUnidad` — EL ARREGLO DE F1 (2026-09-10), Y POR QUÉ NO ES `abierto:true`.
     Hasta hoy este tier era CERRADO y de 1 unidad, así que un carrito con 6 piezas de
     un producto sin escalera se cotizaba por UNA: medido en la tienda viva, 6 ×
     BRAZALETE AMAZONITA que Shopify cobra $198.660 con envío gratis salían del
     formulario como «×1 · TOTAL $65.000» — $133.660 menos y 5 piezas sin despachar,
     SIN un solo aviso en pantalla. Y no era un borde: 57 de los 63 productos activos
     no tienen escalera.

     `porUnidad` significa «este tier escala como el abierto PERO su cantidad viaja en
     el `n`». Es una bandera propia y NO se reusa `abierto`, porque las dos cosas se
     resuelven en sitios distintos del servidor y confundirlas vuelve a perder el
     dinero en silencio:
       · `abierto:true` sólo escala si el TIER DEL METAFIELD lo declara
         (`tierMeta?.abierto === true`, router-co.js:914). El tier sintetizado NO lo
         declara → `resolverTierAbiertoCo` devuelve `unidades: n` y cobra 1: exactamente
         el defecto que se viene a cerrar, pero ahora con el cliente diciendo 6.
       · lo que el servidor sí lee es `b.tier.n` (router-co.js:1184) para construir el
         tier: ahí la cantidad tiene que ir en el `n`. Lo hace `nParaElServidor()`.
     Verificado EN VIVO contra POST /cotizar-co (endpoint que no crea nada) el 10-sep:
     con `tier.n=1` → total $65.000; con `tier.n=6` → subtotal $283.800, descuento
     «A&M❤️» $85.140, envío GRATIS, **total $198.660** = el peso exacto de Shopify. */
  if (!TIERS.length) {
    TIERS = [{
      n: 1,
      precio: cop(PRECIO.precio),
      comparacion: Number(PRECIO.comparacion) > 0 ? cop(PRECIO.comparacion) : 0,
      abierto: false,
      porUnidad: SIN_ESCALERA,
      tieneItems: false,
      titulo: null,
    }];
  }

  /* ── UN SOLO PREDICADO PARA «ESTE TIER ACEPTA MÁS UNIDADES» ────────────────
     Lo consultan el stepper, la aritmética de la tarjeta, la herencia del carrito y el
     pintado. Con dos banderas repartidas por el archivo, el día que alguien toque una
     rama y no la otra el formulario volvería a enseñar un número y a pedir otro. */
  function escalaPorUnidad(t) {
    return !!t && (t.abierto === true || t.porUnidad === true);
  }

  /* 🔒 EL `n` QUE VIAJA AL SERVIDOR. Ver la nota de `porUnidad`: en la escalera del
     metafield el servidor BUSCA el tier por `n` y el `unidades` sólo escala si ESE tier
     es abierto; en un producto sin escalera no hay nada que buscar y el `n` ES la
     cantidad. Esta función es la ÚNICA traducción entre el modelo de la pantalla y el
     del servidor: si mañana se añade otra forma de escalar, se añade aquí. */
  function nParaElServidor(t, u) {
    return (t && t.porUnidad === true) ? u : t.n;
  }

  // ── ¿ESTA ESCALERA TIENE UN 2x1? ─────────────────────────────────────────
  // ESPEJO de DOSXUNO_RE / esTier2x1 (src/landing/landing-schema.js:680-688), el
  // criterio canónico de la casa para «este tier es un 2x1»: mira el TEXTO, no una
  // bandera, porque el texto es lo que el cliente lee y por lo que reclama. No se puede
  // importar —ese módulo es Node/ESM y además vive del lado mexicano— y aquí corre un
  // navegador. El patrón ya está DOS veces en este archivo (TICK_MAX espeja TICK_MAX_CO,
  // CAP_UNIDADES espeja OPEN_TIER_CAP_CO) y va SIEMPRE con un assert que fija los dos
  // literales (scripts/test-cod-co-tema.mjs, sección 14): sin él, el día que alguien
  // amplíe el regex canónico —un «3x2», por ejemplo— la nota deja de salir EN SILENCIO.
  var DOSXUNO_RE_CO = /2\s*[x×]\s*1|2\s*por\s*1|compra\s*1\s*(?:y\s*)?lleva\s*2|lleva\s*2\s*(?:y\s*)?paga\s*1/i;

  // Se prueba CAMPO POR CAMPO, igual que el canónico (`textos.some(...)`), no sobre los
  // dos concatenados: un «compra 1» al final del título con un «lleva 2» al principio
  // del badge casaría a caballo del corte y se inventaría un 2x1 que nadie escribió.
  // ⚠️ DIVERGENCIA DECLARADA: esTier2x1 mira `titulo`, `etiqueta` y `badge`; aquí sólo
  // hay los dos primeros nombres porque `leerTiers` no conserva `etiqueta` (el contrato
  // del metafield exige `titulo`, landing-schema.js:1617). Un metafield escrito a mano
  // que ponga el «2x1» SÓLO en `etiqueta` no dispara la nota: FAIL-CLOSED — la nota no
  // sale, que es la dirección segura, nunca al revés.
  function esTier2x1Co(t) {
    if (!t || Math.trunc(Number(t.n)) !== 2) return false;
    return [t.titulo, t.badge].some(function (x) { return DOSXUNO_RE_CO.test(String(x || '')); });
  }
  var HAY_2X1 = TIERS.some(esTier2x1Co);

  // ── ADICIONALES TIPO TICK (casilla + foto) ───────────────────────────────
  // 🔒 EL ÍNDICE ES EL CONTRATO. El voto viaja como `upsells.ticks[idx]` y el servidor
  // resuelve el precio leyendo `landing.upsellTick[idx]` DEL METAFIELD. Si esta
  // pantalla numerara distinto que él, el cliente marcaría un adicional y se le
  // cobraría OTRO. Por eso la normalización se copia EXACTA de resolverTicksAceptadosCo
  // (router-co.js:700-701): objeto suelto → [objeto] (forma legacy del metafield),
  // array → tal cual, y luego `.slice(0, TICK_MAX_CO)`.
  var TICK_MAX = 4;   // espejo de TICK_MAX_CO (router-co.js:115)
  var TICKS = (function () {
    var m = LANDING ? LANDING.upsellTick : null;
    var arr = Array.isArray(m) ? m : (m ? [m] : []);
    return arr.slice(0, TICK_MAX);
  })();

  // Un tick SIN título el servidor lo descarta (router-co.js:711-712) y NO renumera los
  // que vienen detrás: recorre con `forEach((um, idx))` sobre el array ya cortado. Aquí
  // se hace lo mismo — no se pinta, pero su índice se respeta.
  function tickPintable(t) {
    return !!t && typeof t === 'object' &&
      String(t.titulo == null ? '' : t.titulo).trim() !== '';
  }

  // La foto sólo se pinta si es http(s), igual que exige el contrato del metafield
  // (landing-schema.js, validarTickItem). No es paranoia de XSS —esc() ya cierra el
  // atributo y un <img src> no ejecuta— sino de no dejar un hueco roto en la tarjeta.
  function tickImagen(t) {
    var u = (t && t.imagen != null) ? String(t.imagen).trim() : '';
    return /^https?:\/\//i.test(u) ? u : '';
  }

  // Estado del voto, indexado por el MISMO índice del array normalizado.
  //
  // 🔒 SÓLO PUEDE VALER `true` UN ÍNDICE QUE ESTA PANTALLA PINTA DE VERDAD.
  // `marcadoDefault` se honra —la casilla nace marcada, como en el molde mexicano—
  // porque ahora el cliente LO VE marcado, lo ve en la lista `items` del resumen y lo
  // ve en el total del botón. Eso es justo lo que el ALTO A-1 exigía y lo que antes no
  // ocurría: allí el tick se cobraba sin que ninguna pantalla lo mostrara jamás.
  //
  // 🔒 …Y POR ESO EXIGE TAMBIÉN EL ANCLA. Si el tema montado es VIEJO y no trae
  // `[data-cco-ticks]`, no hay ninguna tarjeta que enseñar — y un `marcadoDefault` que
  // naciera votado ahí sería EL MISMO DEFECTO otra vez, con el agravante de que nadie
  // podría desmarcarlo. Sin ancla, todos los votos nacen en NO y se quedan en NO.
  var ticksState = {};
  TICKS.forEach(function (t, i) {
    ticksState[i] = !!elTicks && tickPintable(t) && t.marcadoDefault === true;
  });

  // 🔒 EL PREDICADO DEL VOTO, EN UN SOLO SITIO. Lo usan `upsellsElegidos()` —lo que
  // VIAJA al servidor— y la lista de adicionales del desglose ESTIMADO. Si fueran dos
  // condiciones distintas, la pantalla podría enseñar (o cobrarse en el estimado) un
  // extra que el pedido no lleva, o al revés: ésa es la clase exacta del ALTO A-1.
  // Las tres condiciones se conservan tal cual: sin ancla no hay tarjeta que enseñar,
  // sin título el servidor lo descarta, y el estado sólo se escribe desde la casilla.
  function tickVotado(t, i) {
    return !!elTicks && tickPintable(t) && ticksState[i] === true && !tickYaEnCarrito(t);
  }

  /* ── 🔴 QUE NADIE PAGUE EL EMPAQUE DOS VECES (10-sep, §5) ──────────────────
     Desde hoy el empaque de regalo se puede meter al carrito como LÍNEA, desde el
     bloque nativo de /cart (`snippets/empaque-co.liquid`). Y una línea del carrito la
     cotiza el servidor como EXTERNO. Así que si el cliente marca además la casilla del
     MISMO empaque en este formulario, se le cobra DOS VECES la misma caja — que es
     exactamente el defecto que este archivo ya documenta de la app «Essential Upsell»
     («el cliente que marca la casilla Y pulsa + Agregar paga el empaque DOS VECES»),
     sólo que ahora es alcanzable con NUESTRO propio bloque, y en la misma página.

     Medido el 10-sep contra el metafield vivo: SEIS productos con `codPropio: true`
     llevan este tick, y los seis traen
     `variantId: "gid://shopify/ProductVariant/46292863090827"` — o sea que el camino
     que se usa de verdad es el del GID, no el del fail-open de abajo.

     🔒 FAIL-OPEN: si el tick NO declara `variantId` (el contrato del metafield lo
        permite: sin él el servidor crea una línea custom en vez de una línea real) no
        hay forma de saber si es el mismo artículo, y se sigue ofreciendo. Perder la
        oferta a ciegas sería peor que el riesgo, y el servidor cotiza lo que se le
        manda, no lo que esta pantalla adivina.

     🔒 SE USA EN LOS DOS SITIOS QUE COMPARTEN EL PREDICADO —`tickVotado` (lo que VIAJA
        y lo que se enseña en el desglose) y `pintarTicks` (la tarjeta)—, nunca en uno
        solo: si divergieran, la pantalla enseñaría un extra que el pedido no lleva, que
        es la clase exacta del ALTO A-1 ya documentado arriba.                        */
  function tickYaEnCarrito(t) {
    var vid = (t && t.variantId != null) ? String(t.variantId).replace(/^.*\//, '') : '';
    if (!/^\d+$/.test(vid)) return false;
    for (var e = 0; e < EXTERNOS.length; e++) if (EXTERNOS[e].variantId === vid) return true;
    return false;
  }

  /* ── CUÁNTAS UNIDADES DEL ADICIONAL (dictado del dueño 04-sep) ─────────────
     «Por si hay clientes que llevan varios productos y quieren llevar varias cajitas».
     Va en un mapa APARTE del voto: `ticksState` sigue siendo el sí/no de siempre, así
     que ningún camino que ya funcionaba cambia de forma. La cantidad sólo tiene sentido
     cuando el voto es SÍ, y por eso `tickCantidad` devuelve 0 si no está votado.
     🔒 El tope espeja TICK_QTY_MAX_CO del servidor. Aquí es sólo para que el botón «+»
     deje de sumar; quien de verdad clampa es el servidor, que no se fía de esta
     pantalla. Si los dos números se separan, manda el servidor y el cliente ve el
     recorte en el resumen antes de poder enviar. */
  var TICK_QTY_MAX = 10;
  var ticksQty = {};
  function tickCantidad(t, i) {
    if (!tickVotado(t, i)) return 0;
    var n = Math.trunc(Number(ticksQty[i]));
    if (!isFinite(n) || n < 1) n = 1;
    return Math.min(n, TICK_QTY_MAX);
  }

  // Los adicionales VOTADOS con su precio del metafield, para el desglose ESTIMADO.
  // 🔴 SÓLO DISPLAY, y sólo mientras el servidor no ha contestado: cuando llega la
  // cotización, `pintarResumen` pinta los `items` que él manda (que son los que se
  // cobran) y esta lista desaparece. El precio del adicional lo sigue poniendo el
  // servidor desde el metafield; aquí se lee el mismo campo sólo para poder ENSEÑARLO.
  function ticksEstimados() {
    var out = [];
    TICKS.forEach(function (t, i) {
      if (!tickVotado(t, i)) return;
      var precio = cop(t.precio);
      out.push({
        titulo: String(t.titulo).trim(),
        precio: precio,
        qty: tickCantidad(t, i),
        comparacion: (Number(t.comparacion) > precio) ? cop(t.comparacion) : 0,
      });
    });
    return out;
  }

  var tierIdx = 0;
  var unidadesElegidas = TIERS[0].n;   // sólo diverge de tier.n en tier ABIERTO

  function tierActual() { return TIERS[tierIdx]; }

  // Unidades efectivas del pedido. Espeja resolverTierAbiertoCo (router-co.js:526):
  // sólo escala si el metafield marca `abierto:true` y el cliente pidió MÁS que n.
  function unidadesEfectivas() {
    var t = tierActual();
    if (escalaPorUnidad(t) && unidadesElegidas > t.n) return Math.min(unidadesElegidas, CAP_UNIDADES);
    return t.n;
  }

  // ── EL PRECIO DE UN TIER PARA UNAS UNIDADES DADAS ────────────────────────
  // 🔒 ÚNICA COPIA DE LA ARITMÉTICA DE TIER EN ESTE ARCHIVO. Espeja
  // `resolverTierAbiertoCo` (router-co.js:611-618): en el tier ABIERTO el unitario es
  // `precio / n` y el total `enteroCop(unitario × unidades)`; la `comparacion` escala
  // IGUAL —misma división, mismo redondeo, mismo `cop()`— porque el servidor la escala
  // en la MISMA función (router-co.js:617) y la manda escalada al desglose
  // (router-co.js:948 `tierMetaDesglose`). En el tier CERRADO `t.precio` YA es el precio
  // del pack completo: no se multiplica por nada.
  //
  // 🔒 NO ES DINERO NUEVO NI UNA SEGUNDA AUTORIDAD. Es EXACTAMENTE la cuenta que
  // `pintarEstimado` ya hacía en línea, extraída aquí para que la TARJETA de la oferta
  // abierta y el desglose estimado NO PUEDAN decir números distintos sobre el mismo
  // pedido — que es justo lo que pasaba: el desglose respetaba el stepper y la tarjeta
  // se quedaba clavada en el precio de `n` ("3 o más" seguía diciendo $58.050 con el
  // stepper en 4). El total que se COBRA lo sigue diciendo /cotizar-co, siempre.
  function precioTierEscalado(t, u) {
    // 🔒 EL TOPE VA AQUÍ DENTRO, no en los llamadores. El servidor capa las unidades
    // ANTES de multiplicar (resolverTierAbiertoCo, router-co.js:611:
    // `Math.min(pedidas, OPEN_TIER_CAP_CO)`), así que una copia sin cap sobrecobra en
    // pantalla: con u=11 daría $212.850 donde el servidor cobra $193.500. Hoy los dos
    // llamadores pasan valores ya capados y es inalcanzable — pero un tercer call site
    // con un número crudo reabriría la divergencia, y esta función es la ÚNICA
    // aritmética de tier del archivo: el candado tiene que vivir en ella.
    var uCap = Math.max(1, Math.min(Number(u) || 1, CAP_UNIDADES));
    u = uCap;
    // `porUnidad` entra por la MISMA puerta: el precio de N unidades de un producto sin
    // escalera es `precioVivo × N`, que es literalmente `(t.precio / 1) * u`, la misma
    // cuenta del tier abierto. Espeja `precio: precioVivo * nPedido` (router-co.js:1216).
    var escalado = !!t && escalaPorUnidad(t) && u > t.n;
    return {
      escalado: escalado,
      precio: escalado ? cop((t.precio / t.n) * u) : cop(t.precio),
      // Sin comparación real (o menor que el precio) no hay tachado: devolver 0 evita
      // que nadie tenga que repetir la condición `comparacion > precio` aguas abajo.
      comparacion: (t && t.comparacion > t.precio)
        ? (escalado ? cop((t.comparacion / t.n) * u) : cop(t.comparacion))
        : 0,
    };
  }

  // `totalPack()` y `comparacionPack()` también se borraron (2026-09-01): eran el
  // otro trozo de aritmética local. El total del pack lo dice la cotización.

  // ── EL STEPPER DE CANTIDAD ───────────────────────────────────────────────
  // 🔴 VIVE DENTRO DE LA TARJETA DEL TIER ABIERTO (dictado del dueño 02-sep, molde
  // mexicano). Antes colgaba de `elUnidades`, fuera de la escalera.
  //
  // 🔒 LO QUE **NO** CAMBIA ES LA FUENTE DEL DATO. Las unidades del pedido siguen
  // saliendo de `unidadesElegidas` → `unidadesEfectivas()`, que es EXACTAMENTE lo que
  // arma `payloadPedido()` (lo que se cotiza y lo que se pide) y lo que rotula el
  // desglose estimado. Aquí sólo se mueve la PIEL: mover el control no mueve el número.
  function stepperHtml(u) {
    return '<div class="cco-step">' +
      '<span class="cco-step__lbl">Cantidad</span>' +
      '<button type="button" class="cco-step__b" data-cco-menos aria-label="Quitar una">−</button>' +
      '<span class="cco-step__n" data-cco-cant>' + u + '</span>' +
      '<button type="button" class="cco-step__b" data-cco-mas aria-label="Agregar una">+</button>' +
      '</div>';
  }

  /* 🛒 (26-oct, dueño punto 11) EL PAQUETE ELEGIDO, PARA LA BARRA DE ENVÍO GRATIS DE LA FICHA.
     La barra (meta-co.js) lee el CARRITO, y en las fichas 2x1 el paquete se pide por este
     formulario: el carrito está vacío y decía «agrega productos para empezar» con el 2x1
     ya marcado. Aquí sólo se PUBLICA el precio que ya pintan las tarjetas (el mismo de
     `precioTierEscalado`); meta-co.js decide el texto. Nunca viaja al servidor. */
  function publicarPack() {
    try {
      if (EN_CARRITO) return;
      var t = tierActual();
      if (!t) return;
      var u = unidadesEfectivas();
      // En las fichas con LANDING (las del 2x1) lo que el cliente ve marcado mientras el
      // formulario está cerrado es la tarjeta de la landing (`.lb-tier.is-active`, la
      // misma que el puente hereda al abrir): se cuenta ésa.
      if (modal.hidden) {
        var land = document.querySelector('.lb-tier.is-active') || document.querySelector('.lb-tier[data-tier-popular="true"]');
        var un = land ? (parseInt(land.getAttribute('data-tier-unidades'), 10) || parseInt(land.getAttribute('data-tier-n'), 10)) : NaN;
        if (un > 0) {
          for (var j = 0; j < TIERS.length; j++) {
            if (TIERS[j].n === un || (escalaPorUnidad(TIERS[j]) && TIERS[j].n < un && TIERS[j].abierto)) { t = TIERS[j]; u = un; break; }
          }
        }
      }
      var pr = precioTierEscalado(t, u);
      var det = { precio: pr.precio, unidades: u, es2x1: esTier2x1Co(t) };
      window.CcoPack = det;
      document.dispatchEvent(new CustomEvent('cco:pack', { detail: det }));
    } catch (e) { /* la barra sigue con el carrito */ }
  }
  // La tarjeta de la landing cambia sin pasar por aquí: se vuelve a publicar tras su clic.
  try {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.lb-tier')) setTimeout(publicarPack, 0);
    }, true);
    // La landing pinta sus tarjetas con su propio script: al terminar de cargar, otra vez.
    window.addEventListener('load', function () { setTimeout(publicarPack, 0); });
    document.addEventListener('DOMContentLoaded', function () { setTimeout(publicarPack, 0); });
  } catch (e) { /* */ }
  function pintarTiers() {
    publicarPack();
    // ⚠️ CON UN SOLO TIER NO HAY ESCALERA QUE PINTAR… PERO SÍ PUEDE HABER STEPPER.
    // Mientras vivió en `elUnidades`, el stepper sobrevivía a este `return` temprano.
    // Ahora vive aquí, así que un producto con UN único tier ABIERTO se quedaría sin
    // ningún control de cantidad y su pedido clavado en el mínimo del pack. Se pinta
    // la tarjeta con el stepper solo.
    if (TIERS.length < 2) {
      var unico = tierActual();
      // Desde el arreglo de F1 esta rama también atiende al producto SIN ESCALERA
      // (`porUnidad`): antes se iba por el `return` de abajo con `elTiers.hidden = true`,
      // así que 57 de los 63 productos activos no tenían NINGÚN control de cantidad
      // dentro del formulario — ni forma de ver, ni de corregir, por cuántas unidades
      // iba el pedido.
      if (escalaPorUnidad(unico)) {
        // Los chips de variante van DENTRO de la tarjeta también aquí (dictado del
        // dueño 09-sep). Es la única tarjeta que existe en este camino, así que si no
        // entraran aquí un producto de un solo tier ABIERTO se quedaría eligiendo la
        // variante fuera del cuadro — justo lo que se vino a corregir.
        elTiers.innerHTML = '<div class="cco-tier-card cco-tier-card--on cco-tier-card--solo">' +
          bloqueChipsHtml(unidadesEfectivas()) +
          stepperHtml(unidadesEfectivas()) + '</div>';
        elTiers.hidden = false;
        refrescarControles();
        return;
      }
      elTiers.innerHTML = '';
      elTiers.hidden = true;
      return;
    }
    var img = imgTarjeta();
    var h = '';
    TIERS.forEach(function (t, i) {
      var on = (i === tierIdx);

      // ── LA TARJETA ABIERTA ENSEÑA EL PRECIO DE LA CANTIDAD ELEGIDA ────────
      // (dictado del dueño 02-sep). Antes toda tarjeta pintaba `t.precio`, o sea el
      // precio de `n` unidades: "3 o más con el 55% OFF" seguía diciendo $58.050 con el
      // stepper en 4, mientras el desglose de abajo —que sí respeta el stepper— decía
      // $77.400. Dos números para el mismo pedido en la misma pantalla.
      //
      // 🔒 SÓLO ESCALA LA ABIERTA **Y ELEGIDA**, y es la misma condición con la que
      // aparece el stepper tres líneas más abajo: las unidades sólo significan algo en
      // el pack que el cliente tiene seleccionado (`unidadesElegidas` se reinicia a
      // `TIERS[i].n` al cambiar de tier). Las cerradas —y la abierta no elegida— siguen
      // enseñando su precio de pack, que es lo que se cobraría si se eligieran.
      //
      // 🔒 Y SE REPINTA SOLA AL MOVER EL STEPPER: `ajustarUnidades` ya llamaba a
      // `pintarTiers()` para actualizar el número de la cantidad, así que el precio
      // viaja con él sin un solo emisor nuevo.
      var uCard = (escalaPorUnidad(t) && on) ? unidadesEfectivas() : t.n;
      var pr = precioTierEscalado(t, uCard);
      // La etiqueta de respaldo (cuando el metafield no trae `titulo`) dice las unidades
      // de la tarjeta, no las del tier: "3 unidades · $77.400" sería la misma
      // contradicción con otra cara. Un `titulo` escrito por el dueño no se toca.
      var etiqueta = t.titulo || (uCard + (uCard === 1 ? ' unidad' : ' unidades'));
      // ── (arreglos 27-oct) LA MISMA ESCALERA QUE LA FICHA ──────────────────────
      // En productos CON 2x1 (HAY_2X1) la tarjeta dice su descuento igual que «Elige tu
      // oferta» de la ficha aprobada por el dueño: 1 unidad → «-20%» pequeño junto al nombre y
      // SIN tachado; 2x1 → tachado + «50% OFF · Ahorras $X» destacado (sin la píldora
      // «compra 1 lleva 2», que ya dice el «HOY 2X1»); 3 o más → «3 o más» + «55% OFF» junto al
      // nombre, con tachado. El % es el auditado (`t.ahorroPct`); si faltara se deriva con FLOOR
      // de los MISMOS precios de la tarjeta (jamás promete de más). Sin 2x1, todo como antes.
      var fichaLike = HAY_2X1;
      var pctT = t.ahorroPct || ((pr.comparacion > pr.precio) ? Math.floor(100 - pr.precio * 100 / pr.comparacion) : 0);
      if (fichaLike && t.n >= 3) etiqueta = String(etiqueta).replace(/\s*con el\s*\d+\s*%\s*OFF/i, '').trim() || etiqueta;
      // El AHORRO escala con el precio: un precio de 4 unidades junto a un ahorro de 3
      // haría que la tarjeta se contradijera sola.
      var ahorro = (pr.comparacion > pr.precio) ? (pr.comparacion - pr.precio) : 0;

      // La TARJETA es ahora un <div> envolvente y el <button> queda dentro, sin borde:
      // el stepper lleva sus PROPIOS <button>, y un <button> dentro de otro es HTML
      // inválido que el navegador desanida en silencio (los sacaría fuera de la
      // tarjeta y el clic dejaría de llegar donde toca). Así el botón del tier sigue
      // siendo un botón de verdad — foco, Enter/Espacio y `disabled` incluidos.
      // `data-cco-card` hace CLICABLE TODA la tarjeta, y no es un adorno: desde hoy la
      // fila «Ahorras…» vive FUERA del <button> (ver la nota de abajo), así que sin este
      // repuesto el cliente podría tocar el 50% OFF y no pasar nada. Lo atiende el
      // listener de `elTiers` como ÚLTIMO recurso, después del stepper y de los chips.
      h += '<div class="cco-tier-card' + (on ? ' cco-tier-card--on' : '') +
        (t.popular ? ' cco-tier-card--pop' : '') + '" data-cco-card="' + i + '">';
      if (t.popular) h += '<span class="cco-tier__pop">MÁS POPULAR</span>';
      // `data-cco-tier-n` / `data-cco-tier-abierto` son la SUPERFICIE que lee el
      // puente de la landing (puente-landing-co.js) para heredar la opción que el
      // cliente eligió fuera: necesita saber cuántas unidades vale cada tarjeta y
      // cuál acepta stepper. Se publica el DATO ya normalizado por `leerTiers`, no
      // uno nuevo: así el puente no tiene que volver a mirar el metafield ni copiar
      // ninguna regla. Sigue sin viajar un solo precio en el DOM del botón.
      h += '<button type="button" class="cco-tier" data-cco-tier="' + i + '"' +
        ' data-cco-tier-n="' + t.n + '"' + (t.abierto ? ' data-cco-tier-abierto="1"' : '') +
        ' aria-pressed="' + (on ? 'true' : 'false') + '">';
      h += '<span class="cco-tier__fila">';
      h += '<span class="cco-tier__radio" aria-hidden="true"></span>';
      if (img) h += '<span class="cco-tier__thumb"><img src="' + esc(img) + '" alt="" loading="lazy"></span>';
      if (fichaLike) {
        var dtoNom = '';
        if (pctT > 0 && t.n === 1) dtoNom = '<span class="cco-tier__dto cco-tier__dto--chico">-' + pctT + '%</span>';
        else if (pctT > 0 && t.n >= 3) dtoNom = '<span class="cco-tier__dto cco-tier__dto--grande">' + pctT + '% OFF</span>';
        h += '<span class="cco-tier__mid">' +
               '<span class="cco-tier__n cco-tier__n--fila">' + esc(etiqueta) + dtoNom + '</span>' +
               (t.n === 2 && t.subtitulo ? '<span class="cco-tier__sub">' + esc(t.subtitulo) + '</span>' : '') +
             '</span>';
      } else {
      h += '<span class="cco-tier__mid">' +
             '<span class="cco-tier__n">' + esc(etiqueta) + '</span>' +
             (t.badge ? '<span class="cco-tier__badge">' + esc(t.badge) + '</span>' : '') +
           '</span>';
      }
      // Precio y TACHADO, los dos de `pr`: el tachado tiene que escalar con el precio o
      // la tarjeta enseñaría el "antes" de 3 unidades sobre el "ahora" de 4 — que es
      // exactamente inventarse un descuento.
      h += '<span class="cco-tier__precios">' +
             '<span class="cco-tier__p">' + money(pr.precio) + '</span>' +
             (pr.comparacion > pr.precio && !(fichaLike && t.n === 1) ? '<s class="cco-tier__was">' + money(pr.comparacion) + '</s>' : '') +
           '</span>';
      h += '</span>';   // fila
      // 🔴 EL BOTÓN SE CIERRA AQUÍ, DESPUÉS DE LA FILA (dictado del dueño 09-sep: «la
      // variante tiene que ir ADENTRO del cuadro donde dice 2x1»). Los chips son
      // <button> y un <button> dentro de otro es HTML inválido que el navegador desanida
      // en silencio —los sacaría de la tarjeta y el clic dejaría de llegar donde toca—,
      // que es exactamente la trampa que ya documentó el stepper el 02-sep. Así que el
      // botón del tier se queda con la fila (nombre, precio y radio) y lo que va debajo
      // —chips, «Ahorras», stepper— son HERMANOS suyos dentro de la tarjeta. La tarjeta
      // entera sigue siendo clicable por `data-cco-card`.
      h += '</button>';
      // (arreglos 27-oct) 2x1 con la escalera de la ficha: la etiqueta destacada va justo bajo
      // la fila nombre/precio y antes de las unidades, como en «Elige tu oferta».
      if (fichaLike && t.n === 2 && ahorro > 0 && pctT > 0) {
        h += '<span class="cco-tier__dto-fila"><span class="cco-tier__dto cco-tier__dto--grande">' + pctT +
             '% OFF <span class="cco-tier__dto-sep">·</span> Ahorras ' + money(ahorro) + '</span></span>';
      }
      // LOS CHIPS, SÓLO EN LA TARJETA ELEGIDA y entre el título y «Ahorras…»: en una
      // tarjeta que no está seleccionada la variante no querría decir nada (el pedido no
      // va por ahí) y tres juegos de chips convertirían la escalera en un formulario.
      if (on) h += bloqueChipsHtml(unidadesEfectivas());
      if (ahorro > 0 && !fichaLike) {
        // ⚠️ EL `%` NO SE RECALCULA, Y NO ES UN OLVIDO. Escalar multiplica precio y
        // comparación por el MISMO factor (`u / n`, la cuenta del servidor), así que la
        // RAZÓN entre los dos —o sea el porcentaje— no cambia: 55% de 3 unidades es 55%
        // de 4. El que se pinta sigue siendo `t.ahorroPct`, el que el portón de la
        // landing ya auditó contra el precio vivo con FLOOR (jamás promete de más);
        // derivarlo aquí sobre dos cifras redondeadas sólo podría inventarse un punto
        // de descuento que nadie auditó. Lo que sí escala es el IMPORTE, arriba.
        h += '<span class="cco-tier__save">' +
               '<span class="cco-tier__save-amt">Ahorras ' + money(ahorro) + '</span>' +
               (t.ahorroPct ? '<span class="cco-tier__save-pct">' + t.ahorroPct + '% OFF</span>' : '') +
             '</span>';
      }
      // El stepper sólo en el tier ABIERTO Y ELEGIDO: cambiar la cantidad de un pack
      // que no está seleccionado no querría decir nada. Misma condición que tenía
      // `pintarUnidades` (`if (t.abierto)` sobre el tier ACTUAL), así que el stepper
      // aparece y desaparece exactamente cuando aparecía y desaparecía antes.
      if (escalaPorUnidad(t) && on) h += stepperHtml(unidadesEfectivas());
      h += '</div>';   // tarjeta
    });

    // ── LA LETRA PEQUEÑA DEL 2x1 (dictado del dueño 08-sep) ────────────────
    // Va DENTRO del innerHTML de la escalera —no en cod-co.liquid— y eso es lo que la
    // hace honesta en las TRES pantallas donde vive este modal:
    //   · SIN ESCALERA no se pinta (el `return` temprano de arriba, cuando hay menos de
    //     dos tiers): una nota estática no tendría a qué referirse.
    //   · EN EL ÉXITO desaparece con `elTiers.hidden = true`. Un <p> en el snippet
    //     heredaría el defecto de `.cco-oferta`, que ese camino NO oculta, y quedaría
    //     poniéndole una restricción a un pedido ya cerrado.
    //   · MIENTRAS EL MODAL SIGA EN MODO CARRITO se apaga con la escalera, porque el
    //     selector `[data-cco-en-carrito] [data-cco-tiers]` (cod-co.css) la alcanza al
    //     vivir dentro: allí la cantidad y el precio ya los decidió el carrito.
    //     ⚠️ Y cuando `aplicarCarrito` DESTAPA la escalera —el carrito no cuadra, o no se
    //     pudo leer: «falla del lado de enseñar de más»— la nota vuelve con ella, que es
    //     lo correcto: si el cliente puede elegir el 2x1 desde aquí, tiene que leer su
    //     letra pequeña.
    // Y sólo si el producto TIENE un 2x1: anunciar la restricción de una promoción que
    // no existe insinúa que existe.
    // ⑥ D3 (dueño 08-oct: «actualmente no hay más descuentos, solo están los 2x1»): con la
    // tira 2x1 encendida esta línea SE QUITA —se leía como contradicción encima de una
    // tira que suma otro 2x1— y no se reemplaza por otra más larga.
    if (HAY_2X1 && !M6.tira) h += '<p class="cco-nota-2x1">El 2x1 no es acumulable con otros descuentos de la tienda.</p>';
    elTiers.innerHTML = h;
    elTiers.hidden = false;
    refrescarControles();   // el innerHTML nuevo nace sin el `disabled` (MEDIO-A)
  }

  // ± del stepper. Se extrae a su propia función porque ahora la llama el listener de
  // `elTiers` (el stepper vive dentro de la tarjeta) y no el de `elUnidades`.
  function ajustarUnidades(mas) {
    var t = tierActual();
    if (!escalaPorUnidad(t)) return;
    var u = unidadesEfectivas();
    // Piso = n del tier (no 1): por debajo de eso el pack deja de ser ese pack.
    var nuevo = mas ? Math.min(CAP_UNIDADES, u + 1) : Math.max(t.n, u - 1);
    // En el tope o en el piso no ha cambiado nada: repintar y recotizar sólo gastaría
    // una llamada contra un rate-limit que bajo CGNAT se comparte con otros compradores.
    if (nuevo === u) return;
    unidadesElegidas = nuevo;
    pintarTiers();      // el número del stepper vive ahora en la tarjeta
    pintarUnidades();   // los selectores de variante por unidad
    programarCotizacion();   // cambió la cantidad → cambió el total (y el umbral de envío)
  }

  /* ── EN EL CARRITO, LAS UNIDADES DEL PACK LAS MANDA EL CARRITO ─────────────
     Dictado del dueño (08-sep): «cuando el cliente hunda en el botón le aparezca la
     misma orden con los productos … que si le diera realizar pago».

     Deja el estado EXACTAMENTE en el mismo sitio que dejaría un clic del cliente
     sobre la tarjeta (`tierIdx` + `unidadesElegidas`), y repinta por las mismas dos
     funciones. No hay un segundo camino para elegir escalón: si mañana cambia la
     regla del clic, ésta la hereda.

     Devuelve una de tres cosas, y cada una tiene su desenlace en `aplicarCarrito`:
       · 'exacto'      — el pedido ES el carrito: la escalera puede quedarse escondida.
       · 'aproximado'  — se heredan las unidades pero el pedido no será exactamente el
                         carrito (un carrito de 12 con el tope en 10; un pack de varias
                         variantes, donde no sabemos QUÉ pieza metió). Se enseña.
       · 'desconocido' — no se pudo leer el carrito. Ni se hereda ni se adivina: se
                         vuelve al escalón mínimo y se enseña.
     Enseñar es siempre la dirección segura: el cliente ve con sus ojos por cuántas
     unidades va el pedido en vez de leer un total que no cuadra con su carrito. */
  function fijarUnidadesDelCarrito() {
    var n = Math.trunc(Number(UNIDADES_PACK_CARRITO));
    // Se limpia SIEMPRE al entrar: un aviso de una apertura anterior (el cliente bajó el
    // carrito de 12 a 3 y volvió) sería una advertencia sobre un pedido que ya no existe.
    avisoCantidad = null;
    if (!isFinite(n) || n < 1) return 'desconocido';

    // 1) El escalón EXACTO manda. (2 pulseras → la tarjeta del 2x1, con su precio de
    //    pack, no dos unidades sueltas del escalón de 1.)
    var idx = -1;
    for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].n === n) { idx = i; break; } }

    // 2) Sin escalón propio, el que ACEPTA MÁS UNIDADES y no se pase (4 → "3 o más").
    //    `escalaPorUnidad` mete aquí también al producto SIN ESCALERA, cuyo tier de 1
    //    unidad acepta cualquier cantidad porque el servidor la precia por unidad.
    if (idx < 0) {
      for (var j = 0; j < TIERS.length; j++) {
        if (!escalaPorUnidad(TIERS[j]) || TIERS[j].n > n) continue;
        if (idx < 0 || TIERS[j].n > TIERS[idx].n) idx = j;
      }
    }

    /* ── 3) LA ESCALERA NO PUEDE DECIR LO QUE HAY EN EL CARRITO ────────────────
       🔴 AQUÍ VIVÍA EL DEFECTO F1: un `return 'aproximado'` **ANTES** de asignar
       `tierIdx`/`unidadesElegidas`, así que el pedido se quedaba en el escalón mínimo
       —1 unidad— y se cotizaba en SILENCIO. Con un único escalón cerrado de 1 unidad
       (el fallback de arriba) eso pasaba SIEMPRE.

       Ahora se hacen las tres cosas que faltaban:
         · se elige, sólo PARA MOSTRAR, el escalón más alto que no se pase (o el
           primero): así el cliente parte de lo más cercano a su carrito;
         · se DESTAPA la escalera (`'aproximado'`, ver `aplicarCarrito`) para que pueda
           elegir a la vista;
         · y se escribe un AVISO con la cantidad REAL, porque un total más bajo que el
           del carrito sin una sola palabra en pantalla es lo que costó este arreglo.
       No se manda `n` al servidor en este caso A PROPÓSITO: con escalera en el metafield
       el servidor BUSCA el tier por `n` y no sintetiza nada (router-co.js:1201 exige
       `!tiers.length`), así que pedir una cantidad que la escalera no tiene devolvería
       `oferta_no_disponible` — un pedido rechazado a ciegas en vez de un pedido chico.
       El arreglo DE FONDO de este caso no va en el cliente: es DATO —darle un escalón
       `abierto:true` a esas escaleras en `landing.data`— y por tanto va en la tanda de
       servidor/datos, no aquí. */
    if (idx < 0) {
      var alt = -1;
      for (var a = 0; a < TIERS.length; a++) {
        if (TIERS[a].n > n) continue;
        if (alt < 0 || TIERS[a].n > TIERS[alt].n) alt = a;
      }
      tierIdx = alt >= 0 ? alt : 0;
      unidadesElegidas = TIERS[tierIdx].n;
      avisoCantidad = 'En tu carrito hay ' + n + ' unidades y esta oferta se pide por paquetes: ' +
        'este pedido va por ' + unidadesEfectivas() + '. Elige abajo el paquete que quieras, ' +
        'o vuelve al carrito y usa «Realizar pago» para llevarte las ' + n + '.';
      pintarTiers();
      pintarUnidades();
      return 'aproximado';
    }

    tierIdx = idx;
    unidadesElegidas = n;
    // 🔑 Y LAS PIEZAS. Se copian ANTES de pintar para que la tarjeta y los desplegables
    // nazcan ya con lo que el cliente eligió en el carrito. A partir de ahí son suyas:
    // puede cambiarlas en el formulario y nadie se las vuelve a pisar (esto sólo corre
    // al abrir el modal).
    // 🔒 SE HEREDA ENTERA O NO SE HEREDA. Se exige una pieza por CADA unidad que se va a
    //    pedir: con una lista más corta, las unidades que sobran caerían en el valor por
    //    defecto y el cliente vería una pieza suya y otra inventada, sin forma de saber
    //    cuál es cuál. Media herencia es peor que ninguna.
    if (Array.isArray(PIEZAS_PACK_CARRITO) && PIEZAS_PACK_CARRITO.length === n) {
      elecciones.length = 0;
      for (var e = 0; e < n; e++) elecciones[e] = PIEZAS_PACK_CARRITO[e];
    }
    pintarTiers();
    pintarUnidades();
    // ¿SE PUEDE ESCONDER LA ESCALERA? Sólo si el pedido va a ser EXACTAMENTE el carrito.
    //  · el tope del tier abierto (y el mínimo del cerrado) los aplica `unidadesEfectivas`,
    //    que es la MISMA cuenta que arma el payload: si no coincide, se pide otra cosa;
    //  · y la PIEZA tiene que estar clara. Con una sola variante no hay nada que saber;
    //    con varias, se sabe si se pudo heredar del carrito una por unidad. Si no se
    //    pudo (una línea que no empareja), el cliente tiene que elegirla a la vista.
    // ⚠️ Hasta esta tarde esto exigía `VARIANTES.length <= 1` a secas, porque la pieza no
    //    se heredaba: cualquier producto de dos colores enseñaba la escalera aunque el
    //    carrito llevara además otras referencias. Con la herencia ya hecha, esa
    //    condición sobraba — y era justo lo que el dueño volvió a reportar.
    // Ojo al orden: las unidades SÍ se heredan en los dos casos —eso siempre se sabe—;
    // lo único que se decide aquí es si el cliente tiene que ver la escalera o no.
    var piezaClara = VARIANTES.length <= 1 ||
      (Array.isArray(PIEZAS_PACK_CARRITO) && PIEZAS_PACK_CARRITO.length === n);

    /* 🔒 EL TOPE TAMBIÉN SE DICE. `unidadesEfectivas()` capa a CAP_UNIDADES (espejo de
       OPEN_TIER_CAP_CO), así que un carrito de 12 se pide de 10 — y eso hay que leerlo,
       no adivinarlo. Se dice con la MISMA cifra y el mismo sentido que el aviso del
       propio servidor cuando clampa el tier abierto («Máximo N unidades por pedido
       contra entrega», router-co.js:2110): la pantalla no inventa una regla nueva.
       ⚠️ Cuando la cotización llega, el servidor puede mandar SU aviso además de éste;
       no se solapan porque el suyo se pinta dentro del resumen y éste va encima. */
    if (unidadesEfectivas() !== n) {
      avisoCantidad = 'En tu carrito hay ' + n + ' unidades; contra entrega se piden hasta ' +
        CAP_UNIDADES + ' por pedido, así que este pedido va por ' + unidadesEfectivas() + '.';
    }
    return (unidadesEfectivas() === n && piezaClara) ? 'exacto' : 'aproximado';
  }

  /* ── PINTAR EL AVISO DE CANTIDAD ───────────────────────────────────────────
     🔴 SE CREA POR JS Y NO VIVE EN EL SNIPPET, a propósito: `cod-co.liquid` se despliega
     por Shopify y este archivo por el mismo camino, pero un tema montado con el snippet
     VIEJO no traería el ancla — y entonces el aviso no se pintaría justo en el tema donde
     más falta hace. Es el mismo patrón, y por el mismo motivo, que el `avisoSuelto` del
     aviso de cambio de precio (más abajo en este archivo).
     Va ENCIMA del resumen: el cliente tiene que leer «este pedido va por 3» ANTES del
     total, no después de decidirse por él. */
  var elAvisoCant = null;
  function pintarAvisoCantidad() {
    if (!avisoCantidad) {
      if (elAvisoCant && elAvisoCant.parentNode) elAvisoCant.parentNode.removeChild(elAvisoCant);
      return;
    }
    if (!elAvisoCant) {
      elAvisoCant = document.createElement('div');
      elAvisoCant.className = 'cco-aviso cco-aviso--cant';
      elAvisoCant.setAttribute('data-cco-aviso-cant', '');
    }
    // textContent y no innerHTML: el texto lleva una cantidad y nada más, pero este nodo
    // se arma con datos leídos del carrito y esa puerta se deja cerrada por costumbre.
    elAvisoCant.textContent = avisoCantidad;
    if (elResumen && elResumen.parentNode && elAvisoCant.parentNode !== elResumen.parentNode) {
      elResumen.parentNode.insertBefore(elAvisoCant, elResumen);
    }
  }

  /* ── EN LA FICHA, EL SELECTOR DE CANTIDAD DEL TEMA (arreglo de F1) ──────────
     Reportado con el defecto: «en /products/brazalete-amazonita puse el selector de
     cantidad del tema en 4 y el formulario siguió diciendo ×1». El modal no leía
     `input[name=quantity]` en ninguna parte, así que el único gesto de cantidad que el
     cliente tiene en una ficha de Dawn se tiraba a la basura.

     🔒 TRES GUARDAS, y ninguna es decorativa:
       · `EN_CARRITO` → en el carrito manda el CARRITO, que es un dato más nuevo y más
         explícito que un selector de la ficha.
       · el pack YA está en el carrito → idem: lo dice `fijarUnidadesDelCarrito`, que
         corrió antes; pisarlo con el selector devolvería el pedido a otra cantidad.
       · `SIN_ESCALERA` → **esto es lo que evita leer el dato equivocado.** En las
         páginas con escalera (las 6 con landing) el ÚNICO `input[name=quantity]` es el
         campo OCULTO del formulario del bloque de ofertas, y su valor son las unidades
         del tier que el cliente eligió arriba: heredarlo sería heredar nuestra propia
         escalera dos veces, y con un tier de piezas fijas sería, además, falso.
         Verificado en la tienda viva (10-sep): en la ficha de la Alineación 7 Chakras
         hay 1 `name="quantity"` y es `type="hidden"` con el `n` del tier; en la del
         Brazalete Amazonita (sin escalera, plantilla Dawn) hay 1 y es el
         `.quantity__input` visible del tema. De ahí el `:not([type="hidden"])`, que es
         cinturón además de la guarda de escalera.
     Falla del lado de no tocar nada: sin selector, con valor basura, 1 o fuera de tope,
     el pedido se queda como estaba. */
  function fijarUnidadesDeLaFicha() {
    if (EN_CARRITO || !SIN_ESCALERA) return false;
    // El pack ya está en el carrito → el carrito ya decidió (y ya pintó su aviso).
    var yaEnCarrito = Math.trunc(Number(UNIDADES_PACK_CARRITO));
    if (isFinite(yaEnCarrito) && yaEnCarrito >= 1) return false;
    var t = tierActual();
    if (!escalaPorUnidad(t)) return false;
    var inp = null;
    try { inp = document.querySelector('input[name="quantity"]:not([type="hidden"])'); } catch (e) { inp = null; }
    if (!inp || (inp.closest && inp.closest('[data-lb-form]'))) return false;
    var q = Math.trunc(Number(inp.value));
    if (!isFinite(q) || q <= t.n || q > CAP_UNIDADES) return false;
    if (unidadesElegidas === q) return false;
    unidadesElegidas = q;
    pintarTiers();
    pintarUnidades();
    return true;
  }

  /* El desplegable de variante vive DENTRO de la tarjeta, igual que los chips, así que
     su evento se escucha aquí. Es `change`, no `click`: un `click` sobre un <select> se
     dispara al ABRIRLO, antes de que el cliente haya elegido nada.
     🔒 `stopPropagation` para que abrir el desplegable no cuente como tocar la tarjeta:
     en el escalón abierto eso devolvería la cantidad al mínimo. Es el mismo cuidado que
     tienen los chips, y aquí sí es load-bearing (el listener de la tarjeta es de `click`,
     pero los oyentes de fuera que escuchen `change` en `document` no lo son). */
  elTiers.addEventListener('change', function (e) {
    if (controlesCongelados()) return;
    var sel = (e.target && e.target.closest) ? e.target.closest('[data-cco-var-sel]') : null;
    if (!sel) return;
    if (e.stopPropagation) e.stopPropagation();
    elegirVariante(parseInt(sel.getAttribute('data-cco-var-sel'), 10), parseInt(sel.value, 10));
  });

  elTiers.addEventListener('click', function (e) {
    if (controlesCongelados()) return;   // MEDIO-A: pedido en vuelo (o ya creado)
    var tgt = e.target;
    // 🔒 EL STEPPER SE ATIENDE PRIMERO. Está DENTRO de la tarjeta, así que cualquier
    // reordenamiento futuro que lo metiera bajo `[data-cco-tier]` haría que su clic
    // burbujeara hasta la selección de tier — y ahí `unidadesElegidas = TIERS[i].n`
    // devolvería la cantidad al mínimo: el botón de SUMAR restaría. Hoy son hermanos y
    // no puede pasar; esta salida es el cinturón para que siga sin poder pasar.
    // 🐛 EL DESPLEGABLE, ANTES QUE NADA. Vive dentro de la tarjeta, que es clicable
    // entera: sin esto, tocarlo para abrirlo elige ese escalón otra vez y —en el
    // abierto— devuelve la cantidad al mínimo, así que la fila que el cliente estaba
    // tocando desaparece debajo del dedo. Es el fallo que el dueño reportó el 09-sep en
    // la ficha con la unidad 4; aquí se cierra por el mismo motivo.
    if (tgt.closest && tgt.closest('[data-cco-var-sel]')) return;
    var mas = tgt.closest ? tgt.closest('[data-cco-mas]') : null;
    var menos = tgt.closest ? tgt.closest('[data-cco-menos]') : null;
    if (mas || menos) { ajustarUnidades(!!mas); return; }
    // 🔒 Y LOS CHIPS TAMBIÉN SE ATIENDEN ANTES DE LA TARJETA. Desde el 09-sep viven
    // DENTRO de ella, así que sin esto tocar «Caballero» acabaría re-seleccionando el
    // pack y `unidadesElegidas = TIERS[i].n` devolvería la cantidad al mínimo: el
    // cliente elegiría una talla y se le cambiaría el pedido. `clicDeChip` corta la
    // propagación por la misma razón.
    if (clicDeChip(e)) return;
    var b = tgt.closest ? tgt.closest('[data-cco-tier]') : null;
    // ÚLTIMO RECURSO: cualquier otro punto de la tarjeta (la fila «Ahorras…», que ya no
    // está dentro del botón, o el aire del padding) selecciona su tier.
    if (!b) b = tgt.closest ? tgt.closest('[data-cco-card]') : null;
    if (!b) return;
    var i = parseInt(b.getAttribute('data-cco-tier') != null
      ? b.getAttribute('data-cco-tier') : b.getAttribute('data-cco-card'), 10);
    if (!(i >= 0 && i < TIERS.length)) return;
    // Ya elegida: no se repinta ni se recotiza (un clic redundante gasta una llamada
    // contra el rate-limit que bajo CGNAT se comparte con otros compradores).
    if (i === tierIdx) return;
    tierIdx = i;
    unidadesElegidas = TIERS[i].n;
    pintarTiers();
    pintarUnidades();
    programarCotizacion();   // el total cambió: hay que volver a preguntárselo al servidor
  });

  // ── Selector de variante POR UNIDAD ──────────────────────────────────────
  // El servidor exige exactamente una entrada por unidad y la resuelve contra las
  // variantes REALES por clave canónica (router-co.js:1118-1132). Con una sola
  // variante no se pregunta nada: se manda `optionValues: []` y él la resuelve
  // (router-co.js:692). Con un tier de piezas fijas tampoco: ese pack no lo elige
  // el cliente.
  var elecciones = [];   // índice de VARIANTES elegido para cada unidad

  function necesitaElegirVariante() {
    return VARIANTES.length > 1 && !tierActual().tieneItems;
  }

  // 🔗 `?variant=<id>` (dueño 02-oct). Los anuncios de Meta enlazan a la VARIANTE que muestran
  // (…/producto?variant=123). Shopify sólo cambiaba la FOTO: el selector de la ficha y este
  // formulario arrancaban siempre en la 1.ª variante, así que quien venía del anuncio de la
  // pieza «Caballero» o de «65 cm» pedía la que NO vio. Si la URL trae el id de una variante
  // de ESTE producto y está DISPONIBLE, manda ella; si no (id ajeno, agotada, basura), la 1.ª
  // disponible, exactamente como antes. Se lee UNA vez al cargar: Dawn reescribe `?variant=`
  // en cada cambio de selector y una lectura viva movería el «por defecto» bajo los pies del
  // cliente. Misma regla y mismo nombre que `puente-landing-co.js` (que tiene su copia).
  // En el carrito (EN_CARRITO) NO aplica: ahí las piezas salen de las líneas del carrito.
  var VARIANTE_URL = -2;   // -2 = aún sin leer · -1 = ninguna · >= 0 = índice en VARIANTES
  function varianteDeLaUrl() {
    if (VARIANTE_URL !== -2) return VARIANTE_URL;
    VARIANTE_URL = -1;
    try {
      if (EN_CARRITO) return VARIANTE_URL;
      var m = String(window.location.search || '').match(/[?&]variant=(\d+)(?:&|#|$)/);
      if (!m) return VARIANTE_URL;
      for (var k = 0; k < VARIANTES.length; k++) {
        if (VARIANTES[k] && String(VARIANTES[k].id) === m[1] && VARIANTES[k].disponible !== false) { VARIANTE_URL = k; break; }
      }
    } catch (e) { VARIANTE_URL = -1; }
    return VARIANTE_URL;
  }

  // La primera variante DISPONIBLE (no la primera a secas: ofrecer una agotada
  // termina en un pedido que no se puede surtir). Con `?variant=` válido, ésa.
  function varPorDefecto() {
    var u = varianteDeLaUrl();
    if (u >= 0) return u;
    for (var k = 0; k < VARIANTES.length; k++) { if (VARIANTES[k].disponible !== false) return k; }
    return 0;
  }

  // 🔑 LA ELECCIÓN DE UNA UNIDAD SE DERIVA, NO SE SIEMBRA. Antes el valor por defecto
  // sólo existía DESPUÉS de que `pintarUnidades` corriera, y en el arranque
  // `pintarTiers()` va PRIMERO: la miniatura de las tarjetas —que desde hoy sigue a la
  // variante elegida— habría pintado la foto genérica en la primera pasada y sólo se
  // habría corregido al primer clic. Derivándolo, las dos funciones ven lo mismo
  // vengan en el orden que vengan.
  function eleccionDe(i) {
    var j = elecciones[i];
    return (j >= 0 && j < VARIANTES.length) ? j : varPorDefecto();
  }

  // ── LA MINIATURA DE LAS TARJETAS DE OFERTA (dictado del dueño 09-sep) ─────
  // `data-cco-img` es la foto DESTACADA del producto, y en varias fichas colombianas
  // eso es una INFOGRAFÍA vertical: recortada al cuadrado de 46 px de la tarjeta queda
  // un rectángulo oscuro con iconitos, que es justo lo que el dueño leyó como "miniatura
  // rota con un ícono de descarga encima". La foto de la VARIANTE elegida enseña lo que
  // el cliente se va a llevar, que es para lo que sirve una miniatura.
  // 🔒 Sin variantes que elegir, o sin foto propia de esa variante, se devuelve la de
  // siempre: el cambio no puede dejar una tarjeta SIN imagen.
  function imgTarjeta() {
    var base = root.getAttribute('data-cco-img') || '';
    if (!necesitaElegirVariante()) return base;
    var v = VARIANTES[eleccionDe(0)];
    return (v && typeof v.imagen === 'string' && v.imagen) ? v.imagen : base;
  }

  /* ── ¿DÓNDE VAN LOS CHIPS? (dictado del dueño 09-sep) ──────────────────────
     «La variante tiene que ir ADENTRO del cuadro donde dice 2x1, donde la gente está
     seleccionando la oferta; no arriba ni abajo.» Así que el sitio natural es la
     TARJETA del tier elegido, y este contenedor (`[data-cco-unidades]`) se queda como
     RESPALDO para el único caso en que no hay tarjeta donde meterlos: un producto de un
     solo tier CERRADO, donde `pintarTiers` no dibuja escalera ninguna. Sin ese respaldo
     ese producto se quedaría con variantes y sin forma de elegirlas.

     🔒 SE DECIDE CON UN PREDICADO, NO CON UNA BANDERA que dejara `pintarTiers`. Las dos
     funciones se llaman en los dos órdenes según el camino (el clic de un chip repinta
     la escalera primero; `ajustarUnidades`, al revés), y una bandera haría que el
     resultado dependiera de quién corrió antes. */
  function hayTarjetaParaChips() {
    if (TIERS.length >= 2) return true;
    var t = tierActual();
    return escalaPorUnidad(t);
  }
  function chipsVanEnTarjeta() {
    return necesitaElegirVariante() && hayTarjetaParaChips();
  }

  // Las FILAS de chips. Devuelve HTML y, de paso, normaliza `elecciones` a las unidades
  // que se están pintando: es la misma cuenta que hacía `pintarUnidades` antes de que
  // esto se extrajera, y sigue siendo el ÚNICO sitio donde se siembra el valor por
  // defecto de una unidad nueva (vía `eleccionDe`).
  /* ── SIEMPRE QUE HAYA QUE ELEGIR, DESPLEGABLE (dictado del dueño 09-sep) ────
     Primero se puso en 4 —los chips de dos opciones se ven de un vistazo y se tocan de
     una vez— pero el dueño lo pidió también para la Alineación 7 Chakras, el Protección
     x4 y los dos anillos, que son de DOS opciones (Dama/Caballero, Dorado/Plateado).
     Así que el umbral baja a 2: con una sola variante no hay nada que elegir y no se
     pinta nada; con dos o más, desplegable.
     Se conserva la constante —y el camino de los chips— porque es lo que hace que
     volver atrás sea cambiar un número, no reescribir el bloque.

     🔒 EL MISMO UMBRAL QUE LA FICHA (puente-landing-co.js), y a propósito: el cliente ve
     las dos pantallas y una elección que en una es un desplegable y en la otra unos
     botones se lee como dos cosas distintas. Hay un assert que se pone rojo si se
     separan.
     🔒 SÓLO CAMBIA LA PIEL. El estado sigue siendo `elecciones[]` y el único camino para
     moverlo sigue siendo `elegirVariante(unidad, variante)`. */
  var UMBRAL_DESPLEGABLE = 2;
  function usarDesplegable() { return VARIANTES.length >= UMBRAL_DESPLEGABLE; }

  function filasChipsHtml(u) {
    var h = '';
    elecciones.length = u;
    for (var i = 0; i < u; i++) {
      elecciones[i] = eleccionDe(i);
      if (usarDesplegable()) {
        h += '<label class="cco-uni cco-uni--sel" data-cco-uni="' + i + '">' +
               '<span class="cco-uni__lbl">Unidad ' + (i + 1) + '</span>' +
               '<select class="cco-uni__sel" data-cco-var-sel="' + i + '"' +
               ' aria-label="Unidad ' + (i + 1) + '">';
        // eslint-disable-next-line no-loop-func
        (function (idx) {
          VARIANTES.forEach(function (v, j) {
            var agotada = v.disponible === false;
            h += '<option value="' + j + '"' + (j === elecciones[idx] ? ' selected' : '') +
              // Lo agotado se deshabilita en la <option>, que es donde el barrido de
              // `refrescarControles` no llega — y por eso aquí no hace falta la marca
              // `data-cco-agotada` que sí necesitan los chips.
              (agotada ? ' disabled' : '') + '>' +
              esc(v.titulo) + (agotada ? ' (agotada)' : '') + '</option>';
          });
        })(i);
        h += '</select></label>';
        continue;
      }
      h += '<div class="cco-uni" data-cco-uni="' + i + '">' +
             '<span class="cco-uni__lbl">Unidad ' + (i + 1) + '</span>' +
             '<div class="cco-chips" role="group" aria-label="Unidad ' + (i + 1) + '">';
      // eslint-disable-next-line no-loop-func
      (function (idx) {
        VARIANTES.forEach(function (v, j) {
          var agotada = v.disponible === false;
          var on = (j === elecciones[idx]);
          h += '<button type="button" class="cco-chip' + (on ? ' is-on' : '') + '"' +
            ' data-cco-var-chip="' + idx + '" data-cco-var-idx="' + j + '"' +
            ' aria-pressed="' + (on ? 'true' : 'false') + '"' +
            // 🔒 LA MARCA DE AGOTADA ES UN ATRIBUTO, NO SÓLO `disabled`.
            // `refrescarControles` reescribe `disabled` sobre TODOS los botones de los
            // dos contenedores cuando descongela el formulario: sin esta marca, un
            // pedido que vuelve de "enviando" dejaría clicable una variante sin
            // existencias. (Con <select> no pasaba: allí lo deshabilitado eran las
            // <option>, que ese barrido no tocaba.)
            (agotada ? ' data-cco-agotada disabled' : '') + '>' +
            esc(v.titulo) + (agotada ? ' (agotada)' : '') + '</button>';
        });
      })(i);
      h += '</div></div>';
    }
    return h;
  }

  // Lo que se inyecta DENTRO de la tarjeta del tier elegido. Vacío si no hay nada que
  // elegir: una tarjeta sin variantes no cambia ni un pixel.
  function bloqueChipsHtml(u) {
    if (!chipsVanEnTarjeta()) return '';
    return '<div class="cco-unis" data-cco-unis>' + filasChipsHtml(u) + '</div>';
  }

  // ── La elección de una variante, en UN solo sitio ────────────────────────
  // La llaman los dos listeners (la escalera, donde viven los chips desde el 09-sep, y
  // el contenedor de respaldo): así no hay dos caminos que puedan divergir.
  function elegirVariante(i, j) {
    if (!(i >= 0) || !(j >= 0 && j < VARIANTES.length)) return;
    if (VARIANTES[j].disponible === false) return;   // cinturón del atributo `data-cco-agotada`
    if (elecciones[i] === j) return;                 // ya elegida: ni repintar ni recotizar
    elecciones[i] = j;
    // La escalera PRIMERO: es la que pinta los chips y la que mueve la miniatura (que
    // sigue a la unidad 1). No toca `tierIdx` ni `unidadesElegidas`, así que la oferta
    // elegida y la cantidad se quedan donde estaban.
    pintarTiers();
    pintarUnidades();
    // La variante no mueve el precio en este carril, PERO sí forma parte del pedido
    // que el servidor resuelve (y puede rechazar). Recotizar mantiene la huella
    // sincronizada: sin esto, el candado de frescura del submit vería un pedido
    // distinto al cotizado y le pediría al cliente que reenvíe sin motivo.
    programarCotizacion();
  }

  // ¿Este clic fue en un chip? Si lo fue, se atiende y se corta la propagación.
  function clicDeChip(e) {
    var b = (e.target && e.target.closest) ? e.target.closest('[data-cco-var-chip]') : null;
    if (!b || b.disabled) return false;
    // `preventDefault` + `stopPropagation`: el chip vive dentro de la tarjeta, que es
    // clicable entera. Mismo cuidado que el puente tiene con los chips de la landing,
    // que viven dentro de un <label>.
    // ⚠️ HONESTIDAD SOBRE QUIÉN PROTEGE DE VERDAD, medido por mutación: lo que impide
    // que el clic acabe cambiando de oferta —y, en el tier abierto, devolviendo la
    // cantidad al mínimo— es el ORDEN del listener de `elTiers` (`if (clicDeChip(e))
    // return;` va ANTES de la tarjeta): quitarlo pone 6 asserts en rojo. Quitar este
    // `stopPropagation` NO mueve ni uno, porque el chip que se puede pulsar sólo existe
    // dentro de la tarjeta YA elegida. Se conserva como cinturón para los oyentes de
    // FUERA de `elTiers` (el bloque mexicano engancha los suyos en `document`) y para el
    // día que alguien pinte chips en una tarjeta no seleccionada — pero no se presenta
    // como el candado, porque no lo es.
    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    elegirVariante(parseInt(b.getAttribute('data-cco-var-chip'), 10),
                   parseInt(b.getAttribute('data-cco-var-idx'), 10));
    return true;
  }

  function pintarUnidades() {
    var u = unidadesEfectivas();
    var h = '';

    // ⚠️ AQUÍ YA NO SE PINTA NI EL STEPPER NI, DESDE EL 09-SEP, LOS CHIPS: el stepper se
    // mudó dentro de la tarjeta del tier abierto (02-sep) y los chips dentro de la
    // tarjeta ELEGIDA. Este contenedor queda como RESPALDO del único caso sin tarjeta
    // (un solo tier, cerrado) — ver la nota de `chipsVanEnTarjeta`.
    if (!necesitaElegirVariante()) {
      elecciones.length = 0;
    } else if (!chipsVanEnTarjeta()) {
      h = filasChipsHtml(u);
    } else {
      // Los chips los pinta la tarjeta, pero `elecciones` tiene que quedar normalizada
      // igual: `payloadPedido()` lee una entrada por unidad y no le importa quién pintó.
      filasChipsHtml(u);
    }

    elUnidades.innerHTML = h;
    elUnidades.hidden = !h;
    refrescarControles();   // idem (MEDIO-A)
  }

  // El contenedor de RESPALDO (producto de un solo tier cerrado). Misma función
  // compartida que usa la escalera: un solo camino para elegir variante.
  elUnidades.addEventListener('click', function (e) {
    if (controlesCongelados()) return;   // MEDIO-A
    clicDeChip(e);
  });

  // (El listener de ± que vivía aquí se fue con el stepper: ahora lo atiende el de
  // `elTiers`, porque el stepper está DENTRO de la tarjeta del tier abierto.)

  // ── TARJETAS DE ADICIONALES (tick) ───────────────────────────────────────
  // 🔒 EL VOTO ES EXPLÍCITO Y SALE DE LO QUE SE PINTA. Cada casilla marcada vuelve a
  // COTIZAR, así que el total del botón y la lista `items` del resumen incluyen siempre
  // lo que está marcado: marcar un extra y que el total no se mueva es justo el bug de
  // confianza que este carril tiene prohibido.
  //
  // El % de ahorro se DERIVA con FLOOR de `comparacion` vs `precio` (misma regla que el
  // molde mexicano, landing-buda.js:2993): jamás se promete más descuento del real.
  function tickAhorroPct(t) {
    var precio = Number(t.precio) || 0;
    var comp = Number(t.comparacion) || 0;
    if (!(comp > precio) || !(precio > 0)) return 0;
    var pct = Math.floor((1 - (precio / comp)) * 100);
    return (pct > 0 && pct < 100) ? pct : 0;
  }

  function pintarTicks() {
    if (!elTicks) return;
    var h = '';
    TICKS.forEach(function (t, i) {
      if (!tickPintable(t)) return;   // sin título el servidor lo descarta: no se ofrece
      // Ya es una línea del carrito: se dice, y sin casilla. Ver `tickYaEnCarrito`.
      // La tarjeta se conserva (no se esconde) para que el cliente ENTIENDA por qué no
      // se le ofrece: un extra que desaparece sin explicación se lee como un error.
      if (tickYaEnCarrito(t)) {
        h += '<div class="cco-tick cco-tick--fijo" data-cco-tickcard="' + i + '"' +
          ' data-cco-tick-titulo="' + esc(String(t.titulo).trim()) + '">' +
          '<span class="cco-tick__body">' +
            '<span class="cco-tick__t">' + esc(String(t.titulo).trim()) + '</span>' +
            '<span class="cco-tick__d">Ya está en tu carrito</span>' +
          '</span>' +
          (tickImagen(t)
            ? '<span class="cco-tick__img"><img src="' + esc(tickImagen(t)) + '" alt="" loading="lazy" width="56" height="56"></span>'
            : '') +
        '</div>';
        return;
      }
      var on = ticksState[i] === true;
      var precio = cop(t.precio);
      var comp = (Number(t.comparacion) > precio) ? cop(t.comparacion) : 0;
      var pct = tickAhorroPct(t);
      var img = tickImagen(t);
      // "Agrega 1 Empaque Premium 💎 por solo $13.900" (dictado del dueño). Con precio 0
      // el adicional es un regalo y se dice así: nunca "por solo $0".
      // 🔴 EL "1" DESAPARECE CUANDO HAY CONTADOR (04-sep). Con el adicional marcado y el
      // contador en 3, "Agrega 1 Empaque Premium" contradice el número que el cliente
      // tiene al lado. Sin marcar sigue siendo el gancho de venta de siempre ("Agrega 1
      // … por solo $13.900"); marcado pasa a «$13.900 c/u», el precio por unidad, que es el dato
      // que necesita para decidir cuántas lleva.
      var frase;
      if (precio <= 0) frase = 'Agrega 1 ' + esc(String(t.titulo).trim()) + ' <b>GRATIS</b>';
      else if (on) frase = esc(String(t.titulo).trim()) + ' · <b>' + money(precio) + '</b> c/u';
      else frase = 'Agrega 1 ' + esc(String(t.titulo).trim()) + ' por solo <b>' + money(precio) + '</b>';

      // `data-cco-tick-titulo` = el título CRUDO del adicional (el del metafield), no
      // la frase de venta. Lo lee el puente de la landing para CRUZAR el índice con
      // el título antes de heredar el voto: el índice es el contrato con el servidor,
      // pero votar por el índice equivocado significa cobrarle al cliente OTRO
      // adicional, así que el puente exige que además coincida el nombre. Si este
      // atributo faltara, el puente no toca ese tick (fail-safe hacia no votar).
      h += '<label class="cco-tick' + (on ? ' cco-tick--on' : '') + '" data-cco-tickcard="' + i + '"' +
        ' data-cco-tick-titulo="' + esc(String(t.titulo).trim()) + '">' +
        '<input type="checkbox" class="cco-tick__cb" data-cco-tick="' + i + '"' + (on ? ' checked' : '') + '>' +
        '<span class="cco-tick__body">' +
          '<span class="cco-tick__t">' + frase + '</span>' +
          (comp
            ? '<span class="cco-tick__was"><s>' + money(comp) + '</s>' +
              (pct ? '<span class="cco-tick__off">-' + pct + '%</span>' : '') + '</span>'
            : '') +
          (t.texto ? '<span class="cco-tick__d">' + esc(String(t.texto)) + '</span>' : '') +
        '</span>' +
        (img
          ? '<span class="cco-tick__img"><img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56"></span>'
          : '') +
        // ── EL CONTADOR, sólo cuando el adicional está MARCADO y CUESTA ────────
        // Si no está marcado no hay nada que contar; si es un regalo ($0) un contador
        // sólo invitaría a pedir "tres gratis". Va DENTRO del <label>, así que sus
        // botones tienen que frenar la propagación o el clic desmarcaría la casilla —
        // ver el manejador. El número que se pinta sale de `tickCantidad`, la MISMA
        // función que arma el voto que viaja: lo que se ve y lo que se pide no pueden
        // separarse.
        ((on && precio > 0)
          ? '<span class="cco-tickq" data-cco-tickq="' + i + '">' +
              '<button type="button" class="cco-tickq__b" data-cco-tickq-menos="' + i + '" aria-label="Quitar una">−</button>' +
              '<span class="cco-tickq__n" data-cco-tickq-n="' + i + '">' + tickCantidad(t, i) + '</span>' +
              '<button type="button" class="cco-tickq__b" data-cco-tickq-mas="' + i + '" aria-label="Agregar una">+</button>' +
            '</span>'
          : '') +
      '</label>';
    });
    elTicks.innerHTML = h;
    elTicks.hidden = !h;
    refrescarControles();   // el innerHTML nuevo nace sin el `disabled` (MEDIO-A)
  }

  if (elTicks) {
    elTicks.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb || !cb.dataset || cb.dataset.ccoTick == null) return;
      var i = parseInt(cb.dataset.ccoTick, 10);
      // Índice fuera del array normalizado, o tick que esta pantalla NO pinta: no puede
      // votar que SÍ ni por error. Se devuelve la casilla al estado real (nunca se deja
      // marcada una casilla cuyo voto no viaja: sería prometer un extra que no llega).
      if (!(i >= 0 && i < TICKS.length) || !tickPintable(TICKS[i]) || controlesCongelados()) {
        cb.checked = (ticksState[i] === true);
        return;
      }
      ticksState[i] = (cb.checked === true);
      // Al marcarlo de nuevo se vuelve a UNA: si conservara la cantidad de antes, el
      // cliente que desmarca y remarca se llevaría tres cajitas sin haberlas pedido.
      if (ticksState[i]) ticksQty[i] = 1; else delete ticksQty[i];
      var card = cb.closest ? cb.closest('[data-cco-tickcard]') : null;
      if (card) card.classList.toggle('cco-tick--on', ticksState[i]);
      pintarTicks();           // aparece (o desaparece) el contador
      programarCotizacion();   // el extra entra (o sale) del total: lo dice el servidor
    });

    // ── EL CONTADOR DEL ADICIONAL ────────────────────────────────────────────
    // 🔒 `preventDefault` + `stopPropagation` son OBLIGATORIOS: estos botones viven
    // DENTRO del <label> de la casilla, así que sin ellos cada clic en «+» alternaría
    // también el voto — el cliente pediría dos cajitas y se le desmarcaría el adicional.
    elTicks.addEventListener('click', function (ev) {
      var tgt = ev.target;
      var mas = (tgt && tgt.closest) ? tgt.closest('[data-cco-tickq-mas]') : null;
      var menos = (tgt && tgt.closest) ? tgt.closest('[data-cco-tickq-menos]') : null;
      if (!mas && !menos) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (controlesCongelados()) return;   // pedido en vuelo: nada se mueve
      var i = parseInt((mas || menos).getAttribute(mas ? 'data-cco-tickq-mas' : 'data-cco-tickq-menos'), 10);
      if (!(i >= 0 && i < TICKS.length) || !tickPintable(TICKS[i]) || ticksState[i] !== true) return;
      var actual = tickCantidad(TICKS[i], i);
      var nueva = mas ? Math.min(TICK_QTY_MAX, actual + 1) : Math.max(1, actual - 1);
      if (nueva === actual) return;        // en el tope: no se recotiza por nada
      ticksQty[i] = nueva;
      var num = elTicks.querySelector('[data-cco-tickq-n="' + i + '"]');
      if (num) num.textContent = String(nueva);
      programarCotizacion();
    });
  }

  // ── COTIZACIÓN: el total que ve el cliente lo calcula el SERVIDOR ─────────
  // Molde: cod-carrito.js:96-176 (cotizado / huellaCotizada / bloquearSubmit /
  // cotizar / pintarResumen / etiquetarSubmit). Lo que cambia respecto a México es
  // QUÉ define el pedido: allá son las líneas del carrito de Shopify, aquí son el
  // tier, las variantes por unidad y los adicionales votados.

  var cotizado = null;        // último desglose devuelto por el SERVIDOR
  var ecoCotizado = null;     // los números EXACTOS que el cliente vio y aprobó
  var huellaCotizada = null;  // el pedido EXACTO que produjo ese desglose
  var tsCotizacion = null;    // CUÁNDO se recibió (reloj monótono, ver ahoraMs)
  var bloqueo = null;         // motivo por el que este pedido NO se puede enviar
  var tokenCotiza = 0;        // anti-carrera: sólo pinta la respuesta más reciente
  var reintentos = 0;         // reintentos automáticos del fallo TRANSITORIO en curso
  var reintentos429 = 0;      // presupuesto PROPIO del 429 (no comparte con el anterior)
  var timerCotiza = null;     // debounce
  var timerReintento = null;  // reintento automático (transitorio o 429)
  var timerCuenta = null;     // cuenta atrás visible del 429
  var timerLatido = null;     // vigila la EDAD de la cotización mientras el modal está abierto
  var tsUltimoRefresco = 0;   // anti-ráfaga de los refrescos automáticos
  // MEDIO-C. Los dos frenos del refresco de fondo, uno por cada forma de desbocarse:
  //   · `gestoDesdeCotizacion` — ¿el cliente sigue AHÍ? Sin una señal de vida suya no
  //     se recotiza nunca (un modal olvidado tiende a cero llamadas).
  //   · `refrescosFondo` — techo DURO por cotización. Sin él, un refresco que falla en
  //     bucle (red intermitente, 429 ajeno) dejaría al latido reintentando para
  //     siempre contra el mismo rate-limit que bajo CGNAT comparten compradores reales.
  var gestoDesdeCotizacion = false;
  var refrescosFondo = 0;
  var MAX_REFRESCOS_FONDO = 2;
  var enVuelo = 0;            // cotizaciones pedidas y sin contestar
  var pedidoHecho = false;    // ya hay orden creada: esta pantalla dejó de vender
  var enviando = false;       // guard de re-entrada del submit (doble tap en móvil)
  var confirmacion = null;    // { antes, ahora } → el precio cambió y hace falta un GESTO

  /* ═══════════════════════════════════════════════════════════════════════════
     ⚡ CADENA DE OFERTAS FLASH — EL ESTADO (G2, 2026-09-10)
     ═══════════════════════════════════════════════════════════════════════════
     Hasta hoy este archivo mandaba `flashAceptados: []` HARDCODEADO y lo decía en su
     cabecera («la cadena flash sigue sin UI»). El servidor ya cocina las ofertas y las
     manda en la MISMA respuesta que el total (`ofertasFlash` de /cotizar-co), así que
     aquí sólo se PINTA y se VOTA: ni un precio se calcula, ni una oferta se elige.

     🔒 LAS TRES PIEZAS, Y POR QUÉ SON TRES:
       · `FLASH_OFERTAS`   lo que el SERVIDOR ofreció en la última cotización. Se
         reemplaza entero en cada `aplicarCotizacion`: una oferta que el servidor dejó
         de ofrecer (se agotó, ya está en el carrito) desaparece sola.
       · `FLASH_ACEPTADOS` el VOTO que viaja dentro de `payloadPedido()` — y por tanto
         dentro de la HUELLA. Aceptar una oferta INVALIDA la cotización aprobada, que es
         justo lo que obliga a recotizar antes de enviar (ver `flashTrasCadena`).
       · `flashCadenaHecha` la cadena corre UNA vez por apertura del modal. Sin esto, el
         cliente que pulsa FINALIZAR dos veces vería la misma oferta dos veces.

     🔒 EL CAMINO DE RIESGO CERO SIGUE SIENDO EL DE HOY: sin ofertas, o con todo
     rechazado, `FLASH_ACEPTADOS` queda vacío, la huella no cambia y el submit continúa
     EXACTAMENTE igual que antes de esta tanda.                                        */
  var FLASH_OFERTAS = [];       // cocidas por el servidor (id, precioFinal, precioBase…)
  var FLASH_ACEPTADOS = [];     // [{ id, qty, variantId }] — el voto que viaja
  var flashCadenaHecha = false; // ya corrió en esta apertura del modal
  var flashCadenaEnCurso = false;
  var flashCerrarCadena = null; // cómo decir «NO a todo lo pendiente» desde fuera (cerrar/Escape)
  // 🔒 EL PEDIDO QUE YA ESTABA APROBADO, GUARDADO ANTES DE RECOTIZAR. Aceptar una oferta
  // obliga a recotizar, y `programarCotizacion()` TIRA el estado de precio vigente
  // (cotizado / eco / huella / ts). Si la cotización nueva no llega o el servidor la veta,
  // sin esta copia no habría a qué volver: el cliente se quedaba con un error en la cara y
  // el pedido —que ya estaba aprobado— sin salir. Aquí no se inventa nada: son los MISMOS
  // objetos que devolvió el servidor y que el cliente vio en pantalla.
  var flashAprobada = null;     // { cotizado, eco, huella, ts, total }

  /* ═══════════════════════════════════════════════════════════════════════════
     🧾 EL PEDIDO QUEDA REGISTRADO AL TOCAR «FINALIZAR» (dictado del dueño, 26-oct-2026)
     ═══════════════════════════════════════════════════════════════════════════
     «El pedido queda REGISTRADO apenas el cliente toca Finalizar; si en la cadena flash
      acepta una oferta, se SUMA a ese mismo pedido; si no acepta nada, se le manda lo
      que pidió; si sale, cierra o toca atrás, el pedido ya existe.»
     Al empezar la cadena se manda el pedido aprobado con `registro:{formId, fase:
     'registrar'}`: el servidor valida TODO (lo mismo que al crear) y lo GUARDA. Desde ahí,
     si la página muere, el servidor crea ese pedido solo al vencer el plazo
     (src/cod-co/registro-co.js explica por qué no se crea la orden de Shopify en el acto:
     Dropify la puede bajar a Dropi a los 19 s y la oferta ya no entraría a esa guía).
     Al terminar la cadena, el pedido final lleva `registro:{formId, fase:'final'}` y el
     servidor crea UNA orden con lo aceptado dentro.
     🧾 (27-oct, dueño) ACEPTAR UNA OFERTA = QUEDA SUMADA. «Hay gente que no lee»: en cuanto
     el cliente toca «Agregar» en una tarjeta, el pedido con la oferta se manda con
     `registro:{formId, fase:'sumar', seq}` y el servidor REEMPLAZA lo registrado. Si sale,
     toca atrás o no toca nada en «Revisa tu pedido», sale CON lo aceptado (el barrido del
     servidor, o el envío solo a los FLASH_RESUMEN_AUTO_SEG). Quitarla es explícito
     («Quitar la oferta y enviar»); si nunca aceptó nada, sale el base.
     🔒 La cadena NO espera al registro (la oferta 1 sale en el acto, como hoy); el envío
     FINAL sí lo espera, para no mandar dos pedidos cruzados.
     🔒 Si el registro falla por red o por el servidor, la cadena sigue y el pedido sale al
     final como siempre: el camino de hoy es el piso. `data-cco-registro="off"` lo apaga. */
  var REGISTRO_ACTIVO = root.getAttribute('data-cco-registro') !== 'off';
  var registro = null;          // { formId, estado: pidiendo|ok|fallo|off|hecho, total, promesa }
  var flashAbortarCadena = null; // cierra la cadena SIN enviar (el registro fue rechazado)
  var flashResumenAbierto = false;
  // 🧾 (27-oct) «Revisa tu pedido» es INFORMATIVA: si el cliente no toca nada, el pedido se
  // envía solo con lo que aceptó a los N segundos (la cuenta va a la vista).
  // `data-cco-resumen-auto-seg` (3..120) sólo para las pruebas; sin él, 20 s.
  var FLASH_RESUMEN_AUTO_SEG = (function () {
    var n = Math.trunc(Number(root.getAttribute('data-cco-resumen-auto-seg')));
    return (n >= 3 && n <= 120) ? n : 20;
  })();
  var flashResumenReloj = null;
  // El total que enseña «Revisa tu pedido» (para saber si el servidor YA tiene ESE pedido).
  var flashResumenTotal = null;
  function nuevoFormId() {
    var s = '';
    for (var i = 0; i < 20; i++) s += 'abcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 36));
    return s;
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // 🔒 EL EJE TIEMPO — ALTO-1 de la 2ª revisión adversaria (2026-09-01)
  // ═══════════════════════════════════════════════════════════════════════════
  // La huella ata la cotización al PAYLOAD del cliente, no al ESTADO DEL SERVIDOR que
  // produjo el número. /ordenar-co vuelve a leer el metafield y vuelve a leer
  // ENVIO_CO_COSTO / ENVIO_CO_UMBRAL por evaluación: son DOS lecturas separadas por
  // todo el tiempo que el cliente tarde en teclear diez campos y pelear con la cascada
  // departamento→ciudad. Si algo cambió en medio (un rollout de ofertas, un
  // `pm2 reload --update-env`), se COBRABA el precio nuevo sobre un total aprobado
  // viejo, y lo único que lo delataba era la pantalla de éxito.
  //
  // Se cierra por TRES vías, y las tres tienen que existir:
  //   (a) TTL: una cotización vieja NO se envía. Se revalida y el cliente ve el número
  //       fresco antes de poder confirmar.
  //   (b) REFRESCO SILENCIOSO: para que el TTL casi nunca le toque el turno a nadie, la
  //       cotización se renueva sola en segundo plano mientras el modal está abierto, y
  //       al volver la pestaña a primer plano (el caso del móvil es EXACTAMENTE ése).
  //   (c) ATADURA REAL en el servidor: el pedido lleva ECO de lo aprobado y /ordenar-co
  //       responde 409 si al recalcular no le sale lo mismo (ver `cotizacionEsperada`).
  //
  // ⚠️ EL RIESGO DEL TTL, Y CÓMO SE DESACTIVA. Un cliente lento tecleando su dirección
  // NO puede quedarse sin poder comprar. Por eso:
  //   · el refresco automático es SILENCIOSO: no borra el resumen, no bloquea el botón,
  //     no mueve el scroll y —sobre todo— NO TOCA NI UN CAMPO DEL FORMULARIO. Lo que el
  //     cliente escribió vive en el <form>, y nada de este archivo lo reescribe nunca.
  //   · si el refresco silencioso FALLA (red, 429), no se toca la cotización vigente:
  //     sigue viva hasta que caduque de verdad. Un hipo de red no le quita el botón.
  //   · si el TTL vence, el pedido no se pierde: se revalida y, si el total no cambió,
  //     sólo hace falta volver a pulsar FINALIZAR (que ya lleva el total en la etiqueta).
  //     Si cambió, se le pide un gesto explícito. En ningún camino se pierde nada tecleado.
  //
  // 5 minutos: es holgado para llenar el formulario completo (la cascada de dos niveles
  // y diez campos se llenan en 1-3 min) y corto para que un cambio de precio no
  // sobreviva más de una ventana.
  var COTIZACION_TTL_MS = 5 * 60 * 1000;

  // ═══════════════════════════════════════════════════════════════════════════
  // 🔒 EL REFRESCO ES COMODIDAD, NO CORRECCIÓN — MEDIO-C (2026-09-01)
  // ═══════════════════════════════════════════════════════════════════════════
  // La primera versión renovaba la cotización a MITAD DE VIDA (2,5 min) y forzaba una
  // cotización en CADA vuelta a primer plano. Medido con el arnés: un modal ABIERTO Y
  // SIN TOCAR generaba 23 cotizaciones en 60 min, indefinidamente; un cliente
  // alternando de app cada 15 s, 39 en 10 min. Contra el límite real de
  // `cotizar_co` (60/10 min POR IP) bastaban 16 modales quietos —o DOS clientes
  // alternando— para agotarlo, y en Colombia el móvil va mayoritariamente por CGNAT:
  // muchos compradores DISTINTOS comparten IP pública. O sea que un puñado de
  // formularios abiertos dejaba sin poder comprar a todos los demás. Cambiábamos
  // "cobrar un número que no viste" por "no poder comprar", que es peor.
  //
  // La corrección NO depende de este refresco y nunca dependió:
  //   · el submit no envía una cotización rancia (candado (d) del invariante), y
  //   · el servidor RECALCULA y responde 409 si no le sale lo que el cliente aprobó.
  // El 409 es la red REAL y autoritativa, y no gasta cuota de cotización. Por eso el
  // refresco proactivo puede ser barato y puede fallar sin consecuencias.
  //
  // Las tres reglas nuevas, y qué corta cada una:
  //  (1) SEÑAL DE VIDA. El latido sólo recotiza si el cliente TOCÓ algo (tecleó, movió
  //      la cascada, cambió de tier) desde la última cotización. Un modal olvidado en
  //      una pestaña no está a punto de comprar: no necesita un número fresco, y si
  //      algún día pulsa enviar, el candado (d) revalida en ese momento. → el modal
  //      quieto pasa de 23 cotizaciones/hora a CERO.
  //  (2) SÓLO CERCA DEL VENCIMIENTO. Ya no se renueva a mitad de vida sino en el último
  //      minuto de la ventana: mientras la cotización sirve para enviar, refrescarla no
  //      compra nada.
  //  (3) VOLVER A PRIMER PLANO YA NO FUERZA NADA. `visibilitychange`, `focus` y
  //      `pageshow` disparan casi juntos —tres eventos, una sola vuelta— y antes cada
  //      uno era una cotización. Ahora sólo MIRAN EL RELOJ (los timers de una pestaña
  //      dormida no corren, y eso es todo lo que hacía falta cubrir): pasan por el
  //      mismo filtro de edad y de señal de vida que el latido. Un alt-tab de 15 s
  //      deja la cotización fresca, así que no cuesta ni una llamada.
  var MARGEN_PRE_TTL_MS = 60 * 1000;  // sólo se renueva en el último minuto de vida
  var REFRESCO_MS = COTIZACION_TTL_MS - MARGEN_PRE_TTL_MS;
  var LATIDO_MS = 20 * 1000;          // cada cuánto se MIRA el reloj (no cotiza)
  // Anti-ráfaga: cinturón por si las tres vueltas a primer plano coincidieran con el
  // final de la ventana. Con el filtro de edad ya no debería morder nunca; es barato
  // y evita que un futuro emisor nuevo abra la puerta otra vez.
  var REFRESCO_MIN_MS = 60 * 1000;

  // Reloj MONÓTONO. Se miden EDADES, no fechas: con Date.now() un ajuste de NTP o un
  // cambio de hora del teléfono puede hacer que una cotización rancia parezca fresca
  // —que es la dirección peligrosa— o al revés. performance.now() no salta.
  var ahoraMs = (function () {
    var p = (typeof performance !== 'undefined' && performance && typeof performance.now === 'function')
      ? performance : null;
    return p ? function () { return p.now(); } : function () { return Date.now(); };
  })();

  function edadCotizacion() {
    if (tsCotizacion == null) return Infinity;
    var d = ahoraMs() - tsCotizacion;
    return d >= 0 ? d : Infinity;   // reloj hacia atrás ⇒ tratar como caducada, nunca como fresca
  }
  function cotizacionFresca() {
    return !!cotizado && edadCotizacion() <= COTIZACION_TTL_MS;
  }

  // Adicionales votados. VOTO EXPLÍCITO: mandar el objeto `ticks` es lo que convierte
  // al cliente en AUTORIDAD sobre TODOS los índices (router-co.js:707 `clienteVota`), y
  // por tanto lo que impide que el servidor acepte "por defecto" un tick que esta
  // pantalla nunca mostró (ALTO A-1). Va por el MISMO payload a los DOS endpoints
  // (/cotizar-co y /ordenar-co), así que lo cotizado es siempre lo cobrado.
  //
  // 🔒 SE EMITE UNA ENTRADA POR CADA ÍNDICE DEL METAFIELD, TAMBIÉN LOS `false`. El NO
  // explícito y el silencio valen igual para el servidor, pero escribirlo deja el voto
  // legible en la petición y hace la huella estable (las claves enteras de un objeto JS
  // se serializan siempre en orden ascendente, así que `huella()` no baila).
  //
  // 🔒 Y EL `true` SALE DE `ticksState`, QUE SÓLO ESCRIBE LO QUE SE PINTA. El
  // `tickPintable` de aquí es el segundo candado: un índice que no llegó a ser tarjeta
  // no puede votar que SÍ aunque alguien manipulara el estado.
  function upsellsElegidos() {
    var ticks = {};
    TICKS.forEach(function (t, i) {
      // `tickVotado` es el MISMO predicado que decide qué se enseña en el desglose
      // estimado: lo votado y lo enseñado no pueden divergir (ver su nota).
      // El voto viaja como CANTIDAD cuando es que sí (el servidor acepta `true` como 1,
      // así que el protocolo viejo sigue valiendo) y como `false` cuando es que no.
      ticks[i] = tickVotado(t, i) ? tickCantidad(t, i) : false;
    });
    // ⚡ `flashAceptados` YA NO ES UNA CONSTANTE VACÍA (G2, 10-sep): es lo que el
    // cliente aceptó en la cadena post-confirmación, y el array vacío sigue siendo un
    // voto explícito (nada aceptado) cuando no aceptó nada o no hubo ofertas.
    // 🔒 SE COPIA, no se comparte la referencia: la huella es este payload serializado y
    // un `push` posterior de la cadena no puede mutar por detrás la huella ya guardada.
    // 🔒 EL ORDEN ES EL DE LA CADENA (pos ascendente) y sólo crece por el final, así que
    // la huella es estable: dos payloads con los mismos votos serializan igual.
    var flash = [];
    for (var k = 0; k < FLASH_ACEPTADOS.length; k++) {
      flash.push({
        id: String(FLASH_ACEPTADOS[k].id),
        qty: Math.max(1, Math.trunc(Number(FLASH_ACEPTADOS[k].qty)) || 1),
        variantId: FLASH_ACEPTADOS[k].variantId == null ? null : String(FLASH_ACEPTADOS[k].variantId),
      });
      // 📍 LA POSICIÓN MOSTRADA (24-sep): entero 1..9, o no viaja. El servidor la usa SÓLO
      // para el ledger (la Turmalina mostrada 1ª quedaba apuntada en la 3ª, el índice del
      // catálogo). Es estable por construcción —se fija al aceptar y no cambia— así que
      // no mueve la huella entre cotizar y ordenar.
      var pm = Math.trunc(Number(FLASH_ACEPTADOS[k].pos));
      if (pm >= 1 && pm <= 9) flash[flash.length - 1].pos = pm;
    }
    return { ticks: ticks, flashAceptados: flash };
  }

  // 🔒 EL PAYLOAD ES UNO SOLO. La cotización y el pedido mandan EXACTAMENTE esto
  // (el pedido añade `datos`, el honeypot y el eco del total). Si fueran dos
  // constructores distintos, el servidor podría resolver un pedido para cotizar y otro
  // para cobrar — que es justo la divergencia que todo este trabajo cierra. NO DUPLICAR.
  /* ── LOS PRODUCTOS EXTERNOS DEL CARRITO (dictado del dueño 04-sep) ─────────
     «Si la persona elige más productos aparte del dos por uno, en el formulario
     también deben aparecer los otros productos externos que agregó al carrito.»

     🔒 DE AQUÍ SÓLO SALEN IDS Y CANTIDADES. Ni un precio, ni un título, ni un total.
     El servidor los re-precia leyendo Shopify y decide qué se puede vender contra
     entrega; esta pantalla no es —ni puede ser— una segunda autoridad del dinero.
     Por eso tampoco se filtra aquí la pulsera de la landing: el candado del doble
     cobro vive en el servidor (`resolverExternosCo`), que es quien sabe a qué
     PRODUCTO pertenece cada variante.

     ⚠️ SE ORDENA antes de guardarlo. La huella que decide si hay que recotizar es
     `JSON.stringify(payloadPedido())`, y el carrito de Shopify no garantiza un orden
     estable: sin ordenar, el mismo carrito daría dos huellas distintas y el submit se
     bloquearía sin motivo. */
  var EXTERNOS = [];

  /* ── LAS UNIDADES DEL PACK QUE HAY EN EL CARRITO ───────────────────────────
     `null` = todavía no se ha podido leer el carrito. NO es lo mismo que 0: con
     `null` no se toca la escalera, y el formulario se queda en lo que ya mostraba.
     Inventar un 1 ahí abriría el pedido en el escalón más caro por unidad justo
     cuando el cliente tiene tres en el carrito.

     🔴 POR QUÉ SE LEE DEL CARRITO VIVO Y NO DE LIQUID. Esto vivía en
     `carrito-co.liquid` como una constante emitida al cargar la página
     (`PACK_QTY`), y el carrito de Dawn cambia la cantidad por AJAX sin recargar:
     el cliente ponía 2, lo subía a 5 y el formulario seguía abriendo en 2 — un
     dato viejo pintado como si fuera el de ahora. Aquí se relee en CADA apertura,
     que es el único momento en que se sabe qué tiene el cliente delante. */
  var UNIDADES_PACK_CARRITO = null;

  /* ── ¿EL CARRITO LLEVA SÓLO EL PRODUCTO DE LA OFERTA? ──────────────────────
     Dictado del dueño (08-sep): «en caso de que el cliente solamente escoja una
     referencia de producto dos por uno, ahí sí le puedes poner ese recuadro en el
     formulario … con la posibilidad de que si quiere agregarle más o cambiarlo, lo
     pueda hacer desde el formulario».

     Con una sola referencia el formulario PUEDE mandar sobre la cantidad sin
     contradecir nada: el carrito no tiene más piezas con las que cuadrar, así que
     cambiar el escalón allí dentro es lo mismo que cambiarlo en la ficha. Con varios
     productos no: ahí el pedido tiene que ser el carrito, y la escalera se esconde.
     `null` = no se pudo leer el carrito (ver UNIDADES_PACK_CARRITO). */
  var SOLO_EL_PACK = null;

  /* ── QUÉ PIEZA TRAE CADA UNIDAD DEL CARRITO ────────────────────────────────
     Dictado del dueño (09-sep): «si en el carrito escojo dama y caballero, cuando le doy
     al botón me abre el 2x1 con dos unidades de dama; necesito que en el formulario
     salga lo mismo que se escogió en el carrito. Y ya en el formulario, si la persona lo
     quiere cambiar, es libre de cambiarlo».

     Esto estaba DECLARADO como límite esta misma mañana («la variante no se hereda del
     carrito, sólo la cantidad») con el argumento de que era inalcanzable: el único
     producto con `codPropio` tenía una sola variante. Dejó de serlo en cuanto se
     encendieron los seis, y entonces el límite declarado se convirtió en un defecto
     vivo — el cliente elegía un Dama y un Caballero y el formulario le abría dos Dama.

     Array de índices en VARIANTES, uno POR UNIDAD y en el orden del carrito. `null` = no
     se pudo leer o no se pudo emparejar: ahí no se toca nada y cada unidad se queda en su
     valor por defecto, que es lo que hacía antes. */
  var PIEZAS_PACK_CARRITO = null;

  /* ── EL AVISO DE CANTIDAD (arreglo de F1, 2026-09-10) ──────────────────────
     `null` = el pedido dice exactamente lo que dice el carrito y no hay nada que
     advertir. Con texto = el carrito y este pedido NO llevan las mismas unidades, y
     entonces el cliente TIENE que leerlo: la alternativa —la de hasta hoy— era cotizar
     una cantidad distinta a la suya sin decir nada, que es como se pierden $133.660 en
     un pedido de 6 brazaletes.
     Lo escribe SÓLO `fijarUnidadesDelCarrito` (el único sitio que compara las dos
     cantidades) y lo pinta `pintarAvisoCantidad`. */
  var avisoCantidad = null;

  // Clave canónica de unos valores de opción, para emparejar la línea del carrito con
  // la variante del metafield. Misma idea que `resolverVarianteCo` del servidor: por
  // VALORES, nunca por posición — los dos JSON los emiten sitios distintos.
  function claveOpciones(vals) {
    return (vals || []).map(function (x) {
      return String(x == null ? '' : x).trim().toLowerCase();
    }).join('||');
  }

  function leerCarritoVivo() {
    // 🔒 SE OLVIDA ANTES DE PREGUNTAR. Si esta lectura falla, lo que NO puede pasar es
    // que el pedido siga con las unidades de la apertura anterior: el cliente cerró el
    // modal, bajó el carrito de 5 a 2, volvió a abrir con la red caída… y habría pedido
    // 5 con la escalera escondida, o sea sin forma de corregirlo. Con `null` la escalera
    // se DESTAPA (aplicarCarrito) y el cliente ve y decide.
    // ⚠️ Es la regla contraria a la de `EXTERNOS`, y a propósito: allí el dato viejo son
    // artículos que el cliente SÍ metió (borrarlos sería quitarle cosas del pedido);
    // aquí el dato viejo son unidades de MÁS que nadie pidió.
    UNIDADES_PACK_CARRITO = null;
    // ⏱️ (21-oct) Con tiempo límite: un /cart.js colgado dejaba `aplicarCarrito` (y con él
    // la cotización) esperando para siempre. Al vencer cae al `catch` de abajo —se conserva
    // lo que hubiera— y se cotiza igual.
    return conPlazo(function (senal) {
      var init = { credentials: 'same-origin' };
      if (senal) init.signal = senal;
      return fetch('/cart.js', init).then(function (r) { return r.ok ? r.json() : null; });
    }, PLAZO_CARRITO_MS)
      .then(function (c) {
        var items = (c && Array.isArray(c.items)) ? c.items : [];
        EXTERNOS = items
          .map(function (i) { return { variantId: String(i && i.variant_id), cantidad: Math.max(1, Number(i && i.quantity) || 1) }; })
          .filter(function (x) { return /^\d+$/.test(x.variantId); })
          .sort(function (a2, b2) { return a2.variantId < b2.variantId ? -1 : (a2.variantId > b2.variantId ? 1 : 0); });
        // Se SUMAN todas las líneas del pack, no se toma la primera: un producto con
        // varias variantes puede estar en el carrito en dos líneas, y el servidor
        // descarta como `ya_en_el_pack` cualquier línea de este producto que llegue
        // por `externos`. Contar sólo una dejaría fuera unidades que el cliente sí
        // metió, sin decírselo.
        if (PRODUCT_ID_NUM) {
          var suma = 0, halladas = 0, ajenas = 0;
          for (var k = 0; k < items.length; k++) {
            if (String(items[k] && items[k].product_id) !== PRODUCT_ID_NUM) { ajenas++; continue; }
            halladas++;
            suma += Math.max(1, Number(items[k].quantity) || 1);
          }
          /* «El pedido no lleva nada más que este producto» = NO HAY LÍNEAS AJENAS.
             Y punto: que el pack esté o no DENTRO del carrito no cambia la respuesta.
             🐛 Antes exigía además `halladas > 0`, y con el carrito VACÍO eso daba
             `false` — o sea "va mezclado" — y la escalera se escondía en la ficha de
             producto de cualquier visitante que llegara sin nada en el carrito, que es
             el caso más común de todos. Lo destapó la comprobación en la tienda viva,
             no la suite: los `<select>` existían en el DOM y los asserts los contaban
             igual, escondidos o no.
             "Una sola referencia" sigue siendo por PRODUCTO, no por línea: dos colores
             del mismo producto no son líneas ajenas. */
          SOLO_EL_PACK = ajenas === 0;

          // Las piezas, en el orden del carrito y repetidas por su cantidad.
          var porClave = {};
          for (var q = 0; q < VARIANTES.length; q++) {
            porClave[claveOpciones((VARIANTES[q].optionValues || []).map(function (o) { return o && o.name; }))] = q;
          }
          var piezas = [];
          var completo = halladas > 0;
          for (var m = 0; m < items.length; m++) {
            if (String(items[m] && items[m].product_id) !== PRODUCT_ID_NUM) continue;
            // `options_with_values` es lo que da Shopify por línea: [{name, value}].
            var vals = (items[m].options_with_values || []).map(function (o) { return o && o.value; });
            var idx = porClave[claveOpciones(vals)];
            if (!(idx >= 0)) { completo = false; break; }
            var qy = Math.max(1, Number(items[m].quantity) || 1);
            for (var z = 0; z < qy; z++) piezas.push(idx);
          }
          // Si una sola línea no se pudo emparejar, NO se hereda ninguna: media herencia
          // sería peor que ninguna (el cliente vería una pieza suya y otra inventada).
          PIEZAS_PACK_CARRITO = completo ? piezas : null;
          // Sin ninguna línea del pack en el carrito se deja en `null` (no se toca la
          // escalera): es el caso de la FICHA de producto, donde el cliente elige la
          // oferta y el carrito no tiene por qué opinar.
          UNIDADES_PACK_CARRITO = halladas ? suma : null;
        }
      })
      // 🔒 NO se inventa un carrito vacío al fallar: se deja el que hubiera. Un /cart.js
      // caído no puede borrar de la pantalla algo que el cliente sí metió — preferimos
      // el dato viejo a un dato inventado.
      .catch(function (e) {
        /* se conserva EXTERNOS */
        if (e && e.plazo) reportarSalud('plazo_carrito');
      });
  }

  // 🎯 Lo que `origen-co.js` guardó al entrar con `?utm_…&ang=…&fbclid=…` (primera y última visita).
  // `undefined` si no hay nada → `JSON.stringify` omite el campo y el cuerpo es el de siempre.
  function origenGuardado() {
    try {
      var o = (window.CcoOrigen && typeof window.CcoOrigen.leer === 'function') ? window.CcoOrigen.leer() : null;
      return o || undefined;
    } catch (e) { return undefined; }
  }

  function payloadPedido() {
    var t = tierActual();
    var u = unidadesEfectivas();
    var variantesPorUnidad = [];
    for (var i = 0; i < u; i++) {
      var v = necesitaElegirVariante() ? VARIANTES[elecciones[i]] : null;
      variantesPorUnidad.push({
        optionValues: (v && Array.isArray(v.optionValues)) ? v.optionValues : [],
      });
    }
    var out = {
      productGid: PRODUCT_GID,
      // Las tres claves que lee el servidor (router-co.js: `n`, `unidades` del tier
      // abierto, y derivarClaveUnidadesCo para la idempotencia). Sin un solo precio.
      // 🔑 `n` PASA POR `nParaElServidor` (ver su nota): en un producto sin escalera la
      // cantidad viaja AHÍ, porque es lo que el servidor lee para sintetizar el tier.
      // `abierto` sigue siendo la verdad del metafield y nunca se inventa.
      tier: { n: nParaElServidor(t, u), unidades: u, abierto: t.abierto === true },
      variantesPorUnidad: variantesPorUnidad,
      upsells: upsellsElegidos(),
      // Va DENTRO del payload —y no en una llamada aparte— para que viaje gratis a los
      // DOS endpoints y para que la huella de recotización lo cubra sin tocar nada más.
      // ⑥ Con un 2x1 sumado desde la tira, sus piezas viajan AQUÍ (nunca /cart/add): se
      // cotizan y se cobran por el mismo camino. Sin tira, el MISMO array de siempre.
      externos: m6Externos(EXTERNOS),
    };
    // ⑥ Sólo con la mejora encendida: con ella apagada el payload es BYTE A BYTE el de hoy.
    if (M6.barra) {
      out.meta2x1 = true;
      if (EXTRAS_TIRA.length) out.tira2x1 = m6Gids();
    }
    return out;
  }

  // Huella del pedido = el payload serializado. Si cambia un solo campo, la
  // cotización vieja deja de valer y el submit no puede usarla.
  function huella(p) { try { return JSON.stringify(p); } catch (e) { return null; } }

  // El botón se apaga por TRES motivos distintos y ninguno debe pisar al otro: un
  // bloqueo del servidor, una confirmación de precio pendiente, o un envío en curso.
  function refrescarBoton() {
    var off = !!bloqueo || !!confirmacion || enviando;
    btnSubmit.disabled = off;
    btnSubmit.classList.toggle('cco-submit--off', off);
    refrescarControles();
  }

  // 🔒 MEDIO-A · MIENTRAS UN PEDIDO VIAJA, EL PEDIDO NO SE PUEDE CAMBIAR.
  // El botón de enviar ya se apagaba, pero la escalera de packs y el stepper seguían
  // vivos: el cliente podía saltar al tier B con el pedido del tier A en vuelo, y la
  // respuesta del A aterrizaba sobre la selección del B. Congelarlos elimina la
  // carrera EN EL ORIGEN; el guard por token de más abajo es el cinturón para la
  // ventana que ningún `disabled` cubre (un submit por Enter, un clic ya despachado).
  function controlesCongelados() { return enviando || pedidoHecho; }
  function refrescarControles() {
    var off = controlesCongelados();
    elTiers.classList.toggle('cco-controles--off', off);
    elUnidades.classList.toggle('cco-controles--off', off);
    // `elTiers` incluye ahora los ± del stepper (viven dentro de la tarjeta): el
    // selector 'button' los alcanza igual, así que se congelan con la escalera.
    // `button,select`: desde el 09-sep la variante puede ser un DESPLEGABLE dentro de la
    // tarjeta (productos de 4+ opciones). Con sólo 'button' el cliente podía cambiar la
    // pieza con el pedido ya viajando, y se despacharía una distinta de la cotizada.
    var i, nodos = elTiers.querySelectorAll ? elTiers.querySelectorAll('button,select') : [];
    // `|| data-cco-agotada`: desde el 09-sep los chips de variante viven DENTRO de la
    // tarjeta, o sea dentro de `elTiers`. Sin la salvedad —que este barrido ya tenía
    // para el otro contenedor— salir del estado "enviando" volvería a dejar clicable
    // una variante sin existencias.
    for (i = 0; i < nodos.length; i++) nodos[i].disabled = off || nodos[i].hasAttribute('data-cco-agotada');
    nodos = elUnidades.querySelectorAll ? elUnidades.querySelectorAll('button,select') : [];
    // `|| data-cco-agotada`: este barrido DESCONGELA poniendo `disabled = false`, y desde
    // que las variantes son chips (09-sep) los agotados son <button> de este mismo
    // contenedor. Sin la salvedad, salir del estado "enviando" volvería a dejar clicable
    // una variante sin existencias.
    for (i = 0; i < nodos.length; i++) nodos[i].disabled = off || nodos[i].hasAttribute('data-cco-agotada');
    // Los adicionales también son PEDIDO: con la orden en vuelo (o ya creada) marcar
    // un extra cambiaría lo cotizado bajo los pies del pedido que está viajando.
    if (elTicks) {
      elTicks.classList.toggle('cco-controles--off', off);
      nodos = elTicks.querySelectorAll ? elTicks.querySelectorAll('input') : [];
      for (i = 0; i < nodos.length; i++) nodos[i].disabled = off;
    }
    // ⑥ La tira (Sumar/Quitar/elegir) y el atajo del Empaque también son PEDIDO.
    if (M6.barra) m6Congelar();
  }
  function bloquearSubmit(motivo) {
    bloqueo = motivo || null;
    refrescarBoton();
  }

  // ── EL BOTÓN QUE ENVÍA — DOS LÍNEAS ─────────────────────────────────────
  //   línea 1  🚚 ¡FINALIZA TU COMPRA!            ← el llamado, SIN cifra
  //   línea 2  Paga al recibir · $60.700          ← el importe (dictado del dueño 02-sep)
  //
  // 🔒 EL IMPORTE SIGUE SIENDO EL DEL SERVIDOR. Cambia DÓNDE se lee, no de dónde sale:
  // `totalActual` sólo se escribe desde `etiquetarSubmit(q.total)` con el total que
  // devolvió /cotizar-co (o el `desglose` del 409). `null` = todavía no hay total, y
  // entonces NO se inventa ninguno: la línea 2 se queda con "Paga al recibir" a secas.
  //
  // 🔴 Sin "COP" ni "MXN": el formato de la casa es "$60.700" a secas (money(), espejo
  // de formatearCop). Y sin "envío gratis" en ninguna línea — en Colombia se cobra.
  //
  // TEMA VIEJO: si el snippet montado no trae `data-cco-submit-l2`, el importe vuelve a
  // la línea 1 (la forma de antes) en vez de perderse; y sin ninguno de los dos <span>
  // se cae al textContent del botón entero, que es lo que ya hacía.
  var elSubmitL1 = $('[data-cco-submit-l1]');
  var elSubmitL2 = $('[data-cco-submit-l2]');
  function textoSubmit(txt) {
    if (elSubmitL1) elSubmitL1.textContent = txt;
    else btnSubmit.textContent = txt;
  }
  var totalActual = null;
  function etiquetarSubmit(total) {
    if (total !== undefined) totalActual = (total == null) ? null : cop(total);
    if (elSubmitL2) {
      textoSubmit('🚚 ¡FINALIZA TU COMPRA!');
      elSubmitL2.textContent = (totalActual == null)
        ? 'Paga al recibir'
        : 'Paga al recibir · ' + money(totalActual);
      return;
    }
    textoSubmit(totalActual == null
      ? '🚚 ¡FINALIZA TU COMPRA!'
      : '🚚 ¡FINALIZA TU COMPRA! - ' + money(totalActual));
  }

  // ── El aviso de CAMBIO DE PRECIO ─────────────────────────────────────────
  // Vive en su propio elemento, pegado al botón de enviar (donde el cliente está
  // mirando cuando pulsa), y NO dentro del resumen: el resumen se repinta entero en
  // cada cotización y se llevaría el aviso por delante.
  // Si el tema montado es VIEJO y no trae `data-cco-cambio`, el aviso se cuelga del
  // resumen. Sin esa red, un cliente con el snippet antiguo vería el botón apagado y
  // NINGUNA explicación de por qué: un callejón sin salida, que es peor que el defecto
  // que estamos cerrando. (Se re-ancla en cada uso porque pintarResumen reescribe el
  // innerHTML del resumen entero y se lo llevaría por delante.)
  var avisoSuelto = null;
  function contenedorAviso() {
    if (elCambio) return elCambio;
    if (!avisoSuelto) {
      avisoSuelto = document.createElement('div');
      avisoSuelto.className = 'cco-cambio';
    }
    if (avisoSuelto.parentNode !== elResumen) elResumen.appendChild(avisoSuelto);
    return avisoSuelto;
  }
  function mostrarAviso(html, enfocar) {
    var c = contenedorAviso();
    c.innerHTML = html;
    c.hidden = false;
    if (enfocar) enfocarAviso();
  }
  function enfocarAviso() {
    var c = elCambio || avisoSuelto;
    if (!c) return;
    try { c.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* */ }
  }
  function ocultarAviso() {
    if (elCambio) { elCambio.hidden = true; elCambio.innerHTML = ''; return; }
    if (avisoSuelto && avisoSuelto.parentNode) avisoSuelto.parentNode.removeChild(avisoSuelto);
    if (avisoSuelto) avisoSuelto.innerHTML = '';
  }

  // EL GESTO EXPLÍCITO. El precio cambió debajo del cliente: se le enseña el número
  // nuevo, se le dice por qué, y NO se puede enviar hasta que lo acepte a mano. Nunca
  // se cobra sin este gesto. Lo que escribió sigue intacto: aquí no se toca el <form>.
  function pedirConfirmacion(antes, ahora) {
    confirmacion = { antes: antes, ahora: ahora };
    mostrarAviso(
      '<div class="cco-cambio__t">El precio cambió mientras llenabas el formulario</div>' +
      '<div class="cco-cambio__n">Antes: <s>' + money(antes) + '</s> · Ahora: <b>' + money(ahora) + '</b></div>' +
      '<div class="cco-cambio__h">No perdiste nada de lo que escribiste. Revisa el nuevo total arriba y confírmalo para poder enviar tu pedido.</div>' +
      '<button type="button" class="cco-cambio__b" data-cco-aceptar-total>Acepto pagar ' + money(ahora) + '</button>',
      true);
    refrescarBoton();
  }
  function limpiarConfirmacion() {
    confirmacion = null;
    ocultarAviso();
    refrescarBoton();
  }

  // El gesto. Delegado en `root` porque el botón se pinta y se borra.
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-cco-aceptar-total]') : null;
    if (!b) return;
    limpiarConfirmacion();
    mostrarAviso('<div class="cco-cambio__ok">Total actualizado. Ya puedes enviar tu pedido.</div>', false);
  });

  // ── Validez de la respuesta: FAIL-CLOSED (MEDIO-2) ───────────────────────
  // Un 200 con el cuerpo incompleto NO es una cotización. Antes bastaba con
  // `ok:true`: un `{ok:true}` pelado pintaba "Pagas al recibir $0" (money(undefined)
  // → NaN → 0) y encima RE-HABILITABA el submit, o sea que el cliente podía enviar un
  // pedido cuyo total figuraba como cero. No es alcanzable desde nuestro servidor hoy,
  // pero entre el navegador y él hay ngrok y un proxy, y todo el resto de este diseño
  // falla CERRADO: aquí no puede ser la excepción.
  // `items` vacío también se rechaza: un total sin una sola línea que lo explique es
  // justo "te cobramos algo que no te podemos nombrar".
  function esNumero(v) {
    if (v === null || v === undefined || v === '' || typeof v === 'boolean') return false;
    var n = Number(v);
    return typeof n === 'number' && isFinite(n);
  }
  function cotizacionValida(b) {
    if (!b || typeof b !== 'object' || b.ok !== true) return false;
    if (!esNumero(b.total) || Number(b.total) < 0) return false;
    if (!esNumero(b.subtotal) || Number(b.subtotal) < 0) return false;
    if (!Array.isArray(b.items) || b.items.length === 0) return false;
    var e = b.envio;
    if (!e || typeof e !== 'object' || !esNumero(e.costo) || Number(e.costo) < 0) return false;
    return true;
  }

  // 🔒 EL ECO. Los cuatro números que el cliente vio, copiados VERBATIM de la respuesta
  // del servidor (cero aritmética: aquí no se suma un peso, igual que en todo el resto
  // del archivo). Viajan de vuelta en /ordenar-co y el servidor RECHAZA con 409 si al
  // recalcular no le salen los mismos.
  //
  // 🔒 ESTO NO ROMPE "EL CLIENTE JAMÁS MANDA PRECIOS". El eco NO SE USA PARA COBRAR
  // —el servidor lo dice explícitamente en router-co.js §8c— sino SÓLO para RECHAZAR.
  // El precio cobrado sigue saliendo del metafield y de las variantes reales. Un
  // cliente que manipule estos números sólo consigue que su propio pedido se rechace.
  // Si alguien lo lee mañana para construir dinero, ha reabierto el agujero entero.
  function ecoDe(b) {
    return {
      total: b.total,
      subtotal: b.subtotal,
      descuentos: b.descuentos,
      envioCosto: (b.envio || {}).costo,
    };
  }

  function pararTimers() {
    if (timerCotiza) { clearTimeout(timerCotiza); timerCotiza = null; }
    if (timerReintento) { clearTimeout(timerReintento); timerReintento = null; }
    if (timerCuenta) { clearInterval(timerCuenta); timerCuenta = null; }
    pararVigia();
  }

  /* ⏱️ EL VIGÍA DE «CALCULANDO» (21-oct-2026). Red de seguridad por si algo que NO es
     una petición deja la pantalla esperando (una promesa que nunca termina, una
     excepción en un temporizador): si el resumen SIGUE diciendo «Calculando tu total…»
     `VIGIA_CALCULANDO_MS` después de pedir la cotización, se avisa al servidor y se
     fuerza el camino de fallo de siempre (reintento automático → «Reintentar»).
     Se re-arma en cada `programarCotizacion` y al abrir. Si ya se ve otra cosa
     (total, estimado, cuenta atrás del 429, error del servidor) no hace nada. */
  var timerVigia = null;
  function pararVigia() { if (timerVigia) { clearTimeout(timerVigia); timerVigia = null; } }
  function armarVigia() {
    pararVigia();
    timerVigia = setTimeout(function () {
      timerVigia = null;
      try {
        if (modal.hidden || pedidoHecho || cotizado) return;
        if (!elResumen || !elResumen.querySelector('.cco-resumen__cargando')) return;
        reportarSalud('calculando_15s');
        tokenCotiza++;   // lo que siga en vuelo ya no puede pintar encima
        falloSeguro(null, 'normal');
      } catch (e) { /* el vigía jamás rompe nada */ }
    }, VIGIA_CALCULANDO_MS);
  }

  // `falloCotizacion` blindado: si pintar el fallo lanza (datos raros del metafield o
  // del carrito), la pantalla NO se queda en «Calculando»: sale un aviso mínimo con
  // «Reintentar» y queda rastro en el servidor.
  function falloSeguro(r, modo) {
    try { return falloCotizacion(r, modo); }
    catch (e) {
      reportarSalud('excepcion_fallo');
      try {
        if (modo === 'silencioso') return;
        cotizado = null; ecoCotizado = null; huellaCotizada = null; tsCotizacion = null;
        bloquearSubmit('No pudimos calcular tu total ahora mismo.');
        elResumen.innerHTML = '<div class="cco-aviso">No pudimos calcular tu total ahora mismo.' +
          ' <button type="button" class="cco-reintentar" data-cco-reintentar>Reintentar</button></div>';
      } catch (e2) { /* */ }
    }
  }

  // Programa una cotización con debounce: el cliente que toca +/− cinco veces
  // seguidas dispara UNA, no cinco (y el rate-limit del servidor lo agradece).
  //
  // 🔒 MEDIO-1: EL TOKEN SE INCREMENTA AQUÍ, no sólo dentro de cotizar(). Antes esta
  // función invalidaba el estado sin tocarlo, así que durante los 250 ms del debounce
  // + el RTT una respuesta EN VUELO del tier anterior pasaba el guard
  // `token !== tokenCotiza` (nadie había incrementado nada) y pintaba el total del tier
  // VIEJO sobre el tier nuevo, re-habilitando el submit. El cobro estaba protegido por
  // la huella, pero el cliente veía un número que no era el suyo — y lo que el cliente
  // VE es exactamente lo que este trabajo defiende.
  function programarCotizacion() {
    cotizado = null; ecoCotizado = null; huellaCotizada = null; tsCotizacion = null;
    tokenCotiza++;                 // invalida TODA respuesta en vuelo (MEDIO-1)
    limpiarConfirmacion();
    pararTimers();
    reintentos429 = 0;
    bloquearSubmit('Estamos calculando tu total…');
    etiquetarSubmit(null);
    // ⑥ Con la tira debajo del resumen, su colapso a una línea la movería bajo el dedo:
    // se compensa (sin la tira, la línea de siempre).
    if (M6.tira && m6Visible(elTira)) m6SinSalto(function () { elResumen.innerHTML = '<div class="cco-resumen__cargando">Calculando tu total…</div>'; });
    else elResumen.innerHTML = '<div class="cco-resumen__cargando">Calculando tu total…</div>';
    m6AlRecotizar();
    armarVigia();
    timerCotiza = setTimeout(function () { timerCotiza = null; cotizar('normal'); }, 250);
  }

  // Modos:
  //   'normal'       — el cliente cambió algo: se bloquea, se repinta, se recotiza.
  //   'silencioso'   — refresco de fondo: NO bloquea, NO borra nada, NO molesta.
  //                    Si el total cambió, ahí sí se pide el gesto explícito.
  //   'revalidacion' — el cliente pulsó enviar con la cotización caducada: se revalida
  //                    y se le enseña el número fresco ANTES de dejarle confirmar.
  function cotizar(modo) {
    modo = modo || 'normal';
    // ⏱️ (21-oct) Armar el pedido corre DENTRO de un temporizador: si lanzaba (un dato
    // raro del carrito o del metafield), no salía ninguna petición y la pantalla se
    // quedaba en «Calculando…» para siempre. Ahora entra al camino de fallo y avisa.
    var p, h;
    try { p = payloadPedido(); h = huella(p); }
    catch (e) {
      reportarSalud('excepcion_armar');
      falloSeguro(null, modo);
      return Promise.resolve();
    }
    var token = ++tokenCotiza;
    tsUltimoRefresco = ahoraMs();
    enVuelo++;
    var viaje;
    try { viaje = api('/cotizar-co', p, PLAZO_LECTURA_MS); } catch (e) { viaje = Promise.reject(e); }
    var contesto = false;
    return viaje.then(function (r) {
      if (token !== tokenCotiza) return;   // llegó tarde: manda una cotización posterior
      contesto = true;
      if (r.status !== 200 || !cotizacionValida(r.body)) return falloSeguro(r, modo);
      aplicarCotizacion(r.body, h, modo);
    }).catch(function (e) {
      if (token !== tokenCotiza) return;
      if (e && e.plazo) reportarSalud('plazo_cotizar');
      else if (e && e.local) reportarSalud('excepcion_armar');   // no llegó a salir
      else if (contesto) reportarSalud('excepcion_pintar');   // el servidor contestó y pintar lanzó
      falloSeguro(null, modo);
    }).finally(function () {
      // Se decrementa PASE LO QUE PASE, incluida la salida temprana por token viejo:
      // si no, un contador atascado dejaría mudo al refresco de fondo para siempre.
      enVuelo = Math.max(0, enVuelo - 1);
    });
  }

  // Acepta una cotización BUENA y decide si hace falta que el cliente vuelva a mirar.
  function aplicarCotizacion(b, h, modo) {
    // ⑥ CANDADOS V0–V2 del 2x1 sumado, ANTES de que esta cotización pueda desbloquear el
    // envío: si no cuadra, se quita el extra, se dice y se recotiza.
    if (M6.barra && m6DeshacerSiFalla(b)) return;
    var antes = (ecoCotizado && esNumero(ecoCotizado.total)) ? cop(ecoCotizado.total) : null;

    cotizado = b;
    // ⚡ LAS OFERTAS FLASH DEL SERVIDOR, REEMPLAZADAS ENTERAS (G2). No se acumulan: una
    // oferta que él dejó de ofrecer (se agotó, ya está en el carrito, dejó de tener
    // descuento) desaparece de la cadena sola, sin que el front tenga que saber por qué.
    FLASH_OFERTAS = Array.isArray(b.ofertasFlash) ? b.ofertasFlash : [];
    ecoCotizado = ecoDe(b);
    huellaCotizada = h;
    tsCotizacion = ahoraMs();
    reintentos = 0;
    reintentos429 = 0;
    // Ciclo nuevo: el número está fresco, así que el refresco de fondo vuelve a
    // exigir una señal de vida y recupera su techo de intentos (MEDIO-C).
    gestoDesdeCotizacion = false;
    refrescosFondo = 0;
    // ⑥ Ídem al crecer: el resumen gana (o pierde) renglones y la tira no se mueve.
    if (M6.tira && m6Visible(elTira)) m6SinSalto(function () { pintarResumen(b); }); else pintarResumen(b);
    // El servidor manda: si la cotización trae bloqueo, el pedido NO se puede enviar.
    bloquearSubmit(b.bloqueo || null);
    // ⑥ La barra pinta ESTA cotización (la de la huella vigente: las viejas ya las tiró
    // el token) y la tira se recalcula si cambió la base.
    if (M6.barra) m6TrasCotizacion(b);

    var ahora = cop(b.total);
    var cambio = (antes != null && antes !== ahora);

    if (modo === 'normal') {
      // El cambio lo pidió el cliente (otro tier, otra cantidad): el número nuevo es lo
      // que esperaba ver. Nada que confirmar.
      limpiarConfirmacion();
      return;
    }
    if (cambio) {
      pedirConfirmacion(antes, ahora);
      return;
    }
    limpiarConfirmacion();
    if (modo === 'revalidacion') {
      // Caducó por tiempo pero el precio es el mismo: no se le hace pasar por un
      // trámite extra, sólo se le dice que está verificado y que pulse otra vez el
      // botón — que lleva el total escrito en la etiqueta.
      mostrarAviso('<div class="cco-cambio__ok">Verificamos tu total antes de enviar: sigue siendo <b>' +
        money(ahora) + '</b>. Pulsa FINALIZAR PEDIDO para confirmar.</div>', true);
    }
  }

  // ⚠️ MODO DEGRADADO. Sin cotización NO se puede enviar el pedido: preferimos
  // perder la venta a cobrar un número que el cliente no vio. Para que un hipo de
  // red no la cueste igualmente, el fallo TRANSITORIO se reintenta solo (2 veces,
  // 800ms y 2400ms) y siempre queda un botón "Reintentar".
  // Un 400 NO se reintenta: el servidor ya dijo qué está mal con el pedido (tier
  // inexistente, variante irresoluble…) y repetirlo daría el mismo 400 — ahí lo útil
  // es enseñarle su mensaje, que ya viene escrito para el cliente colombiano.
  // ── Desglose ESTIMADO (sólo cuando el servidor no contesta) ───────────────
  // Se arma con lo ÚNICO que esta pantalla puede saber sin preguntarle a nadie: QUÉ
  // pack eligió el cliente y CUÁNTAS unidades marcó el stepper. Va rotulado como
  // estimado, pintado en un bloque VISUALMENTE SUBORDINADO (.cco-est) y con el submit
  // bloqueado; en cuanto llega la cotización real, `pintarResumen` lo reemplaza con
  // los números del servidor.
  //
  // ═══════════════════════════════════════════════════════════════════════════
  // 🔴 AQUÍ SE PINTA EL ENVÍO, PERO **NUNCA** UN TOTAL CON CIFRA.
  // ═══════════════════════════════════════════════════════════════════════════
  // El TOTAL sigue sin estimarse: la fila "Total" dice "los confirma el sistema". Ese
  // número es el que el cliente usa para decidir la compra y sólo lo puede decir quien
  // va a cobrarlo — y en él entran cosas que esta pantalla no conoce (los adicionales
  // que el servidor acepte, cualquier regla del metafield que llegue rancia a la caché
  // de Shopify). Si alguien escribe aquí una suma que termine en un TOTAL, ha reabierto
  // el agujero que este archivo cerró el 2026-09-01.
  //
  // El ENVÍO sí se estima (dictado del dueño 02-sep, pedido tres veces): un cliente
  // colombiano que ve "Subtotal" y nada más no sabe si va a pagar flete. Se hace con las
  // dos constantes con nombre `ENVIO_ESPEJO_COSTO` / `ENVIO_ESPEJO_UMBRAL` —espejo
  // DECLARADO de ENVIO_CO_COSTO / ENVIO_CO_UMBRAL, ver la nota grande de arriba— y con
  // la MISMA regla inclusiva del servidor, sobre el subtotal efectivo de más abajo.
  //
  // ⚠️ LA VEZ QUE MINTIÓ, PARA QUE NO SE REPITA: esta función llegó a calcular el envío
  // con `t.precio` a secas, sin mirar las unidades → con el stepper en 4 enseñaba
  // $60.700 mientras el servidor iba a cobrar $172.000, y encima sumaba un TOTAL con
  // ese número. Lo que lo arregla NO es "tener cuidado": es que el envío se calcula
  // sobre `linea` —el subtotal efectivo que espeja `resolverTierAbiertoCo`, el mismo que
  // se pinta dos líneas más arriba— y que el total sigue sin escribirse.
  //
  // "Gratis" del envío sí se pinta cuando el subtotal efectivo cruza el umbral.
  // ⚠️ ACTUALIZADO 02-sep: el estimado YA lista y suma los adicionales marcados, así
  // que su base ya NO es estructuralmente menor que la del servidor: es la MISMA.
  // Se pierde aquel colchón, y a cambio los dos coinciden. Medido con 9.600
  // combinaciones (tamaños de pack × precios × factores de comparación × abierto y
  // cerrado × 1-12 unidades con el clamp × 3 juegos de adicionales): CERO
  // divergencias en subtotal, descuentos, base de envío, costo y veredicto `gratis`.
  // La divergencia que queda es la del metafield rancio de la caché de Shopify, que
  // ya existía para el precio del pack y no crece con esto.
  //
  // ⚠️ Y EL ESTIMADO RESPETA EL STEPPER. Antes usaba `t.precio` a secas y rotulaba
  // las unidades del TIER: con el tier ABIERTO puesto en 4 unidades enseñaba el
  // precio de 1 (y decía "1 unidad" con el stepper marcando 4). Aquí se espeja
  // EXACTAMENTE la cuenta del servidor para el tier abierto
  // (`resolverTierAbiertoCo`, router-co.js:611-616: `unitario = precio / n` y
  // `total = enteroCop(unitario * capadas)`), que es la MISMA aritmética de tier que
  // el resto de este archivo ya conoce vía `unidadesEfectivas()` — no una regla de
  // dinero nueva: aquí no entra ni el envío, ni el umbral, ni ningún descuento que
  // sólo conozca el servidor. En los tiers CERRADOS `t.precio` YA es el precio del
  // pack COMPLETO: no se multiplica por nada.
  //
  // `nota` y `conReintentar` son la NOTA DISCRETA que sustituye a la caja de alarma
  // (dictado del dueño 02-sep). Van DENTRO del párrafo "Estimado…" que ya existía, en
  // vez de en un bloque aparte, para que las dos frases no digan lo mismo dos veces.
  // `conDesglose` es false cuando el servidor contestó 4xx: si acaba de decir que
  // esta oferta no existe (`oferta_no_disponible`), ponerle precio a lo que rechazó
  // es absurdo — ahí va la nota sola.
  // 🔒 Comunicar distinto NO afloja el candado: `cotizado` sigue en null y el submit
  // sigue bloqueado por `bloquearSubmit(msg)`, que lo hace quien llama a esto.
  function pintarEstimado(nota, conReintentar, conDesglose) {
    var t = TIERS[tierIdx];
    var h = '';

    // Sin tier no hay desglose que pintar, pero la NOTA se pinta igual: un botón
    // apagado y mudo es un callejón sin salida (antes un `return` temprano aquí
    // dejaba al cliente sin ninguna explicación).
    if (conDesglose && t) {
      // Las unidades REALES del pedido — la misma fuente que arma el payload que se
      // cotiza y se pide (`payloadPedido`), no las del tier.
      var u = unidadesEfectivas();
      // Espejo de resolverTierAbiertoCo, en la ÚNICA copia que tiene este archivo
      // (`precioTierEscalado`): la misma que usa la tarjeta de la oferta, para que el
      // desglose y la tarjeta no puedan enseñar dos precios del mismo pedido.
      var pr = precioTierEscalado(t, u);
      var linea = pr.precio;
      // `subtotal` es el ANTES (lo que el servidor llama `antesPack`: la comparación si
      // la hay, y si no el propio precio — orden-co.js:240).
      var subtotal = (pr.comparacion > pr.precio) ? pr.comparacion : pr.precio;

      // ── LOS ADICIONALES MARCADOS (dictado del dueño 02-sep) ──────────────
      // Antes el estimado no los listaba: el cliente marcaba "Empaque Premium" y el
      // desglose que tenía delante no cambiaba ni un peso — el mismo bug de confianza
      // que el camino del servidor ya tenía prohibido.
      //
      // 🔒 LA ARITMÉTICA ES LA DEL SERVIDOR, no una nueva (calcularDesgloseCo,
      // orden-co.js:262-275): el tick entra al SUBTOTAL por su `comparacion` (precio de
      // lista) cuando la tiene —igual que el pack entra por la suya— y a los PRODUCTOS
      // por lo que se cobra; la diferencia cae sola en `descuentos`. Un tick sin
      // comparación aporta lo mismo a los dos lados y por tanto 0 de descuento, que es
      // exactamente lo que hace él.
      var extras = ticksEstimados();
      // `productos` = lo que se COBRA por producto, y es la base del envío (el
      // `subtotalProductos` del servidor). Ver la nota de `envioEstimado`.
      var productos = linea;
      var i;
      for (i = 0; i < extras.length; i++) {
        // CANTIDAD (04-sep): el estimado tiene que multiplicar igual que el servidor,
        // o el provisional y el definitivo dirían dos números distintos por lo mismo.
        var qe = Math.max(1, Math.trunc(Number(extras[i].qty)) || 1);
        productos += extras[i].precio * qe;
        subtotal += ((extras[i].comparacion > extras[i].precio) ? extras[i].comparacion : extras[i].precio) * qe;
      }
      var descuentos = (subtotal > productos) ? (subtotal - productos) : 0;
      // ── EL RÓTULO Y LA CANTIDAD (dictado del dueño 02-sep) ───────────────
      // La cantidad pasa a la MISMA píldora `×N` que usa el camino del servidor, y se
      // pinta SIEMPRE —también con una sola unidad—, que es justo lo que se pedía.
      // Antes las unidades iban dentro del rótulo en palabras ("HOY 2X1 · 2 unidades");
      // dejar las dos cosas habría hecho leer "2 unidades ×2".
      // El respaldo cuando el tier no trae `titulo` es 'Tu pedido', que es EXACTAMENTE
      // el que usa el servidor cuando el producto no tiene título (orden-co.js:602):
      // no se inventa una etiqueta nueva, se espeja la suya — así el renglón no cambia
      // de nombre cuando la cotización sustituye al estimado.
      var etiqueta = t.titulo ? String(t.titulo) : 'Tu pedido';

      // El TACHADO del pack (dictado del dueño 03-sep), con la MISMA comparación que
      // ya alimenta a `subtotal` cuatro líneas más arriba — no una segunda lectura del
      // tier. Va también aquí, y no sólo en el camino del servidor, porque si no el
      // renglón GANARÍA un tachado al llegar la cotización y el bloque daría un salto
      // justo en la línea del producto.
      var tachadoPack = (pr.comparacion > pr.precio)
        ? '<s class="cco-li__antes">' + money(pr.comparacion) + '</s> ' : '';
      h += '<div class="cco-est">';
      h += '<div class="cco-li"><span class="cco-li__n">' + esc(etiqueta) +
           ' <span class="cco-li__q">×' + u + '</span></span>' +
           '<span class="cco-li__p">' + tachadoPack + money(linea) + '</span></div>';
      // 🔒 LOS ADICIONALES VAN **ARRIBA**, CON LAS LÍNEAS, NO DEBAJO DE DESCUENTOS.
      // Son parte de lo que COMPONE el subtotal (así los suma el servidor), así que
      // ponerlos después como un sumando haría que la cuenta no cerrara: el cliente
      // leería Subtotal − Descuentos + Adicional y le saldría el extra cobrado dos
      // veces. Mismo sitio y misma piel que en `pintarResumen`, para que la pantalla no
      // dé un salto cuando el estimado se reemplaza por la cotización de verdad.
      for (i = 0; i < extras.length; i++) {
        var qx = Math.max(1, Math.trunc(Number(extras[i].qty)) || 1);
        var tachadoX = (extras[i].comparacion > extras[i].precio)
          ? '<s class="cco-li__antes">' + money(extras[i].comparacion * qx) + '</s> ' : '';
        // `×1` fijo, y no es decorativo: el servidor manda cada adicional con `qty:1`
        // (orden-co.js), así que ésta es la MISMA cantidad que se va a cobrar. Sin
        // ella, al llegar la cotización la línea del extra aparecería de pronto con un
        // `×1` que antes no estaba.
        h += '<div class="cco-li"><span class="cco-li__n">' + esc(extras[i].titulo) +
             ' <span class="cco-li__q">×' + qx + '</span></span>' +
             '<span class="cco-li__p">' + tachadoX + money(extras[i].precio * qx) + '</span></div>';
      }
      h += '<div class="cco-sep"></div>';
      h += '<div class="cco-li"><span>Subtotal</span><span class="cco-li__p">' + money(subtotal) + '</span></div>';

      // ── ENVÍO (dictado del dueño 02-sep) ────────────────────────────────
      // Va JUSTO DEBAJO DE SUBTOTAL, en el mismo orden que el desglose del servidor
      // (`pintarResumen`) y que el pantallazo del dueño, para que el cliente no tenga
      // que releer la pantalla cuando llega la cotización y el bloque se cambia.
      // 🔒 SOBRE `productos`, NUNCA SOBRE `t.precio`: `productos` es el subtotal
      // efectivo —el que respeta el stepper y ahora también los adicionales—. Con
      // `t.precio` fue con lo que este bloque mintió.
      var envio = envioEstimado(productos);
      h += '<div class="cco-li"><span>Envío</span><span class="cco-li__p">' +
           (envio.gratis
             ? '<span class="cco-envio">Gratis</span>'
             : money(envio.costo)) +
           '</span></div>';

      if (descuentos > 0) {
        // 🏷️ A LA DERECHA del rótulo (dictado del dueño 02-sep). El emoji vivía SÓLO en
        // `pintarResumen` —el camino del servidor—, así que en la práctica no se veía
        // nunca: lo que el cliente tiene delante durante los primeros instantes, y cada
        // vez que el servidor tarda, es ESTE bloque. El TONO no se copia: el rojo del
        // renglón de descuentos es del camino del servidor, aquí sigue gris
        // (`.cco-est .cco-desc`), porque nada del estimado puede pesar más que el
        // desglose de verdad.
        h += '<div class="cco-li cco-desc"><span>Descuentos 🏷️</span><span class="cco-li__p">-' + money(descuentos) + '</span></div>';
      }

      // Separador antes del Total (dictado del dueño 02-sep): la misma raya que el
      // camino del servidor —y desde esta tanda la misma raya NEGRA (`--fuerte`)—,
      // para que la jerarquía del pantallazo se conserve también aquí y el bloque no
      // cambie de forma al ser reemplazado. Es lo ÚNICO de la forma que se copia: el
      // VALOR sigue siendo texto, nunca una cifra.
      h += '<div class="cco-sep cco-sep--fuerte"></div>';
      // La línea que ocupa el lugar del TOTAL. El RÓTULO dice "Total" a secas (dictado
      // del dueño 02-sep); el VALOR sigue siendo texto, nunca una cifra: el total es
      // justo lo que esta pantalla no puede saber, y el submit sigue bloqueado hasta
      // que lo diga el servidor.
      // 🔒 Y NO CRECE CON EL TOTAL DE VERDAD: `.cco-tot` sube a 19px y este bloque
      // entero se queda en 12px (`.cco-est`), así que el provisional no puede verse más
      // definitivo que el definitivo — la regla del bloque estimado, intacta.
      h += '<div class="cco-li cco-est__pend"><span>Total</span>' +
           '<span class="cco-est__pendv">los confirma el sistema</span></div>';
      h += '</div>';
    }

    // La nota: "Estimado." + (por qué todavía no se puede pedir) + el enlace de
    // reintento. `data-cco-reintentar` es lo que engancha el listener delegado de
    // elResumen, así que el botón sigue funcionando exactamente igual que en la caja.
    h += '<p class="cco-estimado">' +
         (conDesglose ? 'Estimado. ' : '') +
         (nota ? esc(nota) + ' ' : '') +
         'El envío y el total definitivo los confirma el sistema antes de que puedas pedir.' +
         (conReintentar
           ? ' <button type="button" class="cco-reintentar" data-cco-reintentar>Reintentar</button>'
           : '') +
         '</p>';
    elResumen.innerHTML = h;
    elResumen.hidden = false;
  }

  // 🔒 LA SALIDA DE LA CADENA NO PUEDE DESAPARECER EN EL FALLO QUE LA HACE FALTA.
  // `falloCotizacionDe` llama a `limpiarConfirmacion()`, que vacía el aviso donde vive el
  // botón «enviar sin la oferta»: sin este repinte, el cliente que aceptó una oferta se
  // quedaba otra vez sin salida justo cuando la cotización vuelve a fallar (y el reintento
  // automático garantiza que eso pase, no es un borde raro).
  // · Va al FINAL a propósito: los dos caminos de abajo reescriben `elResumen`, y en un
  //   tema VIEJO sin `data-cco-cambio` el aviso cuelga de ahí y se lo llevarían.
  // · `!cotizado` acota el repinte al estado ROTO: un refresco de fondo que falla sale por
  //   arriba sin tocar nada y no tiene por qué enseñar ninguna salida.
  // · NO se cancela la cotización en vuelo: si acaba llegando, `aplicarCotizacion` deja el
  //   total CON la oferta y el botón vivo —el mejor desenlace posible— y se lleva este
  //   aviso por delante, que es lo correcto porque ya no hay nada de lo que salir.
  function falloCotizacion(r, modo) {
    // ⑥ Sin cotización fiable la barra NO promete nada (S0': el umbral del servidor, si
    // lo había, o el espejo).
    if (M6.barra && modo !== 'silencioso') m6PintarBarra(m6UltimoQ, 'sindato');
    var out = falloCotizacionDe(r, modo);
    if (!cotizado && FLASH_ACEPTADOS.length && flashAprobada) flashPintarSalida();
    return out;
  }
  function falloCotizacionDe(r, modo) {
    var status = r ? r.status : 0;

    // 🔒 UN REFRESCO DE FONDO QUE FALLA NO PUEDE QUITARLE EL BOTÓN A NADIE. La
    // cotización vigente sigue siendo válida hasta que caduque por TTL; ahí sí manda el
    // camino ruidoso. Si esto bloqueara, un hipo de red a mitad de un formulario ya
    // lleno le costaría la venta a un cliente que no hizo nada mal.
    if (modo === 'silencioso') return;

    cotizado = null; ecoCotizado = null; huellaCotizada = null; tsCotizacion = null;
    limpiarConfirmacion();
    etiquetarSubmit(null);

    if (status === 429) return fallo429(r, modo);

    var esDeDatos = status >= 400 && status < 500;   // el 429 ya se fue por arriba
    var msg = (esDeDatos && r.body && r.body.error)
      ? String(r.body.error)
      : 'No pudimos calcular tu total ahora mismo.';
    bloquearSubmit(msg);

    // 🔒 EL DESGLOSE SE PINTA IGUAL, marcado como estimado, para que el cliente vea
    // qué está pidiendo mientras el servidor no contesta. NO toca el invariante:
    // `cotizado` sigue en null y los cinco candados del submit siguen puestos, así que
    // NO se puede crear un pedido con este número. Es DISPLAY, nunca autoridad — y
    // sólo del PRODUCTO: el envío y el total no se estiman (ver pintarEstimado).
    //
    // 🔴 CON UN 4xx NO SE PINTA DESGLOSE. `esDeDatos` significa que el servidor
    // examinó ESTE pedido y lo rechazó (`oferta_no_disponible`, variante irresoluble,
    // tier que no está en el metafield…). Enseñarle un precio a un pedido que acaba
    // de ser rechazado es peor que no enseñar ninguno: sugiere que existe. Ahí va
    // sólo la nota con el mensaje del servidor, que ya viene escrito para el cliente.
    //
    // 02-sep: el motivo y el reintento pasan a la NOTA DISCRETA de `pintarEstimado`
    // (texto pequeño, gris, sin caja) en vez de la caja de alarma .cco-aviso que había
    // aquí. El cliente sigue leyendo por qué el botón está apagado —eso NO se puede
    // quitar: un botón muerto y mudo es un callejón sin salida— pero sin el borde
    // rojizo que lo asustaba encima de un desglose que ya está a la vista.
    if (!esDeDatos && reintentos < 2) {
      reintentos++;
      // Mientras hay reintento automático NO se ofrece el manual: pulsarlo sólo
      // adelantaría el mismo viaje que ya está programado.
      pintarEstimado(msg + ' Reintentando… (' + reintentos + '/2)', false, true);
      programarReintento(reintentos === 1 ? 800 : 2400, modo);
      return;
    }
    // Agotados los reintentos automáticos (o error de datos, que repetir no arregla):
    // la nota se queda visible con el enlace de Reintentar; el desglose sólo si el
    // fallo NO fue un rechazo de datos.
    if (!esDeDatos) reportarSalud('reintentos_agotados');   // ⏱️ 21-oct: que nos enteremos
    pintarEstimado(msg, true, !esDeDatos);
  }

  // ── 429: CASO PROPIO (MEDIO-3) ───────────────────────────────────────────
  // Antes el 429 caía en el saco de los transitorios: se TIRABA el mensaje del servidor
  // y se IGNORABA Retry-After, se reintentaba a 800 ms y 2400 ms (o sea, dentro de la
  // misma ventana del límite → dos 429 más) y se acababa con un "no pudimos calcular"
  // genérico. Bajo CGNAT —normal en el móvil colombiano— varios compradores REALES
  // comparten IP, así que aquí no hay ningún abuso que castigar: hay un cliente que se
  // queda sin poder comprar y sin entender por qué.
  // Ahora: se respeta la espera que dice el servidor, se explica que es temporal y que
  // no es culpa de sus datos, se ve la cuenta atrás, y hay un botón para forzarlo.
  var ESPERA_429_MAX_SEG = 45;   // por encima de esto no se le hace mirar una cuenta atrás
  var REINTENTOS_429 = 3;

  // La espera sale, en este orden, de: el cuerpo (`reintentarEnSeg`, siempre legible),
  // la cabecera `Retry-After` (sólo si el servidor la expone por CORS; acepta segundos
  // o fecha HTTP) y, si ninguna está, una espera corta y honesta.
  function segundosDeReintento(r) {
    var v = null;
    if (r && r.body && esNumero(r.body.reintentarEnSeg)) v = Number(r.body.reintentarEnSeg);
    if (!(v > 0) && r && r.headers && typeof r.headers.get === 'function') {
      var h = null;
      try { h = r.headers.get('Retry-After'); } catch (e) { h = null; }
      if (h != null && String(h).trim() !== '') {
        var txt = String(h).trim();
        if (esNumero(txt)) v = Number(txt);
        else {
          var t = Date.parse(txt);
          if (!isNaN(t)) v = Math.ceil((t - Date.now()) / 1000);
        }
      }
    }
    if (!(v > 0)) v = 5;
    // El techo (1 h) es sólo anti-absurdo. NO se recorta a un número "bonito": el
    // texto que ve el cliente dice la espera REAL del servidor, y decirle "5 minutos"
    // cuando faltan 10 sería mandarle a chocarse otra vez contra el mismo 429.
    // La espera larga nunca se convierte en un temporizador: el auto-reintento sólo
    // corre por debajo de ESPERA_429_MAX_SEG.
    return Math.max(1, Math.min(3600, Math.round(v)));
  }

  function textoEspera(seg) {
    if (seg < 60) return seg + ' segundos';
    var m = Math.ceil(seg / 60);
    return m + (m === 1 ? ' minuto' : ' minutos');
  }

  function fallo429(r, modo) {
    var msg = (r && r.body && r.body.error)
      ? String(r.body.error)
      : 'Estamos recibiendo muchas consultas en este momento.';
    var seg = segundosDeReintento(r);
    bloquearSubmit(msg);

    if (reintentos429 < REINTENTOS_429 && seg <= ESPERA_429_MAX_SEG) {
      reintentos429++;
      cuentaAtras(msg, seg);
      programarReintento(seg * 1000, modo);
      return;
    }
    reportarSalud('limite_429');   // ⏱️ 21-oct: que nos enteremos (agotó su espera)
    elResumen.innerHTML = '<div class="cco-aviso">' + esc(msg) +
      ' <b>Es temporal y no tiene que ver con tu pedido ni con tus datos</b>' +
      ' (a veces varios compradores comparten la misma conexión).' +
      ' Espera ' + textoEspera(seg) + ' y vuelve a intentarlo.' +
      '<button type="button" class="cco-reintentar" data-cco-reintentar>Reintentar</button></div>';
  }

  // Cuenta atrás visible. Sólo escribe en el resumen (no hay ningún input ahí dentro,
  // así que repintarlo cada segundo no puede borrarle nada al cliente).
  function cuentaAtras(msg, seg) {
    var quedan = seg;
    var tk = tokenCotiza;
    function pinta() {
      elResumen.innerHTML = '<div class="cco-aviso">' + esc(msg) +
        ' <b>Es temporal, no es un problema con tu pedido.</b>' +
        ' Lo reintentamos en <b>' + quedan + 's</b>.' +
        '<button type="button" class="cco-reintentar" data-cco-reintentar>Reintentar ahora</button></div>';
    }
    pinta();
    if (timerCuenta) clearInterval(timerCuenta);
    timerCuenta = setInterval(function () {
      // Si hubo una cotización más nueva, esta cuenta atrás ya no describe nada.
      if (tk !== tokenCotiza) { clearInterval(timerCuenta); timerCuenta = null; return; }
      quedan--;
      if (quedan <= 0) { clearInterval(timerCuenta); timerCuenta = null; return; }
      pinta();
    }, 1000);
  }

  // Reintento automático ATADO AL TOKEN: si mientras esperaba el cliente cambió de tier
  // (y por tanto ya hay otra cotización en marcha), este reintento sobra y no se dispara.
  function programarReintento(ms, modo) {
    var tk = tokenCotiza;
    if (timerReintento) clearTimeout(timerReintento);
    timerReintento = setTimeout(function () {
      timerReintento = null;
      if (tk !== tokenCotiza) return;
      cotizar(modo);
    }, ms);
  }

  // Reintento MANUAL. Va delegado en elResumen porque el botón se repinta.
  elResumen.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-cco-reintentar]') : null;
    if (!b) return;
    reintentos = 0;
    reintentos429 = 0;
    programarCotizacion();
  });

  // ── REFRESCO SILENCIOSO: que el TTL casi nunca le toque el turno a nadie ──
  // No interrumpe, no bloquea el botón, no borra el resumen y NO TOCA EL FORMULARIO.
  // Sólo si el total cambió de verdad aparece el aviso y se pide el gesto.
  function refrescoSilencioso() {
    if (modal.hidden) return;                     // nadie está comprando
    // 🔒 Con el pedido YA CREADO no hay nada que recotizar: seguir haciéndolo gastaría
    // el rate-limit (compartido bajo CGNAT con compradores reales) y, peor, podría
    // sacarle un "el precio cambió" a alguien que ya tiene su orden hecha.
    if (pedidoHecho) return;
    if (enviando) return;                         // hay un pedido en vuelo: no lo tocamos
    if (confirmacion) return;                     // ya hay un cambio esperando gesto
    if (bloqueo) return;                          // el camino ruidoso ya está en ello
    if (!cotizado) return;                        // nada que refrescar
    if (timerCotiza || timerReintento) return;    // ya hay una cotización programada
    // 🔒 Y una PEDIDA y sin contestar también cuenta. Sin esto, una petición lenta o
    // colgada dejaba al latido disparando una cotización nueva cada 20 s contra el
    // mismo rate-limit que bajo CGNAT comparten otros compradores reales — y la
    // primera que volviera llegaría con el token ya caducado, o sea trabajo tirado.
    if (enVuelo > 0) return;

    // 🔒 MEDIO-C · LOS DOS FILTROS QUE VACÍAN EL MODAL QUIETO.
    // Nótese que `forzar` YA NO SALTA EL FILTRO DE EDAD: volver a primer plano deja de
    // ser "cotiza otra vez" y pasa a ser "mira el reloj ahora" (los timers de una
    // pestaña dormida no corren, y cubrir eso es TODO lo que hacían falta los tres
    // eventos). Un alt-tab de 15 s encuentra la cotización fresca y no cuesta nada.
    if (!gestoDesdeCotizacion) return;               // nadie está llenando nada
    if (refrescosFondo >= MAX_REFRESCOS_FONDO) return;  // techo duro por cotización
    if (edadCotizacion() < REFRESCO_MS) return;      // todavía sirve para enviar

    var desdeUltimo = ahoraMs() - tsUltimoRefresco;
    if (desdeUltimo >= 0 && desdeUltimo < REFRESCO_MIN_MS) return;  // anti-ráfaga
    refrescosFondo++;
    cotizar('silencioso');
  }

  // SEÑAL DE VIDA. Un cliente que teclea su dirección SÍ está a punto de comprar, y a
  // ése le ahorramos el viaje extra de la revalidación renovándole el total antes de
  // que caduque. Escuchar es GRATIS y —importante— estos handlers NO TOCAN NI LEEN NI
  // REESCRIBEN ningún campo: sólo levantan una bandera. Lo que el cliente escribió
  // vive en el <form> y nada de este archivo lo modifica jamás.
  function marcarGesto() { gestoDesdeCotizacion = true; }
  form.addEventListener('input', marcarGesto);
  form.addEventListener('change', marcarGesto);

  // El latido MIRA el reloj; no cotiza por su cuenta. Vive sólo mientras el modal está
  // abierto: un temporizador corriendo en una página que nadie está usando es gasto y
  // ruido en el rate-limit compartido por CGNAT.
  function arrancarLatido() {
    if (timerLatido) return;
    timerLatido = setInterval(function () { refrescoSilencioso(); }, LATIDO_MS);
  }
  function pararLatido() {
    if (timerLatido) { clearInterval(timerLatido); timerLatido = null; }
  }

  // Volver a primer plano es EL caso del móvil: el cliente se fue a otra app con el
  // modal abierto y vuelve diez minutos después, con los timers congelados mientras
  // tanto. `pageshow` con `persisted` cubre el botón "atrás" restaurando la página
  // desde bfcache, donde el JS ni se enteró.
  //
  // 🔒 MEDIO-C: los tres eventos disparan CASI JUNTOS en una sola vuelta a la app, y
  // antes cada uno forzaba su propia cotización. Ahora los tres hacen lo MISMO que el
  // latido —mirar el reloj— y pasan por los mismos filtros; la ráfaga de tres se
  // colapsa sola porque el primero que recotice deja `enVuelo > 0` y actualiza el
  // anti-ráfaga para los otros dos.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refrescoSilencioso();
  });
  window.addEventListener('focus', function () { refrescoSilencioso(); });
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) refrescoSilencioso();
  });

  // ── Resumen: lo pinta el SERVIDOR, este código sólo lo formatea ───────────
  // `q` es la respuesta de /cotizar-co. Ni una suma aquí: cada número sale tal cual
  // del desglose que se va a cobrar.
  // Frases de los códigos de rechazo del carrito. Las escribe LA PANTALLA a partir de
  // un CÓDIGO estable, no el servidor: así el texto se cambia sin tocar el backend y
  // un consumidor futuro (WhatsApp) puede decirlo con sus palabras. Lección del caso
  // Sofía: clasificar por prosa es cómo un fallo de estado se volvió "el código postal
  // no coincide".
  var MOTIVO_EXTERNO = {
    agotado: 'se agotó',
    no_cod: 'no se puede pagar contra entrega',
    no_vendible: 'ya no está disponible',
    precio_no_entero: 'no se puede cobrar contra entrega',
    ya_en_el_pack: 'ya va incluido arriba'
  };

  // 🔒 UN ARTÍCULO QUE DESAPARECE SIN DECIR NADA ES PEOR QUE UNO RECHAZADO. El cliente
  // metió algo al carrito; si no sale en el resumen y nadie se lo explica, se queda
  // creyendo que va en el pedido. No bloquea: el pack sigue en pie.
  function pintarExternosRechazados(q) {
    var r = (q && Array.isArray(q.externosRechazados)) ? q.externosRechazados : [];
    // 🔴 `ya_en_el_pack` NO SE LE DICE AL CLIENTE, y lo destapó la prueba del carrito:
    // desde /cart el formulario manda el carrito ENTERO, así que la propia pulsera del
    // 2x1 llega también como externo y el servidor la descarta para no cobrarla dos
    // veces. Es un candado interno, no un rechazo: esa pieza SÍ entró al pedido, arriba,
    // como pack. Decir "un artículo de tu carrito no entró" sobre lo que el cliente está
    // viendo cobrado dos renglones más arriba es peor que no decir nada.
    r = r.filter(function (x) { return x && x.motivo !== 'ya_en_el_pack'; });
    if (!r.length) return '';
    var cuantos = r.length === 1 ? 'Un artículo de tu carrito' : (r.length + ' artículos de tu carrito');
    var motivos = [];
    for (var i = 0; i < r.length; i++) {
      var m = MOTIVO_EXTERNO[r[i] && r[i].motivo] || 'no se puede enviar contra entrega';
      if (motivos.indexOf(m) < 0) motivos.push(m);
    }
    return '<p class="cco-estimado">' + esc(cuantos + ' no entró a este pedido: ' + motivos.join(' · ') +
      '. Lo demás sí va.') + '</p>';
  }

  function pintarResumen(q) {
    var h = '';

    // Lo que se va a COBRAR, línea por línea — incluidos los adicionales que el
    // servidor aceptó. Esto es el candado del ALTO A-1: si algo entra al total,
    // entra a esta lista, porque las dos salen del mismo sitio.
    //
    // ✅ SHAPE VERIFICADO CONTRA EL SERVIDOR (orden-co.js:603-622, 02-sep). `items` es
    // SIEMPRE un array y el pack es el elemento [0]; cada adicional aceptado entra como
    // UN elemento más, del tipo `{ tipo:'tick', titulo, qty:1, precio }` con
    // `comparacion` sólo cuando es mayor que el precio (los flash añaden además
    // `precioBase` y `precioUnitario`). El bucle no filtra por `tipo`: pinta TODO lo que
    // venga, que es la única forma de que un adicional no pueda cobrarse sin verse.
    m6AgruparItems(q.items || []).forEach(function (it) {
      var qty = Number(it.qty) || 1;
      var tachado = (Number(it.precioBase) > Number(it.precio))
        ? '<s class="cco-li__antes">' + money(it.precioBase) + '</s> '
        : ((Number(it.comparacion) > Number(it.precio))
          ? '<s class="cco-li__antes">' + money(it.comparacion) + '</s> ' : '');
      // ── LA CANTIDAD, SIEMPRE (dictado del dueño 02-sep) ─────────────────
      // Antes el `×N` se omitía cuando N era 1: la línea de un pedido de una pulsera
      // no decía cuántas llevaba, y la de dos sí. El cliente que compra UNA es
      // justamente el que más necesita leer que va una — es el pedido donde un
      // malentendido de cantidad no tiene ninguna otra pista en pantalla. `qty` sale
      // del servidor (orden-co.js: el pack lleva las unidades, cada adicional 1), así
      // que esto sólo deja de ESCONDER un dato que ya venía.
      h += '<div class="cco-li"><span class="cco-li__n">' + esc(it.titulo) +
        ' <span class="cco-li__q">×' + qty + '</span></span>' +
        '<span class="cco-li__p">' + tachado + money(it.precio) + '</span></div>';
      // ── QUÉ PIEZAS ELIGIÓ (dictado del dueño 09-sep) ────────────────────
      // «Donde dice brazalete protección por 4 debe decir los que se escogieron, dama,
      //  caballero … para que el cliente sepa qué eligió también ahí en el formulario.»
      // Va DEBAJO del nombre y sin precio propio: la línea del pack sigue llevando UN
      // solo importe, el que se cobra. Partirlo en varios obligaría al cliente a sumar
      // de cabeza para reconocer su total.
      if (Array.isArray(it.piezas) && it.piezas.length) {
        h += '<div class="cco-li__piezas">' + it.piezas.map(function (p2) {
          var n2 = Math.max(1, Math.trunc(Number(p2.qty)) || 1);
          return esc(p2.titulo) + ' ×' + n2;
        }).join(' · ') + '</div>';
      }
    });

    h += '<div class="cco-sep"></div>';
    h += '<div class="cco-li"><span>Subtotal</span><span class="cco-li__p">' + money(q.subtotal) + '</span></div>';

    // ── ORDEN DE LAS FILAS: Subtotal · Envío · Descuentos (dictado del dueño 02-sep,
    // la forma de su pantallazo). Es SÓLO orden de pintado: los tres números son los
    // que manda el servidor, `q.total` no se recalcula aquí y el estimado se pinta en
    // este mismo orden para que la pantalla no dé un salto al reemplazarse.
    //
    // 🔴 El renglón de envío dice la VERDAD, con el número del servidor. Nunca
    // "Gratis" cuando se va a cobrar. Con costo 0 por configuración también se pinta
    // 'Gratis' (envio-co.js pide exactamente eso del front).
    var env = q.envio || {};
    if (env.gratis || Number(env.costo) === 0) {
      // Tachar el costo base cuando el envío salió gratis POR EL UMBRAL es
      // información real de venta: el cliente ve lo que se ahorró.
      var base = (env.gratis && Number(env.costoBase) > 0)
        ? '<s class="cco-envio__base">' + money(env.costoBase) + '</s> ' : '';
      h += '<div class="cco-li"><span>Envío</span><span class="cco-li__p">' + base +
        '<span class="cco-envio">Gratis</span></span></div>';
    } else {
      h += '<div class="cco-li"><span>Envío</span><span class="cco-li__p">' + money(env.costo) + '</span></div>';
    }

    if (Number(q.descuentos) > 0) {
      // 🏷️ A LA DERECHA del rótulo, y ROJO (dictado del dueño 02-sep). El color va SÓLO
      // aquí, en el camino del SERVIDOR: el desglose estimado sigue subordinado en gris
      // (.cco-est .cco-desc), porque nada de esa pantalla puede competir con el total
      // de verdad.
      // El NOMBRE del descuento cuando es el de toda la tienda (08-sep). El carrito de
      // Shopify lo escribe («A&M❤️ -$51.600») y aquí también: una rebaja sin nombre en
      // una pantalla que pide diez datos parece un error de cuentas, no un regalo.
      // Sin nombre —que es cuando gana la escalera del 2x1— la fila queda como siempre.
      var nomDesc = q.descuentoNombre ? (' <span class="cco-desc__n">' + esc(q.descuentoNombre) + '</span>') : '';
      h += '<div class="cco-li cco-desc"><span>Descuentos 🏷️' + nomDesc + '</span><span class="cco-li__p">-' + money(q.descuentos) + '</span></div>';
      // 🔴 POR QUÉ LA LÍNEA DEL PRODUCTO PUEDE NO CUADRAR CON LA TARJETA QUE TOCÓ.
      // Cuando gana el descuento de toda la tienda, el 2x1 NO se aplica (sólo actúa uno,
      // igual que en el checkout), así que el pack se cobra desde su precio de lista con
      // el porcentaje encima: la tarjeta puede decir $43.000 y el renglón $60.200 aunque
      // el TOTAL sea menor. Sin esta frase el cliente ve un número más alto que el que
      // eligió y no tiene dónde leer por qué — y en el carrito la escalera ni se pinta.
      // ⚡ EL CANDIDATO (C): la oferta flash se cobró a su precio de LISTA con el
      // descuento de la tienda encima, porque así el TOTAL es menor que con su precio
      // cerrado (orden-co.js, los tres candidatos: «el cliente NUNCA paga más con la
      // oferta que sin ella»). Sin decirlo, el renglón de la oferta sale por encima del
      // precio flash que el cliente acaba de aceptar y no tiene dónde leer por qué.
      // 🔒 Se lee el HECHO que manda el servidor, no se deduce del importe. Y desde el
      // 11-sep la FRASE también la escribe el servidor: `ofertaAPrecioDeListaTexto`
      // (`textoOfertaAPrecioDeListaCo` en orden-co.js, reenviada por `cuerpoCotizacionCo`
      // en /cotizar-co y /ordenar-co). Aquí sólo se PINTA.
      //
      // 🚨 POR QUÉ, MEDIDO: elegir el texto aquí por `descuentoNombre` escribía algo
      // FALSO en el candidato (D) —«tu oferta se cobró con 2x1 aplicado encima»— cuando
      // el 2x1 es del PACK y a la pieza de la oferta no se le aplicó nada; y con las
      // familias (E)/(F) hay un tercer porqué ('descuento_de_producto') con DOS verdades
      // distintas según si el descuento cayó también sobre la pieza. Dos autores para la
      // misma frase = un día uno de los dos miente, y el que se lee es éste.
      //
      // 🔒 LOS DOS `else if` SE QUEDAN, y no son código muerto: son la RED para un
      // servidor viejo que todavía no mande la frase (el campo es ADITIVO). Si llega, la
      // suya gana siempre. Se pierde el <b> del nombre del descuento a propósito: el
      // servidor manda TEXTO, y volver a decidir aquí dónde va la negrita sería volver a
      // tener dos autores de la misma prosa por un adorno.
      if (q.ofertaAPrecioDeListaTexto) {
        h += '<div class="cco-desc__pq">' + esc(q.ofertaAPrecioDeListaTexto) + '</div>';
      } else if (q.ofertaAPrecioDeLista === true && q.descuentoNombre) {
        h += '<div class="cco-desc__pq">Tu oferta se cobró con <b>' + esc(q.descuentoNombre) +
          '</b> aplicado encima, en vez de su precio cerrado, porque así tu total queda <b>más bajo</b>.</div>';
      } else if (q.descuentoSustituye && q.descuentoNombre && q.packAPrecioDeOferta !== true) {
        // ⑥ `packAPrecioDeOferta` (sólo lo manda el servidor con `meta2x1`): ganaron SÓLO
        // espejos 2x1 y el pack quedó al precio de su tarjeta → la frase sería FALSA.
        h += '<div class="cco-desc__pq">Se aplicó <b>' + esc(q.descuentoNombre) +
          '</b> en vez de la oferta por cantidad porque te sale más barato en total.</div>';
      }
    }

    // Separador antes del Total. Es lo que el pantallazo del dueño pide y lo que separa
    // el desglose del número por el que se decide la compra.
    // 🖤 LÍNEA DELGADA **NEGRA**, debajo de Descuentos (dictado del dueño 02-sep). El
    // `.cco-sep` gris que hay entre las demás filas separa renglones parecidos; éste
    // separa el desglose del TOTAL, que es otra cosa. El modificador `--fuerte` es 1 px
    // en el negro de la casa (var(--cco-text), #1C1712): la pantalla no gana un color
    // nuevo. Mismo separador en el bloque estimado, para que el resumen no dé un salto
    // de forma cuando la cotización de verdad lo reemplaza.
    h += '<div class="cco-sep cco-sep--fuerte"></div>';
    // EL TOTAL, LA LÍNEA MÁS GRANDE DEL RESUMEN (dictado del dueño 02-sep: rótulo y
    // cifra suben de tamaño, ver `.cco-tot` en cod-co.css).
    // 🔤 EL RÓTULO DICE "TOTAL" (dictado del dueño 02-sep). Antes decía "Pagas al
    // recibir", que era el único sitio del desglose donde se leía que ese dinero se
    // entrega al transportador — y esa información NO se pierde: sigue escrita, y con
    // la misma cifra, en la línea 2 del botón de enviar ("Paga al recibir · $X") y en
    // el botón que abre el modal. Lo que se gana es que la palabra que corona el
    // desglose sea la MISMA en los dos caminos: el bloque estimado ya rotulaba "Total"
    // su fila pendiente, así que hasta hoy el rótulo del renglón decisivo CAMBIABA
    // cuando el provisional se sustituía por el del servidor. La caja alta es la única
    // diferencia que queda, y va del lado del número real (dictado del dueño).
    h += '<div class="cco-tot"><span class="cco-tot__lbl">TOTAL</span><span>' + money(q.total) + '</span></div>';

    // ── LA BANDA DE ENVÍO GRATIS (dictado del dueño 02-sep) ────────────────
    // 🔒 SÓLO CUANDO EL SERVIDOR LO DICE, Y SÓLO AQUÍ. `env.gratis` es el veredicto de
    // `calcularEnvioCo` que viene en la MISMA respuesta que produjo el total: no se
    // deriva de ningún umbral local.
    // ⚠️ ACTUALIZADO 02-sep: `pintarEstimado` SÍ pinta un renglón de envío, por dictado
    // del dueño, con el espejo ENVIO_ESPEJO_* de arriba, y desde esta tanda TAMBIÉN
    // suma los adicionales marcados → su base es la MISMA que la del servidor, no una
    // menor. Ya no hay colchón estructural; lo que sostiene la equivalencia es que las
    // dos usan la misma aritmética, medido con 9.600 combinaciones sin una sola
    // divergencia. Esta banda verde sigue siendo EXCLUSIVA del servidor: es la única
    // que afirma sin condición, y el submit sigue bloqueado hasta que él conteste.
    //
    // Ocupa el MISMO sitio que el empujón de "todavía no": son mutuamente excluyentes
    // (o el envío ya es gratis, o falta para serlo), así que el resumen no crece.
    //
    // ═══════════════════════════════════════════════════════════════════════════
    // 🚨 EL EMPUJÓN DICE EL UMBRAL, NO UN DELTA (arreglo del 10-sep)
    // ═══════════════════════════════════════════════════════════════════════════
    // Hasta hoy esta línea decía «Te faltan $X para envío gratis» con la resta pelada
    // del servidor, y era FALSA. Medido el 10-sep contra la cotización real:
    //   · 2 uds de PULSERA ALINEACIÓN 7 CHAKRAS (2x1): se cobra $69.000 y la pantalla
    //     pedía $60.000… pero hacían falta 3 unidades más ($207.000 de lista) porque
    //     la escalera por cantidad re-precia TODAS las unidades en cada peldaño
    //     (3 uds → $93.150 · 4 → $124.200 · 5 → $155.250, el primero que es gratis).
    //   · 2 uds de BRAZALETE AMAZONITA (sin escalera): se cobra $94.600 y pedía
    //     $34.400; el cliente agregaba UNA unidad ($47.300, MÁS de lo pedido), con eso
    //     el subtotal de lista cruzaba los $129.000, entraba el «A&M❤️» -30%, el pedido
    //     se cobraba $99.330 y el envío SEGUÍA costando $17.700. La promesa se rompía
    //     justo por obedecerla.
    // Así que ya no se predice: se dicen los DOS HECHOS que el servidor manda en la
    // misma respuesta que produjo el total — `env.umbral` (la condición de la tarifa)
    // y `env.base` (lo que se cobra por producto, después de descuentos y sin flete).
    // Es EL MISMO criterio que la barra de meta nativa (meta-co.js,
    // `faltaParaEnvioGratis` → null → «cuando el total llega a $X — vas en $Y»), y las
    // dos pantallas dicen ahora la misma frase.
    //
    // 🔒 AQUÍ NO SE LEE `env.faltaParaGratis` A PROPÓSITO. El servidor ya sólo manda
    //    `0` o `null`, pero mientras exista en este archivo una rama que sepa pintar un
    //    delta, alguien la volverá a alimentar. No hay delta que pintar.
    // 🔒 Y SI FALTA UN DATO, NO SE INVENTA: sin `base` creíble se dice sólo el umbral
    //    (sigue siendo verdad); sin `umbral` creíble se cae al espejo, que es la misma
    //    cifra con la que el estimado decide si cobra el flete.
    if (M6.barra) {
      // ⑥ UNA SOLA VOZ: con la barra encendida el resumen ya no repite el mensaje del
      // envío. En su lugar, la fila que ATA la barra al resumen (hallazgo ALTA a): la
      // MISMA cifra de «Llevas $X en productos» — `envio.base`, nunca el Subtotal (precio
      // antes del descuento) ni el TOTAL (lleva el envío dentro).
      var baseM6 = Number(env.base);
      if (isFinite(baseM6) && baseM6 >= 0) {
        h += '<div class="cco-li cco-cuentan"><span>Para el envío gratis cuentan tus productos:</span><span class="cco-li__p">' + money(baseM6) + '</span></div>';
      }
    } else if (env.gratis) {
      h += '<div class="cco-gratisband">¡Genial! Tu envío es GRATIS 🎉</div>';
    } else {
      var umbEnv = cop(env.umbral) > 0 ? cop(env.umbral) : ENVIO_ESPEJO_UMBRAL;
      var baseEnv = Number(env.base);
      var hayBase = isFinite(baseEnv) && baseEnv >= 0;
      h += '<div class="cco-falta">El envío es GRATIS cuando el total llega a ' + money(umbEnv) +
        (hayBase ? ' — vas en ' + money(baseEnv) : '') + ' 🍃</div>';
    }

    // Nada se recorta en silencio (molde cod-carrito.js:159-163): si el servidor
    // clampó la cantidad o hay un bloqueo, se dice AQUÍ, no después del 400.
    if (q.aviso) h += '<div class="cco-aviso">' + esc(q.aviso) + '</div>';
    if (q.bloqueo) h += '<div class="cco-aviso">' + esc(q.bloqueo) + '</div>';
    h += pintarExternosRechazados(q);

    elResumen.innerHTML = h;
    etiquetarSubmit(q.total);
  }

  // ── Cascada de cobertura: departamento → ciudad (DOS niveles, sin CP) ────
  // Molde de la cascada mexicana (cod-carrito.js:180-237) con dos pasos en vez de
  // cuatro. GET /cobertura-co devuelve { ok, nivel, items:[string] }
  // (router-co.js:901-928). El `codigo` (ANT/CUN/VAC…) NO viaja al cliente a
  // propósito: el provinceCode lo resuelve el servidor desde su catálogo.
  var selDepartamento = form.elements.departamento;
  var selCiudad = form.elements.ciudad;

  /* ── 🗺️ DEPARTAMENTO Y CIUDAD, COMO LOS LEE UNA PERSONA (dueño 26-oct, punto 3) ──────
     El catálogo (y el servidor, que es quien valida) habla en MAYÚSCULAS sin tildes
     («BOGOTA», «VALLE»). El VALOR de cada opción se queda EXACTAMENTE así —es lo que viaja
     y lo que el servidor compara—; sólo cambia el TEXTO que se ve: «Bogotá», «Valle del
     Cauca», con tilde y mayúscula inicial.
     Y el orden: primero las 5 ciudades donde más vendemos (pedidos reales de Colombia,
     27-ago → 25-oct: Bogotá 610 · Medellín 213 · Cali 104 · Envigado 52 · Pereira 43),
     que llenan departamento Y ciudad de un toque; después todos los departamentos en
     orden alfabético. En la ciudad, primero las que más piden de ESE departamento. */
  var DEPTOS_BONITOS = {
    'AMAZONAS': 'Amazonas', 'ANTIOQUIA': 'Antioquia', 'ARAUCA': 'Arauca',
    'ARCHIPIELAGO DE SAN ANDRES': 'Archipiélago de San Andrés', 'ATLANTICO': 'Atlántico',
    'BOLIVAR': 'Bolívar', 'BOYACA': 'Boyacá', 'CALDAS': 'Caldas', 'CAQUETA': 'Caquetá',
    'CASANARE': 'Casanare', 'CAUCA': 'Cauca', 'CESAR': 'Cesar', 'CHOCO': 'Chocó',
    'CORDOBA': 'Córdoba', 'CUNDINAMARCA': 'Cundinamarca', 'GUAINIA': 'Guainía',
    'GUAVIARE': 'Guaviare', 'HUILA': 'Huila', 'LA GUAJIRA': 'La Guajira', 'MAGDALENA': 'Magdalena',
    'META': 'Meta', 'NARIÑO': 'Nariño', 'NORTE DE SANTANDER': 'Norte de Santander',
    'PUTUMAYO': 'Putumayo', 'QUINDIO': 'Quindío', 'RISARALDA': 'Risaralda', 'SANTANDER': 'Santander',
    'SUCRE': 'Sucre', 'TOLIMA': 'Tolima', 'VALLE': 'Valle del Cauca', 'VAUPES': 'Vaupés', 'VICHADA': 'Vichada',
  };
  // Palabras con tilde que más salen en los nombres de municipios. Lo que no esté aquí
  // sale con mayúscula inicial y sin tilde (nunca un nombre inventado).
  var TILDES = {
    BOGOTA: 'Bogotá', MEDELLIN: 'Medellín', ITAGUI: 'Itagüí', IBAGUE: 'Ibagué', CUCUTA: 'Cúcuta',
    POPAYAN: 'Popayán', MONTERIA: 'Montería', CHIA: 'Chía', FACATATIVA: 'Facatativá', ZIPAQUIRA: 'Zipaquirá',
    FUSAGASUGA: 'Fusagasugá', TULUA: 'Tuluá', JAMUNDI: 'Jamundí', QUIBDO: 'Quibdó', CALARCA: 'Calarcá',
    CHINCHINA: 'Chinchiná', APARTADO: 'Apartadó', CAJICA: 'Cajicá', UBATE: 'Ubaté', GIRON: 'Girón',
    SOGAMOSO: 'Sogamoso', CIENAGA: 'Ciénaga', MAGANGUE: 'Magangué', SAHAGUN: 'Sahagún', LORICA: 'Lorica',
    GUATAPE: 'Guatapé', MARIA: 'María', JOSE: 'José', JESUS: 'Jesús', RIO: 'Río', BOLIVAR: 'Bolívar',
    CORDOBA: 'Córdoba', BELEN: 'Belén', TIMBIO: 'Timbío', GUADALAJARA: 'Guadalajara', SOPO: 'Sopó',
    TOCANCIPA: 'Tocancipá', GACHANCIPA: 'Gachancipá', SESQUILE: 'Sesquilé', TENJO: 'Tenjo', COTA: 'Cota',
    TABIO: 'Tabio', CHOCONTA: 'Chocontá', GUASCA: 'Guasca', GUATAVITA: 'Guatavita', ANAPOIMA: 'Anapoima',
    VILLETA: 'Villeta', LIBANO: 'Líbano', ESPINAL: 'Espinal', MARIQUITA: 'Mariquita', FUNDACION: 'Fundación',
    CONCEPCION: 'Concepción', ASUNCION: 'Asunción', SAMANA: 'Samaná', SONSON: 'Sonsón', TAMESIS: 'Támesis',
    TITIRIBI: 'Titiribí', YARUMAL: 'Yarumal', CAUCASIA: 'Caucasia', NECOCLI: 'Necoclí', CAREPA: 'Carepa',
    TUMACO: 'Tumaco', IPIALES: 'Ipiales', TUQUERRES: 'Túquerres', LERIDA: 'Lérida', GUAMO: 'Guamo',
    PURIFICACION: 'Purificación', AGUACHICA: 'Aguachica', OCAÑA: 'Ocaña', PAMPLONA: 'Pamplona',
    MALAGA: 'Málaga', BARBOSA: 'Barbosa', SOCORRO: 'Socorro', VELEZ: 'Vélez', CHIQUINQUIRA: 'Chiquinquirá',
    PAIPA: 'Paipa', MONIQUIRA: 'Moniquirá', GARAGOA: 'Garagoa', ACACIAS: 'Acacías', GRANADA: 'Granada',
    PUERTO: 'Puerto', GAITAN: 'Gaitán', LOPEZ: 'López', MARTIN: 'Martín', SEBASTIAN: 'Sebastián',
    ANDRES: 'Andrés', ANGEL: 'Ángel', CANDELARIA: 'Candelaria', DARIEN: 'Darién', VIJES: 'Vijes',
    'YUMBO': 'Yumbo', CERETE: 'Cereté', CHINU: 'Chinú', SINCE: 'Sincé', COROZAL: 'Corozal',
    TOLU: 'Tolú', TURBACO: 'Turbaco', ARJONA: 'Arjona', MOMPOS: 'Mompós', SANTA: 'Santa',
    ESPIRITU: 'Espíritu', PIEDECUESTA: 'Piedecuesta', FLORIDABLANCA: 'Floridablanca', MANAURE: 'Manaure',
    RIOHACHA: 'Riohacha', MAICAO: 'Maicao', LETICIA: 'Leticia', NARIÑO: 'Nariño', INIRIDA: 'Inírida',
    MITU: 'Mitú', TAME: 'Tame', ARAUCA: 'Arauca', MOCOA: 'Mocoa', SIBUNDOY: 'Sibundoy', PITALITO: 'Pitalito',
    GARZON: 'Garzón', LA: 'La', SAN: 'San',
  };
  var MINUSCULAS = { DE: 'de', DEL: 'del', LA: 'la', LAS: 'las', LOS: 'los', Y: 'y', EL: 'el' };
  function nombreBonito(txt, esDepto) {
    var t = String(txt == null ? '' : txt).trim();
    if (!t) return t;
    if (esDepto && DEPTOS_BONITOS[t.toUpperCase()]) return DEPTOS_BONITOS[t.toUpperCase()];
    var palabras = t.split(/(\s+|[()])/);
    var n = 0;
    return palabras.map(function (w) {
      if (!w || /^\s+$/.test(w) || w === '(' || w === ')') return w;
      var W = w.toUpperCase();
      var primera = (n++ === 0);
      if (/^[A-ZÑ]\.?$/.test(W) && W.length <= 2 && !primera) return W;            // «(Q)», «D.C.»
      if (/^D\.C\.?$/.test(W)) return 'D.C.';
      if (!primera && MINUSCULAS[W]) return MINUSCULAS[W];
      if (TILDES[W]) return TILDES[W];
      return W.charAt(0) + W.slice(1).toLowerCase();
    }).join('');
  }
  function sinTildeMay(x) {
    return String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();
  }
  // Las 5 ciudades donde más vendemos (atajo de un toque) y, por departamento, las que más
  // piden (para que salgan arriba en la lista de ciudades). Datos agregados, sin clientes.
  // 🧭 (dueño 27-oct) En la lista de DEPARTAMENTO se lee primero el departamento y la
  // ciudad va entre paréntesis: «Antioquia (Medellín)». El orden sigue siendo el de las
  // ventas (Bogotá arriba: 610 pedidos en 60 días contra 213 de Medellín). Al elegir, un
  // toque sigue llenando departamento Y ciudad (el valor `@DEPTO|CIUDAD` no cambia).
  var ATAJOS_CIUDAD = [
    { d: 'CUNDINAMARCA', c: 'BOGOTA', t: 'Bogotá D.C.' },
    { d: 'ANTIOQUIA', c: 'MEDELLIN', t: 'Antioquia (Medellín)' },
    { d: 'VALLE', c: 'CALI', t: 'Valle del Cauca (Cali)' },
    { d: 'ANTIOQUIA', c: 'ENVIGADO', t: 'Antioquia (Envigado)' },
    { d: 'RISARALDA', c: 'PEREIRA', t: 'Risaralda (Pereira)' },
  ];
  var CIUDADES_FRECUENTES = {
    CUNDINAMARCA: ['BOGOTA', 'CHIA', 'SOACHA', 'CAJICA', 'MOSQUERA'],
    ANTIOQUIA: ['MEDELLIN', 'ENVIGADO', 'BELLO', 'ITAGUI', 'SABANETA'],
    VALLE: ['CALI', 'PALMIRA', 'CARTAGO', 'BUGA'],
    RISARALDA: ['PEREIRA', 'DOSQUEBRADAS', 'SANTA ROSA DE CABAL'],
    CALDAS: ['MANIZALES'], ATLANTICO: ['BARRANQUILLA'], SANTANDER: ['BUCARAMANGA', 'FLORIDABLANCA'],
    QUINDIO: ['ARMENIA (Q)', 'ARMENIA'], BOLIVAR: ['CARTAGENA'], HUILA: ['NEIVA'], TOLIMA: ['IBAGUE'],
    META: ['VILLAVICENCIO'], BOYACA: ['DUITAMA', 'TUNJA'], 'NARIÑO': ['PASTO'],
    'NORTE DE SANTANDER': ['CUCUTA'], CORDOBA: ['MONTERIA'],
  };
  function opcion(valor, texto) {
    var op = document.createElement('option');
    op.value = valor; op.textContent = texto;
    return op;
  }
  function grupo(etiqueta) {
    var g = document.createElement('optgroup');
    g.label = etiqueta;
    return g;
  }
  function porNombre(a, b) {
    try { return a.t.localeCompare(b.t, 'es', { sensitivity: 'base' }); } catch (e) { return a.t < b.t ? -1 : 1; }
  }
  function llenar(sel, items, placeholder) {
    sel.innerHTML = '';
    sel.appendChild(opcion('', placeholder));
    var lista = items || [];
    var esDepto = sel === selDepartamento;
    var todos = lista.map(function (it) { return { v: it, t: nombreBonito(it, esDepto) }; }).sort(porNombre);
    var arriba = [];
    if (esDepto) {
      var hay = {};
      lista.forEach(function (it) { hay[sinTildeMay(it)] = it; });
      ATAJOS_CIUDAD.forEach(function (a) { if (hay[a.d]) arriba.push({ v: '@' + hay[a.d] + '|' + a.c, t: a.t }); });
    } else {
      var dep = sinTildeMay(selDepartamento && selDepartamento.value);
      var frec = CIUDADES_FRECUENTES[dep] || [];
      var porClave = {};
      lista.forEach(function (it) { porClave[sinTildeMay(it)] = it; });
      frec.forEach(function (c) { if (porClave[c]) arriba.push({ v: porClave[c], t: nombreBonito(porClave[c], false) }); });
      // Sin duplicar: lo que sube arriba no se repite abajo.
      var subidas = {};
      arriba.forEach(function (x) { subidas[x.v] = 1; });
      todos = todos.filter(function (x) { return !subidas[x.v]; });
    }
    if (arriba.length) {
      var g1 = grupo(esDepto ? 'Donde más enviamos' : 'Las más pedidas');
      arriba.forEach(function (x) { g1.appendChild(opcion(x.v, x.t)); });
      sel.appendChild(g1);
      var g2 = grupo(esDepto ? 'Todos los departamentos' : 'Todas las ciudades');
      todos.forEach(function (x) { g2.appendChild(opcion(x.v, x.t)); });
      sel.appendChild(g2);
    } else {
      todos.forEach(function (x) { sel.appendChild(opcion(x.v, x.t)); });
    }
    sel.disabled = !lista.length;
  }

  // ── RESPALDO LOCAL DE LA COBERTURA ────────────────────────────────────────
  // El catálogo colombiano (32 departamentos / 1.126 ciudades) se publica también
  // como asset del tema. Motivo: sin el carril desplegado, los desplegables salían
  // VACÍOS y el formulario era invendible; y ante un hipo de red, quedarse sin
  // ciudades es peor que servirlas de una copia estática.
  //
  // 🔒 EL SERVIDOR SIGUE MANDANDO. Esto solo PINTA opciones; la validación de
  // (departamento, ciudad) y el provinceCode los resuelve el servidor contra SU
  // catálogo (regla "el catálogo manda", cascada-co.js). Los dos leen el MISMO
  // archivo (data/coverage/coverage-co.json), así que no pueden divergir salvo
  // que alguien publique uno sin el otro — por eso se prefiere SIEMPRE la
  // respuesta del servidor y esto solo entra cuando esa respuesta no llega.
  var _coberturaLocal = null;
  function coberturaLocal() {
    if (_coberturaLocal) return Promise.resolve(_coberturaLocal);
    var url = root.getAttribute('data-cco-cobertura-url');
    if (!url) return Promise.resolve(null);
    return conPlazo(function (senal) {
      return fetch(url, senal ? { signal: senal } : undefined).then(function (r) { return r.ok ? r.json() : null; });
    }, PLAZO_COBERTURA_MS)
      .then(function (j) {
        var deps = j && (j.departamentos || j.provinces);
        if (!Array.isArray(deps)) return null;
        _coberturaLocal = deps;
        return deps;
      })
      .catch(function () { return null; });
  }
  function localItems(departamento) {
    return coberturaLocal().then(function (deps) {
      if (!deps) return [];
      if (!departamento) return deps.map(function (d) { return d.nombre || d.label; });
      var norm = function (x) {
        return String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toUpperCase().replace(/\s+/g, ' ').trim();
      };
      var d = deps.filter(function (x) { return norm(x.nombre || x.label) === norm(departamento); })[0];
      return (d && (d.ciudades || d.cities)) || [];
    });
  }

  function cobertura(departamento) {
    var qs = departamento ? ('?departamento=' + encodeURIComponent(departamento)) : '';
    // ⚡ SIN CABECERAS PROPIAS (21-oct-2026). Esta lectura iba con 'ngrok-skip-browser-warning'
    // de cuando el carril vivía detrás de ngrok; hoy el endpoint es el VPS. Una cabecera que no
    // está en la lista segura de CORS convierte el GET en «no simple» y el navegador manda un
    // OPTIONS antes de cada departamento y cada ciudad (un viaje de ida y vuelta más). Sin ella
    // es un GET simple, cacheable 1 h. Si alguien volviera a poner ngrok en el ajuste del
    // endpoint, la página de aviso no es JSON → `catch` → respaldo estático del tema: nunca un
    // desplegable vacío. Los POST (cotizar/ordenar) llevan JSON y su preflight existe igual:
    // no se tocan.
    // ⏱️ (21-oct) Con tiempo límite. La lista de departamentos se PRECARGA desde el <head>
    // (cod-co-temprano.liquid) y el navegador le entrega a este fetch esa misma respuesta:
    // si la precarga se quedó colgada, este fetch se colgaba con ella. Al vencer se pide
    // DE NUEVO, directo y con otra URL (`r=1`, el servidor la ignora) para no engancharse
    // a la precarga; y si tampoco contesta, el respaldo estático del tema.
    function pedir(url) {
      return conPlazo(function (senal) {
        return fetch(url, senal ? { signal: senal } : undefined).then(function (r) { return r.json(); });
      }, PLAZO_COBERTURA_MS).then(function (j) { return (j && j.ok && j.items) || []; });
    }
    var base = ENDPOINT + '/cobertura-co' + qs;
    return pedir(base)
      .catch(function (e) {
        if (!(e && e.plazo)) return [];
        reportarSalud('plazo_cobertura');
        return pedir(base + (qs ? '&' : '?') + 'r=1').catch(function () { return []; });
      })
      .then(function (items) {
        // El servidor manda; el respaldo solo cubre su ausencia.
        return (items && items.length) ? items : localItems(departamento);
      });
  }

  var coberturaPedida = false;
  function cargarDepartamentos() {
    if (coberturaPedida) return;
    coberturaPedida = true;
    cobertura('').then(function (items) {
      if (!items.length) { coberturaPedida = false; }  // permite reintentar al reabrir
      llenar(selDepartamento, items, 'Selecciona…');
      if (items.length) borradorReponerDepartamento();
    });
  }

  // `ciudadQueSigue`: la ciudad que hay que dejar elegida cuando lleguen las ciudades (un
  // atajo «Bogotá D.C.», o lo que el cliente ya había escrito y se recupera del teléfono).
  var ciudadQueSigue = null;
  /* 📏 ¿SE ENTIENDE LA LISTA? (dueño 27-oct). Contador propio del servidor, sin píxel y sin
     datos personales (src/cod-co/medir-departamentos-co.js): la PRIMERA elección (atajo de
     «Donde más enviamos» o departamento de la lista completa), si se CAMBIA después (señal
     de confusión) y si el pedido queda registrado. Solo cuentan los cambios del CLIENTE:
     lo que pone el borrador guardado (`deptoProgramatico`) no. Una vez por sesión de
     página y evento. Las visitas de vista previa van al cajón `prueba`. */
  var deptoProgramatico = false;
  var MDEP = { primera: null, ultimo: null, cambio: false, enviado: {} };
  function deptoEsPrueba() {
    try {
      if (/[?&]preview_theme_id=/.test(String(location.search || ''))) return true;
      var t = window.Shopify && window.Shopify.theme;
      if (t && t.role && t.role !== 'main') return true;
    } catch (e) { /* */ }
    return false;
  }
  function medirDepto(ev, via, cambio) {
    if (!ENDPOINT || MDEP.enviado[ev]) return;
    MDEP.enviado[ev] = true;
    try {
      var cuerpo = JSON.stringify({ v: 1, ev: ev, via: via, cambio: !!cambio, ses: SALUD_SES, prueba: deptoEsPrueba() });
      var url = ENDPOINT + '/flash-vista-co/depto';
      if (navigator.sendBeacon && navigator.sendBeacon(url, cuerpo)) return;
      fetch(url, { method: 'POST', body: cuerpo, keepalive: true }).catch(function () { /* */ });
    } catch (e) { /* una métrica jamás rompe el formulario */ }
  }
  function medirDeptoEleccion(v) {
    if (deptoProgramatico || !v) return;
    var via = v.charAt(0) === '@' ? 'atajo' : 'lista';
    if (!MDEP.primera) { MDEP.primera = via; MDEP.ultimo = v; medirDepto('primera', via, false); return; }
    if (v !== MDEP.ultimo) { MDEP.ultimo = v; MDEP.cambio = true; medirDepto('cambio', MDEP.primera, true); }
  }
  function medirDeptoPedido() {
    medirDepto('pedido', MDEP.primera || 'ninguna', MDEP.cambio);
  }
  window.__ccoMedirDepto = { estado: function () { return { primera: MDEP.primera, cambio: MDEP.cambio, enviado: Object.keys(MDEP.enviado) }; } };
  selDepartamento.addEventListener('change', function () {
    var v = String(selDepartamento.value || '');
    try { medirDeptoEleccion(v); } catch (e) { /* */ }
    if (v.charAt(0) === '@') {
      // Atajo: «@DEPARTAMENTO|CIUDAD». El select se queda con el departamento DE VERDAD
      // (es lo que viaja), y la ciudad se elige sola al llegar la lista.
      var par = v.slice(1).split('|');
      selDepartamento.value = par[0] || '';
      ciudadQueSigue = par[1] || null;
    }
    llenar(selCiudad, [], 'Cargando…');
    if (!selDepartamento.value) { llenar(selCiudad, [], 'Selecciona el departamento…'); return; }
    var pedida = selDepartamento.value;
    cobertura(pedida).then(function (items) {
      if (selDepartamento.value !== pedida) return;   // el cliente ya eligió otro
      // items vacío llega con 200 y motivo `departamento_desconocido`
      // (router-co.js:915): no es un error del cliente, pero sí hay que decírselo.
      llenar(selCiudad, items, items.length ? 'Selecciona…' : 'Sin ciudades disponibles');
      if (ciudadQueSigue) {
        var quiero = sinTildeMay(ciudadQueSigue);
        for (var i = 0; i < selCiudad.options.length; i++) {
          if (sinTildeMay(selCiudad.options[i].value) === quiero) { selCiudad.value = selCiudad.options[i].value; break; }
        }
        ciudadQueSigue = null;
        if (selCiudad.value) {
          campoBien(selCiudad);
          try { selCiudad.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { /* */ }
        }
      }
    });
  });

  // ── Abrir / cerrar ──────────────────────────────────────────────────────
  /* ⚠️ LA **VARIANTE** NO SE HEREDA DEL CARRITO, SÓLO LA CANTIDAD — Y POR ESO, CON MÁS
     DE UNA VARIANTE, EL CARRITO NO MANDA.
     El selector por unidad nace en la primera variante DISPONIBLE, no en la que el
     cliente metió al carrito: con dorado + plateado en el carrito, el pedido saldría
     con dos dorados. Emparejarlas SÍ se puede hoy (`options_with_values` de `/cart.js`
     contra los `optionValues` que emite el snippet), pero es lógica nueva sobre el
     camino que decide QUÉ pieza se despacha, y hoy no hay un solo producto de varias
     variantes con `codPropio`.
     Así que mientras eso no se escriba, este caso se trata como "la escalera no puede
     decir lo que hay en el carrito": se DESTAPA y el cliente elige a la vista, que es
     exactamente lo que hacía antes de este cambio. Falla del lado de enseñar de más.
     ⚠️ El selector de variante NO se oculta nunca en modo carrito (hay un assert que lo
     vigila): es la única forma que tiene el cliente de corregir la pieza. */

  /* Lo que pasa DESPUÉS de leer el carrito, en las dos salidas de la promesa (leída o
     fallida): en la ficha de producto no hace nada y en el carrito manda el carrito.
     Va en una función y no en dos callbacks distintos para que el camino del fallo no
     pueda quedarse haciendo algo diferente al del éxito. */
  // ⏱️ (21-oct) Si leer o aplicar el carrito lanza (un carrito con algo que no esperábamos),
  // la cotización SALE IGUAL: antes la excepción se tragaba la llamada a
  // `programarCotizacion` del final y la pantalla quedaba en «Calculando…» para siempre.
  function aplicarCarritoSeguro() {
    try { aplicarCarrito(); }
    catch (e) {
      reportarSalud('excepcion_carrito');
      try { programarCotizacion(); } catch (e2) { falloSeguro(null, 'normal'); }
    }
  }
  function aplicarCarrito() {
    /* ── UNA SOLA REGLA PARA LAS DOS PANTALLAS (dictado del dueño 08-sep) ──────
       «Cuando tienen otros productos en el carrito, quitar esas promociones del
        formulario … que sólo aparezcan si se va a llevar la referencia del dos por uno.»

       LA ESCALERA SE VE ⟺ EL PEDIDO NO LLEVA NADA MÁS QUE ESTE PRODUCTO.
       Y no es un gusto: con otras piezas dentro, el descuento de toda la tienda puede
       ganarle a la oferta por cantidad (se aplica UNO solo), y entonces las tarjetas
       enseñan un precio que NO es el que se está cobrando — el pantallazo del dueño:
       la tarjeta decía $55.200 y el renglón cobraba $48.300. Esconderla quita la
       contradicción de raíz en vez de explicarla.

       Antes esto sólo pasaba en /cart, porque el atributo lo ponía el snippet del
       carrito. Ahora lo decide el JS con lo que hay en el carrito de verdad, así que
       vale igual en la ficha de producto, que es donde el dueño lo vio. */
    var mezclado = SOLO_EL_PACK === false;

    // Las unidades del pack las manda el carrito cuando el formulario se abrió DESDE el
    // carrito, y también cuando el pedido va mezclado: ahí el carrito es el único sitio
    // donde el cliente puede cambiarlas, porque la escalera no está a la vista.
    /* 🔑 …Y TAMBIÉN CUANDO EL PRODUCTO NO TIENE ESCALERA Y YA ESTÁ EN EL CARRITO
       (arreglo de F1). La regla del 08-sep —«en la ficha manda la ficha»— se dictó para
       un producto CON escalera: allí el cliente elige el pack a la vista y el carrito no
       tiene por qué opinar. En un producto sin escalera no hay pack que elegir, así que
       el carrito es la ÚNICA expresión de cuántas quiere; ignorarlo era el otro medio
       camino del defecto: con 4 en el carrito, abrir el formulario desde la ficha
       cotizaba ×1 igual que desde /cart.
       Los dos productos con escalera siguen exactamente igual (`SIN_ESCALERA` es false),
       y la escalera se queda a la vista en los dos casos: si el cliente quiere otra
       cantidad, la cambia con el stepper. */
    var packEnElCarrito = (function () {
      var n0 = Math.trunc(Number(UNIDADES_PACK_CARRITO));
      return isFinite(n0) && n0 >= 1;
    })();
    var veredicto = (EN_CARRITO || mezclado || (SIN_ESCALERA && packEnElCarrito))
      ? fijarUnidadesDelCarrito() : 'exacto';

    if (veredicto === 'desconocido' && EN_CARRITO) {
      // 🔒 SIN CARRITO NO SE ADIVINA, Y SE FALLA HACIA ABAJO. Si esto se dejara en las
      // unidades de la apertura anterior, el cliente que abrió con 5, cerró, bajó a 2 y
      // reabrió con la red caída pediría 5: tres pulseras de más despachadas contra
      // entrega, que es un costo real (devolución), no una venta perdida. Volver al
      // escalón mínimo falla del lado barato y el cliente lo ve y lo sube.
      // Sólo en el carrito: en la ficha, `desconocido` sólo significa que este producto
      // no está en el carrito, y el escalón que eligió el cliente ahí no se le toca.
      tierIdx = 0;
      unidadesElegidas = TIERS[0].n;
      pintarTiers();
      pintarUnidades();
    }

    // El aviso se pinta (o se retira) SIEMPRE, en las tres salidas del veredicto: si sólo
    // se pintara cuando hay texto, el aviso de una apertura anterior se quedaría en
    // pantalla sobre un pedido que ya cuadra.
    pintarAvisoCantidad();
    fijarUnidadesDeLaFicha();

    /* 🔒 SE ESCONDE EN CUANTO SABEMOS QUE EL PEDIDO LLEVA ALGO MÁS.
       `mezclado` ya implica que el carrito SE PUDO LEER (si no, `SOLO_EL_PACK` es null),
       así que aquí no se está adivinando nada. Dentro de ese caso, `desconocido` sólo
       significa "este producto todavía no está en el carrito" — que es exactamente el
       pantallazo del dueño: estaba en la ficha de la Alineación con otra pulsera en el
       carrito. Ahí también se esconde.

       LA ÚNICA EXCEPCIÓN es `aproximado`: la escalera NO puede expresar lo que hay en el
       carrito (el tope de 10 unidades, o un pack de varias variantes del que no sabemos
       qué pieza eligió). Ahí se ENSEÑA aunque el pedido vaya mezclado, porque el cliente
       tiene que poder ver —y corregir— por cuántas unidades va. Enseñar de más nunca
       cuesta un pedido mal despachado; esconder de más, sí. */
    if (mezclado && veredicto !== 'aproximado') root.setAttribute('data-cco-en-carrito', '1');
    else root.removeAttribute('data-cco-en-carrito');
    /* 🔒 Y LAS TARJETAS DE ADICIONALES SE REPINTAN AQUÍ, no sólo al abrir. `EXTERNOS` se
       llena DESPUÉS (`leerCarritoVivo` es asíncrono y `abrir()` pinta antes de que
       conteste), así que sin esto la casilla del empaque seguiría ofreciéndose mientras
       `tickVotado` ya lo estaría descartando por estar en el carrito: la pantalla
       enseñando un extra que el pedido no lleva, o sea el ALTO A-1 otra vez, y esta vez
       introducido por el arreglo del doble cobro. */
    pintarTicks();
    programarCotizacion();
  }
  /* ═══════════════════════════════════════════════════════════════════════════
     ⑥ MEJORA 6 · BARRA DE ENVÍO GRATIS EN LA CABECERA + TIRA 2x1 (08-oct)
     ═══════════════════════════════════════════════════════════════════════════
     ESPEC: data/landing-agente/co/form-barra-2x1/ESPEC.md (2.ª versión, con los 14
     hallazgos de la revisión adversaria). Decisiones del dueño del 08-oct: D1 sí al
     atajo del Empaque, D2 A/B al publicar (en el tema de prueba se ve siempre), D3 sin la
     línea «no acumulable» cuando hay tira, D4 la barra de ficha/carrito no se toca.

     🔒 APAGADO = HOY. Todo cuelga de `M6.barra`, que sólo se enciende si
     `CodMejoras.activa('metaEnvio')` (landing.form de la tienda, sistema `co`, COP). Con
     la mejora apagada: ni un nodo, ni una llamada a /tira2x1-co, y `payloadPedido()` es
     BYTE A BYTE el de siempre (no lleva `meta2x1`, `tira2x1` ni externos de la tira).

     🔒 NI UN PESO SE CALCULA AQUÍ. La barra pinta SÓLO la última cotización del servidor
     (`envio.base`, `envio.umbral`, `envio.distancia`); la tira, sólo lo que devuelve
     /tira2x1-co. Lo único «de la página» es el precio del botón del 2x1 de la escalera,
     que es el mismo que Shopify ya pintó arriba (regla de la cabecera de este archivo).

     🔒 NUNCA /cart/add. Un 2x1 sumado viaja como `externos` [{variantId, cantidad}] por el
     MISMO payload (se cotiza y se cobra con él) y el servidor lo re-precia entero.
     ═══════════════════════════════════════════════════════════════════════════ */
  var M6_SS = 'cco-en-vuelo:';
  var M6_TTL_VUELO_MS = 15 * 60 * 1000;
  var elMeta = null, elMetaT = null, elMetaInfo = null, elMetaAcc = null;
  var elTira = null;
  var tiraResp = null;           // última respuesta de /tira2x1-co
  var tiraHuella = null;         // huella del payload con el que se pidió
  var tiraOrden = [];            // orden CONGELADO de las tarjetas en esta apertura
  var tiraOcultas = {};          // productGid → true (falló un candado en esta apertura)
  var tiraEligiendo = null;      // productGid de la tarjeta que está eligiendo piezas
  // 🔒 ELEGIR = ELEGIR (dueño 08-oct): las 2 unidades empiezan VACÍAS («Elige el diseño…»)
  // y sólo se suma con las DOS elegidas por el cliente. Se guardan aquí (no en el <select>)
  // porque la tira se repinta entera (cotización, avisos) y lo elegido no puede perderse.
  var tiraElegidas = ['', ''];
  var tiraIdx = 0;               // tarjeta visible
  var tiraAviso = '';            // «No pudimos sumar …» / «… se agotó …»
  var tiraSaltada = false;       // la 1.ª aparición se saltó porque el cliente ya bajó
  var tiraToken = 0, tiraTimer = null, tiraBaseVista = null;
  var tiraEnVuelo = false;       // hay un POST con extras sin respuesta DEFINITIVA
  var tiraRestaurada = false;    // se reabrió con un pedido anterior en vuelo
  var tiraAuto = { timer: null, apagada: false, visible: false, vuelta: false, sumarHasta: 0 };
  var m6TimerCalc = null;
  var m6Senales = [];

  function m6Activa(nombre) {
    try {
      var api2 = window.CodMejoras || window.__codMejoras;
      return !!(api2 && typeof api2.activa === 'function' && api2.activa(nombre) === true);
    } catch (e) { return false; }
  }
  function m6Senal(cual) {
    // Sin datos del cliente. Hoy sólo queda a la vista para QA (`__ccoM6.senales`); el
    // beacon `frente:'form'` es el paquete P0 de la ESPEC.
    try { if (m6Senales.indexOf(cual) < 0) m6Senales.push(cual); console.warn('[cod-co] meta2x1 señal: ' + cual); } catch (e) { /* */ }
  }
  function m6Cop(v) { var n = Number(v); return isFinite(n) ? Math.round(n) : NaN; }

  // ── AJUSTE SIN RECORTES (hallazgo MEDIA d): cada renglón trae sus versiones de la más
  // completa a la más corta y se queda la PRIMERA QUE CABE. Nunca elipsis en un renglón
  // con dinero: primero cae «de $129.000», luego «tu», luego la 🍃; la cifra jamás.
  // 🔒 Dueño 08-oct (iPhone): el atajo «Empaque 💎 +$13.900 y pagas $X menos» se veía
  // CORTADO. Medir sólo `scrollWidth` del renglón no basta: el texto va dentro de un <button>
  // con `max-width:100%`, y en WebKit el botón RECORTA su contenido, así que el desborde no
  // llega al renglón y se quedaba la versión más larga. Ahora se mide el TEXTO con un Range
  // (no la caja: el ::before de 44 px de toque se sale a propósito) contra el renglón y
  // contra su botón. Si ni la versión más corta cabe, la letra baja un punto (clase
  // `cco-meta--apretado` en el renglón) antes de rendirse; el alto de la barra no cambia.
  function m6Cabe(el) {
    if (el.scrollWidth > el.clientWidth + 0.5) return false;
    var rx = el.getBoundingClientRect();
    if (!(rx.width > 0)) return true;
    var hs = el.querySelectorAll('button, span, b');
    for (var i = 0; i < hs.length; i++) {
      var rh = hs[i].getBoundingClientRect(), rt;
      try { var rg = document.createRange(); rg.selectNodeContents(hs[i]); rt = rg.getBoundingClientRect(); } catch (e) { continue; }
      if (!(rt.width > 0)) continue;
      if (rt.right > Math.min(rh.right, rx.right) + 0.5 || rt.left < Math.max(rh.left, rx.left) - 0.5) return false;
    }
    return true;
  }
  function m6Ajustar(el, versiones) {
    if (!el) return;
    el.classList.remove('cco-meta--apretado');
    for (var pasada = 0; pasada < 2; pasada++) {
      for (var i = 0; i < versiones.length; i++) {
        el.innerHTML = versiones[i];
        el.setAttribute('data-version', String(i));
        if (m6Cabe(el)) return;
      }
      el.classList.add('cco-meta--apretado');
    }
  }

  function m6CrearBarra() {
    if (elMeta) return;
    var sub = $('[data-cco-sub]');
    if (!sub || !sub.parentNode) return;
    elMeta = document.createElement('div');
    elMeta.className = 'cco-meta cco-meta--sin';
    elMeta.setAttribute('data-cco-meta', '');
    elMeta.setAttribute('role', 'status');
    elMeta.setAttribute('aria-live', 'polite');
    elMeta.innerHTML = '<p class="cco-meta__t"></p><div class="cco-meta__bar" aria-hidden="true"><i></i></div>' +
      '<div class="cco-meta__pie"><span class="cco-meta__info"></span><span class="cco-meta__acc-l" hidden></span></div>';
    sub.parentNode.insertBefore(elMeta, sub.nextSibling);
    elMetaT = elMeta.querySelector('.cco-meta__t');
    elMetaInfo = elMeta.querySelector('.cco-meta__info');
    elMetaAcc = elMeta.querySelector('.cco-meta__acc-l');
  }

  // El umbral que dice LA PÁGINA (franja de la marquesina y barra de la ficha). Sólo para
  // detectar que el editor del tema y el VPS se desfasaron (hallazgo MEDIA umbral): el
  // número que se pinta es SIEMPRE el del servidor.
  function m6UmbralesDePagina() {
    var out = [];
    try {
      var a = document.querySelector('[data-ccq-umbral]');
      var na = a ? m6Cop(a.getAttribute('data-ccq-umbral')) : NaN;
      if (isFinite(na) && na > 0) out.push(na);
      var b = document.querySelector('[data-ccm-meta]');
      var nb = b ? m6Cop(Number(b.getAttribute('data-ccm-meta')) / 100) : NaN;
      if (isFinite(nb) && nb > 0) out.push(nb);
    } catch (e) { /* */ }
    return out;
  }

  // PURA (salvo leer la escalera de la página). Decide QUÉ dice la barra.
  //   q = cotización del servidor (o null mientras no hay) · modo = 'sin'|'sindato'
  function m6EstadoBarra(q, modo) {
    var env = (q && q.envio) || {};
    var U = m6Cop(env.umbral);
    var uTxt = '<b>' + money(isFinite(U) && U > 0 ? U : ENVIO_ESPEJO_UMBRAL) + '</b>';
    var neutro = ['Envío GRATIS cuando tus productos suman ' + uTxt + ' 🍃', 'Envío GRATIS cuando tus productos suman ' + uTxt,
      'Envío GRATIS desde ' + uTxt + ' en productos 🍃', 'Envío GRATIS desde ' + uTxt + ' en productos', 'Envío GRATIS desde ' + uTxt + ' 🍃'];
    if (modo === 'sin' || !q) return { cls: 'cco-meta--sin', t: neutro, info: ['Calculando tus productos…'], acc: [''], pct: 0 };
    var sinDato = { cls: 'cco-meta--sin', t: neutro, pct: 0, acc: [''],
      info: ['Cuentan tus productos ya con descuento, sin el envío', 'Cuentan tus productos ya con descuento', 'Cuentan tus productos con descuento'] };
    if (modo === 'sindato') return sinDato;
    var base = m6Cop(env.base), costo = m6Cop(env.costo);
    if (!isFinite(U) || U <= 0 || !isFinite(base) || base < 0 || !isFinite(costo)) return sinDato;
    // 🔒 Umbral desfasado entre el editor del tema y el VPS → sin promesas, con el del servidor.
    var pag = m6UmbralesDePagina();
    for (var k = 0; k < pag.length; k++) if (pag[k] !== U) { m6Senal('umbral_desfasado'); return sinDato; }
    var llevas = 'Llevas <b>' + money(base) + '</b> en productos';
    var pct = Math.max(0, Math.min(100, base / U * 100));
    if (costo === 0 && env.gratis === true) {
      return { cls: 'cco-meta--gratis', pct: 100, t: ['¡Felicidades! Tu envío es GRATIS 🍃', '¡Felicidades! Tu envío es GRATIS', 'Tu envío es GRATIS'],
        info: [llevas], acc: m6Cop(env.costoBase) > 0 ? ['<span class="cco-meta__ok">Ahorras <b>' + money(env.costoBase) + '</b> de envío</span>'] : [''] };
    }
    if (costo === 0) {   // gratis por configuración (ENVIO_CO_COSTO=0): no hubo umbral → sin «Ahorras»
      return { cls: 'cco-meta--gratis', pct: 100, t: ['Tu envío es GRATIS 🍃', 'Tu envío es GRATIS'], info: [llevas], acc: [''] };
    }
    if (base >= U) { m6Senal('meta_incoherente'); return sinDato; }   // 🔒 «llegó» sólo con costo 0
    var falta = (env.distancia === null || env.distancia === undefined) ? null : m6Cop(env.distancia);
    if (falta === null || !isFinite(falta) || falta <= 0) {
      return { cls: 'cco-meta--neutral', t: neutro, info: [llevas], acc: [''], pct: pct };
    }
    var cerca = falta <= U * 0.25;
    var fr = function (casi, tu, hoja) {
      return (casi ? '¡Casi! ' : '') + 'Te faltan <b>' + money(falta) + '</b> para' + (tu ? ' tu' : '') + ' envío GRATIS' + (hoja ? ' 🍃' : '');
    };
    var t = [fr(cerca, true, true), fr(cerca, false, true), fr(cerca, false, false)];
    if (cerca) t.push(fr(false, false, false));
    var info = ['Llevas <b>' + money(base) + '</b> de ' + money(U) + ' en productos', llevas];
    var acc = [''];
    // S1u · escalón de 1 unidad y el producto tiene 2x1: la escalera es lo más cercano.
    var t2i = m6IdxTier2x1();
    var A = m6AtajoVigente();
    if (t2i >= 0 && tierIdx !== t2i && TIERS[tierIdx] && TIERS[tierIdx].n === 1 && !EXTRAS_TIRA.length) {
      var p2 = TIERS[t2i].precio;
      acc = ['<button type="button" class="cco-meta__acc" data-cco-meta-tier2>Lleva el 2x1: 2 por ' + money(p2) + ' →</button>',
        '<button type="button" class="cco-meta__acc" data-cco-meta-tier2>Lleva el 2x1 →</button>'];
    } else if (cerca && A) {
      // D1 · «nada se suma en silencio»: las dos cifras del servidor en el texto.
      acc = A.ahorro > 0 ? [
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Agrega el Empaque 💎 (+' + money(A.precio) + ') y pagas ' + money(A.ahorro) + ' menos</button>',
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Empaque 💎 +' + money(A.precio) + ' y pagas ' + money(A.ahorro) + ' menos</button>',
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Empaque +' + money(A.precio) + ' y pagas ' + money(A.ahorro) + ' menos</button>',
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Agrega el Empaque 💎 +' + money(A.precio) + ' y llegas</button>',
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Empaque 💎 +' + money(A.precio) + ' y llegas</button>'] : [
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Agrega el Empaque 💎 +' + money(A.precio) + ' y llegas</button>',
        '<button type="button" class="cco-meta__acc" data-cco-meta-empaque>Empaque 💎 +' + money(A.precio) + ' y llegas</button>'];
    } else if (m6HayTarjetas()) {
      acc = ['<button type="button" class="cco-meta__acc" data-cco-meta-ir>Súmale un 2x1 ↓</button>'];
    }
    return { cls: '', t: t, info: info, acc: acc, pct: pct };
  }

  function m6IdxTier2x1() {
    for (var i = 0; i < TIERS.length; i++) if (esTier2x1Co(TIERS[i])) return i;
    return -1;
  }
  // El atajo del Empaque sólo vale con la respuesta de la tira de ESTE pedido.
  function m6AtajoVigente() {
    if (!M6.tira || !tiraResp || !tiraResp.atajoEmpaque) return null;
    if (tiraHuella !== huella(payloadPedido())) return null;
    var A = tiraResp.atajoEmpaque;
    var i = Math.trunc(Number(A.tick));
    if (!(i >= 0 && i < TICKS.length) || ticksState[i] === true) return null;
    if (!(m6Cop(A.precio) > 0)) return null;
    return { tick: i, precio: m6Cop(A.precio), ahorro: m6Cop(A.ahorro) || 0 };
  }

  var m6UltimoQ = null, m6UltimoModo = 'sin';
  function m6PintarBarra(q, modo) {
    if (!M6.barra || !elMeta) return;
    m6UltimoQ = q || null; m6UltimoModo = modo || (q ? 'ok' : 'sin');
    if (m6TimerCalc) { clearTimeout(m6TimerCalc); m6TimerCalc = null; }
    var e = m6EstadoBarra(m6UltimoQ, m6UltimoModo);
    elMeta.className = 'cco-meta' + (e.cls ? ' ' + e.cls : '');
    elMeta.style.setProperty('--p', (Number(e.pct) || 0).toFixed(1) + '%');
    m6Ajustar(elMetaT, e.t);
    m6Ajustar(elMetaInfo, e.info);
    elMetaAcc.hidden = !e.acc[0];
    m6Ajustar(elMetaAcc, e.acc);
    m6Congelar();
  }
  // Recalculando: lo de antes se ATENÚA (nunca se presenta como vigente) y a los 350 ms
  // la info dice «Calculando…». El alto no cambia.
  function m6AlRecotizar() {
    if (!M6.barra || !elMeta) return;
    if (!m6UltimoQ) { m6PintarBarra(null, 'sin'); return; }
    elMeta.classList.add('cco-meta--calc');
    if (m6TimerCalc) clearTimeout(m6TimerCalc);
    m6TimerCalc = setTimeout(function () {
      m6TimerCalc = null;
      if (elMeta && elMeta.classList.contains('cco-meta--calc')) m6Ajustar(elMetaInfo, ['Calculando tus productos…', 'Calculando…']);
    }, 350);
    if (elTira) elTira.classList.add('cco-tira--vieja');
  }

  // ── RESUMEN: las piezas de un mismo 2x1 sumado en UN renglón (necesita `productGid`
  // en los externos, que el servidor sólo manda con `meta2x1`). Sólo presentación.
  function m6AgruparItems(items) {
    if (!M6.barra) return items;
    var out = [], porGid = {};
    (items || []).forEach(function (it) {
      if (!it || it.tipo !== 'externo' || !it.productGid) { out.push(it); return; }
      var g = porGid[it.productGid];
      var partes = String(it.titulo || '').split(' — ');
      if (!g) {
        g = porGid[it.productGid] = { tipo: 'externo', productGid: it.productGid, titulo: partes[0], qty: 0, precio: 0, comparacion: 0, piezas: [] };
        out.push(g);
      }
      var q2 = Number(it.qty) || 1;
      g.qty += q2;
      g.precio += Number(it.precio) || 0;
      g.comparacion += Number(it.comparacion) > 0 ? Number(it.comparacion) : (Number(it.precio) || 0);
      // Sólo si la línea NOMBRA una variante (el servidor manda «Producto — Variante»; con
      // la única variante de un producto sin opciones manda sólo el producto): repetir el
      // nombre del producto o enseñar «Default Title» no le dice nada al cliente.
      var nv = partes.length > 1 ? partes.slice(1).join(' — ') : '';
      if (!nv || m6EsDefault(nv)) return;
      for (var k = 0; k < g.piezas.length; k++) if (g.piezas[k].titulo === nv) { g.piezas[k].qty += q2; return; }
      g.piezas.push({ titulo: nv, qty: q2 });
    });
    return out;
  }

  // ── CANDADOS V0–V2 (ESPEC §6.4). Se llaman con CADA cotización y con el 409 fresco.
  // V0 ninguna variante del extra rechazada · V1 las líneas del extra suman EXACTAMENTE
  // «2 por $P» · V2 la línea del pack cuesta lo de la tarjeta elegida.
  // Devuelve la lista de extras que FALLAN (con el porqué).
  function m6ExtrasQueFallan(q) {
    if (!M6.barra || !EXTRAS_TIRA.length || !q) return [];
    var malos = [];
    var rech = Array.isArray(q.externosRechazados) ? q.externosRechazados : [];
    var items = Array.isArray(q.items) ? q.items : [];
    var pk = items[0];
    var esperadoPack = precioTierEscalado(tierActual(), unidadesEfectivas()).precio;
    var packMal = !(pk && pk.tipo === 'pack' && m6Cop(pk.precio) === esperadoPack);
    EXTRAS_TIRA.forEach(function (x) {
      var agotado = x.lineas.some(function (l) {
        return rech.some(function (r) { return r && String(r.variantId) === String(l.variantId); });
      });
      if (agotado) { malos.push({ x: x, motivo: 'agotado' }); return; }
      var suma = 0, hay = false;
      items.forEach(function (it) { if (it && it.tipo === 'externo' && it.productGid === x.productGid) { hay = true; suma += m6Cop(it.precio); } });
      if (!hay || suma !== x.precio || packMal) malos.push({ x: x, motivo: 'precio' });
    });
    return malos;
  }
  // Si algo falla: se quitan esos extras, se dice, se oculta su tarjeta y se recotiza.
  // 🔒 Sólo con una respuesta DEFINITIVA del servidor (cotización 200 o 409 con la
  // fresca): jamás tras un error de red, un timeout o un 5xx (ahí el pedido pudo crearse).
  function m6DeshacerSiFalla(q) {
    if (tiraEnVuelo || tiraRestaurada) return false;
    var malos = m6ExtrasQueFallan(q);
    if (!malos.length) return false;
    malos.forEach(function (m) {
      tiraOcultas[m.x.productGid] = true;
      EXTRAS_TIRA = EXTRAS_TIRA.filter(function (e) { return e !== m.x; });
    });
    var m0 = malos[0];
    tiraAviso = m0.motivo === 'agotado'
      ? (m0.x.titulo + ' se agotó. Tu pedido sigue igual.')
      : ('No pudimos sumar ' + m0.x.titulo + ' con su precio 2x1. Tu pedido sigue igual.');
    m6SinSalto(function () { m6PintarTira(); });
    programarCotizacion();
    return true;
  }

  // ── PAYLOAD: lo que la mejora añade (sólo encendida) ─────────────────────
  function m6Externos(base) {
    if (!M6.barra || !EXTRAS_TIRA.length) return base;
    var out = base.slice();
    EXTRAS_TIRA.forEach(function (x) { x.lineas.forEach(function (l) { out.push({ variantId: String(l.variantId), cantidad: l.cantidad }); }); });
    return out;
  }
  function m6Gids() { return EXTRAS_TIRA.map(function (x) { return x.productGid; }); }

  // ── LA TIRA ──────────────────────────────────────────────────────────────
  function m6HayTarjetas() {
    return !!(M6.tira && elTira && !elTira.hidden && elTira.querySelector('.cco-tira__c'));
  }
  function m6Scroller() {
    var box = modal.querySelector('.cco-modal__box');
    if (box && box.scrollHeight > box.clientHeight + 1) return box;
    return null;
  }
  // 🔒 SIN SALTOS BAJO EL DEDO (hallazgo MEDIA d). Safari de iPhone no tiene
  // `overflow-anchor`: todo repintado que cambie la altura de algo ENCIMA de la tira
  // (el resumen al sumar o quitar, elegir piezas, el atajo del Empaque) compensa el
  // desplazamiento con el Δ de la tira en pantalla.
  function m6Visible(el) { return !!(el && el.parentNode && el.getClientRects && el.getClientRects().length); }
  function m6SinSalto(fn, anclaDada) {
    // El ancla es la tira; si todavía no se ve (1.ª aparición), quien llama puede pasar
    // otra (el nodo que la sigue). Un ancla invisible NO compensa: medir un display:none
    // da top 0 y «compensaría» mil píxeles (medido en la 1.ª versión).
    var ancla = anclaDada || (m6Visible(elTira) ? elTira : null);
    var y0 = m6Visible(ancla) ? ancla.getBoundingClientRect().top : null;
    fn();
    if (y0 == null || !m6Visible(ancla)) return;
    var dy = ancla.getBoundingClientRect().top - y0;
    // 🔒 Lo que el navegador NO deja compensar (el borde de arriba: scrollTop no baja de 0)
    // queda PENDIENTE y se descuenta de la siguiente compensación. Sin esto, «el resumen
    // colapsa a una línea» (no compensable con la caja arriba del todo) y «vuelve a
    // crecer» (sí compensable) movían el formulario 180 px hacia abajo al abrir (medido).
    var objetivo = dy + m6Pendiente;
    if (Math.abs(objetivo) >= 0.5) {
      var s = m6Scroller();
      var antes = s ? s.scrollTop : (window.pageYOffset || 0);
      m6TsCompensa = Date.now();
      if (s) s.scrollTop = antes + objetivo; else window.scrollBy(0, objetivo);
      var despues = s ? s.scrollTop : (window.pageYOffset || 0);
      m6Pendiente = objetivo - (despues - antes);
      if (Math.abs(m6Pendiente) < 0.5) m6Pendiente = 0;
    } else {
      m6Pendiente = 0;
    }
    window.__ccoUltimoDy = dy;
  }
  // Si el CLIENTE desplaza la caja, lo pendiente deja de tener sentido (su referencia era
  // la posición anterior): se olvida. Los desplazamientos propios (≤ 150 ms) no cuentan.
  var m6Pendiente = 0, m6TsCompensa = 0;
  try {
    var boxM6 = modal.querySelector('.cco-modal__box');
    if (boxM6) boxM6.addEventListener('scroll', function () { if (Date.now() - m6TsCompensa > 150) m6Pendiente = 0; }, { passive: true });
  } catch (e) { /* */ }

  function m6TextoResultado(r) {
    if (!r) return { t: '', ok: false };
    if (r.tipo === 'gratis') return { t: '✓ Con este llegas a envío GRATIS', ok: true };
    if (r.tipo === 'ya_gratis') return { t: '2 por el precio de 1', ok: false };
    if (r.tipo === 'empaque') return { t: 'Quedarías a ' + money(r.falta) + ' — con el Empaque 💎 llegas', ok: false };
    if (r.tipo === 'falta') return { t: 'Quedarías a ' + money(r.falta) + ' del envío GRATIS', ok: false };
    return { t: '', ok: false };
  }
  function m6Img(u) { return /^https:\/\//.test(String(u || '')) ? (String(u) + (String(u).indexOf('?') >= 0 ? '&' : '?') + 'width=160') : ''; }

  // Las tarjetas, en el orden CONGELADO de esta apertura: primero lo ya sumado.
  function m6Lista() {
    var lista = [];
    EXTRAS_TIRA.forEach(function (x) { lista.push({ en: true, x: x, productGid: x.productGid }); });
    var max = (tiraResp && Number(tiraResp.max) >= 0) ? Number(tiraResp.max) : 2;
    if (EXTRAS_TIRA.length >= max) return lista;
    var tarj = (tiraResp && Array.isArray(tiraResp.tarjetas)) ? tiraResp.tarjetas : [];
    var porGid = {};
    tarj.forEach(function (t) { if (t && t.productGid) porGid[t.productGid] = t; });
    // Se congela el orden de la PRIMERA respuesta; lo nuevo va al final.
    tarj.forEach(function (t) { if (t && t.productGid && tiraOrden.indexOf(t.productGid) < 0) tiraOrden.push(t.productGid); });
    tiraOrden.forEach(function (g) {
      var t = porGid[g];
      if (!t || tiraOcultas[g]) return;
      if (EXTRAS_TIRA.some(function (x) { return x.productGid === g; })) return;
      lista.push({ en: false, t: t, productGid: g });
    });
    return lista;
  }

  // 🔒 FOTO = VISOR, NUNCA LA FICHA (dueño 08-oct): tocar la foto de una tarjeta la amplía
  // DENTRO del formulario (sin salir del embudo). Es un <button>, no un enlace: no hay
  // href al que navegar.
  function m6Fig(img, titulo, desc) {
    var chip = '<span class="cco-tira__chip">2x1</span>';
    if (!img) return '<span class="cco-tira__fig">' + chip + '</span>';
    return '<button type="button" class="cco-tira__fig" data-cco-tira-foto="' + esc(img) + '" data-cco-tira-foto-t="' + esc(titulo) + '"' +
      (desc ? ' data-cco-tira-foto-d="' + esc(desc) + '"' : '') +
      ' aria-label="Ver foto de ' + esc(titulo) + '"><img src="' + esc(m6Img(img)) + '" alt="" loading="lazy" width="72" height="72">' + chip + '</button>';
  }
  // Selector de una unidad. El <select> nativo de iOS corta el valor en UNA línea («Mujer +
  // Ga…»): el texto visible es un <span> que hace salto de línea, y el <select> va encima,
  // transparente, para que el toque abra el selector nativo de siempre (accesible igual:
  // la etiqueta es suya y el lector lee su valor).
  // `sel` = índice de la variante elegida, o -1 = todavía nada («Elige el diseño…»).
  var M6_PH = 'Elige el diseño…';
  function m6Selector(t, u, sel) {
    var v = sel >= 0 ? (t.variantes[sel] || null) : null;
    return '<label class="cco-tira__u"><span class="cco-tira__ul">Unidad ' + (u + 1) + '</span>' +
      '<span class="cco-tira__sel' + (v ? '' : ' cco-tira__sel--vacio') + '" data-cco-tira-selbox="' + u + '"><span class="cco-tira__selv" aria-hidden="true" data-cco-tira-selv>' + esc(v ? (v.titulo || '') : M6_PH) + '</span>' +
      '<select data-cco-tira-u="' + u + '"' + (v ? '' : ' aria-invalid="true"') + '>' + m6Opciones(t, v ? sel : -1) + '</select></span></label>';
  }
  function m6Opciones(t, sel) {
    return '<option value="" disabled' + (sel < 0 ? ' selected' : '') + '>' + esc(M6_PH) + '</option>' +
      t.variantes.map(function (v, k) {
        return '<option value="' + esc(v.variantId) + '"' + (k === sel ? ' selected' : '') + '>' + esc(v.titulo) + '</option>';
      }).join('');
  }
  // Índice de la variante que el cliente eligió para la unidad u (-1 = nada / ya no existe).
  function m6IdxElegida(t, u) {
    var id = tiraElegidas[u];
    if (!id) return -1;
    for (var k = 0; k < t.variantes.length; k++) if (t.variantes[k].variantId === id) return k;
    return -1;
  }
  // 🔒 BOTÓN NEGRO Y ACTIVO DESDE EL PRINCIPIO (dueño 08-oct, iPhone): el gris «Elige tus 2
  // piezas» parecía roto. El botón siempre dice «Sumar a mi pedido · 2 por $X» y suma DIRECTO
  // con lo que esté seleccionado (las 2 unidades vienen preseleccionadas: m6DefectoTira).
  // Si por lo que sea una unidad quedara vacía (variante que desapareció), NO se suma nada:
  // se resalta y enfoca la que falta (red inerte en la conducta normal).
  function m6TextoOk(t) { return 'Sumar a mi pedido · 2 por ' + money(t.precio); }
  function m6EstadoOk(art, t) {
    var b = art && art.querySelector('[data-cco-tira-ok]');
    if (!b || !t) return;
    b.setAttribute('aria-disabled', 'false');
    b.classList.remove('cco-tira__ok--off');
    b.textContent = m6TextoOk(t);
  }

  // 🔒 PRESELECCIONADO (dueño 08-oct, 2.ª prueba): las 2 unidades ya vienen elegidas para que
  // quien no quiere elegir sume de una con el botón negro; los selectores laten al abrir para
  // que se note que se pueden cambiar. Regla:
  //   · el producto tiene un valor Dama/Mujer y otro Caballero/Hombre → Unidad 1 = la de dama,
  //     Unidad 2 = la de caballero (el 2x1 suele ser en pareja), con el MISMO resto de opciones
  //     si existe («Prosperidad / Dama» → «Prosperidad / Caballero»);
  //   · si no (o una de las dos no viene, o sea sin stock: el servidor sólo manda variantes con
  //     stock) → la primera variante disponible ×2, o la 1.ª + la 2.ª si de ella queda 1 pieza.
  // (landing.data no declara ninguna variante por defecto para la tira: no existe ese dato.)
  var M6_DAMA = /(^|[^a-záéíóúñ])(dama|mujer)([^a-záéíóúñ]|$)/i, M6_CAB = /(^|[^a-záéíóúñ])(caballero|hombre)([^a-záéíóúñ]|$)/i;
  function m6DefectoTira(t) {
    var vs = (t && Array.isArray(t.variantes)) ? t.variantes : [];
    if (!vs.length) return ['', ''];
    var clave = function (v, re) { return String(v.titulo || '').replace(re, '$1#$3').toLowerCase(); };
    var f = null;
    for (var i = 0; i < vs.length && !f; i++) if (M6_DAMA.test(vs[i].titulo || '') && !M6_CAB.test(vs[i].titulo || '')) f = vs[i];
    if (f) {
      var kf = clave(f, M6_DAMA), mPar = null, m1 = null;
      for (var j = 0; j < vs.length; j++) {
        var v = vs[j], tt = v.titulo || '';
        if (!M6_CAB.test(tt) || M6_DAMA.test(tt)) continue;
        if (!m1) m1 = v;
        if (!mPar && clave(v, M6_CAB) === kf) mPar = v;
      }
      var m = mPar || m1;
      if (m) return [f.variantId, m.variantId];
    }
    var v0 = vs[0];
    if (v0.piezas >= 2 || vs.length === 1) return [v0.variantId, v0.variantId];
    return [v0.variantId, vs[1].variantId];
  }

  // 🔒 NUNCA «Default Title» a la vista (dueño 08-oct, «BRAZALETE ABUNDANCIA INTERIOR»):
  // así llama Shopify a la ÚNICA variante de un producto sin opciones. Producto de una
  // sola variante → «2 piezas»; dos iguales → «2 × Dama»; distintas → «Dama · Caballero»
  // (con « · » y no « + »: hay nombres que ya llevan «+», «Mujer + Perro (Collar-50cm)»).
  function m6EsDefault(n) { return /^\s*default\s+title\s*$/i.test(String(n == null ? '' : n)); }
  function m6NombresSumado(x) {
    var ns = (Array.isArray(x.nombres) ? x.nombres : []).filter(function (n) { return n && !m6EsDefault(n); });
    var total = Array.isArray(x.nombres) && x.nombres.length ? x.nombres.length : 2;
    if (x.unica || ns.length !== total) return total + ' piezas';
    if (ns.length === 2 && ns[0] === ns[1]) return '2 × ' + ns[0];
    return ns.join(' · ');
  }

  function m6Tarjeta(it) {
    if (it.en) {
      var x = it.x;
      return '<article class="cco-tira__c cco-tira__c--en" data-cco-tira-c="' + esc(x.productGid) + '">' +
        m6Fig(x.img, x.titulo, x.desc) +
        '<span class="cco-tira__info"><span class="cco-tira__n">' + esc(x.titulo) + '</span>' +
        '<span class="cco-tira__pr"><s>' + money(x.precio * 2) + '</s><b>2 por ' + money(x.precio) + '</b></span></span>' +
        '<div class="cco-tira__pie"><span class="cco-tira__res cco-tira__res--ok">✓ En tu pedido · ' + esc(m6NombresSumado(x)) + '</span>' +
        '<button type="button" class="cco-tira__btn cco-tira__btn--quitar" data-cco-tira-quitar="' + esc(x.productGid) + '">Quitar</button></div></article>';
    }
    var t = it.t;
    var cab = m6Fig(t.img, t.titulo, t.desc) +
      '<span class="cco-tira__info"><span class="cco-tira__n">' + esc(t.titulo) + '</span>' +
      '<span class="cco-tira__pr"><s>' + money(t.tachado) + '</s><b>2 por ' + money(t.precio) + '</b></span></span>';
    if (tiraEligiendo === t.productGid) {
      var e0 = m6IdxElegida(t, 0), e1 = m6IdxElegida(t, 1);
      return '<article class="cco-tira__c cco-tira__c--elegir" data-cco-tira-c="' + esc(t.productGid) + '">' + cab +
        '<div class="cco-tira__pick"><p>Elige tus 2 piezas</p>' +
        m6Selector(t, 0, e0) + m6Selector(t, 1, e1) +
        '<div class="cco-tira__acc"><button type="button" class="cco-tira__ok" aria-disabled="false" data-cco-tira-ok="' + esc(t.productGid) + '">' + esc(m6TextoOk(t)) + '</button>' +
        '<button type="button" class="cco-tira__cancel" data-cco-tira-cancel>Cancelar</button></div></div></article>';
    }
    var r = m6TextoResultado(t.resultado);
    return '<article class="cco-tira__c" data-cco-tira-c="' + esc(t.productGid) + '">' + cab +
      '<div class="cco-tira__pie"><span class="cco-tira__res' + (r.ok ? ' cco-tira__res--ok' : '') + '">' + esc(r.t) + '</span>' +
      '<button type="button" class="cco-tira__btn" data-cco-tira-sumar="' + esc(t.productGid) + '">+ Sumar</button></div></article>';
  }

  function m6PintarTira() {
    if (!M6.tira || !elTira) return;
    var lista = m6Lista();
    if (!lista.length) {
      elTira.hidden = true;
      elTira.innerHTML = '';
      if (m6UltimoQ) m6PintarBarra(m6UltimoQ, m6UltimoModo);
      return;
    }
    var sumado = EXTRAS_TIRA.length > 0;
    var titulo = sumado ? '✓ Sumado a tu mismo pedido' : 'Súmale otro 2x1 a tu pedido';
    var vieja = tiraHuella !== huella(payloadPedido());
    // 🔒 ELEGIR PIEZAS = TODO EL ANCHO (dueño 08-oct, iPhone 390 px): mientras se eligen las
    // 2 piezas la tarjeta ocupa el riel entero y las vecinas se apartan (no asoman ni se
    // montan encima); al cancelar o sumar, el carrusel vuelve tal cual.
    var eligiendo = !!tiraEligiendo && lista.some(function (it) { return !it.en && it.productGid === tiraEligiendo; });
    elTira.className = 'cco-tira' + (sumado ? ' cco-tira--ok' : '') + (vieja ? ' cco-tira--vieja' : '') + (eligiendo ? ' cco-tira--elegir' : '') +
      ((tiraEnVuelo || tiraRestaurada) ? ' cco-tira--congelada' : '');
    if (tiraIdx >= lista.length) tiraIdx = lista.length - 1;
    if (tiraIdx < 0) tiraIdx = 0;
    elTira.innerHTML = '<div class="cco-tira__h"><span class="cco-tira__tit">' + esc(titulo) + '</span>' +
      (lista.length > 1 ? '<span class="cco-tira__nav"><button type="button" aria-label="Anterior" data-cco-tira-prev>‹</button>' +
        '<span data-cco-tira-pos>' + (tiraIdx + 1) + '/' + lista.length + '</span>' +
        '<button type="button" aria-label="Siguiente" data-cco-tira-next>›</button></span>' : '') + '</div>' +
      ((tiraEnVuelo || tiraRestaurada) ? '<p class="cco-tira__aviso">Estamos confirmando tu pedido anterior…</p>' : (tiraAviso ? '<p class="cco-tira__aviso">' + esc(tiraAviso) + '</p>' : '')) +
      '<div class="cco-tira__track" data-cco-tira-track>' + lista.map(m6Tarjeta).join('') + '</div>';
    elTira.hidden = false;
    var tr = elTira.querySelector('[data-cco-tira-track]');
    if (tr) {
      tr.addEventListener('scroll', function () {
        // Con una sola tarjeta a la vista (eligiendo piezas) el desplazamiento no dice cuál es.
        if (tiraEligiendo) return;
        var cs = tr.querySelectorAll('.cco-tira__c');
        if (!cs.length) return;
        var w = cs[0].getBoundingClientRect().width + 8;
        tiraIdx = Math.max(0, Math.min(cs.length - 1, Math.round(tr.scrollLeft / w)));
        var pos = elTira.querySelector('[data-cco-tira-pos]');
        if (pos) pos.textContent = (tiraIdx + 1) + '/' + cs.length;
      }, { passive: true });
      var c0 = tr.querySelectorAll('.cco-tira__c')[tiraIdx];
      if (c0) tr.scrollLeft = Math.max(0, c0.offsetLeft - 12);
    }
    m6Congelar();
    if (m6UltimoQ) m6PintarBarra(m6UltimoQ, m6UltimoModo);
  }

  function m6IrA(i, suave) {
    if (!elTira) return;
    var tr = elTira.querySelector('[data-cco-tira-track]');
    if (!tr) return;
    var cs = tr.querySelectorAll('.cco-tira__c');
    if (!cs.length) return;
    i = Math.max(0, Math.min(cs.length - 1, i));
    tiraIdx = i;
    try { tr.scrollTo({ left: Math.max(0, cs[i].offsetLeft - 12), behavior: suave ? 'smooth' : 'auto' }); }
    catch (e) { tr.scrollLeft = Math.max(0, cs[i].offsetLeft - 12); }
    var pos = elTira.querySelector('[data-cco-tira-pos]');
    if (pos) pos.textContent = (i + 1) + '/' + cs.length;
  }

  // 🔒 PRIMERA APARICIÓN SIN EMPUJAR (hallazgo MEDIA d): la respuesta puede llegar tarde.
  // Si el punto de inserción ya quedó POR ENCIMA del área visible (el cliente bajó
  // leyendo), en esta apertura no se inserta.
  function m6InsertarTira() {
    if (elTira || tiraSaltada) return !!elTira;
    var s = m6Scroller();
    var r = elResumen.getBoundingClientRect();
    var techo = s ? s.getBoundingClientRect().top : 0;
    if (r.bottom < techo) { tiraSaltada = true; return false; }
    elTira = document.createElement('section');
    elTira.className = 'cco-tira';
    elTira.hidden = true;
    elTira.setAttribute('data-cco-tira', '');
    elTira.setAttribute('aria-label', 'Súmale otro 2x1 a tu pedido');
    elResumen.parentNode.insertBefore(elTira, elResumen.nextSibling);
    elTira.addEventListener('change', function (e) {
      var s = e.target;
      if (!s || !s.hasAttribute || !s.hasAttribute('data-cco-tira-u')) return;
      var vis = s.parentNode && s.parentNode.querySelector('[data-cco-tira-selv]');
      var o = s.options[s.selectedIndex];
      if (vis && o) vis.textContent = o.text;
      var u = Number(s.getAttribute('data-cco-tira-u'));
      if (u === 0 || u === 1) tiraElegidas[u] = s.value || '';
      if (s.value) {
        s.removeAttribute('aria-invalid');
        if (s.parentNode) s.parentNode.classList.remove('cco-tira__sel--vacio', 'cco-tira__sel--falta');
      }
      var art = s.closest ? s.closest('[data-cco-tira-c]') : null;
      if (art) m6EstadoOk(art, m6TarjetaDe(art.getAttribute('data-cco-tira-c')));
    });
    m6VigilarTira();
    return true;
  }

  function m6PedirTira(inmediato) {
    if (!M6.tira || pedidoHecho) return;
    if (tiraTimer) clearTimeout(tiraTimer);
    tiraTimer = setTimeout(function () {
      tiraTimer = null;
      var p, h;
      try { p = payloadPedido(); h = huella(p); } catch (e) { return; }   // sin tira: el formulario sigue igual
      var tk = ++tiraToken;
      api('/tira2x1-co', p, PLAZO_LECTURA_MS).then(function (r) {
        if (tk !== tiraToken || !M6.tira || pedidoHecho) return;
        if (r.status !== 200 || !r.body || r.body.ok !== true) return;
        tiraResp = r.body;
        tiraHuella = h;
        var hay = (Array.isArray(r.body.tarjetas) && r.body.tarjetas.length) || EXTRAS_TIRA.length;
        if (!hay && !elTira) { if (m6UltimoQ) m6PintarBarra(m6UltimoQ, m6UltimoModo); return; }
        var primera = !elTira;
        if (!m6InsertarTira()) return;
        if (primera) {
          // 1.ª aparición: lo que está DEBAJO del resumen (pasos, reseñas, campos) es lo que
          // el cliente puede estar mirando. Si el punto de inserción está en la mitad de
          // arriba de lo visible, ese contenido se queda quieto (se compensa con él); si
          // está más abajo, se deja crecer hacia abajo (no hay nada bajo el dedo).
          var s1 = m6Scroller();
          var techo1 = s1 ? s1.getBoundingClientRect().top : 0;
          var alto1 = s1 ? s1.clientHeight : (window.innerHeight || 800);
          var punto = elResumen.getBoundingClientRect().bottom;
          var sig = elTira.nextElementSibling;
          if (punto - techo1 < alto1 / 2 && punto > techo1 && m6Visible(sig)) m6SinSalto(function () { m6PintarTira(); }, sig);
          else m6PintarTira();
        } else {
          m6SinSalto(function () { m6PintarTira(); });
        }
      }).catch(function () { /* sin tira: el formulario sigue igual (ESPEC R4) */ });
    }, inmediato ? 0 : 600);
  }

  // Tras cada cotización buena: la barra; y la tira se recalcula cuando cambió la base.
  function m6TrasCotizacion(b) {
    if (!M6.barra) return;
    m6PintarBarra(b, 'ok');
    if (!M6.tira) return;
    var base = (b && b.envio) ? m6Cop(b.envio.base) : null;
    if (tiraResp == null || base !== tiraBaseVista || tiraHuella !== huella(payloadPedido())) {
      tiraBaseVista = base;
      m6PedirTira(tiraResp == null);
    } else if (elTira) {
      m6PintarTira();
    }
  }

  // ── EL MOVIMIENTO («pasando»): una tarjeta a la vez, cada 5 s, con FRENOS: sólo con la
  // tira ≥ 60 % a la vista, nunca con un campo enfocado, se apaga PARA SIEMPRE al primer
  // toque, en pausa con la pestaña oculta, apagado con movimiento reducido, una sola
  // vuelta. Tras cada avance, «+ Sumar» queda inactivo 800 ms.
  function m6MovReducido() { try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; } }
  function m6VigilarTira() {
    if (!elTira || m6MovReducido()) { tiraAuto.apagada = true; return; }
    var apagar = function () { tiraAuto.apagada = true; if (tiraAuto.timer) { clearInterval(tiraAuto.timer); tiraAuto.timer = null; } };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { elTira.addEventListener(ev, apagar, { passive: true }); });
    try {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { tiraAuto.visible = e.intersectionRatio >= 0.6; }); }, { threshold: [0, 0.6, 1] });
      io.observe(elTira);
    } catch (e) { tiraAuto.visible = false; }
    tiraAuto.timer = setInterval(function () {
      if (tiraAuto.apagada || modal.hidden || document.hidden || !tiraAuto.visible) return;
      var a = document.activeElement;
      if (a && /^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName)) return;
      if (tiraEligiendo || tiraEnVuelo || tiraRestaurada || enviando) return;
      var n = elTira.querySelectorAll('.cco-tira__c').length;
      if (n < 2) return;
      if (tiraIdx + 1 >= n) { apagar(); return; }   // una sola vuelta
      tiraAuto.sumarHasta = Date.now() + 800;
      m6IrA(tiraIdx + 1, true);
    }, 5000);
  }

  // Congelado: con el pedido viajando (o restaurado tras una recarga) nada de la tira ni
  // del atajo se puede tocar.
  function m6Congelar() {
    var off = controlesCongelados() || tiraEnVuelo || tiraRestaurada;
    if (elTira) {
      var bs = elTira.querySelectorAll('button,select');
      for (var i = 0; i < bs.length; i++) {
        var nav = bs[i].hasAttribute('data-cco-tira-prev') || bs[i].hasAttribute('data-cco-tira-next') || bs[i].hasAttribute('data-cco-tira-foto');
        bs[i].disabled = off && !nav;
      }
      elTira.classList.toggle('cco-tira--off', off);
    }
    if (elMeta) {
      var ab = elMeta.querySelectorAll('button');
      for (var j = 0; j < ab.length; j++) ab[j].disabled = !!off;
    }
  }

  // Al abrir «Elige tus 2 piezas»: la tarjeta a la vista (sólo si no lo está ya, para no
  // mover nada de más) y los 2 selectores laten 2 veces con el cobre de la marca (~1,2 s).
  // Con movimiento reducido: sin latido ni desplazamiento suave, sólo el borde resaltado.
  function m6PulsoElegir(g) {
    if (!elTira) return;
    var art = elTira.querySelector('[data-cco-tira-c="' + g + '"]');
    if (!art) return;
    var pick = art.querySelector('.cco-tira__pick') || art;
    var r = pick.getBoundingClientRect();
    var s = m6Scroller();
    var techo = s ? s.getBoundingClientRect().top : 0;
    var piso = s ? s.getBoundingClientRect().bottom : (window.innerHeight || document.documentElement.clientHeight);
    if (r.top < techo || r.bottom > piso) {
      try { pick.scrollIntoView({ behavior: m6MovReducido() ? 'auto' : 'smooth', block: 'nearest' }); }
      catch (e) { try { pick.scrollIntoView(false); } catch (e2) { /* */ } }
    }
    var cajas = art.querySelectorAll('.cco-tira__sel');
    for (var i = 0; i < cajas.length; i++) m6Resaltar(cajas[i], 'cco-tira__sel--pulso', 1250);
  }
  // Toque sobre «Sumar a mi pedido» sin haber elegido las 2 unidades: se resalta la que
  // falta y recibe el foco (sin abrir el selector). No se suma nada.
  function m6SenalarFalta(faltan) {
    for (var i = 0; i < faltan.length; i++) {
      var caja = faltan[i].parentNode;
      if (caja) { caja.classList.add('cco-tira__sel--falta'); m6Resaltar(caja, 'cco-tira__sel--pulso', 1250); }
    }
    if (faltan[0]) { try { faltan[0].focus({ preventScroll: true }); } catch (e) { /* */ } }
  }
  function m6Resaltar(el, clase, ms) {
    if (!el) return;
    el.classList.remove(clase);
    void el.offsetWidth;   // reinicia la animación si se toca dos veces
    el.classList.add(clase);
    setTimeout(function () { el.classList.remove(clase); }, ms || 1800);
  }
  function m6BajarA(el) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: m6MovReducido() ? 'auto' : 'smooth', block: 'center' }); }
    catch (e) { try { el.scrollIntoView(); } catch (e2) { /* */ } }
  }

  function m6TarjetaDe(g) {
    var tarj = (tiraResp && Array.isArray(tiraResp.tarjetas)) ? tiraResp.tarjetas : [];
    for (var i = 0; i < tarj.length; i++) if (tarj[i] && tarj[i].productGid === g) return tarj[i];
    return null;
  }
  function m6Sumar(t, ids) {
    var porId = {};
    t.variantes.forEach(function (v) { porId[v.variantId] = v; });
    var lineas = [], nombres = [];
    ids.forEach(function (id) {
      var v = porId[id] || t.variantes[0];
      nombres.push(v.titulo);
      var l = null;
      for (var k = 0; k < lineas.length; k++) if (lineas[k].variantId === v.variantId) l = lineas[k];
      if (l) l.cantidad += 1; else lineas.push({ variantId: v.variantId, cantidad: 1 });
    });
    EXTRAS_TIRA.push({ productGid: t.productGid, titulo: t.titulo, precio: t.precio, img: t.img, desc: (typeof t.desc === 'string' ? t.desc : null), nombres: nombres, lineas: lineas, unica: t.variantes.length === 1 });
    tiraEligiendo = null;
    tiraElegidas = ['', ''];
    tiraAviso = '';
    tiraAuto.apagada = true;
    tiraIdx = 0;
    m6SinSalto(function () { m6PintarTira(); });
    m6IrA(0, false);
    programarCotizacion();
  }

  // ── VISOR DE LA FOTO (dentro del formulario) ─────────────────────────────
  var elVisor = null, visorDe = null;
  function m6VisorAbierto() { return !!(elVisor && !elVisor.hidden); }
  function m6CerrarVisor() {
    if (!m6VisorAbierto()) return;
    elVisor.hidden = true;
    var img = elVisor.querySelector('img');
    if (img) img.removeAttribute('src');
    var de = visorDe; visorDe = null;
    if (de && de.isConnected) { try { de.focus({ preventScroll: true }); } catch (e) { try { de.focus(); } catch (e2) { /* */ } } }
  }
  function m6AbrirVisor(boton) {
    var url = boton.getAttribute('data-cco-tira-foto');
    if (!/^https:\/\//.test(String(url || ''))) return;
    if (!elVisor) {
      elVisor = document.createElement('div');
      elVisor.className = 'cco-visor';
      elVisor.hidden = true;
      elVisor.setAttribute('role', 'dialog');
      elVisor.setAttribute('aria-modal', 'true');
      elVisor.setAttribute('data-cco-visor', '');
      // Debajo de la foto: el NOMBRE y, si hay dato real (servidor: DESC_TIRA_CO), una línea
      // breve de qué está hecha. Sin dato fiable, sólo foto y nombre.
      elVisor.innerHTML = '<button type="button" class="cco-visor__x" aria-label="Cerrar foto" data-cco-visor-x>✕</button>' +
        '<figure class="cco-visor__fig"><img class="cco-visor__img" alt=""><figcaption class="cco-visor__pie">' +
        '<b class="cco-visor__n" data-cco-visor-n></b><span class="cco-visor__d" data-cco-visor-d></span></figcaption></figure>';
      elVisor.addEventListener('click', function (e) {
        // La X o el fondo cierran; la foto en sí no.
        if (e.target && e.target.closest && e.target.closest('.cco-visor__fig')) return;
        e.stopPropagation();
        m6CerrarVisor();
      });
      // El foco no se escapa al formulario de detrás: el único control es la X.
      elVisor.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') { e.preventDefault(); try { elVisor.querySelector('[data-cco-visor-x]').focus(); } catch (e2) { /* */ } }
      });
      modal.appendChild(elVisor);
    }
    var t = boton.getAttribute('data-cco-tira-foto-t') || '';
    elVisor.setAttribute('aria-label', 'Foto de ' + t);
    var img = elVisor.querySelector('img');
    img.alt = t;
    var dsc = boton.getAttribute('data-cco-tira-foto-d') || '';
    elVisor.querySelector('[data-cco-visor-n]').textContent = t;
    var dn = elVisor.querySelector('[data-cco-visor-d]');
    dn.textContent = dsc;
    dn.hidden = !dsc;
    img.src = String(url) + (String(url).indexOf('?') >= 0 ? '&' : '?') + 'width=1000';
    visorDe = boton;
    elVisor.hidden = false;
    try { elVisor.querySelector('[data-cco-visor-x]').focus({ preventScroll: true }); } catch (e) { /* */ }
  }

  root.addEventListener('click', function (e) {
    if (!M6.barra) return;
    var tgt = e.target;
    var b = tgt && tgt.closest ? tgt.closest('button') : null;
    if (!b || !root.contains(b)) return;
    // La barra
    if (b.hasAttribute('data-cco-meta-ir')) {
      // «Súmale un 2x1 ↓» (el dueño 08-oct: no invasivo; al tocarlo baja SUAVE hasta la
      // tira y la resalta).
      if (elTira && !elTira.hidden) { m6BajarA(elTira); m6Resaltar(elTira, 'cco-tira--resalta'); }
      return;
    }
    if (b.hasAttribute('data-cco-meta-tier2')) {
      if (controlesCongelados()) return;
      var i2 = m6IdxTier2x1();
      var card = i2 >= 0 ? elTiers.querySelector('[data-cco-tier="' + i2 + '"]') : null;
      if (card) card.click();   // el MISMO clic que haría el cliente (recotiza solo)
      return;
    }
    if (b.hasAttribute('data-cco-meta-empaque')) {
      if (controlesCongelados() || tiraEnVuelo || tiraRestaurada) return;
      var A = m6AtajoVigente();
      if (!A) return;
      // D1 · «nada se suma en silencio»: se MARCA con el mismo clic del cliente, se baja
      // hasta su tarjeta y se resalta 1,8 s; ahí se puede desmarcar.
      var cb = elTicks ? elTicks.querySelector('[data-cco-tick="' + A.tick + '"]') : null;
      if (cb && !cb.checked) m6SinSalto(function () { cb.click(); });
      var tc = elTicks ? elTicks.querySelector('[data-cco-tickcard="' + A.tick + '"]') : null;
      m6BajarA(tc);
      m6Resaltar(tc, 'cco-tick--resalta');
      return;
    }
    if (!elTira || !elTira.contains(b)) return;
    // La foto se amplía aquí mismo, también con la tira congelada (mirar no cambia el pedido).
    if (b.hasAttribute('data-cco-tira-foto')) { e.preventDefault(); m6AbrirVisor(b); return; }
    if (b.hasAttribute('data-cco-tira-prev')) { m6IrA(tiraIdx - 1, true); return; }
    if (b.hasAttribute('data-cco-tira-next')) { m6IrA(tiraIdx + 1, true); return; }
    if (controlesCongelados() || tiraEnVuelo || tiraRestaurada) return;
    var g;
    if ((g = b.getAttribute('data-cco-tira-sumar'))) {
      if (Date.now() < tiraAuto.sumarHasta) return;
      var t = m6TarjetaDe(g);
      if (!t) return;
      // Producto de UNA sola variante (con stock para las 2): se suma directo.
      if (t.variantes.length === 1) { m6Sumar(t, [t.variantes[0].variantId, t.variantes[0].variantId]); return; }
      tiraEligiendo = g;
      tiraElegidas = m6DefectoTira(t);
      tiraAviso = '';
      m6SinSalto(function () { m6PintarTira(); });
      m6IrA(Math.max(0, m6Lista().map(function (x) { return x.productGid; }).indexOf(g)), false);
      m6PulsoElegir(g);
      return;
    }
    if (b.hasAttribute('data-cco-tira-cancel')) {
      var g2 = tiraEligiendo;
      tiraEligiendo = null;
      tiraElegidas = ['', ''];
      m6SinSalto(function () { m6PintarTira(); });
      m6IrA(Math.max(0, m6Lista().map(function (x) { return x.productGid; }).indexOf(g2)), false);
      return;
    }
    if ((g = b.getAttribute('data-cco-tira-ok'))) {
      var t2 = m6TarjetaDe(g);
      var art = b.closest('[data-cco-tira-c]');
      if (!t2 || !art) return;
      var sels = art.querySelectorAll('select[data-cco-tira-u]');
      var ids = [];
      // 🔒 Sólo lo que ELIGIÓ el cliente: falta una unidad (o su variante ya no existe) →
      // no se suma nada; se señala la que falta. Nunca se rellena con una por defecto.
      var faltan = [];
      for (var k = 0; k < sels.length; k++) {
        var vk = m6IdxElegida(t2, k) >= 0 ? tiraElegidas[k] : '';
        if (!vk) faltan.push(sels[k]); else ids.push(vk);
      }
      if (sels.length !== 2 || faltan.length) { m6SenalarFalta(faltan); return; }
      // Misma variante dos veces: sólo si hay 2 piezas de ella.
      if (ids.length === 2 && ids[0] === ids[1]) {
        var vv = null;
        t2.variantes.forEach(function (v) { if (v.variantId === ids[0]) vv = v; });
        if (vv && !(vv.piezas >= 2)) { tiraAviso = 'De ' + vv.titulo + ' queda una sola pieza: elige otra para la segunda.'; m6SinSalto(function () { m6PintarTira(); }); return; }
      }
      m6Sumar(t2, ids);
      return;
    }
    if ((g = b.getAttribute('data-cco-tira-quitar'))) {
      EXTRAS_TIRA = EXTRAS_TIRA.filter(function (x) { return x.productGid !== g; });
      tiraAviso = '';
      tiraIdx = 0;
      m6SinSalto(function () { m6PintarTira(); });
      m6IrA(0, false);
      programarCotizacion();
    }
  });

  // ── ANTI DOBLE PEDIDO (hallazgo ALTA b, ESPEC §6.6) — la mitad del navegador ──────
  function m6SsLeer() {
    try {
      var raw = window.sessionStorage.getItem(M6_SS + PRODUCT_GID);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !Array.isArray(o.extras) || !(Date.now() - Number(o.ts) < M6_TTL_VUELO_MS)) {
        window.sessionStorage.removeItem(M6_SS + PRODUCT_GID);
        return null;
      }
      return o;
    } catch (e) { return null; }
  }
  function m6SsBorrar() { try { window.sessionStorage.removeItem(M6_SS + PRODUCT_GID); } catch (e) { /* */ } }
  // Justo antes del POST: si el pedido lleva extras de la tira, queda la marca.
  function m6AntesDeEnviar(tel10) {
    if (!M6.barra || !EXTRAS_TIRA.length) return;
    tiraEnVuelo = true;
    try {
      window.sessionStorage.setItem(M6_SS + PRODUCT_GID, JSON.stringify({ whatsapp: tel10, extras: EXTRAS_TIRA, ts: Date.now() }));
    } catch (e) { /* navegación privada: queda la 2.ª reserva del servidor */ }
    m6Congelar();
  }
  // Respuesta DEFINITIVA (200, 400, 409): se borra la marca y se descongela.
  function m6Definitivo() {
    if (!M6.barra) return;
    m6SsBorrar();
    tiraEnVuelo = false;
    tiraRestaurada = false;
    if (elTira) m6PintarTira(); else m6Congelar();
  }

  function m6Abrir() {
    if (pedidoHecho) return;   // la pantalla de éxito ya no vende (SEL_VENTA_EXITO)
    M6.barra = m6Activa('metaEnvio');
    // La tira: no en /cart ni con la escalera escondida (carrito mezclado), que es
    // donde manda el carrito (ESPEC §2).
    M6.tira = M6.barra && m6Activa('tira2x1') && !EN_CARRITO && root.getAttribute('data-cco-en-carrito') !== '1';
    document.documentElement.classList.toggle('cco-meta-on', M6.barra);
    var sub = $('[data-cco-sub]');
    if (!M6.barra) {
      if (elMeta) elMeta.hidden = true;
      if (sub) sub.hidden = false;
      if (elTira) elTira.hidden = true;
      EXTRAS_TIRA = [];
      return;
    }
    m6CrearBarra();
    if (elMeta) elMeta.hidden = false;
    if (sub && elMeta) sub.hidden = true;
    // Cada apertura empieza limpia… salvo que haya un pedido anterior EN VUELO.
    var marca = m6SsLeer();
    tiraEnVuelo = false;
    tiraRestaurada = !!marca;
    EXTRAS_TIRA = marca ? marca.extras : [];
    tiraResp = null; tiraHuella = null; tiraOrden = []; tiraOcultas = {}; tiraEligiendo = null; tiraElegidas = ['', ''];
    tiraIdx = 0; tiraAviso = ''; tiraSaltada = false; tiraBaseVista = null;
    m6Pendiente = 0;
    tiraAuto.apagada = false;
    if (elTira) { elTira.hidden = true; elTira.innerHTML = ''; }
    m6PintarBarra(null, 'sin');
  }
  function m6Cerrar() {
    m6CerrarVisor();
    if (tiraTimer) { clearTimeout(tiraTimer); tiraTimer = null; }
    tiraToken++;
    if (tiraAuto.timer) { clearInterval(tiraAuto.timer); tiraAuto.timer = null; }
    if (elTira && elTira.parentNode) elTira.parentNode.removeChild(elTira);
    elTira = null;
  }
  function m6Reajustar() { if (M6.barra && elMeta && !modal.hidden) m6PintarBarra(m6UltimoQ, m6UltimoModo); }
  try { window.addEventListener('resize', m6Reajustar); } catch (e) { /* */ }
  try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(m6Reajustar); } catch (e) { /* */ }

  // Diagnóstico para QA (sin datos del cliente).
  window.__ccoM6 = {
    estado: function () {
      return { barra: M6.barra, tira: M6.tira, extras: EXTRAS_TIRA.map(function (x) { return x.productGid; }),
        enVuelo: tiraEnVuelo, restaurada: tiraRestaurada, senales: m6Senales.slice(), dy: window.__ccoUltimoDy };
    },
    _puras: { estadoBarra: m6EstadoBarra, agrupar: m6AgruparItems, extrasQueFallan: m6ExtrasQueFallan, defectoTira: m6DefectoTira },
  };

  /* ── ⭐ RESEÑAS DEL FORMULARIO: SOLO LAS POSITIVAS (dueño 27-oct) ───────────────────
     Las reseñas que rotan bajo «Súmale otro 2x1» las pinta cod-mejoras.js (módulo
     COMPARTIDO con México, no se toca) con el dato del fragmento literal de cod-co.liquid.
     El dueño vio una de 4★ que decía «queda un poco grande»: en el formulario —donde el
     cliente está a un toque de pedir— solo van las POSITIVAS. Regla:
       · 4★ o 5★ (sin estrellas conocidas: fuera);
       · sin ninguna frase de queja (`QUEJA_RE`, sobre el texto sin tildes).
     Se aplica en DOS sitios porque los dos scripts cargan `async` y cualquiera puede
     llegar primero: (1) sobre el JSON del fragmento y el de las reseñas de la tienda
     ANTES de que cod-mejoras lo lea, y (2) sobre la lista que cod-mejoras YA eligió si
     llegó antes. El rotador se arma al ABRIR, así que podar al arrancar y al abrir basta.
     La transición del rotador NO se toca. Solo presentación: el pedido no cambia. */
  var QUEJA_RE = new RegExp([
    'queda(n)? (un poco |algo |muy |demasiado |super )?(grande|pequen|apretad|ajustad|flojo|floja|suelt|larg|cort|anch|estrech)',
    '(un poco|algo|muy|demasiado) (grande|pequen|apretad|flojo|floja|suelt)',
    '\\bpero\\b', 'a pesar', 'sin embargo', 'lastima', 'lamentabl', 'no me gust', 'decepcion',
    'mala calidad', 'de mala', '\\bmalo\\b', '\\bmala\\b', '\\bregular\\b', 'esperaba (mas|otra|otro)',
    'no es (igual|como)', 'diferente a la', 'no (se )?parece', 'no coincide', 'no corresponde',
    'no (me )?(llego|ha llegado)', 'demor', '\\btardo\\b', 'tarde en llegar', 'retras',
    'se (le )?(rompio|dano|desarmo|despego|cayo|pelo|oscurecio|destino|reviento|solto|partio|quebro|perdio)',
    '\\broto\\b', '\\brota\\b', 'oxid', 'se pone negr', 'se puso negr', 'mancha', 'alergi', 'picazon',
    'incomod', 'devol', 'reclam', 'queja', '(podria|podrian|deberia|deberian|puede|pueden|por) mejorar', '\\bfalto\\b', 'faltaba', 'no funciona', 'no sirve',
    'equivoc', 'mal estado', 'defect', 'fragil', 'no recomiendo', 'nada que ver', 'no vale', 'caro\\b'
  ].join('|'));
  function sinTildesMin(x) {
    var t = String(x == null ? '' : x).toLowerCase();
    try { if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* */ }
    return t.replace(/\s+/g, ' ');
  }
  function resenaPositivaCo(r) {
    if (!r || typeof r !== 'object') return false;
    var e = Number(r.e != null ? r.e : r.estrellas);
    if (!(isFinite(e) && e >= 4)) return false;
    var t = r.t != null ? r.t : r.texto;
    if (typeof t !== 'string' || !t.replace(/\s+/g, '')) return false;
    return !QUEJA_RE.test(sinTildesMin(t));
  }
  function soloPositivas(lista) {
    var out = [];
    for (var i = 0; i < (lista || []).length; i++) if (resenaPositivaCo(lista[i])) out.push(lista[i]);
    return out;
  }
  function podarResenasFormCo() {
    // (1) El dato, antes de que cod-mejoras lo lea.
    try {
      var nodos = document.querySelectorAll('script[data-cod-mejoras][data-sistema="co"]');
      for (var i = 0; i < nodos.length; i++) {
        var d = JSON.parse(nodos[i].textContent || 'null');
        if (d && Array.isArray(d.resenas)) {
          var f = soloPositivas(d.resenas);
          if (f.length !== d.resenas.length) { d.resenas = f; nodos[i].textContent = JSON.stringify(d); }
        }
      }
    } catch (e) { /* */ }
    var tiendaFiltrada = [];
    try {
      var nt = document.querySelector('script[data-codm-resenas-tienda]');
      if (nt) {
        var v = JSON.parse(nt.textContent || 'null');
        var arr = Array.isArray(v) ? v : (v && Array.isArray(v.items) ? v.items : null);
        if (arr) {
          tiendaFiltrada = soloPositivas(arr);
          if (tiendaFiltrada.length !== arr.length) nt.textContent = JSON.stringify(tiendaFiltrada);
        }
      }
    } catch (e) { /* */ }
    // (2) La lista que cod-mejoras ya eligió (si llegó primero).
    try {
      var cm = window.__codMejoras;
      var inst = cm && cm.instancias && cm.instancias.co;
      if (inst && Array.isArray(inst.resenas) && inst.resenas.length) {
        var buenas = soloPositivas(inst.resenas);
        if (!buenas.length && tiendaFiltrada.length && cm._puras && typeof cm._puras.normalizarResena === 'function') {
          // Todas las de la pieza eran quejas: las mejores reales de la tienda (como hace
          // cod-mejoras cuando la pieza no tiene reseñas de cliente).
          for (var k = 0; k < tiendaFiltrada.length && buenas.length < 12; k++) {
            var nr = cm._puras.normalizarResena(tiendaFiltrada[k], 'cliente');
            if (nr && resenaPositivaCo(nr)) buenas.push(nr);
          }
        }
        if (buenas.length !== inst.resenas.length) inst.resenas = buenas;
      }
    } catch (e) { /* el formulario sigue igual */ }
  }
  window.__ccoResenas = { _puras: { positiva: resenaPositivaCo, soloPositivas: soloPositivas }, podar: podarResenasFormCo };
  try { podarResenasFormCo(); } catch (e) { /* */ }

  function abrir() {
    try { podarResenasFormCo(); } catch (e) { /* */ }
    modal.hidden = false;
    // ⚡ CADA APERTURA ES UNA SESIÓN NUEVA DE LA CADENA (G2): el voto anterior no
    // sobrevive a un cierre. Se resetea ANTES de cotizar, porque `payloadPedido()` lo
    // lleva dentro y la cotización de esta apertura tiene que describir el pedido real.
    FLASH_ACEPTADOS = [];
    flashCadenaHecha = false;
    // Y la copia del pedido aprobado tampoco sobrevive al cierre: es de ESTA apertura y de
    // este pedido. Hoy no es alcanzable (el botón que la usa vive en el aviso, y el aviso lo
    // borra `limpiarConfirmacion` en cuanto se recotiza), pero un estado de precio de la
    // apertura anterior es justo lo que este archivo no se puede permitir tener guardado.
    flashAprobada = null;
    document.documentElement.style.overflow = 'hidden';
    // ⑥ MEJORA 6: decide AQUÍ si la barra y la tira van (antes de pintar la escalera, por
    // la línea «no acumulable» de D3, y antes de cotizar, por el payload).
    // ⏱️ (21-oct) Si algo de esto lanza, la apertura SIGUE: lo importante es que la
    // cotización salga (abajo) y que el vigía tenga a quién vigilar.
    try {
      m6Abrir();
      cargarDepartamentos();
      pintarTiers();
      pintarUnidades();
      pintarTicks();
    } catch (e) { reportarSalud('excepcion_abrir'); }
    reportarSalud('apertura');
    armarVigia();
    // SIEMPRE se recotiza al abrir (nada de `if (!cotizado)`), molde cod-carrito.js:243:
    // entre una apertura y otra pueden haber cambiado los precios del metafield o el
    // costo de envío del servidor, y lo que el cliente ve tiene que ser lo vigente.
    reintentos = 0;
    // El carrito se lee AL ABRIR y antes de cotizar: es el único momento en que se sabe
    // que el cliente ya terminó de meter cosas. Si la lectura falla, se cotiza igual con
    // lo que hubiera — el pedido del pack nunca se queda sin poder hacerse por un
    // /cart.js caído.
    leerCarritoVivo().then(aplicarCarritoSeguro, aplicarCarritoSeguro);
    // El vigilante de la EDAD de la cotización sólo vive con el modal abierto (ver el
    // bloque del EJE TIEMPO): un temporizador corriendo en una página que nadie está
    // usando es gasto y ruido en un rate-limit que bajo CGNAT se comparte con otros
    // compradores reales.
    arrancarLatido();
  }
  function cerrar() {
    // ⚡ DURANTE LA CADENA, CERRAR CIERRA LA CADENA — NO EL PEDIDO (G2). Vale como «NO a
    // todo lo pendiente» y el envío continúa con lo ya aceptado. El modal se queda
    // ABIERTO a propósito: ocultarlo mientras el pedido viaja le esconde al cliente la
    // pantalla de éxito y el aviso de precio, y se quedaría creyendo que no pasó nada.
    if (flashCadenaEnCurso && flashCerrarCadena) { flashCerrarCadena(); return; }
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    pararLatido();
    m6Cerrar();
    // Reintentos y cuentas atrás en vuelo no tienen a quién servir con el modal
    // cerrado. Al reabrir, abrir() recotiza desde cero (y programarCotizacion incrementa
    // el token, así que nada en vuelo puede pintar sobre la cotización nueva).
    pararTimers();
  }
  $('[data-cco-abrir]').addEventListener('click', abrir);
  root.querySelectorAll('[data-cco-cerrar]').forEach(function (b) {
    b.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) {
      // Con la foto ampliada, Escape cierra SOLO la foto (el formulario sigue abierto).
      if (typeof m6VisorAbierto === 'function' && m6VisorAbierto()) { m6CerrarVisor(); return; }
      cerrar();
    }
  });

  // ── El botón, PEGADO a "Agregar al carrito" (dictado del dueño 09-sep) ──────
  //
  // POR QUÉ HACE FALTA JS y no basta con dónde lo pinta Liquid: el snippet se
  // renderiza justo debajo de <product-form>, pero DENTRO del formulario del tema hay
  // apps que inyectan sus recuadros DESPUÉS de cargar la página (medido en vivo en la
  // ficha del brazalete ónix: "Empaque Premium" y la barra de envío gratis cuelgan del
  // propio <form>, y el bloque de "Envío rápido / Devolución / Garantía" cuelga de
  // <product-form>). Resultado: el cliente veía el botón de contra entrega al final de
  // todo eso, a ~700 px del botón de comprar.
  //
  // DOS PASOS, y el segundo es el que aguanta:
  //  1. Se MUEVE el .cco-wrap DENTRO del <form>, una sola vez.
  //  2. El ORDEN lo fija el CSS (.cco-anclado en cod-co.css), no la posición en el DOM
  //     — si lo dejáramos en "justo después de los botones", la siguiente app que
  //     inyecte ahí lo empujaría otra vez hacia abajo, que es el defecto que se está
  //     arreglando. Con `order` da igual cuándo inyecte nadie y en qué sitio.
  //
  // 🔒 SE MUEVE EL BLOQUE ENTERO, no sólo el botón: las variables de color viven en
  //    `.cco-wrap` y el JS busca todo con `root.querySelector`, así que sacar el botón
  //    de su caja lo dejaría sin fondo y sin nada a lo que agarrarse.
  // 🔒 VERIFICADO EN VIVO antes de escribir esto (ficha del ónix): el <form> del modal
  //    queda anidado dentro del de Shopify, y eso es legal por DOM — los campos del
  //    formulario contra entrega siguen siendo suyos (13 campos, dueño `cco-form`), el
  //    de Shopify no gana ni un campo con nombre, y "Agregar al Carrito" siguió
  //    metiendo la variante correcta (BRAZALETE ONIX · Dama ×1 $43.000).
  // 🔌 Si algo no encaja, NO se mueve nada: el botón se queda donde lo puso Liquid, que
  //    es como estaba hasta hoy. Nunca deja al cliente sin botón.
  function anclarBajoAgregarAlCarrito() {
    // Lo pide QUIEN RENDERIZA (data-cco-anclar, ver cod-co.liquid), no se adivina por el
    // DOM: el primer intento miraba si la caja del bloque contenía un <product-form> y
    // eso también se cumplía en las seis fichas del 2x1 — medido en vivo, movía su
    // formulario sin que nadie se lo hubiera pedido. Un flag explícito no se equivoca.
    if (root.dataset.ccoAnclar !== '1') return;
    if (EN_CARRITO) return;                       // en el carrito no hay ficha que seguir
    var caja = root.parentElement;
    if (!caja) return;
    var pf = caja.querySelector('product-form');
    if (!pf) return;
    var formTema = pf.querySelector('form');
    var botones = formTema && formTema.querySelector('.product-form__buttons');
    if (!formTema || !botones) return;
    if (root.parentElement !== formTema) formTema.appendChild(root);
    formTema.classList.add('cco-anclado');
  }
  try { anclarBajoAgregarAlCarrito(); } catch (e) { /* el botón se queda donde estaba */ }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⚡ LA CADENA DE OFERTAS FLASH (G2) — POST-CONFIRMACIÓN DEL **FORMULARIO**
  // ═══════════════════════════════════════════════════════════════════════════
  // «Post-confirmación» significa lo mismo que en México (`correrCadena`,
  // landing-buda.js:3678): TRAS validar el formulario y ANTES del POST. No es
  // post-confirmación de la ORDEN — cuando hay orden ya no hay nada que ofrecer.
  //
  // 🔒 AQUÍ NO SE CALCULA UN PESO. El precio flash (`precioFinal`), el tachado
  // (`precioBase`, leído VIVO por el servidor), el badge y el orden de la escalera
  // (`pos`) vienen cocidos en la respuesta de /cotizar-co. Esta cadena sólo pinta lo que
  // le dan y devuelve un VOTO: `{ id, qty, variantId }`. Si alguien edita este JS en el
  // navegador, lo peor que consigue es votar un `variantId` que no está en la lista
  // blanca del catálogo — y `resolverFlashAceptadosCo` (router-co.js:1060) lo cae a la
  // variante por defecto.
  //
  // 🔒 UN SOLO TIMER PARA TODA LA CADENA, y por DELTA DE RELOJ. No hay un
  // `setInterval` por tarjeta ni un contador que decremente de 1 en 1: el throttling de
  // pestañas en segundo plano CONGELA los intervalos (lección COD Total, 11-jul), así
  // que un decremento por tick daría 60 s de oferta a quien la deje en segundo plano y
  // la cuenta atrás mentiría al volver. El reloj es `ahoraMs()` — el MONÓTONO de este
  // archivo, no `Date.now()`: un ajuste de NTP o un cambio de hora del teléfono no
  // puede alargar ni acortar la oferta.
  var FLASH_SEG_DEFECTO = 60;
  var FLASH_ESPERA_MAX_MS = 20000;  // cubre el debounce (250ms) + los 2 reintentos (800+2400) + RTT

  function flashOfertaPorId(id) {
    for (var i = 0; i < FLASH_OFERTAS.length; i++) {
      var o = FLASH_OFERTAS[i];
      if (o && String(o.id) === String(id)) return o;
    }
    return null;
  }
  function flashYaAceptada(id) {
    for (var i = 0; i < FLASH_ACEPTADOS.length; i++) {
      if (String(FLASH_ACEPTADOS[i].id) === String(id)) return true;
    }
    return false;
  }

  // 🔒 FAIL-CLOSED: sólo se ofrece lo que se puede pintar SIN MENTIR. Sin `precioFinal`
  // positivo no hay qué cobrar, y sin un `precioBase` ESTRICTAMENTE mayor no hay
  // tachado real — una «oferta» sin ahorro es una mentira, y el servidor ya la descarta
  // con el motivo `sin_descuento`. Esto es el cinturón del front: si un día llegara una
  // sin verificar, no se ofrece en vez de pintarse sin ancla.
  function flashOfrecibles() {
    var out = [];
    for (var i = 0; i < FLASH_OFERTAS.length; i++) {
      var o = FLASH_OFERTAS[i];
      if (!o || typeof o !== 'object' || o.id == null || o.id === '') continue;
      if (!(cop(o.precioFinal) > 0)) continue;
      if (!(cop(o.precioBase) > cop(o.precioFinal))) continue;
      if (flashYaAceptada(o.id)) continue;
      out.push(o);
    }
    return out;
  }

  // ¿Corre la cadena en ESTE submit? Se exige una cotización BUENA y FRESCA porque los
  // dos números del «antes» de la regla de continuación (§G2.2) salen de ella: comparar
  // contra un total rancio pediría un gesto explícito a quien no lo necesita, o —peor—
  // dejaría pasar uno que sí. Sin cotización usable, los candados de siempre corren
  // primero (revalidan) y la cadena se ofrece en el intento siguiente.
  function flashDebeCorrer() {
    if (flashCadenaHecha || flashCadenaEnCurso) return false;
    if (pedidoHecho || enviando) return false;
    if (bloqueo || confirmacion) return false;
    if (!cotizado || !cotizacionFresca()) return false;
    return flashOfrecibles().length > 0;
  }

  function flashSegundos(o) {
    var n = Math.trunc(Number(o && o.countdownSeg));
    return (n > 0 && n <= 600) ? n : FLASH_SEG_DEFECTO;
  }
  function flashVarianteDefecto(o) {
    var vs = flashVariantes(o);
    if (o && o.variantId) return String(o.variantId);
    return vs.length ? String(vs[0].variantId) : null;
  }
  function flashVariantes(o) {
    var vs = (o && Array.isArray(o.variantes)) ? o.variantes : [];
    var out = [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i] && vs[i].variantId) out.push(vs[i]);
    }
    return out;
  }
  function flashImagenDe(o, variantId) {
    var vs = flashVariantes(o);
    for (var i = 0; i < vs.length; i++) {
      if (String(vs[i].variantId) === String(variantId) && vs[i].imagen) return String(vs[i].imagen);
    }
    return (o && o.imagen) ? String(o.imagen) : '';
  }
  function flashImagenOk(u) { return /^https?:\/\//i.test(String(u || '')) ? String(u) : ''; }

  // ── EL BADGE, EN DOS CARACTERES Y NO EN DOS RENGLONES ────────────────────
  // PURA. El servidor manda «58% DE DESCUENTO» (`badgeFlashCo`, flash-co.js:255-258) y
  // esa cadena, dentro de la pastilla de una tarjeta de 375 px, cae en DOS renglones y
  // tapa un tercio de la foto de la pieza (medido en el preview del duplicado). Aquí se
  // acorta a «-58%».
  // 🔒 NO SE CALCULA NINGÚN PORCENTAJE: se LEE el que el servidor ya redondeó con floor
  // (`ahorroPctReal` — nunca prometer un descuento mayor del real) y sólo se cambia su
  // envoltorio. Si el texto no trae un `%`, se pinta TAL CUAL: el front no adivina lo
  // que no entiende, y así un badge futuro («ÚLTIMAS 3») no se convierte en basura.
  // ⚠️ DIVERGENCIA DECLARADA: la MISMA transformación vive también en la pantalla del
  // carrito (`carrito-co.liquid`), y NO hay dónde poner una pura compartida sin inventar un
  // global — `cod-co.js` sólo carga en la FICHA y el guion del panel sólo en `/cart`, nunca
  // los dos en la misma página. Cada lado tiene su propio assert sobre el MISMO texto del
  // servidor (aquí C2-1a; el panel, en su sección), y los dos cuelgan del mismo candado
  // anti-desfase (C2-1g): que `badgeFlashCo` siga escribiendo «% DE DESCUENTO».
  function flashBadge(txt) {
    var s = String(txt == null ? '' : txt).trim();
    if (!s) return '';
    var m = s.match(/(\d{1,3})\s*%/);
    return m ? ('-' + m[1] + '%') : s;
  }

  // ── EL TÍTULO Y EL MATERIAL, SEPARADOS (copia de MX `tituloSinParentesisFinal`) ──
  // PURA. México saca el material de una tabla escrita a mano (`FLASH_FICHA`, gid →
  // material). Aquí NO hace falta inventar esa tabla: el propio servidor ya manda el
  // material dentro del título («Pulsera Prosperidad Infinita ♾️ (Baño de oro 18K)») y
  // lo escribe el barrido de materiales honestos del 29-jul. Se PARTE ese título: el
  // paréntesis final pasa a `.cco-flash__mat` y el resto queda como nombre.
  // 🔒 NO SE INVENTA NI SE TRADUCE NADA: si el título no trae paréntesis final, `mat`
  // sale vacío y el nombre se pinta EXACTAMENTE como vino. Y la cola no alfanumérica
  // (emojis, símbolos) se CONSERVA — es parte del título que escribió el dueño; ése fue
  // un bug real en México el 27-jul, donde «… (Baño de oro 18K) ❤️‍🔥» no matcheaba y el
  // material salía DOS VECES.
  // Sin property escapes (\p{L}) a propósito: este asset corre en móviles viejos.
  function flashPartirTitulo(t) {
    var s = String(t == null ? '' : t).trim();
    var m = s.match(/^([\s\S]*?)\s*\(([^()]*)\)\s*([^A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ(]*)$/);
    if (!m || !m[1].trim() || !m[2].trim()) return { nombre: s, mat: '' };
    return {
      nombre: (m[1] + ' ' + (m[3] || '')).replace(/\s+/g, ' ').trim(),
      mat: m[2].trim(),
    };
  }

  // ── LAS FOTOS DE UNA OFERTA ──────────────────────────────────────────────
  // México pinta un CARRUSEL cuando la oferta trae 2+ fotos (`of.imagenes`). Aquí se
  // copia la MISMA regla y sobre el MISMO campo, para que el día que el servidor lo
  // mande el carrusel aparezca solo.
  // El servidor YA cocina `imagenes` cuando la galería del producto tiene 2+ fotos
  // (flash-co.js, commit 985d74ed): el carrusel aparece solo en esas ofertas; con una
  // sola foto se pinta la foto única, igual que México.
  // 🔒 LAS FOTOS DE LAS VARIANTES NO SON UN CARRUSEL, y no es pereza: deslizar a la
  // «foto 2» enseñaría el hilo negro mientras el chip marcado dice «Hilo rojo» — la
  // tarjeta estaría enseñando una variante que no es la que se vota. Las variantes las
  // gobiernan los chips, igual que en México.
  function flashImagenes(o) {
    var xs = (o && Object.prototype.toString.call(o.imagenes) === '[object Array]') ? o.imagenes : [];
    var out = [];
    for (var i = 0; i < xs.length && out.length < 6; i++) {
      var u = flashImagenOk(xs[i]);
      if (u) out.push(u);
    }
    return out;
  }

  // LA TARJETA, ENTERA — COPIA PÍXEL A PÍXEL DE LA DE SOY BUDA MÉXICO (dictado §19.18).
  // El marcado espeja `mostrarOferta()` de `landing-buda.js` en su rama fullscreen:
  //   card > [✕ · scroll(paso · foto · chips · nombre+material · copy · precio+% · reloj)
  //           · pie(cantidad · CTA · «No, gracias.»)]
  // 🔴 SIN «Envío gratis» y SIN «COP» en ninguna cadena: en Colombia el envío se cobra
  // ($17.700) y sólo es gratis desde $129.000; el formato de la casa es «$33.000» a
  // secas (money(), espejo de formatearCop). Máximo UN emoji por botón (el 🚚 del CTA).
  function flashHtml(o, variantId, total, idx) {
    var vs = flashVariantes(o);
    var fotos = flashImagenes(o);
    var img = flashImagenOk(flashImagenDe(o, variantId));
    var badge = flashBadge(o.badgeText);
    var tit = flashPartirTitulo(o.titulo);
    // El selector de cantidad sólo existe si HAY algo que elegir, que es la regla de
    // México TAL CUAL (`qtyMax > 1`). Con el `FLASH_CO_QTY_MAX = 3` de hoy (flash-co.js,
    // commit 985d74ed) SÍ se pinta; queda igual de fail-safe si algún día el servidor
    // volviera a mandar 1: un stepper que no puede pasar de 1 es un control muerto.
    var qtyMax = Math.max(1, Math.trunc(Number(o && o.qtyMax) || 1));

    var h = '<div class="cco-flash__card">';
    // El ✕ táctil: en el móvil no hay tecla Escape y la tarjeta tapa la ✕ del modal.
    // Comparte `data-cco-flash-no` con «No, gracias.» — cerrar es rechazar ESTA oferta.
    h += '<button type="button" class="cco-flash__x" data-cco-flash-no aria-label="Cerrar oferta">×</button>';
    h += '<div class="cco-flash__scroll">';
    h += '<p class="cco-flash__paso">Oferta ' + (idx + 1) + ' de ' + total + '</p>';
    if (fotos.length >= 2) {
      h += '<div class="cco-flash__slider" data-cco-flash-slider>' +
        '<div class="cco-flash__slider-track" data-cco-flash-track>';
      for (var f = 0; f < fotos.length; f++) {
        h += '<img class="cco-flash__img cco-flash__slider-slide"' + (f === 0 ? ' data-cco-flash-img' : '') +
          ' src="' + esc(fotos[f]) + '" alt=""' + (f > 0 ? ' loading="lazy"' : ' loading="eager"') + '>';
      }
      h += '</div>' +
        '<button type="button" class="cco-flash__slider-arrow cco-flash__slider-arrow--prev" data-cco-flash-prev aria-label="Foto anterior"></button>' +
        '<button type="button" class="cco-flash__slider-arrow cco-flash__slider-arrow--next" data-cco-flash-next aria-label="Foto siguiente"></button>' +
        '</div>';
    } else if (img) {
      h += '<div class="cco-flash__marco">' +
        '<img class="cco-flash__img' + (vs.length >= 2 ? ' cco-flash__img--var' : '') +
        '" data-cco-flash-img src="' + esc(img) + '" alt="" loading="eager">' +
        '</div>';
    }
    // Chips SOLO TEXTO, y sólo cuando hay de verdad algo que elegir. Con una sola
    // variante un chip no es una elección: es ruido que ocupa la pantalla del móvil.
    if (vs.length >= 2) {
      h += '<div class="cco-flash__chips" role="group">';
      for (var i = 0; i < vs.length; i++) {
        var on = String(vs[i].variantId) === String(variantId);
        h += '<button type="button" class="cco-flash__chip' + (on ? ' cco-flash__chip--on' : '') +
          '" data-cco-flash-chip="' + esc(vs[i].variantId) + '"' +
          (on ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' +
          esc(vs[i].label || 'Opción') + '</button>';
      }
      h += '</div>';
    }
    // 🔒 UN `div`, NO UN `<h3>`, Y NO ES UN DETALLE DE SEMÁNTICA: es lo que hace que
    // la Georgia de México llegue viva a la pantalla. Medido el 11-sep en la ficha del
    // duplicado v2: un `<style>` inyectado en la tienda declara
    // `h1,h2,h3,h4,h5,h6 { font-family:"Nunito Sans" !important }` — un `!important`
    // le gana a CUALQUIER clase nuestra, así que el nombre salía en la tipografía del
    // tema y la tarjeta dejaba de leerse como una joyería. México la pinta con un
    // `<div class="lb2-flash__name">` (verificado en su DOM vivo), así que copiarlo TAL
    // CUAL resuelve el choque sin escribir un solo `!important` de nuestro lado. La
    // tarjeta es un diálogo efímero: no aporta un encabezado al índice de la página.
    h += '<div class="cco-flash__t">' + esc(tit.nombre) +
      (tit.mat ? ' <span class="cco-flash__mat">(' + esc(tit.mat) + ')</span>' : '') + '</div>';
    if (o.copy) h += '<p class="cco-flash__copy">' + esc(o.copy) + '</p>';
    // El bloque ANCLA: tachado · precio enorme · píldora del descuento, en una fila.
    h += '<div class="cco-flash__precios">' +
      '<s class="cco-flash__antes">' + money(o.precioBase) + '</s>' +
      '<b class="cco-flash__ahora">' + money(o.precioFinal) + '</b>' +
      (badge ? '<span class="cco-flash__badge">' + esc(badge) + '</span>' : '') +
      '</div>';
    // La urgencia, en UN grupo: la etiqueta y los tres chips son una sola idea.
    h += '<div class="cco-flash__urg">' +
      '<span class="cco-flash__cdlbl">⏰ La oferta termina en:</span>' +
      '<span class="cco-flash__reloj" data-cco-flash-reloj aria-live="off">' +
        '<span class="cco-flash__cd-chip" data-cco-flash-hh>00</span>' +
        '<span class="cco-flash__cd-sep">:</span>' +
        '<span class="cco-flash__cd-chip" data-cco-flash-mm>00</span>' +
        '<span class="cco-flash__cd-sep">:</span>' +
        '<span class="cco-flash__cd-chip" data-cco-flash-ss>00</span>' +
      '</span>' +
      '</div>';
    h += '</div>';
    // EL PIE VA FUERA DEL SCROLL (§4 del estándar de espacios flash): en 375 px con el
    // teclado abierto un pie dentro del scroll desaparece, y el cliente se queda sin
    // poder decir ni sí ni no.
    h += '<div class="cco-flash__pie">';
    if (qtyMax > 1) {
      h += '<div class="cco-flash__qty">' +
        '<button type="button" class="cco-flash__qty-btn" data-cco-flash-menos aria-label="Quitar una unidad">−</button>' +
        '<span class="cco-flash__qty-n" data-cco-flash-qty>1</span>' +
        '<button type="button" class="cco-flash__qty-btn" data-cco-flash-mas aria-label="Añadir una unidad">+</button>' +
        '</div>';
    }
    // 🔴 EL TEXTO ES EL DE MÉXICO, LETRA POR LETRA: «🛍 Agregar a tu pedido», y el total
    // SÓLO aparece cuando hay más de una unidad (« · $66.000»), que es exactamente lo
    // que hace `pintaQty` allá. No lleva el precio pegado porque el precio ya está dos
    // renglones más arriba, en 22,8 px y en blanco: repetirlo en el botón le robaba
    // sitio a la llamada a la acción.
    //
    // 🔴 LA SUBLÍNEA ES LO ÚNICO QUE NO SE COPIA, y se queda SIN emoji. Allá dice
    // «Paga al recibir · Envío gratis 🇲🇽»; en Colombia el envío se cobra ($17.700) y
    // sólo es gratis desde $129.000, así que la promesa se cae — y con ella la
    // banderita, que era su compañera. Antes esta línea llevaba un 🚚 puesto aquí, no
    // copiado de México: con el 🛍 de la línea de arriba el botón sumaba DOS emojis y
    // el dueño dictó «máximo un emoji por botón» (10-sep §8). Entre el de México y el
    // nuestro se conserva el de México, que es lo que este dictado manda copiar.
    // Para volver al 🚚 basta con quitar el 🛍 de la línea de arriba: la regla es que
    // haya UNO, no cuál.
    h += '<button type="button" class="cco-flash__si" data-cco-flash-si>' +
        '<span class="cco-flash__si-l1">🛍 Agregar a tu pedido<span data-cco-flash-si-total></span></span>' +
        '<span class="cco-flash__si-l2">Paga al recibir</span>' +
      '</button>' +
      '<button type="button" class="cco-flash__no" data-cco-flash-no>No, gracias.</button>' +
      '</div>';
    h += '</div>';
    return h;
  }

  // Al tocar un chip cambian DOS cosas y ninguna más: la foto grande y el `variantId`
  // que se vota. El PRECIO no se toca — las dos variantes del F1 valen lo mismo
  // ($79.900 verificado en vivo) y el servidor sólo acepta variantes de su lista blanca,
  // así que un chip nunca puede mover un peso.
  function flashPintarChip(host, variantId, o) {
    var chips = host.querySelectorAll('[data-cco-flash-chip]');
    for (var i = 0; i < chips.length; i++) {
      var on = String(chips[i].getAttribute('data-cco-flash-chip')) === String(variantId);
      chips[i].classList.toggle('cco-flash__chip--on', on);
      chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var img = flashImagenOk(flashImagenDe(o, variantId));
    if (!img) return;
    /* CON CARRUSEL, LA ELECCIÓN GANA AL ÁLBUM (copia de México, `landing-buda.js` en el
       manejador de sus pills): si la oferta trae a la vez galería y variantes, al elegir
       una variante el track se sustituye por UNA sola foto —la de la variante, a marco
       lleno— en vez de cambiarle el `src` a la primera diapositiva. Si no, deslizando se
       vería la foto del hilo negro con el chip marcado en «Hilo rojo»: la tarjeta estaría
       enseñando una variante que no es la que se vota. Las flechas se retiran con el
       álbum, que es lo que hace allá. */
    var track = host.querySelector('[data-cco-flash-track]');
    if (track) {
      track.innerHTML = '<img class="cco-flash__img cco-flash__img--var cco-flash__slider-slide"' +
        ' data-cco-flash-img src="' + esc(img) + '" alt="" loading="eager">';
      var flechas = host.querySelectorAll('.cco-flash__slider-arrow');
      for (var f = 0; f < flechas.length; f++) flechas[f].hidden = true;
      return;
    }
    var el = host.querySelector('[data-cco-flash-img]');
    if (el) el.setAttribute('src', img);
  }

  /* ── TELEMETRÍA DE LAS OFERTAS FLASH (CASO 12, 22-sep) ─────────────────────
     Hasta hoy sólo se sabía qué ofertas se COBRARON. Cuántas se MOSTRARON, no — y sin
     denominador no hay tasa, así que la rotación del dictado no tendría con qué
     aprender. Esto lo emite: una `vista` por tarjeta pintada, la decisión, el reloj
     vencido, y el fin de la cadena.

     🔒 FIRE-AND-FORGET DE VERDAD. `navigator.sendBeacon` con el cuerpo como STRING (o
     sea `text/plain`): un Blob `application/json` dispararía preflight y un preflight
     fallido tira el beacon en silencio. El servidor acepta cualquier content-type en
     esta ruta y contesta 204 siempre. Si el endpoint todavía no existe (404) o falla,
     aquí no pasa NADA: no hay `then`, no hay estado, no hay UI que dependa de esto. Una
     venta jamás se pierde por una métrica.
     🔒 `FLASH_SES` es un id ALEATORIO por carga de página. No identifica a nadie —no es
     el token del carrito, ni el teléfono— y existe sólo para DE-DUPLICAR: sin él, un
     reintento del navegador contaría como otra impresión y la tasa bajaría sola. */
  var FLASH_SES = (function () {
    var abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var out = '';
    try {
      var buf = new Uint8Array(16);
      (window.crypto || window.msCrypto).getRandomValues(buf);
      for (var i = 0; i < buf.length; i++) out += abc.charAt(buf[i] % abc.length);
    } catch (e) {
      for (var j = 0; j < 16; j++) out += abc.charAt(Math.floor(Math.random() * abc.length));
    }
    return out;
  })();
  var flashVistaEmitida = {};   // ufId → true (una vista por tarjeta y por sesión)

  function flashBeacon(evento, ufId, pos, extra) {
    if (!ENDPOINT) return;
    try {
      var datos = {
        frente: 'formulario',
        evento: String(evento),
        ufId: String(ufId || ''),
        pos: Math.max(1, Math.min(9, Math.trunc(Number(pos)) || 1)),
        ses: FLASH_SES
      };
      if (PRODUCT_GID) datos.productGid = PRODUCT_GID;
      if (extra && typeof extra === 'object') {
        for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) datos[k] = extra[k];
      }
      var cuerpo = JSON.stringify(datos);
      var url = ENDPOINT + '/flash-vista-co';
      if (navigator.sendBeacon && navigator.sendBeacon(url, cuerpo)) return;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
        body: cuerpo,
        keepalive: true
      }).catch(function () { /* fire-and-forget */ });
    } catch (e) { /* una métrica jamás rompe la cadena */ }
  }

  function flashCaja() { return modal.querySelector('.cco-modal__box') || modal; }

  function correrCadenaFlash() {
    var cola = flashOfrecibles();
    if (!cola.length) { flashCadenaHecha = true; flashTrasCadena(); return; }

    flashCadenaEnCurso = true;
    var caja = flashCaja();
    var host = document.createElement('div');
    host.className = 'cco-flash';
    host.setAttribute('data-cco-flash', '');
    caja.appendChild(host);
    // El modal puede estar scrolleado (el formulario es largo): sin esto la tarjeta
    // nacería con el scroll a medias y el cliente vería la mitad de la oferta.
    try { caja.scrollTop = 0; } catch (e) { /* da igual */ }

    var idx = 0;
    var decidido = false;      // 🔒 GUARD ANTI-CARRERA por tarjeta
    var variante = null;
    var t0 = 0;
    var timer = null;

    function limpiar() {
      if (timer) { clearInterval(timer); timer = null; }
      if (host.parentNode) host.parentNode.removeChild(host);
      flashCadenaEnCurso = false;
      flashCerrarCadena = null;
      flashAbortarCadena = null;
      flashCadenaHecha = true;
    }
    /* `cierre` distingue las DOS maneras de llegar aquí, y no son lo mismo: 'cadena' es
       haber visto las tres tarjetas y decidir sobre todas (el equivalente del «Continuar
       al pago» del panel), 'abandono' es cerrar el modal o pulsar Escape a mitad.
       Sin ese campo los dos emitían el MISMO evento `continuar` y el resumen sumaba en
       la misma casilla «llegó al final» y «se fue». `aceptadas` permite leer cuántas se
       llevó cada sesión sin cruzar con la venta. */
    function fin(cierre) {
      var ultima = cola[Math.min(idx, cola.length - 1)];
      if (ultima && ultima.id != null) {
        flashBeacon('continuar', ultima.id, Math.min(9, Math.max(1, Math.min(idx + 1, cola.length))), {
          aceptadas: FLASH_ACEPTADOS.length,
          cierre: cierre === 'abandono' ? 'abandono' : 'cadena'
        });
      }
      limpiar();
      flashTrasCadena();
    }

    // EL RELOJ, EN TRES CHIPS HH : MM : SS (copia de `pintaCd` de México). A 30
    // segundos se pone ROJO y late — el rojo es la oferta que se acaba, no un adorno,
    // así que se mantiene aunque el latido lo apague `prefers-reduced-motion`.
    var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
    function reloj() {
      var o = cola[idx];
      if (!o) return 0;
      var falta = Math.max(0, flashSegundos(o) * 1000 - Math.max(0, ahoraMs() - t0));
      var s = Math.ceil(falta / 1000);
      var el = host.querySelector('[data-cco-flash-reloj]');
      if (el) {
        var hh = el.querySelector('[data-cco-flash-hh]');
        var mm = el.querySelector('[data-cco-flash-mm]');
        var ss = el.querySelector('[data-cco-flash-ss]');
        if (hh) hh.textContent = p2(Math.floor(s / 3600));
        if (mm) mm.textContent = p2(Math.floor((s % 3600) / 60));
        if (ss) ss.textContent = p2(s % 60);
        el.classList.toggle('cco-flash__reloj--urge', s <= 30);
      }
      return falta;
    }
    // El CARRUSEL de fotos (copia de México, 20 y 21-jul). Dos cosas que allá costaron
    // dos correcciones en vivo y aquí se heredan hechas:
    //   · el salto es INSTANTÁNEO: Chrome descarta el `scrollTo` suave sobre un track
    //     con `scroll-snap: mandatory` y la foto no avanza;
    //   · el índice se calcula del scroll REAL en el momento del clic, no de una
    //     variable capturada, así que nunca queda a mitad entre dos fotos.
    function flechaFoto(paso) {
      var track = host.querySelector('[data-cco-flash-track]');
      if (!track || !track.children.length) return;
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w) + paso;
      if (i < 0) i = 0;
      if (i > track.children.length - 1) i = track.children.length - 1;
      var destino = track.children[i];
      if (destino) track.scrollLeft = destino.offsetLeft;
    }
    // LA CANTIDAD. El servidor declara `FLASH_CO_QTY_MAX = 3` (flash-co.js, commit
    // 985d74ed), así que el selector SÍ se pinta cuando la oferta lo permite (misma
    // regla que México: sólo con `qtyMax > 1`). El tope se lee del PROPIO `o.qtyMax`
    // de cada oferta, nunca hardcodeado aquí, para que el que se respete sea el SUYO.
    var cantidad = 1;
    function topeQty() {
      var o = cola[idx];
      return Math.max(1, Math.trunc(Number(o && o.qtyMax) || 1));
    }
    // Lo que se PINTA al mover la cantidad. El tachado también se multiplica: con 2
    // unidades un «antes» sin multiplicar quedaría POR DEBAJO del precio final y el
    // descuento parecería falso (pulido de México, v5).
    function pintaQty() {
      var o = cola[idx];
      if (!o) return;
      var n = host.querySelector('[data-cco-flash-qty]');
      if (n) n.textContent = String(cantidad);
      var ahora = host.querySelector('.cco-flash__ahora');
      if (ahora) ahora.textContent = money(cop(o.precioFinal) * cantidad);
      var antes = host.querySelector('.cco-flash__antes');
      if (antes) antes.textContent = money(cop(o.precioBase) * cantidad);
      // El total en el botón sólo con 2+ unidades, como allá: con una sola unidad
      // repetiría el precio que ya se lee enorme justo encima.
      var tot = host.querySelector('[data-cco-flash-si-total]');
      if (tot) tot.textContent = cantidad > 1 ? ' \u00b7 ' + money(cop(o.precioFinal) * cantidad) : '';
    }
    function pintar() {
      var o = cola[idx];
      decidido = false;
      variante = flashVarianteDefecto(o);
      cantidad = 1;
      t0 = ahoraMs();
      host.innerHTML = flashHtml(o, variante, cola.length, idx);
      // 🧾 Cada tarjeta se reescribe entera: el aviso «tu pedido ya quedó registrado» se
      // vuelve a poner en cada una (si el registro ya respondió).
      registroPintarAviso();
      reloj();
      // UNA vista por tarjeta y por sesión: la cadena corre una vez por apertura del
      // modal (`flashCadenaHecha`), pero el guard hace que ni un re-render pueda contar
      // dos veces la misma impresión.
      if (o && o.id != null && !flashVistaEmitida[String(o.id)]) {
        flashVistaEmitida[String(o.id)] = true;
        flashBeacon('vista', o.id, idx + 1);
      }
    }
    // La PRIMERA decisión gana: el clic y el vencimiento del reloj pueden caer en el
    // mismo tick y sin este guard la oferta entraría dos veces (o entraría una que el
    // cliente acababa de rechazar).
    function decidir(si, porReloj) {
      if (decidido) return;
      decidido = true;
      var o = cola[idx];
      // El MISMO guard `decidido` que impide la doble entrada impide el doble beacon:
      // clic y vencimiento pueden caer en el mismo tick y sólo el primero pasa de aquí.
      if (o && o.id != null) flashBeacon(porReloj ? 'reloj' : (si ? 'acepta' : 'rechaza'), o.id, idx + 1);
      if (si && o) {
        // La cantidad que viaja es la que se VE (hoy siempre 1, ver `cantidad`), clampada
        // al tope del propio servidor. Él vuelve a clampar: aquí no se decide nada.
        FLASH_ACEPTADOS.push({
          id: String(o.id),
          qty: Math.max(1, Math.min(topeQty(), cantidad)),
          variantId: variante == null ? null : String(variante),
          // La posición en que el cliente VIO esta tarjeta (la MISMA del beacon). Sólo
          // para el ledger del servidor: el precio no la mira.
          pos: idx + 1,
        });
        // 🧾 (27-oct) Aceptar = queda sumada YA en el pedido registrado (no espera a la
        // pantalla del total): si el cliente sale ahora, el pedido sale con esta oferta.
        registroSumar(null);
      }
      idx++;
      if (idx >= cola.length) { fin(); return; }
      pintar();
    }
    function tick() { if (reloj() <= 0) decidir(false, true); }

    host.addEventListener('click', function (e) {
      var t = e.target;
      var b = (t && t.closest) ? t.closest('button') : null;
      if (!b || !host.contains(b)) return;
      if (b.hasAttribute('data-cco-flash-si')) { decidir(true); return; }
      if (b.hasAttribute('data-cco-flash-no')) { decidir(false); return; }
      if (b.hasAttribute('data-cco-flash-prev')) { flechaFoto(-1); return; }
      if (b.hasAttribute('data-cco-flash-next')) { flechaFoto(1); return; }
      if (b.hasAttribute('data-cco-flash-menos')) { cantidad = Math.max(1, cantidad - 1); pintaQty(); return; }
      if (b.hasAttribute('data-cco-flash-mas')) { cantidad = Math.min(topeQty(), cantidad + 1); pintaQty(); return; }
      var chip = b.getAttribute('data-cco-flash-chip');
      if (chip) { variante = String(chip); flashPintarChip(host, chip, cola[idx]); }
    });

    // Cerrar / Escape durante la cadena = NO a todo lo pendiente, y el pedido SIGUE con
    // lo ya aceptado. No se pierde nada de lo que el cliente escribió ni aceptó.
    flashCerrarCadena = function () { decidido = true; idx = cola.length; fin('abandono'); };
    // 🧾 El registro fue RECHAZADO (datos, cobertura, precio): la cadena se cierra SIN
    // enviar nada — el pedido no era enviable tal cual y el cliente tiene que verlo.
    flashAbortarCadena = function () { decidido = true; idx = cola.length; FLASH_ACEPTADOS = []; limpiar(); historialSoltar(); };

    timer = setInterval(tick, 250);   // UN SOLO TIMER, para toda la cadena
    historialTomar();
    pintar();
  }

  /* ── 🧾 «ATRÁS» DURANTE LA CADENA = «NO, GRACIAS A TODO» (P03, dueño 26-oct) ─────────
     Al abrir la cadena se guarda un paso en el historial del navegador; si el cliente
     toca «atrás» (lo más común en Android), el navegador NO sale de la página: se dispara
     `popstate` y aquí se cierra la cadena como la ✕ — el pedido sigue con lo aceptado y,
     si aceptó algo, se le enseña el total nuevo. En la pantalla del total, «atrás» manda
     el pedido CON lo aceptado (27-oct, dueño: aceptar = queda sumada). Al terminar, el paso extra se devuelve
     para que el «atrás» siguiente sí salga de la página. */
  var historialPaso = false;
  var historialIgnorar = 0;
  function historialTomar() {
    try {
      if (historialPaso || !window.history || !history.pushState) return;
      history.pushState({ ccoCadena: 1 }, '');
      historialPaso = true;
    } catch (e) { /* sin historial: la ✕ y Escape siguen funcionando */ }
  }
  function historialSoltar() {
    try {
      if (!historialPaso) return;
      historialPaso = false;
      if (history.state && history.state.ccoCadena) { historialIgnorar++; history.back(); }
    } catch (e) { /* */ }
  }
  window.addEventListener('popstate', function () {
    if (historialIgnorar > 0) { historialIgnorar--; return; }
    if (!historialPaso) return;
    historialPaso = false;
    if (flashCadenaEnCurso && flashCerrarCadena) {
      reportarSalud('cadena_atras');
      flashCerrarCadena();
      return;
    }
    if (flashResumenAbierto) {
      // 🧾 (27-oct) «Atrás» en «Revisa tu pedido» = salir sin tocar nada: el pedido sale CON
      // lo que aceptó (decisión del dueño). Quitar la oferta es sólo el botón explícito.
      reportarSalud('cadena_atras');
      flashConfirmarConOferta();
    }
  });

  // ═══════════════════════════════════════════════════════════════════════════
  // 🔒 LA REGLA DE CONTINUACIÓN (§G2.2) — DÓNDE SE JUNTAN LA CADENA Y EL EJE TIEMPO
  // ═══════════════════════════════════════════════════════════════════════════
  // Aceptar una oferta CAMBIA el payload, y la huella es el payload serializado: la
  // cotización aprobada deja de valer en ese mismo instante. Así que se recotiza en modo
  // 'normal' (que por diseño NO pide gesto: el cambio lo pidió el cliente) y se ESPERA
  // la fresca antes de enviar nada.
  //
  //   esperado = totalViejo + Σ(precioFinal·qty) − (envioViejo − envioNuevo)
  //   total nuevo == esperado  → se continúa el envío solo (aprobó las dos mitades)
  //   cualquier otra cosa      → GESTO EXPLÍCITO, y no se envía nada
  //
  // 🔒 LOS DOS SUMANDOS SON NÚMEROS DEL SERVIDOR: `precioFinal` de la oferta que él
  // coció y los dos `envio.costo` de las dos cotizaciones. El front no inventa
  // aritmética de dinero: COMPARA.
  // 🔒 EL TÉRMINO DEL ENVÍO NO ES UN ADORNO. Aceptar una oferta puede cruzar los
  // $129.000 y volver el envío GRATIS, así que el total puede subir MENOS que el precio
  // de la oferta. Sin ese término, la regla mandaría a gesto explícito justo a los
  // clientes que más gastan. (Y si mañana el servidor decidiera que la flash NO empuja
  // el umbral, el término vale 0 y la regla sigue cuadrando: se resta lo MEDIDO, no lo
  // supuesto.)
  // 🔒 SI ALGO NO SE PUEDE VERIFICAR (una oferta aceptada que ya no está en la lista del
  // servidor, la cotización fresca que no llega), NO se envía: se pide el gesto o se
  // enseña el error. El fallo cae siempre del lado de no cobrar sin que lo hayan visto.
  function flashTrasCadena() {
    if (!FLASH_ACEPTADOS.length) { flashReenviar(); return; }

    var totalAntes = cop(cotizado ? cotizado.total : 0);
    var envioAntes = cop((cotizado && cotizado.envio) ? cotizado.envio.costo : 0);
    var suma = 0;
    for (var i = 0; i < FLASH_ACEPTADOS.length; i++) {
      var o = flashOfertaPorId(FLASH_ACEPTADOS[i].id);
      if (!o) { suma = null; break; }
      suma += cop(o.precioFinal) * Math.max(1, Math.trunc(Number(FLASH_ACEPTADOS[i].qty)) || 1);
    }

    // 🔒 LA COPIA DEL PEDIDO APROBADO, ANTES DE TOCAR NADA (MEDIO del escéptico
    // «no-perder-al-que-paga», 11-sep). La línea siguiente destruye el estado de precio
    // vigente; sin esta copia, el cliente que aceptó una oferta y se quedó sin cotización
    // fresca perdía un pedido que YA estaba aprobado — o sea que aceptar la oferta era lo
    // único que introducía el modo de falla. Se guarda sólo si de verdad había un pedido
    // aprobado (los tres campos): prometer «lo envío sin la oferta» sin tener a qué volver
    // sería otra promesa que no se puede cumplir.
    // 🔒 Y SÓLO SI ERA ENVIABLE: `!bloqueo`. La cadena corre ANTES del candado (a) del
    // submit, así que se puede llegar aquí con el pedido VETADO por el servidor; ofrecer
    // «lo envío sin la oferta» sobre un pedido vetado sería mandar al cliente a chocarse
    // contra el mismo veto. Sin copia, el desenlace es el mensaje del servidor, que ya
    // dice qué pasa.
    flashAprobada = (cotizado && ecoCotizado && huellaCotizada != null && !bloqueo) ? {
      cotizado: cotizado, eco: ecoCotizado, huella: huellaCotizada,
      ts: tsCotizacion, total: totalAntes,
    } : null;

    // La huella del pedido CON la oferta dentro. Es la que tiene que traer la cotización
    // fresca para que se pueda enviar (candado (c) del invariante).
    var hEsperada = huella(payloadPedido());
    programarCotizacion();
    flashEsperarFresca(hEsperada, function (llego) {
      // No llegó la cotización fresca (429, 500, el túnel): NO se envía nada con un total
      // que nadie calculó —eso sigue igual— pero tampoco se deja al cliente en un mensaje
      // sin salida: se le ofrece mandar su pedido de siempre, el que ya aprobó.
      if (!llego) { flashOfrecerSinOferta('No pudimos actualizar tu total con la oferta.'); return; }
      // El servidor vetó el pedido CON la oferta dentro (la pieza se agotó entre medias,
      // por ejemplo). Se le dice con SU mensaje y se le ofrece la misma salida: el veto es
      // de la oferta, no del pedido que ya estaba aprobado.
      if (bloqueo) { flashOfrecerSinOferta(bloqueo); return; }
      var ahora = cop(cotizado.total);
      var envioAhora = cop((cotizado.envio || {}).costo);
      // 🧾 (26-oct, dueño) «Antes de enviar algo aceptado se le muestra el total nuevo»:
      // ya no se envía solo aunque la cuenta cuadre. SIEMPRE la pantalla del resumen con
      // «Confirmar pedido por $X». La fórmula se conserva como testigo para el log.
      var esperado = (suma == null) ? null : (totalAntes + suma - (envioAntes - envioAhora));
      void esperado;
      pedirConfirmacionFlash(totalAntes, ahora);
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // 🔒 NUNCA UN ESTADO SIN SALIDA, Y NUNCA UN PRECIO SIN GESTO
  // ═══════════════════════════════════════════════════════════════════════════
  // Los dos desenlaces que antes eran callejones, cada uno con SU salida:
  //
  //   (1) la cotización fresca SÍ llegó pero no cuadra con la fórmula → hay un número
  //       nuevo, así que hace falta el gesto; lo que cambia es que el gesto ENVÍA en el
  //       mismo toque («Confirmar pedido por $X») en vez de dejar el botón desbloqueado
  //       para que el cliente adivine que tiene que pulsar otra vez. Un gesto, no dos.
  //       El número sigue estando escrito DENTRO del botón, que es lo que hace que el
  //       gesto valga: nadie confirma un total que no ve.
  //
  //   (2) la cotización fresca NO llegó (o el servidor vetó el pedido con la oferta) →
  //       no hay número nuevo que mostrar, así que no hay nada que confirmar: se ofrece
  //       ENVIAR SIN LA OFERTA, que es exactamente el pedido que el cliente ya aprobó,
  //       con su total y su huella intactos.
  //
  // 🚫 LO QUE NO SE HACE EN NINGUNA DE LAS DOS: enviar «por si acaso». Si no hay
  // cotización que respalde el total, no sale un pedido; el cliente decide, y su decisión
  // es siempre sobre un número que está a la vista. El eco (`cotizacionEsperada`) y el 409
  // del servidor siguen siendo el último candado en las dos ramas.
  function flashOfrecerSinOferta(msg) {
    mostrarError(String(msg || 'No pudimos aplicar la oferta a tu pedido.'));
    flashPintarSalida();
  }

  // Sólo la pintura, para poder repintarla desde `falloCotizacion` sin repetir el mensaje
  // rojo (ahí el motivo ya está escrito en la nota del desglose, y dos avisos del mismo
  // fallo son ruido). Sin pedido aprobado NO se promete una salida que no existe: el
  // camino sigue siendo el de siempre (el Reintentar de la cotización).
  function flashPintarSalida() {
    if (!flashAprobada) return;
    // 🧾 (27-oct) Si el servidor YA sumó la oferta al registro, se dice la verdad: el pedido
    // está registrado con ella (y saldrá así si el cliente se va). Quitarla sigue a un toque.
    var rgS = registro;
    if (rgS && rgS.estado === 'ok' && rgS.ackConFlash && rgS.ackTotal != null) {
      mostrarAviso(
        '<div class="cco-cambio__t">Tu pedido quedó registrado con la oferta</div>' +
        '<div class="cco-cambio__h">Pagas al recibir ' + money(rgS.ackTotal) + '. Te escribimos por WhatsApp para confirmarlo.</div>' +
        '<button type="button" class="cco-cambio__b2" data-cco-flash-sin>' + flashTextoQuitar() + ' y enviar por ' +
          money(flashAprobada.total) + '</button>',
        true);
      return;
    }
    mostrarAviso(
      '<div class="cco-cambio__t">No pudimos aplicar la oferta</div>' +
      '<div class="cco-cambio__h">Tu pedido sigue listo, tal como lo aprobaste. Puedes enviarlo ahora sin la oferta.</div>' +
      '<button type="button" class="cco-cambio__b" data-cco-flash-sin>Enviar sin la oferta por ' +
        money(flashAprobada.total) + '</button>',
      true);
  }

  // El gesto de la cadena. Mismo candado que `pedirConfirmacion` —`confirmacion` puesta =
  // submit bloqueado (candado (e))— pero con un botón que CONFIRMA Y ENVÍA, y con la
  // salida de (2) al lado como alternativa secundaria: quien se arrepiente del total
  // nuevo no tiene por qué abandonar el pedido entero.
  function pedirConfirmacionFlash(antes, ahora) {
    confirmacion = { antes: antes, ahora: ahora };
    // 🧾 LA PANTALLA DEL TOTAL NUEVO (dueño 26-oct, punto 12): a pantalla completa, como
    // la tarjeta de la oferta, con TODO lo que se va a mandar y el botón grande
    // «Confirmar pedido por $X». Si no se puede pintar (sin cotización), el aviso de
    // siempre, más abajo.
    if (flashResumenPintar(antes, ahora)) { refrescarBoton(); return; }
    mostrarAviso(
      '<div class="cco-cambio__t">Tu total con la oferta</div>' +
      '<div class="cco-cambio__n">Antes: <s>' + money(antes) + '</s> · Ahora: <b>' + money(ahora) + '</b></div>' +
      '<div class="cco-cambio__h">La oferta ya está sumada a tu pedido (resumen de arriba).</div>' +
      '<button type="button" class="cco-cambio__b" data-cco-flash-confirmar>Enviar mi pedido por ' +
        money(ahora) + '</button>' +
      (flashAprobada
        ? '<button type="button" class="cco-cambio__b2" data-cco-flash-sin>' + flashTextoQuitar() + ' y enviar por ' +
            money(flashAprobada.total) + '</button>'
        : ''),
      true);
    refrescarBoton();
  }

  // El resumen a pantalla completa. Pinta lo que el SERVIDOR cotizó (líneas, envío,
  // total): aquí no se suma nada. Devuelve false si no hay con qué pintarlo.
  function flashResumenPintar(antes, ahora) {
    try {
      if (!cotizado || !Array.isArray(cotizado.items)) return false;
      flashResumenCerrar();
      var host = document.createElement('div');
      host.className = 'cco-flash cco-flash--resumen';
      host.setAttribute('data-cco-flash-resumen', '');
      var h = '<div class="cco-flash__card cco-resfin" role="dialog" aria-modal="true" aria-label="Revisa tu pedido">';
      h += '<div class="cco-flash__scroll">';
      // 🔒 (corrección 27-oct, revisión adversaria) «registrado CON lo que elegiste» sólo si
      // el servidor CONFIRMÓ la suma de este mismo total. Si la suma no llegó (red, 409), un
      // texto neutro: si el cliente se fuera, saldría el pedido base, y la pantalla no puede
      // haberle dicho otra cosa. Se repinta en cuanto llega la confirmación.
      flashResumenTotal = esNumero(ahora) ? cop(ahora) : null;
      if (registro && registro.estado === 'ok') {
        h += '<div class="cco-flash__registrado" role="status" data-cco-resfin-registrado>' + esc(registroTextoResumen()) + '</div>';
      }
      h += '<p class="cco-resfin__t">Revisa tu pedido</p><div class="cco-resfin__lista">';
      // 🔒 LA CUENTA TIENE QUE CUADRAR A LA VISTA (revisión del 26-oct): cada línea trae el
      // precio YA rebajado, así que va con su TACHADO, y antes del envío va el SUBTOTAL (la
      // suma de los tachados), igual que en el resumen del formulario (pintarResumen):
      // Subtotal + Envío − Descuentos = Total. Sin el Subtotal, «Descuentos −$X» se restaba
      // dos veces a ojos del cliente justo en la pantalla donde confirma cuánto paga.
      m6AgruparItems(cotizado.items || []).forEach(function (it) {
        var qty = Math.max(1, Math.trunc(Number(it.qty)) || 1);
        var tachado = (Number(it.precioBase) > Number(it.precio))
          ? '<s class="cco-resfin__antes">' + money(it.precioBase) + '</s> '
          : ((Number(it.comparacion) > Number(it.precio))
            ? '<s class="cco-resfin__antes">' + money(it.comparacion) + '</s> ' : '');
        h += '<div class="cco-resfin__li"><span>' + esc(it.titulo) + ' <b>×' + qty + '</b></span><span>' + tachado + money(it.precio) + '</span></div>';
      });
      if (esNumero(cotizado.subtotal)) {
        h += '<div class="cco-resfin__li cco-resfin__sub"><span>Subtotal</span><span>' + money(cotizado.subtotal) + '</span></div>';
      }
      var env = cotizado.envio || {};
      h += '<div class="cco-resfin__li cco-resfin__env"><span>Envío</span><span>' +
        ((env.gratis || Number(env.costo) === 0) ? 'Gratis' : money(env.costo)) + '</span></div>';
      if (Number(cotizado.descuentos) > 0) {
        h += '<div class="cco-resfin__li cco-resfin__desc"><span>Descuentos</span><span>-' + money(cotizado.descuentos) + '</span></div>';
      }
      h += '<div class="cco-resfin__total"><span>Total a pagar al recibir</span><b>' + money(ahora) + '</b></div>';
      h += '<p class="cco-resfin__nota">Pagas al recibir · Envío rápido de 1 a 3 días hábiles</p>';
      h += '</div><div class="cco-flash__pie">';
      h += '<button type="button" class="cco-flash__si cco-resfin__si" data-cco-flash-confirmar>' +
        '<span class="cco-flash__si-l1">Enviar mi pedido por ' + money(ahora) + '</span></button>';
      // 🧾 (27-oct) La pantalla es INFORMATIVA: sin tocar nada, el pedido sale así solo.
      h += '<p class="cco-resfin__auto" data-cco-resfin-auto aria-live="polite">Si no tocas nada, lo enviamos así en <b data-cco-resfin-cuenta>' + FLASH_RESUMEN_AUTO_SEG + '</b> s.</p>';
      if (flashAprobada) {
        h += '<button type="button" class="cco-flash__no cco-resfin__no" data-cco-flash-sin>' + flashTextoQuitar() + ' y enviar por ' + money(flashAprobada.total) + '</button>';
      }
      h += '</div></div>';
      host.innerHTML = h;
      flashCaja().appendChild(host);
      flashResumenAbierto = true;
      historialTomar();
      try { var bt = host.querySelector('[data-cco-flash-confirmar]'); if (bt) bt.focus(); } catch (e) { /* */ }
      // 🧾 (27-oct) El total de esta pantalla queda ATADO al registro con su eco exacto: si
      // el cliente sale desde aquí, el servidor envía justo esto.
      registroSumar(ecoCotizado);
      flashResumenCuenta();
      void antes;
      return true;
    } catch (e) { return false; }
  }
  // La cuenta atrás de «Revisa tu pedido». Por RELOJ (no por ticks: un teléfono que
  // congela la pestaña no la estira) y con UN solo timer, que se apaga al cerrar.
  function flashResumenCuenta() {
    if (flashResumenReloj) { clearInterval(flashResumenReloj); flashResumenReloj = null; }
    var limite = ahoraMs() + FLASH_RESUMEN_AUTO_SEG * 1000;
    flashResumenReloj = setInterval(function () {
      if (!flashResumenAbierto) { clearInterval(flashResumenReloj); flashResumenReloj = null; return; }
      var falta = Math.max(0, Math.ceil((limite - ahoraMs()) / 1000));
      var el = modal.querySelector('[data-cco-resfin-cuenta]');
      if (el) el.textContent = String(falta);
      if (falta <= 0) {
        clearInterval(flashResumenReloj); flashResumenReloj = null;
        reportarSalud('resumen_auto_envio');
        flashConfirmarConOferta();
      }
    }, 250);
  }
  function flashTextoQuitar() {
    return (FLASH_ACEPTADOS.length > 1) ? 'Quitar las ofertas' : 'Quitar la oferta';
  }
  // Enviar el pedido CON lo aceptado: el botón grande, la cuenta que llega a 0, y «atrás».
  function flashConfirmarConOferta() {
    if (pedidoHecho || enviando) return;
    flashResumenCerrar();
    limpiarConfirmacion();
    flashReenviar();
  }
  // ¿El servidor tiene YA registrado el pedido tal como lo enseña «Revisa tu pedido»?
  function registroTieneElResumen() {
    var rg = registro;
    return !!(rg && rg.estado === 'ok' && rg.ackConFlash === true && rg.ackTotal != null &&
      flashResumenTotal != null && Math.abs(cop(rg.ackTotal) - flashResumenTotal) <= 1);
  }
  function registroTextoResumen() {
    return registroTieneElResumen()
      ? '✅ Tu pedido quedó registrado con lo que elegiste.'
      : '✅ Tu pedido quedó registrado. Toca «Enviar mi pedido» para sumar lo que elegiste.';
  }
  function registroPintarResumen() {
    try {
      var el = modal.querySelector('[data-cco-flash-resumen] [data-cco-resfin-registrado]');
      if (el) el.textContent = registroTextoResumen();
    } catch (e) { /* ayuda, no camino */ }
  }
  function flashResumenCerrar() {
    if (flashResumenReloj) { clearInterval(flashResumenReloj); flashResumenReloj = null; }
    flashResumenAbierto = false;
    var viejo = modal.querySelector('[data-cco-flash-resumen]');
    if (viejo && viejo.parentNode) viejo.parentNode.removeChild(viejo);
  }

  // Vuelve al pedido APROBADO y lo manda. No se «arregla» ningún número: se RESTAURA el
  // estado de precio que el servidor había dado y el cliente había visto, se vacía el voto
  // (con lo que el payload vuelve a ser EXACTAMENTE el que produjo esa huella) y se re-entra
  // por el submit de siempre, con los cinco candados. Si algo no cuadrara, los candados lo
  // cazan: esta función no envía nada por su cuenta.
  function flashEnviarSinOferta() {
    if (!flashAprobada) return;
    var snap = flashAprobada;
    FLASH_ACEPTADOS = [];
    // 🧾 (27-oct) Quitar la oferta es la ÚNICA forma de sacarla: el registro vuelve al base
    // en el acto (si el envío de abajo no llegara, el servidor manda el base, no la oferta).
    registroSumar(null);
    // La recotización CON la oferta ya no interesa: se cancela lo programado y se invalida
    // lo que pueda estar en vuelo. Sin esto, una respuesta tardía —o su fallo, que es el
    // caso probable aquí— aterrizaría encima del estado restaurado y volvería a dejar al
    // cliente sin botón, deshaciendo justo lo que este camino existe para arreglar.
    pararTimers();
    tokenCotiza++;
    reintentos = 0;
    reintentos429 = 0;
    cotizado = snap.cotizado;
    ecoCotizado = snap.eco;
    huellaCotizada = snap.huella;
    tsCotizacion = snap.ts;
    limpiarConfirmacion();
    pintarResumen(snap.cotizado);   // el resumen vuelve a decir la verdad
    // La copia sólo se toma de un pedido SIN veto (ver `flashAprobada`), así que aquí el
    // estado que se restaura es «enviable»: no se está tapando un bloqueo del servidor.
    bloquearSubmit(null);
    flashReenviar();
  }

  // Los dos botones se pintan y se borran, así que los clics van delegados en `root`
  // (mismo molde que `data-cco-aceptar-total`).
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-cco-flash-confirmar]')) { flashConfirmarConOferta(); return; }
    if (t.closest('[data-cco-flash-sin]')) { flashResumenCerrar(); flashEnviarSinOferta(); return; }
  });

  // Espera la cotización que corresponde a ESTA huella. Se sondea el estado en vez de
  // engancharse a un callback nuevo para no añadir un emisor más al camino del dinero:
  // `huellaCotizada` sólo se escribe en `aplicarCotizacion`, o sea cuando el servidor ya
  // contestó algo válido. Al vencer el plazo NO se envía nada.
  function flashEsperarFresca(h, cb) {
    var t0 = ahoraMs();
    var iv = setInterval(function () {
      if (cotizado && huellaCotizada === h) { clearInterval(iv); cb(true); return; }
      if (Math.max(0, ahoraMs() - t0) > FLASH_ESPERA_MAX_MS) { clearInterval(iv); cb(false); }
    }, 80);
  }

  // Vuelve a entrar por el submit de siempre, con los CINCO candados intactos. No se
  // duplica ni una línea del envío: `flashCadenaHecha` ya está en `true`, así que la
  // cadena no puede volver a correr y el flujo es el de un submit normal.
  function flashReenviar() {
    var ev = null;
    try { ev = new Event('submit', { bubbles: true, cancelable: true }); }
    catch (e) {
      try { ev = document.createEvent('Event'); ev.initEvent('submit', true, true); } catch (e2) { ev = null; }
    }
    if (ev) { form.dispatchEvent(ev); return; }
    if (btnSubmit && !btnSubmit.disabled) btnSubmit.click();
  }

  /* ── ✍️ ERRORES QUE GUÍAN (dueño 26-oct, punto 1) ───────────────────────────────────
     Al fallar: el campo en rojo, el aviso JUSTO DEBAJO de él, y la pantalla sube al
     PRIMER campo con problema. En cuanto el cliente lo corrige, el rojo y el aviso se van
     solos. El aviso general junto al botón se queda corto («Revisa los campos marcados»). */
  function campoMal(nombre, msg) {
    var el = (typeof nombre === 'string') ? form.elements[nombre] : nombre;
    if (!el) return null;
    el.classList.add('cco-bad');
    try { el.setAttribute('aria-invalid', 'true'); } catch (e) { /* */ }
    var caja = el.closest ? el.closest('.cco-f') : null;
    if (caja) {
      var fe = caja.querySelector('[data-cco-fe]');
      if (!fe) {
        fe = document.createElement('p');
        fe.className = 'cco-fe';
        fe.setAttribute('data-cco-fe', '');
        fe.setAttribute('role', 'alert');
        caja.appendChild(fe);
      }
      fe.textContent = msg || 'Revisa este dato.';
    }
    return el;
  }
  function campoBien(el) {
    if (!el) return;
    el.classList.remove('cco-bad');
    try { el.removeAttribute('aria-invalid'); } catch (e) { /* */ }
    var caja = el.closest ? el.closest('.cco-f') : null;
    var fe = caja && caja.querySelector('[data-cco-fe]');
    if (fe && fe.parentNode) fe.parentNode.removeChild(fe);
  }
  function irAlPrimerError() {
    var el = form.querySelector('.cco-bad');
    if (!el) return;
    try { (el.closest('.cco-f') || el).scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { /* */ }
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) { /* */ } }
  }
  function errorCorto(msg) {
    elError.textContent = msg;
    elError.hidden = false;
  }
  var MSG_FALTA = {
    nombre: 'Escribe tu nombre.', apellido: 'Escribe tu apellido.', whatsapp: 'Escribe tu WhatsApp.',
    direccion: 'Escribe tu dirección.', barrio: 'Escribe tu barrio.',
    departamento: 'Elige tu departamento.', ciudad: 'Elige tu ciudad.',
  };
  function quitarRojoAlCorregir(e) {
    var t = e && e.target;
    if (!t || !t.classList || !t.classList.contains('cco-bad')) return;
    if (String(t.value || '').trim()) campoBien(t);
  }
  form.addEventListener('input', quitarRojoAlCorregir);
  form.addEventListener('change', quitarRojoAlCorregir);

  /* ── ⌨️ «SIGUIENTE» EN EL TECLADO (dueño 26-oct, punto 2) ──────────────────────────
     El teclado muestra «Siguiente» (`enterkeyhint`) y esa tecla pasa al campo siguiente
     en vez de ENVIAR el formulario (en iPhone, Intro enviaba y lanzaba la página ~500 px).
     En el último campo, la tecla sólo cierra el teclado: el pedido se envía con el botón. */
  var ORDEN_CAMPOS = ['nombre', 'apellido', 'whatsapp', 'cedula', 'direccion', 'barrio', 'departamento', 'ciudad', 'email', 'nota'];
  (function () {
    try {
      ORDEN_CAMPOS.forEach(function (n, i) {
        var el = form.elements[n];
        if (el && el.tagName === 'INPUT') el.setAttribute('enterkeyhint', i === ORDEN_CAMPOS.length - 1 ? 'done' : 'next');
      });
    } catch (e) { /* */ }
  })();
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || t.type === 'checkbox' || t.type === 'submit') return;
    var i = ORDEN_CAMPOS.indexOf(t.name);
    if (i < 0) return;
    e.preventDefault();
    for (var j = i + 1; j < ORDEN_CAMPOS.length; j++) {
      var sig = form.elements[ORDEN_CAMPOS[j]];
      if (sig && !sig.disabled && sig.offsetParent !== null) { try { sig.focus(); } catch (e2) { /* */ } return; }
    }
    try { t.blur(); } catch (e3) { /* */ }
  });

  /* ── 💾 LO ESCRITO SE GUARDA EN EL PROPIO TELÉFONO (dueño 26-oct, punto 4) ────────────
     Si la página se recarga (saltar a WhatsApp desde Instagram la recarga) el formulario
     vuelve lleno. Vive SÓLO en este navegador (localStorage, nada al servidor), dura 7
     días y se BORRA en cuanto el pedido queda registrado o creado. */
  var BORRADOR_KEY = 'cco-borrador-v1';
  var BORRADOR_CAMPOS = ['nombre', 'apellido', 'whatsapp', 'cedula', 'direccion', 'barrio', 'departamento', 'ciudad', 'email'];
  var borradorTimer = null;
  function borradorGuardar() {
    try {
      var o = { ts: Date.now() };
      var algo = false;
      BORRADOR_CAMPOS.forEach(function (n) {
        var el = form.elements[n];
        var v = el ? String(el.value || '') : '';
        if (v.charAt(0) === '@') v = '';
        o[n] = v.slice(0, 200);
        if (v) algo = true;
      });
      if (algo) window.localStorage.setItem(BORRADOR_KEY, JSON.stringify(o));
    } catch (e) { /* sin almacenamiento: no pasa nada */ }
  }
  function borradorBorrar() {
    try { window.localStorage.removeItem(BORRADOR_KEY); } catch (e) { /* */ }
  }
  function borradorLeer() {
    try {
      var o = JSON.parse(window.localStorage.getItem(BORRADOR_KEY) || 'null');
      if (!o || typeof o !== 'object') return null;
      if (!(Date.now() - Number(o.ts) < 7 * 24 * 3600 * 1000)) { borradorBorrar(); return null; }
      return o;
    } catch (e) { return null; }
  }
  form.addEventListener('input', function () {
    if (pedidoHecho) return;
    if (borradorTimer) clearTimeout(borradorTimer);
    borradorTimer = setTimeout(borradorGuardar, 400);
  });
  form.addEventListener('change', function () { if (!pedidoHecho) borradorGuardar(); });
  var borradorPendiente = borradorLeer();
  (function () {
    try {
      if (!borradorPendiente) return;
      ['nombre', 'apellido', 'whatsapp', 'cedula', 'direccion', 'barrio', 'email'].forEach(function (n) {
        var el = form.elements[n];
        if (el && !el.value && borradorPendiente[n]) el.value = String(borradorPendiente[n]);
      });
    } catch (e) { /* */ }
  })();
  // El departamento y la ciudad se reponen cuando llega la lista (cargarDepartamentos).
  function borradorReponerDepartamento() {
    try {
      var b = borradorPendiente;
      if (!b || !b.departamento || selDepartamento.value) return;
      var quiero = sinTildeMay(b.departamento);
      for (var i = 0; i < selDepartamento.options.length; i++) {
        var o = selDepartamento.options[i];
        if (o.value.charAt(0) !== '@' && sinTildeMay(o.value) === quiero) {
          selDepartamento.value = o.value;
          ciudadQueSigue = b.ciudad || null;
          deptoProgramatico = true;
          try { selDepartamento.dispatchEvent(new Event('change', { bubbles: true })); } finally { deptoProgramatico = false; }
          break;
        }
      }
      borradorPendiente = null;
    } catch (e) { /* */ }
  }

  /* ── 🧾 «YA TIENES TU PEDIDO» (dueño 26-oct, punto 9) ───────────────────────────────
     Si el cliente vuelve a esta ficha después de pedir, una franja arriba del botón le
     dice que su pedido ya existe (en 60 días hubo 6-8 pares de pedidos dobles). Vive en
     este navegador 2 días. Sin número todavía (el pedido se registró y se crea al vencer
     el plazo) dice «ya registramos tu pedido». */
  var FRANJA_KEY = 'cco-pedido-v1:' + PRODUCT_GID;
  function franjaGuardar(o) {
    try {
      var prev = JSON.parse(window.localStorage.getItem(FRANJA_KEY) || 'null') || {};
      var nuevo = { ts: Date.now(), estado: o.estado, orderName: o.orderName || prev.orderName || null, total: (o.total != null ? o.total : prev.total) };
      window.localStorage.setItem(FRANJA_KEY, JSON.stringify(nuevo));
    } catch (e) { /* */ }
  }
  function franjaPintar() {
    try {
      var o = JSON.parse(window.localStorage.getItem(FRANJA_KEY) || 'null');
      if (!o || !(Date.now() - Number(o.ts) < 2 * 24 * 3600 * 1000)) return;
      if (root.querySelector('[data-cco-franja]')) return;
      var el = document.createElement('div');
      el.className = 'cco-franja';
      el.setAttribute('data-cco-franja', '');
      el.setAttribute('role', 'status');
      var que = o.orderName ? ('Ya tienes tu pedido ' + esc(o.orderName)) : 'Ya registramos tu pedido';
      el.innerHTML = '<span class="cco-franja__t">✅ ' + que +
        (o.total != null ? (' · pagas al recibir ' + money(o.total)) : '') +
        '. Te escribimos por WhatsApp para confirmarlo.</span>' +
        '<button type="button" class="cco-franja__x" data-cco-franja-x aria-label="Cerrar aviso">×</button>';
      root.insertBefore(el, root.firstChild);
      el.querySelector('[data-cco-franja-x]').addEventListener('click', function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    } catch (e) { /* */ }
  }
  try { franjaPintar(); } catch (e) { /* */ }

  /* ── 🧾 LA PANTALLA DE GRACIAS (dueño 26-oct, punto 8) ──────────────────────────────
     Qué sigue en palabras simples: te escribimos por WhatsApp al número que pusiste,
     pagas al recibir, envío rápido de 1 a 3 días hábiles, y la lista corta de lo pedido.
     El botón al chat de CONFIRMACIÓN sólo sale si el tema trae ese número
     (`data-cco-wa-confirmacion`): no se publica un número que no sea el que confirma. */
  /* ── ✨ PULIDO 27-oct (cambio 98, el dueño la aprobó «brutal»: solo orden y estética) ──
     MISMO CONTENIDO, en este orden: el TOTAL grande y centrado arriba (lo pinta
     mostrarPedidoHecho en `[data-cco-ok-total]`), «Tu pedido» en tarjeta con el precio de
     cada línea, «Qué sigue» como pasos 1-2-3 con su icono alineado y el botón de WhatsApp
     verde lleno a todo el ancho. Aire parejo: todo bloque con el mismo margen.
     🔒 Los precios por línea salen de la ÚLTIMA cotización del SERVIDOR (`cotizado`), y
     solo se pintan si su total es EL MISMO que el `desglose` de la orden creada: si no
     cuadrara (no debería), la tarjeta sale sin importes antes que con uno falso. Las filas
     Envío/Total solo van si la cuenta cuadra al peso a la vista. */
  // En esta pantalla no van emojis sueltos (dueño 27-oct): los que trae el NOMBRE de un
  // producto («✨ Collar Colibrí ✨», «♾️») se quitan SOLO al pintarlo aquí; el pedido no cambia.
  function sinEmojis(t) {
    return String(t == null ? '' : t)
      .replace(/[\uD83C-\uDBFF][\uDC00-\uDFFF]/g, '')
      .replace(/[\u2190-\u21FF\u2300-\u23FF\u2460-\u27BF\u2900-\u297F\u2B00-\u2BFF\uFE0E\uFE0F\u200D\u20E3]/g, '')
      .replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }
  function graciasLineas(body) {
    var q = cotizado;
    var d = body && body.desglose;
    var items = (q && Array.isArray(q.items)) ? m6AgruparItems(q.items) : [];
    if (!items.length) return null;
    var totalOrden = (d && esNumero(d.total)) ? cop(d.total) : null;
    var conPrecio = totalOrden != null && esNumero(q.total) && cop(q.total) === totalOrden;
    var suma = 0;
    var filas = items.slice(0, 6).map(function (it) {
      var qty = Math.max(1, Math.trunc(Number(it.qty)) || 1);
      var pr = esNumero(it.precio) ? cop(it.precio) : null;
      if (pr == null) conPrecio = false; else suma += pr;
      var piezas = (Array.isArray(it.piezas) && it.piezas.length) ? it.piezas.map(function (p2) {
        return esc(sinEmojis(p2.titulo)) + ' ×' + (Math.max(1, Math.trunc(Number(p2.qty)) || 1));
      }).join(' · ') : '';
      return { titulo: sinEmojis(it.titulo), qty: qty, precio: pr, piezas: piezas };
    });
    if (items.length > 6) conPrecio = false;
    var env = q.envio || {};
    var envCosto = (env.gratis || Number(env.costo) === 0) ? 0 : (esNumero(env.costo) ? cop(env.costo) : null);
    var desc = Number(q.descuentos) > 0 ? cop(q.descuentos) : 0;
    var cuadra = conPrecio && envCosto != null;
    var conDesc = false;
    if (cuadra && suma + envCosto !== totalOrden) {
      if (desc > 0 && suma + envCosto - desc === totalOrden) conDesc = true; else cuadra = false;
    }
    return { filas: filas, conPrecio: conPrecio, cuadra: cuadra, envCosto: envCosto, desc: conDesc ? desc : 0, total: totalOrden };
  }
  function graciasPintar(body) {
    var box = elOk;
    if (!box) return;
    var viejo = box.querySelector('[data-cco-gracias]');
    if (viejo && viejo.parentNode) viejo.parentNode.removeChild(viejo);
    var g = document.createElement('div');
    g.className = 'cco-gracias';
    g.setAttribute('data-cco-gracias', '');
    var h = '';
    if (body && body.flashNoAplicado) {
      h += '<p class="cco-gracias__aviso">Tu pedido ya estaba registrado. La oferta que elegiste al final no se agregó.</p>';
    }
    // ① «Tu pedido» en tarjeta, con el precio de cada línea.
    var L = (body && body.flashNoAplicado) ? null : graciasLineas(body);
    if (L) {
      h += '<section class="cco-gracias__card" data-cco-gracias-pedido><p class="cco-gracias__st">Tu pedido</p>';
      L.filas.forEach(function (f) {
        // La última palabra del nombre y la cantidad no se separan (« ×1» solo en otra línea).
        h += '<div class="cco-gracias__li"><span class="cco-gracias__n">' + esc(f.titulo) +
          '&nbsp;<span class="cco-gracias__q">×' + f.qty + '</span>' +
          (f.piezas ? '<span class="cco-gracias__pz">' + f.piezas + '</span>' : '') + '</span>' +
          (L.conPrecio ? '<span class="cco-gracias__p">' + money(f.precio) + '</span>' : '') + '</div>';
      });
      if (L.cuadra) {
        h += '<div class="cco-gracias__li cco-gracias__li--sec"><span>Envío</span><span class="cco-gracias__p">' + (L.envCosto === 0 ? 'Gratis' : money(L.envCosto)) + '</span></div>';
        if (L.desc > 0) h += '<div class="cco-gracias__li cco-gracias__li--sec"><span>Descuentos</span><span class="cco-gracias__p">-' + money(L.desc) + '</span></div>';
        h += '<div class="cco-gracias__li cco-gracias__li--tot"><span>Total a pagar</span><span class="cco-gracias__p">' + money(L.total) + '</span></div>';
      }
      h += '</section>';
    }
    // ② «Qué sigue» en pasos 1-2-3: solo el número en círculo y el texto, SIN emojis
    //    (dueño 27-oct, 2.ª vuelta). El paso 2 aclara que el envío corre desde que confirma.
    var pasos = [
      'Te vamos a escribir por <b>WhatsApp</b> al número que pusiste para confirmar tu pedido.',
      'Una vez confirmes tu pedido, envío rápido de 1 a 3 días hábiles.',
      'Pagas al recibir.',
    ];
    h += '<section class="cco-gracias__card cco-gracias__card--sigue"><p class="cco-gracias__st">Qué sigue</p><ol class="cco-gracias__pasos">';
    pasos.forEach(function (t, k) {
      h += '<li class="cco-gracias__paso"><span class="cco-gracias__num" aria-hidden="true">' + (k + 1) + '</span>' +
        '<span class="cco-gracias__tx">' + t + '</span></li>';
    });
    h += '</ol></section>';
    // ③ El botón al chat de confirmación, verde lleno y a todo el ancho.
    var wa = String(root.getAttribute('data-cco-wa-confirmacion') || '').replace(/\D/g, '');
    if (/^57\d{10}$/.test(wa)) {
      var txt = 'Hola, hice el pedido ' + (body && body.orderName ? body.orderName : '') + ' y quiero confirmarlo.';
      h += '<a class="cco-gracias__btn" href="https://wa.me/' + wa + '?text=' + encodeURIComponent(txt) + '" target="_blank" rel="noopener">' +
        '<svg class="cco-gracias__wico" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 2s.8 2.3 1 2.5c.1.2 1.6 2.5 4 3.5 1.5.6 2 .7 2.8.6.4-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.4-.2z"/></svg>' +
        '<span>Abrir el chat de confirmación</span></a>';
    }
    g.innerHTML = h;
    box.appendChild(g);
    // El párrafo viejo («Te contactamos…») lo dice ahora el paso 1.
    var pv = box.querySelector('[data-cco-ok-viejo]');
    if (pv) pv.hidden = true;
  }

  // ── Envío del pedido ────────────────────────────────────────────────────
  function mostrarError(msg) {
    elError.textContent = msg;
    elError.hidden = false;
    elError.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  // Obligatorios EN CLIENTE. Es el mismo juego que exige validarDatosClienteCo
  // (router-co.js:359-368): cédula, correo y nota NO están porque son opcionales
  // también en el servidor.
  var REQUERIDOS = ['nombre', 'apellido', 'whatsapp', 'direccion', 'barrio', 'departamento', 'ciudad'];

  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;   // espejo de RE_EMAIL_CO (router-co.js:146)

  // Motivos que se pueden pintar SOBRE un campo concreto. Se clasifica por el
  // CÓDIGO `motivo`, JAMÁS por la prosa de `error` — es literalmente la lección
  // del caso Sofía que router-co.js:112-115 deja escrita: una regex sobre el texto
  // convirtió un fallo de estado en un mensaje sobre el código postal.
  var CAMPO_DE_MOTIVO = {
    nombre_requerido: 'nombre',
    apellido_requerido: 'apellido',
    whatsapp_invalido: 'whatsapp',
    whatsapp_no_celular: 'whatsapp',
    email_invalido: 'email',
    cedula_invalida: 'cedula',
    departamento_requerido: 'departamento',
    departamento_desconocido: 'departamento',
    ciudad_requerida: 'ciudad',
    ciudad_no_pertenece_al_departamento: 'ciudad',
    barrio_requerido: 'barrio',
    direccion_requerida: 'direccion',
  };

  // ═══════════════════════════════════════════════════════════════════════
  // 🎯 EL PURCHASE DEL PIXEL DE META (dictado del dueño 03-oct · Lanza)
  // ═══════════════════════════════════════════════════════════════════════
  // EL DEFECTO, MEDIDO: campaña «Collar Lazo Eterno COL1» → Meta contó 1 compra y
  // Shopify tenía 5 pedidos de ESTE formulario. Los pedidos COD se crean por la API
  // de administración (/ordenar-co → orderCreate), así que el checkout de Shopify no
  // existe para ellos y la app de Facebook de Shopify —que sólo manda Purchase en
  // `checkout_completed`— nunca se entera. Y el CAPI está cerrado (la cuenta de
  // desarrollador de Meta está suspendida; router-co.js lo deja como hueco declarado):
  // la ÚNICA vía es el pixel DEL NAVEGADOR, desde esta pantalla.
  //
  // CÓMO ESTÁ CARGADO EL PIXEL EN soybuda.com.co (medido en vivo el 03-oct con Chrome
  // sin cabeza, sin enviar nada): la app de Facebook corre como «app pixel» en el
  // marco PRINCIPAL y define `window.fbq` con el pixel «SB - COL» 3314331535558876 ya
  // inicializado; ella misma manda PageView y ViewContent, y crea `_fbp` y `_fbc` al
  // llegar con `?fbclid=`. Por eso aquí:
  //   · NO se manda PageView jamás (ya lo manda la app: sería duplicarlo);
  //   · se usa `trackSingle` con el id del pixel colombiano, para que el evento no
  //     pueda caer en ningún otro pixel que alguien inicialice en la página;
  //   · se re-inicializa el MISMO pixel con los datos del cliente (coincidencia
  //     avanzada). Medido: actualiza los datos del pixel ya cargado, no crea otro ni
  //     manda un PageView nuevo. fbq los hashea antes de salir.
  //   · si `window.fbq` NO existe (la app desactivada, un bloqueo), se carga el SDK
  //     oficial y se inicializa SÓLO este pixel, con `autoConfig` apagado y sin
  //     PageView… salvo que Shopify diga que el cliente NO dio permiso de marketing:
  //     ahí no se carga nada (el consentimiento manda sobre la medición).
  //
  // 🔒 NO TOCA EL PEDIDO. Ni el payload, ni el precio, ni la escalera, ni la respuesta:
  // sólo LEE lo que ya se cotizó y lo que el servidor contestó. Todo va dentro de
  // try/catch: un pixel roto jamás puede impedir que el cliente vea su pedido creado.
  //
  // 🔒 UNA VEZ POR PEDIDO. El `eventID` es estable por pedido —'sbcol-' + número de
  // orden de Shopify— y se recuerda en sessionStorage: un reintento que el servidor
  // contesta con la MISMA orden (`duplicado:true`) no cuenta dos compras, y si aun así
  // saliera dos veces Meta las deduplica por el mismo eventID.
  //
  // ⏱️ SI EL SERVIDOR NO ALCANZA A RESPONDER (molde de trackPurchase2 en México): si la
  // página se cierra con el pedido VIAJANDO, el Purchase sale en `pagehide` con el
  // total que el cliente acaba de aprobar (el servidor rechaza con 409 cualquier otro
  // total, así que es el que se cobra) y un eventID del intento. Si la respuesta llega
  // después (la página vuelve de la caché), NO se dispara otro.
  // ⚠️ Límite declarado: el `fetch` de /ordenar-co no lleva `keepalive` (no se toca el
  // envío del pedido), así que en ese caso el pedido llegó al servidor si el cuerpo
  // alcanzó a salir — que es lo normal cuando el cliente ya vio «ENVIANDO…».
  //
  // 🚫 NO SE DISPARA si el pedido falla (400, 409, 429, 5xx, red caída) ni ante la
  // respuesta FALSA del honeypot (`HP-…`: ahí no se creó ninguna orden).
  var PX_ID = '3314331535558876';
  var PX_SS = 'cco_px_compra_v1';
  var PX_SDK = 'https://connect.facebook.net/en_US/fbevents.js';
  var pxMem = {};          // respaldo si sessionStorage no existe (navegación privada)
  var pxEnVuelo = null;    // el contexto del pedido que está viajando (pagehide)

  function pxHechos() {
    try {
      var t = window.sessionStorage.getItem(PX_SS);
      var o = t ? JSON.parse(t) : null;
      return (o && typeof o === 'object') ? o : {};
    } catch (e) { return {}; }
  }
  function pxYa(id) { return !!pxMem[id] || !!pxHechos()[id]; }
  function pxMarcar(id) {
    pxMem[id] = 1;
    try {
      var o = pxHechos();
      o[id] = Date.now();
      window.sessionStorage.setItem(PX_SS, JSON.stringify(o));
    } catch (e) { /* sin storage: vale la memoria de esta carga */ }
  }

  // Texto normalizado como pide Meta: minúsculas, sin tildes, sólo letras a-z.
  // `conEspacios` los conserva colapsados (nombres); sin él se quitan (ciudad, depto).
  function pxNorm(v, conEspacios) {
    var s = String(v == null ? '' : v).toLowerCase();
    try { if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* */ }
    s = s.replace(/[^a-z ]+/g, conEspacios ? ' ' : '');
    s = conEspacios ? s.replace(/\s+/g, ' ') : s.replace(/\s+/g, '');
    return s.replace(/^\s+|\s+$/g, '');
  }

  // Datos de coincidencia avanzada (fbq los hashea). Teléfono con indicativo 57.
  function pxUsuario(d) {
    var ud = { country: 'co' };
    try {
      var dig = String((d && d.whatsapp) || '').replace(/\D/g, '');
      if (dig.length === 12 && dig.indexOf('57') === 0) dig = dig.slice(2);
      if (/^3\d{9}$/.test(dig)) ud.ph = '57' + dig;
      var em = String((d && d.email) || '').replace(/^\s+|\s+$/g, '').toLowerCase();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) ud.em = em;
      var fn = pxNorm(d && d.nombre, true).split(' ')[0];
      if (fn) ud.fn = fn;
      var ln = pxNorm(d && d.apellido, true);
      if (ln) ud.ln = ln;
      var ct = pxNorm(d && d.ciudad, false);
      if (ct) ud.ct = ct;
      // 🚫 SIN `st` (departamento), a propósito. Medido en vivo el 03-oct: fbq recorta el
      // estado a DOS letras antes de hashear (normalización de EE. UU.), así que
      // «cundinamarca» sale como «cu», y Caldas, Caquetá, Casanare y Cauca saldrían todos
      // como «ca». Un dato ambiguo no ayuda a la coincidencia: ensucia. Ciudad y país sí.
    } catch (e) { /* lo que se alcanzó a armar */ }
    return ud;
  }

  // Ids de VARIANTE de Shopify (los mismos que usa el catálogo de Meta y la app de
  // Facebook en ViewContent) y cantidades. Sale del MISMO pedido que se cotizó; no
  // decide nada, sólo describe. Una línea sin id de variante conocido no entra.
  function pxContenidos(p) {
    var cant = {}, orden = [];
    function suma(id, q) {
      var s = String(id == null ? '' : id).replace(/^.*\//, '');
      if (!/^\d+$/.test(s)) return;
      var n = Math.max(1, Math.trunc(Number(q)) || 1);
      if (!cant[s]) { cant[s] = 0; orden.push(s); }
      cant[s] += n;
    }
    try {
      var propias = {};
      for (var a = 0; a < VARIANTES.length; a++) {
        if (VARIANTES[a] && VARIANTES[a].id != null) propias[String(VARIANTES[a].id)] = 1;
      }
      var u = Math.max(0, Math.trunc(Number(p && p.tier && p.tier.unidades)) || 0);
      for (var i = 0; i < u; i++) {
        var v = VARIANTES[elecciones[i]] || VARIANTES[0];
        if (v) suma(v.id, 1);
      }
      var tk = (p && p.upsells && p.upsells.ticks) || {};
      TICKS.forEach(function (t, j) {
        var q = tk[j];
        if (!q || !t) return;
        suma(t.variantId != null ? t.variantId : t.variantGid, q === true ? 1 : q);
      });
      var fl = (p && p.upsells && p.upsells.flashAceptados) || [];
      for (var k = 0; k < fl.length; k++) if (fl[k]) suma(fl[k].variantId, fl[k].qty);
      var ex = (p && p.externos) || [];
      for (var x = 0; x < ex.length; x++) {
        // Las líneas del MISMO producto ya están contadas arriba como unidades del pack
        // (el servidor también las descarta como `ya_en_el_pack`).
        if (ex[x] && !propias[String(ex[x].variantId)]) suma(ex[x].variantId, ex[x].cantidad);
      }
    } catch (e) { /* lo que se alcanzó a contar */ }
    var contents = [], num = 0;
    for (var z = 0; z < orden.length; z++) {
      contents.push({ id: orden[z], quantity: cant[orden[z]] });
      num += cant[orden[z]];
    }
    return { ids: orden.slice(), contents: contents, num: num };
  }

  // El pixel ya cargado por la app; si no hay, el SDK oficial (sin PageView). `null`
  // si no se puede medir o si el cliente no dio permiso de marketing.
  function pxFbq() {
    if (typeof window.fbq === 'function') return window.fbq;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false) return null;
    } catch (e) { /* sin API de privacidad: se sigue */ }
    try {
      /* Snippet base oficial de Meta, SIN la línea de PageView. */
      (function (f, b, e, v) {
        if (f.fbq) return;
        var n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        var t = b.createElement(e); t.async = true; t.src = v;
        var s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) s.parentNode.insertBefore(t, s); else (b.head || b.documentElement).appendChild(t);
      })(window, document, 'script', PX_SDK);
      window.fbq('set', 'autoConfig', false, PX_ID);
      return window.fbq;
    } catch (e2) { return null; }
  }

  // Si la cookie `_fbc` no está (la borró el navegador, o el pixel de la app no corrió
  // en la página del anuncio) pero origen-co.js guardó el `fbclid` del clic, se rehace
  // con el formato de Meta para que el Purchase lleve el clic del anuncio.
  function pxFbcDelOrigen() {
    try {
      if (/(?:^|;\s*)_fbc=/.test(document.cookie)) return;
      var o = (window.CcoOrigen && typeof window.CcoOrigen.leer === 'function') ? window.CcoOrigen.leer() : null;
      var t = o && ((o.ultima && o.ultima.fbclid) ? o.ultima : ((o.primera && o.primera.fbclid) ? o.primera : null));
      if (!t || !/^[A-Za-z0-9_\-]+$/.test(String(t.fbclid))) return;
      var ts = Math.trunc(Number(t.ts)) || Date.now();
      document.cookie = '_fbc=fb.1.' + ts + '.' + t.fbclid + '; path=/; max-age=7776000; SameSite=Lax';
    } catch (e) { /* sin cookie: el Purchase sale igual */ }
  }

  // El disparo. Devuelve true si salió. Marca ANTES de llamar a fbq: si fbq lanzara a
  // mitad, lo peor es perder una compra, nunca contarla dos veces.
  function pxCompra(ctx, eventId, orderId) {
    try {
      if (!ctx || !eventId || pxYa(eventId)) return false;
      pxFbcDelOrigen();
      var f = pxFbq();
      if (!f) return false;
      pxMarcar(eventId);
      f('init', PX_ID, ctx.ud || {});
      var c = ctx.contenidos || { ids: [], contents: [], num: 0 };
      var data = {
        value: ctx.value,
        currency: 'COP',
        content_type: 'product',
        content_ids: c.ids,
        contents: c.contents,
        num_items: c.num,
      };
      if (orderId) data.order_id = orderId;
      f('trackSingle', PX_ID, 'Purchase', data, { eventID: eventId });
      return true;
    } catch (e) { return false; }
  }

  // Se arma al ENVIAR, con lo que el cliente acaba de aprobar.
  function pxPreparar(datos, pedido, cot) {
    try {
      var intento = 'sbcol-i';
      for (var i = 0; i < 12; i++) intento += 'abcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 36));
      return {
        value: cop(cot && cot.total),
        contenidos: pxContenidos(pedido),
        ud: pxUsuario(datos),
        intento: intento,
        disparado: false,
      };
    } catch (e) { return null; }
  }

  // Tras un 200 con `ok`: el eventID es el número de la orden de Shopify.
  function pxTrasPedido(body, ctx) {
    try {
      if (!ctx || !body) return;
      var nombre = String(body.orderName == null ? '' : body.orderName);
      if (/^HP-/.test(nombre)) return;           // honeypot: no se creó ninguna orden
      var num = nombre.replace(/[^0-9A-Za-z]/g, '');
      var id = num ? ('sbcol-' + num) : ctx.intento;
      // Ya salió en `pagehide` con el id del intento: sólo se recuerda la orden.
      if (ctx.disparado) { pxMarcar(id); return; }
      var d = body.desglose;
      var valor = (d && d.total != null && isFinite(Number(d.total))) ? cop(d.total) : ctx.value;
      ctx.disparado = true;
      pxCompra({ value: valor, contenidos: ctx.contenidos, ud: ctx.ud }, id, num || null);
    } catch (e) { /* la pantalla de éxito ya está a la vista */ }
  }

  try {
    window.addEventListener('pagehide', function () {
      // 🧾 (26-oct) La página se cierra con el pedido REGISTRADO y la cadena (o la pantalla
      // del total) todavía abierta: el pedido base se va a crear en el servidor al vencer
      // el plazo, así que ESTA es la compra. Un solo evento: con el id del registro y el
      // total que el cliente aprobó al tocar «Finalizar»; si vuelve y termina, el envío
      // final ve `pxDisparado` y no manda otro.
      var rg = registro;
      if (rg && rg.estado === 'ok' && !pedidoHecho && !enviando && !rg.pxDisparado && (flashCadenaEnCurso || flashResumenAbierto || rg.ackConFlash) && rg.px) {
        rg.pxDisparado = true;
        try { reportarSalud('cadena_salio_registrado'); } catch (e) { /* */ }
        // 🧾 (27-oct) El valor es el del pedido que el servidor va a crear: con la oferta si
        // ya quedó sumada (la última suma que el servidor confirmó), si no, el base.
        var vRg = registroTotalVigente(rg);
        pxCompra({ value: vRg != null ? vRg : rg.px.value, contenidos: rg.px.contenidos, ud: rg.px.ud }, 'sbcol-r' + rg.formId, null);
        return;
      }
      var c = pxEnVuelo;
      if (!c || !enviando || c.disparado) return;
      c.disparado = true;
      pxCompra(c, c.intento, null);
    });
  } catch (e) { /* sin pagehide: sólo el camino normal */ }

  // `enviando` se declara arriba, con el resto del estado de la cotización: el botón
  // se apaga por tres motivos a la vez (bloqueo, confirmación pendiente, envío en
  // curso) y refrescarBoton() los mira todos.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (enviando) return;             // guard de re-entrada (doble tap en móvil)
    elError.hidden = true;

    var datos = {};
    var faltan = [];
    REQUERIDOS.forEach(function (k) {
      var el = form.elements[k];
      var v = String(el.value || '').trim();
      datos[k] = v;
      if (!v) { campoMal(el, MSG_FALTA[k]); faltan.push(k); }
      else campoBien(el);
    });
    datos.cedula = String(form.elements.cedula.value || '').trim();
    datos.email = String(form.elements.email.value || '').trim();
    datos.nota = String(form.elements.nota.value || '').trim();

    // ✍️ (26-oct) El aviso va debajo de CADA campo y la pantalla sube al primero. Un
    // WhatsApp escrito pero corto se marca en la MISMA pasada (no en un segundo intento).
    if (faltan.length) {
      var wa0 = String(datos.whatsapp || '').replace(/\D/g, '');
      if (wa0 && wa0.length < 10) campoMal('whatsapp', 'El WhatsApp debe tener 10 dígitos.');
      errorCorto('Revisa los campos marcados.'); irAlPrimerError(); return;
    }

    // Celular colombiano: 10 dígitos que empiezan por 3 (RE_CELULAR_CO,
    // router-co.js:150). Se distinguen los dos fallos igual que el servidor,
    // porque "te faltan dígitos" y "eso es un fijo" se arreglan distinto.
    var dig = String(datos.whatsapp).replace(/\D/g, '');
    if (dig.length === 12 && dig.indexOf('57') === 0) dig = dig.slice(2);
    var tel10 = dig.slice(-10);
    if (dig.length < 10) {
      campoMal('whatsapp', 'El WhatsApp debe tener 10 dígitos.');
      errorCorto('Revisa los campos marcados.'); irAlPrimerError();
      return;
    }
    if (!/^3\d{9}$/.test(tel10)) {
      campoMal('whatsapp', 'Escribe un celular (empieza por 3): el pedido se confirma por WhatsApp.');
      errorCorto('Revisa los campos marcados.'); irAlPrimerError();
      return;
    }

    // Cédula OPCIONAL y NUNCA BLOQUEA (dictado del dueño 08-oct). Aquí no se valida
    // NADA: el servidor la normaliza (normalizarCedulaCo, router-co.js) y, si lo
    // escrito no es un documento razonable, la orden sale sin cédula y lo escrito
    // queda como nota interna para la asesora. Un formato raro jamás frena la venta.
    form.elements.cedula.classList.remove('cco-bad');

    // Correo OPCIONAL: sólo formato, y sólo si lo escribió (router-co.js:378-383).
    if (datos.email && !RE_EMAIL.test(datos.email)) {
      campoMal('email', 'Revisa el correo (o déjalo vacío: es opcional).');
      errorCorto('Revisa los campos marcados.'); irAlPrimerError();
      return;
    }
    campoBien(form.elements.email);

    // ⚠️ Esta validación es de CORTESÍA. La que MANDA es la del servidor: él
    // normaliza el teléfono, valida el PAR (departamento, ciudad) contra el
    // catálogo y resuelve el provinceCode. Aquí sólo se evita el viaje de ida y
    // vuelta cuando el fallo es obvio.

    // ═══════════════════════════════════════════════════════════════════════
    // ⚡ LA CADENA DE OFERTAS FLASH VA AQUÍ, Y NO EN OTRO SITIO (G2)
    // ═══════════════════════════════════════════════════════════════════════
    // DESPUÉS de validar los campos (no se le ofrece nada a quien todavía tiene que
    // corregir su teléfono) y ANTES de los cinco candados del invariante: el pedido
    // que salga de aquí puede llevar una línea más, así que tiene que pasar por los
    // candados DE NUEVO, con la cotización que la incluye.
    // Al terminar, la cadena vuelve a entrar por este mismo `submit` (flashReenviar),
    // así que ningún candado se salta ni se duplica.
    // 🧾 (26-oct) La cadena arranca DESPUÉS de los candados (abajo), no aquí: el registro
    // del pedido viaja con la cotización aprobada y su eco, igual que el envío normal.

    // ═══════════════════════════════════════════════════════════════════════
    // 🔒 EL INVARIANTE, EN CINCO CANDADOS
    //   "el cliente no puede enviar un pedido sin haber visto, calculado por el
    //    servidor, exactamente lo que se le va a cobrar."
    // (a) hay un bloqueo activo (sin cotización, o el servidor la vetó) → no se envía;
    // (b) no hay cotización → no se envía;
    // (c) el pedido cambió desde que se cotizó → se recotiza y se le enseña el total
    //     nuevo ANTES de volver a intentarlo. Molde: el candado de frescura de
    //     cod-carrito.js:300-308, adaptado a que aquí el "carrito" es el payload.
    // (d) EJE TIEMPO — la cotización CADUCÓ: el pedido no cambió, pero el servidor sí
    //     pudo cambiar debajo (rollout de precios, ENVIO_CO_* recargado). Se revalida y
    //     el cliente ve el número fresco ANTES de poder confirmar. NO se pierde nada de
    //     lo que escribió: el formulario no se toca en ningún camino.
    // (e) EJE TIEMPO — hay un cambio de precio esperando GESTO explícito. Nunca se
    //     cobra un total nuevo que el cliente no haya aceptado a mano.
    // El botón además está `disabled` en los cinco casos; esto es el cinturón por si
    // alguien envía el formulario con Enter o desde la consola.
    // ═══════════════════════════════════════════════════════════════════════
    if (bloqueo) { mostrarError(bloqueo); return; }
    if (confirmacion) {
      mostrarError('El precio cambió. Confirma el nuevo total para enviar tu pedido.');
      enfocarAviso();
      return;
    }
    var pedidoAhora = payloadPedido();
    if (!cotizado || huellaCotizada == null || !ecoCotizado) {
      mostrarError('Espera un momento: estamos calculando tu total.');
      programarCotizacion();
      return;
    }
    if (huella(pedidoAhora) !== huellaCotizada) {
      mostrarError('Tu pedido cambió. Revisa el nuevo total y vuelve a enviar.');
      programarCotizacion();
      return;
    }
    if (!cotizacionFresca()) {
      // NO se envía. Se revalida SIN tocar el formulario y sin borrar el resumen; en
      // cuanto llegue la respuesta, aplicarCotizacion() decide: mismo total → un aviso
      // y a pulsar otra vez; total distinto → gesto explícito.
      mostrarError('Verificamos tu total antes de enviar (tardaste un poco). Un segundo…');
      cotizar('revalidacion');
      return;
    }

    // ⚡🧾 LA CADENA DE OFERTAS, CON EL PEDIDO YA REGISTRADO (26-oct). Los cinco candados
    // pasaron: lo que se registra es exactamente el pedido que el cliente ve con su total.
    if (flashDebeCorrer()) {
      // Sólo si el servidor dijo que sabe registrar (`registroCo` en la cotización): contra
      // un servidor que no lo anuncia, el camino de siempre (crear al final de la cadena).
      if (REGISTRO_ACTIVO && !registro && cotizado && cotizado.registroCo === true) registrarPedido(datos, pedidoAhora, ecoCotizado);
      correrCadenaFlash();
      return;
    }
    // 🧾 El registro todavía viaja (la cadena terminó en un segundo): se espera su respuesta
    // antes de mandar el pedido final, para no cruzar dos pedidos.
    if (registro && registro.estado === 'pidiendo' && registro.promesa) {
      textoSubmit('ENVIANDO…');
      var regEspera = registro;
      regEspera.promesa.then(function () {
        if (registro === regEspera && !pedidoHecho) flashReenviar();
      });
      return;
    }

    // El eco de lo aprobado, capturado ANTES de mandar. Si entre esta línea y el
    // servidor cambiara algo, es el propio servidor quien lo caza con un 409.
    var ecoAprobado = ecoCotizado;
    // 🔒 MEDIO-A · EL TOKEN DEL ENVÍO. La rama del 409 REPINTA el estado de precio
    // (cotizado / ecoCotizado / huellaCotizada / tsCotizacion) y es la única respuesta
    // de /ordenar-co que lo hace. Si entre este instante y su aterrizaje el pedido
    // cambió —el cliente saltó de tier y ya hay otra cotización aplicada—, ese repinte
    // pondría el total del pedido VIEJO encima de la selección NUEVA: el cobro seguiría
    // atado por la huella, pero el cliente vería un número que no es el suyo, que es
    // exactamente lo que MEDIO-1 cerró por la otra puerta. Se captura aquí, como en
    // cotizar().
    var tokenEnvio = tokenCotiza;
    // 🎯 El contexto del Purchase (pixel): lo que el cliente ACABA de aprobar. Sólo se
    // lee; no entra en el cuerpo del pedido. `pxEnVuelo` lo ve el oyente de `pagehide`.
    var pxCtx = pxPreparar(datos, pedidoAhora, cotizado);
    pxEnVuelo = pxCtx;

    enviando = true;
    // ⑥ ANTI DOBLE PEDIDO: con un 2x1 de la tira, la marca «en vuelo» se guarda ANTES del
    // POST (sessionStorage) y la tira queda congelada hasta una respuesta DEFINITIVA.
    m6AntesDeEnviar(tel10);
    refrescarBoton();
    // Sólo la línea 1: si se escribiera sobre el botón entero se borraría el
    // "Paga al recibir" y no volvería nunca (etiquetarSubmit sólo repinta la 1).
    textoSubmit('ENVIANDO…');

    // MISMO payload que se cotizó (productGid, tier, variantesPorUnidad, upsells,
    // externos) + los datos del cliente y el honeypot. No se reconstruye ni un campo: el
    // servidor resuelve el MISMO pedido y cobra el MISMO total que acaba de mostrarse.
    //
    // 🐛 `externos` FALTABA, y el comentario de arriba llevaba desde el 04-sep diciendo
    // "MISMO payload" sin serlo. El formulario COTIZA con los artículos del carrito
    // (`payloadPedido()` los incluye y el resumen los pinta), pero al ENVIAR no los
    // mandaba: el servidor recalculaba sin ellos, el total no cuadraba con el eco y el
    // cliente recibía «El precio cambió mientras llenabas el formulario» — y si lo
    // aceptaba, su pedido se creaba SIN los artículos que había aprobado en pantalla.
    // No cobraba de más; entregaba de menos, que es peor de explicar.
    // Hasta hoy no salía porque el único producto con la oferta activa era el de prueba
    // (sus líneas se descartan como `ya_en_el_pack` y el total no cambiaba). Con los
    // seis productos reales encendidos le podía pasar a cualquiera que tuviera algo en
    // el carrito. Lo encontró la revisión adversaria del 08-sep.
    //
    // ⏱️ PLAZO_ENVIO_MS (22-oct): a los 25 s sin respuesta se aborta la espera y el cliente
    // puede volver a tocar. Un segundo envío del MISMO pedido no crea otro: lo reconoce el
    // servidor por su contenido (ver la cabecera de PLAZO_ENVIO_MS). `respondio` separa una
    // excepción de ESTA página al pintar la respuesta de un fallo de la red.
    var respondio = false;
    api('/ordenar-co', {
      datos: datos,                        // nombre apellido whatsapp cedula direccion
                                           // barrio departamento ciudad email nota
      productGid: pedidoAhora.productGid,
      tier: pedidoAhora.tier,
      variantesPorUnidad: pedidoAhora.variantesPorUnidad,
      upsells: pedidoAhora.upsells,        // VOTO EXPLÍCITO (ALTO A-1)
      externos: pedidoAhora.externos,      // los artículos del carrito que se cotizaron
      // 🔒 EL ECO DEL EJE TIEMPO (ALTO-1). Los cuatro números que el cliente ACABA de
      // aprobar, tal cual los mandó el servidor. NO SON UN PRECIO QUE SE VAYA A COBRAR:
      // el servidor los usa SÓLO para comparar con lo que le sale al recalcular y, si
      // no cuadra, RECHAZAR con 409 (router-co.js §8c lo dice del otro lado). El dinero
      // sigue saliendo del metafield. Manipular esto sólo consigue que tu propio pedido
      // se rechace; jamás baja un peso el total.
      cotizacionEsperada: ecoAprobado,
      website: form.elements.website.value,  // honeypot (esBotCo, router-co.js:305)
      // 🎯 ORIGEN DEL ANUNCIO (Capa 3, dueño 01-oct). Va AQUÍ y no dentro de `payloadPedido()`
      // a propósito: ese payload es la huella de la cotización y la clave de idempotencia, y el
      // origen no es parte de lo que se cotiza ni de lo que se cobra. El servidor lo limpia con
      // lista blanca y lo guarda en customAttributes ocultos «_…». Sin origen no viaja.
      origen: origenGuardado(),
      // ⑥ Sólo con la mejora encendida (si no, `undefined` → JSON.stringify los omite y el
      // cuerpo es byte a byte el de siempre). El servidor exige `tira2x1` ⊆ `externos`.
      meta2x1: pedidoAhora.meta2x1,
      tira2x1: pedidoAhora.tira2x1,
      // 🧾 El pedido que se REGISTRÓ al tocar «Finalizar». También si la respuesta del
      // registro no llegó (`fallo`): si el servidor sí lo guardó, lo reclama; si no, crea
      // como siempre. Sin registro (`undefined`) el cuerpo es el de siempre.
      // (corrección 27-oct) Con la última suma pedida (`seq`): ninguna suma más vieja que
      // llegue tarde puede pisar este pedido final si Shopify lo rechazara.
      registro: (registro && (registro.estado === 'ok' || registro.estado === 'fallo'))
        ? (registro.seqSuma > 0 ? { formId: registro.formId, fase: 'final', seq: registro.seqSuma } : { formId: registro.formId, fase: 'final' })
        : undefined,
    }, PLAZO_ENVIO_MS).then(function (r) {
      respondio = true;
      // ⑥ Respuesta DEFINITIVA (éxito, 400 o 409): se borra la marca «en vuelo». Un 429 o
      // un 5xx NO lo son: el pedido pudo crearse y la tira sigue congelada.
      if (r.status === 200 || r.status === 400 || r.status === 409) m6Definitivo();
      // 👁️ Lo que vio el cliente, sin datos personales (salud-form.js).
      reportarSalud((r.status === 200 && r.body && r.body.ok) ? 'envio_ok' : ('envio_fallido:' + codigoEnvio(r.status)));
      if (r.status === 200 && r.body && r.body.ok) {
        mostrarPedidoHecho(r.body, pxCtx);
        return;
      }
      procesarRechazoPedido(r, { ecoAprobado: ecoAprobado, tokenEnvio: tokenEnvio, pedidoAhora: pedidoAhora });
    }).catch(function (err) {
      manejarFalloEnvio(err, respondio);
    }).finally(function () {
      enviando = false;
      pxEnVuelo = null;   // el pedido ya no viaja: `pagehide` no tiene nada que medir
      // Si sigue habiendo bloqueo (cotización perdida durante el envío) o hay un cambio
      // de precio esperando gesto, el botón NO se rehabilita: reenviar sólo repetiría el
      // problema, o cobraría un total sin aprobar. Molde cod-carrito.js:331.
      refrescarBoton();
      etiquetarSubmit();   // restaura el texto con el total vigente, no el genérico
    });
  });

  // ── EL PEDIDO CREADO: la pantalla de gracias (extraída del submit el 26-oct para que
  // el registro —que también puede encontrarse un pedido ya creado— pinte LA MISMA). ──
  function mostrarPedidoHecho(body, pxCtx) {
        pedidoHecho = true;
        pararLatido();
        pararTimers();
        limpiarConfirmacion();
        form.hidden = true;
        elResumen.hidden = true;
        elTiers.hidden = true;
        elUnidades.hidden = true;
        elOk.hidden = false;
        // 🧾 LA PANTALLA DE GRACIAS DEJA DE VENDER (24-sep, pedido de prueba #45313). Tras
        // «¡Pedido registrado!» seguían a la vista «¡OBTENER OFERTA!» y «Envío gratis
        // cuando tu total llega a $129.000»: vivían FUERA del formulario y nadie los
        // escondía. La clase de estado los apaga por CSS (cod-co.css, `.cco--exito`) y
        // además se les pone `hidden` aquí, por si el CSS del tema viene de caché. Sólo
        // presentación: el pedido ya está creado y no se toca nada del envío.
        pintarExito();
        $('[data-cco-ref]').textContent = body.orderName ? ('Pedido ' + body.orderName) : '';
        // El total de la pantalla de éxito sale del `desglose` del SERVIDOR. Desde
        // el 2026-09-01 tiene que coincidir SIEMPRE con el que el cliente acaba de
        // aprobar (misma `cotizarPedidoCo` sobre el mismo pedido); antes era la
        // única reconciliación que existía, y llegaba tarde.
        // 🔴 Sin "COP": el formato de la casa es "$60.700" a secas (money(), espejo de
        // formatearCop). Coherente con la etiqueta del botón y con el resumen.
        // 🔴 Y SIN EL PARÉNTESIS DEL ENVÍO (dictado del dueño 04-sep, viendo la
        // pantalla de su pedido de prueba #44897): aquí sólo va lo que el cliente
        // tiene que tener en la mano cuando llegue el transportador. El desglose ya lo
        // leyó y lo aprobó en el resumen —subtotal, envío, descuentos y total— justo
        // antes de pulsar; repetir sólo el envío al final no completa la cuenta, la
        // interrumpe: el número grande queda con un satélite que no suma ni resta.
        // 🔒 No se esconde nada: `total` YA INCLUYE el envío (orden-co.js:
        // `total = productos + env.costo`), así que la cifra que se enseña sigue
        // siendo, al peso, la que se va a cobrar en la puerta.
        var d = body.desglose;
        // ✨ (27-oct, cambio 98) El total, GRANDE y centrado arriba: rótulo + cifra. Mismo
        // número de siempre (el `desglose` del servidor).
        var elTot = $('[data-cco-ok-total]');
        if (d && d.total != null) {
          elTot.innerHTML = '<span class="cco-ok__totl">Total a pagar al recibir</span><span class="cco-ok__totv">' + money(d.total) + '</span>';
          elTot.hidden = false;
        } else { elTot.textContent = ''; elTot.hidden = true; }
        // 🧾 (26-oct) La pantalla de gracias del dueño: qué sigue, lo pedido, el WhatsApp.
        try { graciasPintar(body); } catch (e) { /* lo esencial ya está a la vista */ }
        try { medirDeptoPedido(); } catch (e) { /* una vez por sesión: si ya salió al registrar, no se repite */ }
        try {
          flashResumenCerrar();
          historialSoltar();
          franjaGuardar({ estado: 'creado', orderName: body.orderName || null, total: (d && d.total != null) ? cop(d.total) : null });
          borradorBorrar();
        } catch (e) { /* */ }
        // 🎯 Purchase del pixel, DESPUÉS de pintar el éxito (jamás lo puede impedir).
        // Un solo Purchase: si ya salió al cerrar la página con el pedido registrado, no otro.
        if (registro && registro.pxDisparado && pxCtx) pxCtx.disparado = true;
        if (pxCtx) pxTrasPedido(body, pxCtx);
        else if (registro && registro.px && !registro.pxDisparado) { registro.pxDisparado = true; pxTrasPedido(body, registro.px); }
  }

  /* ── 🧾 REGISTRAR EL PEDIDO AL TOCAR «FINALIZAR» (26-oct) ──────────────────────────
     El MISMO cuerpo que el envío de siempre (datos + lo cotizado + el eco del total que el
     cliente ve) más `registro:{formId, fase:'registrar'}`. El servidor lo valida entero y
     lo guarda SIN crear la orden. Mientras tanto la cadena ya está a la vista.
       · 200 `registrado` → listo: aunque la página muera, el pedido se crea.
       · 200 sin `registrado` → ese mismo pedido ya estaba creado (un envío anterior): se
         cierra la cadena y se enseña.
       · 409 `registro_apagado` → el servidor no registra: la cadena sigue como siempre.
       · 400 / 409 / 429 por teléfono → el pedido NO es enviable tal cual (datos, cobertura,
         el precio cambió): se cierra la cadena SIN enviar y se enseña el motivo, igual que
         al enviar.
       · red, plazo, 5xx → la cadena sigue; el pedido final lleva el mismo formId (si el
         servidor sí alcanzó a guardarlo, lo reclama; si no, lo crea como siempre). */
  function registrarPedido(datos, p, eco) {
    var reg = { formId: nuevoFormId(), estado: 'pidiendo', total: (eco && esNumero(eco.total)) ? cop(eco.total) : null, promesa: null,
      px: pxPreparar(datos, p, cotizado), pxDisparado: false,
      // 🧾 (27-oct) Para sumar las ofertas que acepte: los datos (sólo en memoria), el
      // número de la última suma pedida y lo último que el servidor confirmó.
      datos: datos, seqSuma: 0, ackSeq: 0, ackTotal: null, ackConFlash: false,
      // 🔒 Sólo se suma si el servidor lo ANUNCIÓ (`registroSumaCo`): un servidor sin la fase
      // «sumar» no la reconocería como registro y crearía el pedido en el acto.
      sumaOk: !!(cotizado && cotizado.registroSumaCo === true) };
    registro = reg;
    var tokenReg = tokenCotiza;
    var listo = null;
    reg.promesa = new Promise(function (res) { listo = res; });
    var cerrar = function () { try { listo(); } catch (e) { /* */ } };
    api('/ordenar-co', {
      datos: datos,
      productGid: p.productGid,
      tier: p.tier,
      variantesPorUnidad: p.variantesPorUnidad,
      upsells: p.upsells,
      externos: p.externos,
      cotizacionEsperada: eco,
      website: form.elements.website.value,
      origen: origenGuardado(),
      meta2x1: p.meta2x1,
      tira2x1: p.tira2x1,
      registro: { formId: reg.formId, fase: 'registrar' },
    }, PLAZO_ENVIO_MS).then(function (r) {
      if (registro !== reg) return;
      var b = r.body || {};
      if (r.status === 200 && b.ok && b.registrado) {
        reg.formId = String(b.formId || reg.formId);   // `adoptado`: el registro de otra pestaña
        reg.estado = 'ok';
        if (b.desglose && esNumero(b.desglose.total)) reg.total = cop(b.desglose.total);
        reportarSalud('registro_ok');
        try { medirDeptoPedido(); } catch (e) { /* */ }
        franjaGuardar({ estado: 'registrado', total: reg.total });
        borradorBorrar();
        registroPintarAviso();
        return;
      }
      if (r.status === 200 && b.ok) {
        // Ese pedido ya existía (el servidor lo reconoció por su contenido): no hay nada
        // que sumarle. Se cierra la cadena sin enviar y se enseña SU pedido.
        reg.estado = 'hecho';
        if (flashAbortarCadena) flashAbortarCadena();
        mostrarPedidoHecho(b, null);
        return;
      }
      if (r.status === 409 && b.motivo === 'registro_apagado') { reg.estado = 'off'; return; }
      if (r.status === 400 || r.status === 409 || (r.status === 429 && b.motivo === 'rate_limit_telefono')) {
        registro = null;
        if (flashAbortarCadena) flashAbortarCadena();
        procesarRechazoPedido(r, { ecoAprobado: eco, tokenEnvio: tokenReg, pedidoAhora: p });
        return;
      }
      reg.estado = 'fallo';
      reportarSalud('registro_fallo');
    }).catch(function () {
      if (registro === reg) { reg.estado = 'fallo'; reportarSalud('registro_fallo'); }
    }).then(cerrar, cerrar);
  }

  // El aviso dentro de la cadena: el cliente lee que su pedido YA está hecho y que lo de
  // la tarjeta es opcional. Sale en cuanto el servidor lo confirma (y en cada tarjeta).
  function registroPintarAviso() {
    try {
      var host = modal.querySelector('[data-cco-flash]');
      if (!host || !registro || registro.estado !== 'ok') return;
      var card = host.querySelector('.cco-flash__card') || host;
      var el = card.querySelector('[data-cco-flash-registrado]');
      if (!el) {
        el = document.createElement('div');
        el.className = 'cco-flash__registrado';
        el.setAttribute('data-cco-flash-registrado', '');
        el.setAttribute('role', 'status');
        card.insertBefore(el, card.firstChild);
      }
      // 🧾 (27-oct) El total es el del pedido que YA está registrado: con las ofertas que el
      // servidor ya sumó. Se repinta en cuanto confirma cada suma.
      var tv = registroTotalVigente(registro);
      el.textContent = '✅ Tu pedido ya quedó registrado' + (registro.ackConFlash ? ' con lo que elegiste' : '') +
        (tv != null ? (' · pagas al recibir ' + money(tv)) : '') + '. Si quieres, súmale esto:';
    } catch (e) { /* el aviso es ayuda, no camino */ }
  }

  // El total del pedido que el servidor tiene registrado AHORA (la última suma confirmada).
  function registroTotalVigente(rg) {
    if (!rg) return null;
    if (rg.ackSeq > 0 && rg.ackTotal != null) return rg.ackTotal;
    return rg.total;
  }

  /* ── 🧾 SUMAR AL REGISTRO LO QUE EL CLIENTE ACEPTA (27-oct, dueño) ───────────────────
     El pedido de ahora (con las ofertas aceptadas, o sin ellas si las quitó) viaja con
     `registro:{formId, fase:'sumar', seq}`. El servidor lo valida como al crear y
     REEMPLAZA lo registrado: si el cliente sale o no toca nada, sale ESTO.
       · `eco` = null al tocar «Agregar» en la tarjeta (el total nuevo aún no se ha
         pintado: el servidor exige que sea el base + la oferta); el eco EXACTO al pintar
         «Revisa tu pedido».
       · `seq` creciente: la respuesta vieja que llega tarde no pisa la decisión nueva.
       · Fire-and-forget: nunca bloquea la cadena ni la pantalla. Si falla, el registro se
         queda con lo último que el servidor confirmó y el envío final sigue siendo el piso. */
  function registroSumar(eco) {
    var reg = registro;
    if (!reg || pedidoHecho) return;
    if (reg.estado === 'pidiendo' && reg.promesa) {
      reg.promesa.then(function () { if (registro === reg) registroSumar(eco); });
      return;
    }
    if (reg.estado !== 'ok' || !reg.datos || !reg.sumaOk) return;
    var p;
    try { p = payloadPedido(); } catch (e) { return; }
    var seq = ++reg.seqSuma;
    api('/ordenar-co', {
      datos: reg.datos,
      productGid: p.productGid,
      tier: p.tier,
      variantesPorUnidad: p.variantesPorUnidad,
      upsells: p.upsells,
      externos: p.externos,
      cotizacionEsperada: eco || undefined,
      website: form.elements.website.value,
      origen: origenGuardado(),
      meta2x1: p.meta2x1,
      tira2x1: p.tira2x1,
      registro: { formId: reg.formId, fase: 'sumar', seq: seq },
    }, PLAZO_ENVIO_MS).then(function (r) {
      if (registro !== reg || seq < reg.ackSeq) return;
      var b = r.body || {};
      if (r.status === 200 && b.ok) {
        reg.ackSeq = seq;
        reg.ackConFlash = b.sumado === true;
        reg.ackTotal = (b.desglose && esNumero(b.desglose.total)) ? cop(b.desglose.total) : reg.ackTotal;
        reportarSalud(b.sumado ? 'registro_sumado' : 'registro_sin_oferta');
        registroPintarAviso();
        registroPintarResumen();
        return;
      }
      if (r.status === 409 && b.motivo === 'suma_vieja') return;
      reportarSalud('registro_suma_fallo');
    }).catch(function () {
      if (registro === reg) reportarSalud('registro_suma_fallo');
    });
  }

  // ── El servidor NO creó el pedido (409 del eje tiempo, 4xx con su motivo). Extraído del
  // submit el 26-oct: el registro del pedido recibe los MISMOS rechazos y los pinta igual.
  function procesarRechazoPedido(r, ctx) {
      var ecoAprobado = ctx.ecoAprobado, tokenEnvio = ctx.tokenEnvio, pedidoAhora = ctx.pedidoAhora;
      // ── 409: EL PRECIO CAMBIÓ MIENTRAS LLENABA EL FORMULARIO (eje tiempo) ──
      // El servidor recalculó y no le salió lo que el cliente aprobó. NO se creó nada.
      // Aquí NO se falla en seco y NO se pierde ni un campo de lo que escribió: se
      // repinta el total NUEVO con la cotización fresca que viene en la respuesta y se
      // le pide un gesto explícito. Si el servidor no pudo adjuntarla, se recotiza.
      if (r.status === 409 && r.body && r.body.motivo === 'cotizacion_desactualizada') {
        // Llegó tarde: el pedido que este 409 describe ya no es el que el cliente tiene
        // delante. NO se pinta nada suyo —ni el total, ni la huella, ni el reloj— y NO
        // se recotiza (la cotización viva ya es la buena). No se creó ninguna orden, así
        // que basta con decirle la verdad: su selección cambió, que vuelva a enviar.
        if (tokenEnvio !== tokenCotiza) {
          mostrarError('Cambiaste tu pedido mientras lo enviábamos. Revisa el total y vuelve a enviarlo.');
          return;
        }
        var antes = (ecoAprobado && esNumero(ecoAprobado.total)) ? cop(ecoAprobado.total) : null;
        var fresca = r.body.cotizacion;
        if (cotizacionValida(fresca)) {
          // ⑥ El 409 también pasa por los candados del 2x1 sumado (ESPEC §6.4).
          if (M6.barra && m6DeshacerSiFalla(fresca)) {
            mostrarError(String(r.body.error || 'El precio cambió. Revisa el nuevo total y vuelve a enviar.'));
            return;
          }
          cotizado = fresca;
          ecoCotizado = ecoDe(fresca);
          huellaCotizada = huella(pedidoAhora);   // el pedido no cambió: sólo el precio
          tsCotizacion = ahoraMs();
          pintarResumen(fresca);
          bloquearSubmit(fresca.bloqueo || null);
          if (M6.barra) m6PintarBarra(fresca, 'ok');
          var ahoraTotal = cop(fresca.total);
          if (antes != null && antes !== ahoraTotal) pedirConfirmacion(antes, ahoraTotal);
          else limpiarConfirmacion();   // mismo total: sólo hace falta volver a pulsar
          mostrarError(String(r.body.error || 'El precio cambió. Revisa el nuevo total y confirma.'));
        } else {
          // Sin cotización adjunta no se puede pintar el número nuevo, y sin número
          // nuevo no hay nada que confirmar: se recotiza desde cero (el formulario
          // sigue intacto) y el flujo normal vuelve a poner el total en pantalla.
          mostrarError(String(r.body.error || 'El precio cambió. Revisa el nuevo total y vuelve a enviar.'));
          programarCotizacion();
        }
        return;
      }

      // Se pinta el campo culpable clasificando por el CÓDIGO estable, y se
      // muestra la prosa del servidor tal cual: sus mensajes ya están escritos
      // para el cliente colombiano.
      var motivo = (r.body && r.body.motivo) || '';
      var campo = CAMPO_DE_MOTIVO[motivo];
      if (campo && form.elements[campo]) {
        // ✍️ (26-oct) El motivo del servidor, debajo del campo culpable, y se sube a él.
        campoMal(campo, (r.body && r.body.error) || 'Revisa este dato.');
        errorCorto('Revisa los campos marcados.');
        irAlPrimerError();
        return;
      }
      mostrarError((r.body && r.body.error) || 'No se pudo procesar tu pedido. Intenta de nuevo.');
  }

  // ── El envío no tuvo respuesta utilizable (red, plazo, o esta página lanzó al pintar).
  function manejarFalloEnvio(err, respondio) {
      // El pedido YA se registró y lo que lanzó fue pintar la pantalla de éxito: no se le
      // dice al cliente que falló (invitaría a pedir otra vez). Sólo se avisa.
      if (pedidoHecho) { reportarSalud('excepcion_envio'); return; }
      // El servidor SÍ contestó y lo que lanzó fue esta página al pintar la respuesta: no
      // es la conexión del cliente. Mismo texto que un fallo del servidor.
      if (respondio) {
        reportarSalud('excepcion_envio');
        mostrarError('No se pudo procesar tu pedido. Intenta de nuevo.');
        return;
      }
      // ⏱️ 25 s sin respuesta: la espera se cortó. NO se reintenta solo: toca el cliente.
      if (err && err.plazo) {
        mostrarError(TXT_ENVIO_COLGADO);
        // «Toca…»: el botón (justo debajo del aviso) tiene que quedar a la vista.
        try { btnSubmit.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* */ }
        reportarSalud('envio_colgado');
        return;
      }
      if (err && err.local) { reportarSalud('excepcion_envio'); }
      else { reportarSalud('envio_fallido:red'); }
      mostrarError('No se pudo procesar tu pedido. Revisa tu conexión e intenta de nuevo.');
  }

  // Los nodos de VENTA que no son del formulario (el formulario ya se oculta entero).
  var SEL_VENTA_EXITO = '[data-cco-sub], .cco-oferta, [data-cco-flash], [data-cco-ticks], [data-cco-cambio], [data-cco-meta], [data-cco-tira]';
  function pintarExito() {
    try {
      root.classList.add('cco--exito');
      var vs = root.querySelectorAll(SEL_VENTA_EXITO);
      for (var i = 0; i < vs.length; i++) vs[i].hidden = true;
    } catch (e) { /* la confirmación ya está a la vista: esto es sólo limpieza */ }
  }

  // ── SUBTÍTULO DEL MODAL (dictado del dueño 02-sep) ───────────────────────
  // "✨Envío gratis cuando tu total llega a $129.000✨", en lugar de "LLENA TUS DATOS
  // FÁCIL Y REALIZA UNA COMPRA GARANTIZADA". Es una promesa CONDICIONAL —dice el
  // umbral— y por eso es honesta, al revés que un "envío gratis" a secas.
  //
  // 🚨 DECÍA "en compras superiores a $129.000" y eso era FALSO por DOS motivos
  //    (arreglo del 10-sep, el mismo que la línea del resumen):
  //      · "superiores a" deja fuera el propio umbral, y la regla es INCLUSIVA
  //        (envio-co.js: `>=`, exactamente $129.000 ya sale gratis);
  //      · y sobre todo, "compras" se lee como el precio de lista de lo que uno mete
  //        al carrito, cuando la condición se mide sobre el TOTAL **después de
  //        descuentos**: con el -30% de la tienda, una compra de $141.900 se cobra
  //        $99.330 y PAGA flete (medido el 10-sep). Decir "cuando tu total llega a"
  //        nombra el número correcto y la comparación correcta, con las mismas
  //        palabras que la línea del resumen y que la barra de meta.
  //
  // 🔴 EL NÚMERO SALE DE `ENVIO_ESPEJO_UMBRAL`, NO DE UN LITERAL EN EL .liquid. Es la
  // MISMA constante con la que el desglose estimado decide si el envío se cobra: si
  // mañana el umbral cambia y sólo se toca un sitio, no puede quedar un texto de la
  // pantalla prometiendo otra cifra. Y `money()` lo formatea con el punto de miles de
  // la casa, así que el texto tampoco puede divergir en el FORMATO.
  //
  // `textContent`, no innerHTML: aquí no entra marcado.
  var elSub = $('[data-cco-sub]');
  if (elSub) {
    elSub.textContent = '✨Envío gratis cuando tu total llega a ' + money(ENVIO_ESPEJO_UMBRAL) + '✨';
  }

  // Primera pintada (por si el tema abre el modal por su cuenta). El submit nace
  // BLOQUEADO: hasta que el servidor no haya cotizado, no hay total que mostrar y por
  // tanto no hay pedido que se pueda enviar.
  pintarTiers();
  pintarUnidades();
  pintarTicks();
  ocultarAviso();
  bloquearSubmit('Estamos calculando tu total…');
  etiquetarSubmit(null);

  // ⚡ VELOCIDAD (21-oct-2026). Los departamentos se piden YA, al arrancar, y no al abrir:
  // abrir y esperar la lista costaba 0,9–2,3 s más en un móvil lento. Es la MISMA llamada de
  // siempre (cargarDepartamentos: GET /cobertura-co, cacheable 1 h, con el respaldo estático
  // del tema si el servidor no contesta) y es idempotente: `abrir()` la vuelve a llamar y, si
  // ya está pedida, no hace nada; si falló (lista vacía), al abrir se reintenta como siempre.
  try { cargarDepartamentos(); } catch (e) { /* al abrir se vuelve a pedir */ }

  // Fin del arranque: TODOS los oyentes están puestos. La cola del <head>
  // (snippets/cod-co-temprano.liquid) mira esta marca para repetir el toque que llegó antes
  // de tiempo; sin ella nunca retiene nada que ya funcionaría.
  root.setAttribute('data-cco-enlazado', '1');
  try { if (window.CcoCola && typeof window.CcoCola.avisar === 'function') window.CcoCola.avisar(); } catch (e) { /* */ }
  }
})();
